webpackJsonp([1],{

/***/ "/f5r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0kct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default.a
  },
  data: function data() {
    return {
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        data: {
          organization: {
            name: '',
            business_address: {
              street1: '',
              street2: '',
              city: '',
              state_province: '',
              country: ''
            }
          }
        },
        list: {
          countries: __WEBPACK_IMPORTED_MODULE_3_country_data___default.a.countries
        }
      },
      dialog: false
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].getOrganization({
      id: this.$route.params.id,
      success: function success(organizationData) {
        component.C.data.organization = organizationData;
        component.C.data.organization.business_address = component.C.data.organization.business_address || {};
      }
    });
  }
});

/***/ }),

/***/ "1Fki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__("BGMQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js__ = __webpack_require__("yiUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__);





var tools = {};

// App Ready Tools
tools.alert = __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.noop;

// Base Tools
tools.loggedInData = function (options) {
  options = options || {};
  options.success = options.success || function (loggedInData) {
    console.log('loggedInData', loggedInData);
  };
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };

  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/people/detail').then(function (response) {
    var loggedInData = response && response.data && response.data.data && response.data.data.user || {};

    __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.data = loggedInData;
    __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.organization = {};

    var godRoleItem = __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.find(loggedInData.global_roles, function (roleItem) {
      return roleItem.role_id === 13;
    });

    if (godRoleItem) {
      __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.isGod = true;
    }

    if (loggedInData.organization_roles && loggedInData.organization_roles.length > 0) {
      for (var i = 0; i < loggedInData.organization_roles.length; i++) {
        var orgLabelKey = 'id-' + loggedInData.organization_roles[i].id;

        if (!__WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.organization[orgLabelKey]) {
          __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.organization[orgLabelKey] = {};
        }

        __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.organization[orgLabelKey]['role-' + loggedInData.organization_roles[i].role_id] = true;

        if (loggedInData.organization_roles[i].role_id === 14) {
          __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.isOrgAdmin = true;

          __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state.organization[orgLabelKey].isAdmin = true;
        }
      }
    }

    options.success({
      state: __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state,
      data: __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.data
    });
  }).catch(options.error);
};

tools.signOut = function (options) {
  options = options || {};
  options.success = options.success || function (logoutData) {
    console.log('logoutData', logoutData);
  };
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };
  options.skipAPIlogout = options.skipAPIlogout || false;

  var skipAPIlogout = options.skipAPIlogout;

  function resetAuthData(logoutData) {
    delete __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.defaults.headers.common['Authorization'];
    delete window.localStorage['prolific_authorization'];
    delete window.localStorage['prolific_authorization_isGod'];
    __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.loggedIn = false;
    __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.state = {};
    __WEBPACK_IMPORTED_MODULE_1__global_settings_js__["a" /* default */].authorization.data = {};

    options.success(logoutData);
  }

  if (skipAPIlogout) {
    resetAuthData();
  } else {
    __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/logout').then(function (response) {
      var logoutData = response && response.data && response.data.data || {};

      resetAuthData(logoutData);
    }).catch(options.error);
  }
};

tools.setupFroalaConfig = function (additionalConfig) {
  additionalConfig = additionalConfig || {};

  var resultingConfig = __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* default */].default.froala, additionalConfig);
  resultingConfig.requestHeaders = {
    Authorization: __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.defaults.headers.common['Authorization']
  };

  return resultingConfig;
};

tools.getUser = function (options) {
  options = options || {};
  options.success = options.success || function () {};
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };

  var userID = options.id;

  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/options/user', {
    params: {
      user_id: userID
    }
  }).then(function (response) {
    var userData = response && response.data && response.data.data && response.data.data.user || {};

    options.success(userData);
  }).catch(options.error);
};

tools.getOrganizationsList = function (options) {
  options = options || {};
  options.success = options.success || function () {};
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };

  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/list', {
    params: {
      page: 1,
      size: 50
    }
  }).then(function (response) {
    var organizationList = response && response.data && response.data.data && response.data.data.organizations || [];

    options.success(organizationList);
  }).catch(options.error);
};

tools.getOrganization = function (options) {
  options = options || {};
  options.success = options.success || function () {};
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };

  var organizationID = options.id;

  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/detail', {
    params: {
      organization_id: organizationID
    }
  }).then(function (response) {
    var organizationData = response && response.data && response.data.data && response.data.data.organization || {};

    options.success(organizationData);
  }).catch(options.error);
};

tools.getRolesList = function (options) {
  options = options || {};
  options.success = options.success || function () {};
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    });
  };
  options.roleType = options.roleType || 'global';

  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/options/roles', {
    params: {
      role_type: options.roleType
    }
  }).then(function (response) {
    var rolesList = response && response.data && response.data.data && response.data.data.roles || [];

    options.success(rolesList);
  }).catch(options.error);
};

/* harmony default export */ __webpack_exports__["a"] = (tools);

/***/ }),

/***/ "1Jsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('v-navigation-drawer',{staticClass:"sidenav",attrs:{"app":"app","permanent":_vm.$vuetify.breakpoint.mdAndUp,"fixed":"fixed","width":"220"}},[_c('v-layout',{staticClass:"pl-3",attrs:{"column":"column","fill-height":"fill-height","justify-space-between":"justify-space-between"}},[_c('v-list',[_c('v-list-tile',{staticClass:"logo"},[_c('h1',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":{name: "Default"},"tag":"span"}},[_c('svg',{attrs:{"width":"123","height":"29","viewbox":"0 0 123 29"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#222"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#00D732"}})])])])],1)]),_vm._l((_vm.navMainItems),function(item){return (((!item.restriction || (item.restriction === "!god" && !_vm.CR.authorization.state.isGod) || (item.restriction === "atleast-1-org" && (((_vm.CR.authorization.data && _vm.CR.authorization.data.organizations) || []).length > 0 || _vm.CR.authorization.state.isGod)) || (item.restriction === "atleast-1-org-and-not-god" && (((_vm.CR.authorization.data && _vm.CR.authorization.data.organizations) || []).length > 0 && !_vm.CR.authorization.state.isGod))) || (item.restriction === "god" && _vm.CR.authorization.state.isGod)))?_c('v-list-tile',{key:item.title,attrs:{"to":{name: item.targetState}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1):_vm._e()})],2),_c('v-layout',{attrs:{"column":"column","fill-height":"fill-height","justify-end":"justify-end"}},[_c('v-list',{staticClass:"mb-4"},[_c('v-list-tile',{attrs:{"to":{name: "Profile"}}},[_c('v-list-tile-title',[_c('v-list-tile-title',[_vm._v("Profile")])],1)],1),_c('v-list-tile',{on:{"click":function($event){_vm.CR.trigger.signOut()}}},[_c('v-list-tile-title',[_vm._v("Sign Out")])],1)],1),_c('v-list',{staticClass:"mb-3",attrs:{"dense":"dense"}},[_c('v-list-tile',{attrs:{"avatar":"avatar"}},[_c('avatar',{attrs:{"username":_vm.CR.authorization.data.fullname ? _vm.CR.authorization.data.fullname : "?"}})],1),(_vm.CR.authorization.data.email)?_c('v-list-tile',[_c('v-list-tile-title',[_c('div',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.CR.authorization.data.firstname)+" "+_vm._s(_vm.CR.authorization.data.lastname))])])],1):_vm._e()],1)],1)],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "23iP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      search: '',
      pagination: {},
      headers: [{
        text: 'Name',
        align: 'left',
        value: 'name'
      }, {
        text: 'Invention Opportunities',
        align: 'left',
        value: 'inventions_amount'
      }, {
        text: 'Submissions',
        align: 'left',
        value: 'submissions_amount'
      }, {
        text: 'Inventors',
        align: 'left',
        value: 'inventors_amount'
      }, {
        text: 'Admins',
        align: 'left',
        value: 'admins_amount'
      }],
      items: []
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].getOrganizationsList({
      success: function success(organizationList) {
        for (var i = 0; i < organizationList.length; i++) {
          var targetOrganization = organizationList[i] || {};

          component.items.push({
            id: targetOrganization.id,
            name: targetOrganization.name,
            summary: targetOrganization.summary,
            time_zone: targetOrganization.time_zone,
            inventions_amount: targetOrganization.inventions_amount,
            submissions_amount: targetOrganization.submissions_amount,
            inventors_amount: targetOrganization.inventors_amount,
            admins_amount: targetOrganization.admins_amount
          });
        }
      }
    });
  }
});

/***/ }),

/***/ "26kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEdit_vue__ = __webpack_require__("n4Bv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d8a726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEdit_vue__ = __webpack_require__("xZ7c");
function injectStyle (ssrContext) {
  __webpack_require__("Uwka")
  __webpack_require__("IFzy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00d8a726"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00d8a726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Dd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Person_vue__ = __webpack_require__("vmn8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe38e02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Person_vue__ = __webpack_require__("kJPl");
function injectStyle (ssrContext) {
  __webpack_require__("JkBQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fe38e02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Person_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe38e02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Person_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3C/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/ND":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidePanel__ = __webpack_require__("iERt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'side-panel': __WEBPACK_IMPORTED_MODULE_3__SidePanel__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      seen: false,
      inventionsListToggle: 0,
      headers: [{
        text: '',
        align: 'left',
        value: 'comments_count'
      }, {
        text: 'Name',
        align: 'left',
        value: 'title'
      }, { text: 'Status', value: 'phase', align: 'left' }, { text: 'Role', value: 'role', align: 'left' }, { text: 'Opportunity', value: 'opportunity.title', align: 'left' }, { text: 'Updated', value: 'updated_time' }, { text: ' ', value: 'phase' }],
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        state: {
          sidepanel: {
            tab: 'tab-1'
          },
          list: {
            baseCount: 20
          },
          selected: {
            invention: {
              active: false,
              details: false,
              data: {}
            }
          },
          infiniteScroll: {
            inventionsList: {
              increment: 10,
              throttle: 500,
              active: false,
              lock: false,
              lastCount: -1
            }
          }
        },
        data: {
          inventions: []
        },
        filters: {
          selected: {
            organization_id: null,
            user_role: null,
            phase: null
          },
          list: {
            organizations: [],
            user_roles: [{
              label: 'Inventor',
              value: 'inventor'
            }, {
              label: 'Co-inventor',
              value: 'co_inventor'
            }, {
              label: 'Mentor/Expert',
              value: 'mentor'
            }],
            phases: [{
              label: 'Concept',
              value: 'phase-1'
            }, {
              label: 'Invention Brief',
              value: 'phase-2'
            }, {
              label: 'Invention Full',
              value: 'phase-3'
            }, {
              label: 'Invention Review',
              value: 'phase-4'
            }, {
              label: 'Invention Complete',
              value: 'phase-5'
            }]
          }
        },
        form: {
          selected: {
            invention_id: null,
            invention: {
              title: '',
              description: '',
              search_list: '',
              keywords: '',
              search_results: '',
              action: '',
              action_note: '',
              search: [],
              $search: {
                title: '',
                url: '',
                note: '',
                tag: ''
              },
              uploaded_filename: '',
              invention_opportunity_id: null,
              organization_id: null,
              bulk_read_access: null
            },
            $collaborator: {
              $item: null,
              access: null
            },
            scratchpad: '',
            co_inventors: [],
            upload: null,
            comments: {
              $list: [],
              content: ''
            }
          },
          trigger: {
            setSelected: function setSelected(inventionDataItem, targetSidePanelTab) {
              var component = _this;

              component.C.state.sidepanel.tab = targetSidePanelTab || 'tab-1';

              if (inventionDataItem) {
                component.C.form.selected.invention_id = inventionDataItem.id;
                component.C.form.selected.invention.title = inventionDataItem.title;
                component.C.form.selected.invention.description = inventionDataItem.description;
                component.C.form.selected.invention.search_list = inventionDataItem.search_list || '';
                component.C.form.selected.invention.keywords = inventionDataItem.keywords || '';
                component.C.form.selected.invention.search_results = inventionDataItem.search_results || '';
                component.C.form.selected.invention.action = inventionDataItem.action;
                component.C.form.selected.invention.action_note = inventionDataItem.action_note;
                component.C.form.selected.invention.search = inventionDataItem.searches; // ### Incomplete
                component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename;

                var targetOpportunityID = inventionDataItem.opportunity && inventionDataItem.opportunity.id;
                if (targetOpportunityID === -1) {
                  component.C.form.selected.invention.invention_opportunity_id = '$other';
                } else {
                  component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID;
                }

                component.C.form.selected.invention.organization_id = inventionDataItem.organization && inventionDataItem.organization.id;
                component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null;
                component.C.form.selected.scratchpad = inventionDataItem.scratchpad && inventionDataItem.scratchpad.content || '';

                component.C.form.selected.co_inventors = [];

                for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                  component.C.form.selected.co_inventors.push({
                    $name: (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname) + ' ' + (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname),
                    user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                    access: inventionDataItem.co_inventors[i].access
                  });
                }

                component.C.form.selected.comments.$list = inventionDataItem.comments;
              } else {
                component.C.form.selected.invention_id = null;
                component.C.form.selected.invention.title = '';
                component.C.form.selected.invention.description = '';
                component.C.form.selected.invention.search_list = '';
                component.C.form.selected.invention.keywords = '';
                component.C.form.selected.invention.search_results = '';
                component.C.form.selected.invention.action = '';
                component.C.form.selected.invention.action_note = '';
                component.C.form.selected.invention.search = [];
                component.C.form.selected.invention.$search.title = '';
                component.C.form.selected.invention.$search.url = '';
                component.C.form.selected.invention.$search.note = '';
                component.C.form.selected.invention.$search.tag = '';
                component.C.form.selected.invention.uploaded_filename = '';
                component.C.form.selected.invention.invention_opportunity_id = null;
                component.C.form.selected.invention.organization_id = null;
                component.C.form.selected.invention.bulk_read_access = null;
                component.C.form.selected.scratchpad = '';

                component.C.form.selected.co_inventors = [];

                component.C.form.selected.comments.$list = [];
              }

              component.C.form.selected.$collaborator.$item = null;
              component.C.form.selected.$collaborator.access = null;
              component.C.form.selected.upload = null;

              component.C.form.error.active = false;
              component.C.form.error.type = null;
            }
          },
          error: {
            active: false,
            type: null
          }
        },
        trigger: {
          refreshBaseData: function refreshBaseData(options) {
            var component = _this;

            __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/list', {
              params: {
                page: 1,
                size: component.C.state.list.baseCount,
                title: component.C.filters.selected.title,
                organization_id: component.C.filters.selected.organization_id,
                user_role: component.C.filters.selected.user_role,
                phase: component.C.filters.selected.phase,
                sort_column: 'updated_time',
                sort_order: 'desc'
              }
            }).then(function (response) {
              var inventionsList = response && response.data && response.data.data && response.data.data.inventions || [];

              component.C.data.inventions = inventionsList;

              component.C.state.infiniteScroll.inventionsList.active = false;

              if (inventionsList.length === component.C.state.infiniteScroll.inventionsList.lastCount) {
                component.C.state.infiniteScroll.inventionsList.lock = true;
              } else {
                component.C.state.infiniteScroll.inventionsList.lastCount = inventionsList.length;
              }

              console.info('component.C.data.inventions', component.C.data.inventions);
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          },
          toggleAddInventionPanel: function toggleAddInventionPanel() {
            var component = _this;

            component.C.form.trigger.setSelected();

            component.C.state.selected.invention.active = !component.C.state.selected.invention.active;
            component.C.state.selected.invention.details = false;
          },
          selectInvention: function selectInvention(invention, forceSidePanel, targetSidePanelTab) {
            var component = _this;

            if ((invention.phase === 'phase-2' || invention.phase === 'phase-3' || invention.phase === 'phase-4' || invention.phase === 'phase-5') && !forceSidePanel) {
              component.$router.push({
                name: 'InventionSolution',
                params: {
                  id: invention.id
                }
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/detail', {
                params: {
                  invention_id: invention.id
                }
              }).then(function (response) {
                var inventionItem = response && response.data && response.data.data && response.data.data.invention || {};
                var isEditable = response && response.data && response.data.data && response.data.data.is_editable || false;

                component.C.form.trigger.setSelected(inventionItem, targetSidePanelTab);

                component.C.state.selected.invention.active = true;
                component.C.state.selected.invention.details = true;
                component.C.state.selected.invention.data = inventionItem;
                component.C.state.selected.invention.isEditable = isEditable;
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        },
        event: {
          extendInventionsList: function extendInventionsList() {
            var component = _this;

            if (!component.C.state.infiniteScroll.inventionsList.lock) {
              component.C.state.infiniteScroll.inventionsList.active = true;

              component.C.state.list.baseCount += component.C.state.infiniteScroll.inventionsList.increment;
              component.C.trigger.refreshBaseData();
            }
          }
        },
        dictionary: {
          phase: {
            'phase-1': 'Concept',
            'phase-2': 'Invention Brief',
            'phase-3': 'Invention Full',
            'phase-4': 'Invention Review',
            'phase-5': 'Invention Complete'
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    component.C.trigger.refreshBaseData();
  }
});

/***/ }),

/***/ "4Buq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4q66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      headers: [{
        text: 'Name',
        align: 'left',
        value: 'name'
      }, { text: 'Drafts', value: 'drafts', align: 'left' }, { text: 'Inventions', value: 'inventions', align: 'left' }, { text: 'Organizations', value: 'organizations' }],
      items: [],
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        filters: {
          selected: {
            name: '',
            organization_id: null,
            status: null
          },
          list: {
            organizations: [],
            globalStatuses: [{
              label: 'Enabled',
              value: 'Active'
            }, {
              label: 'Suspended',
              value: 'Suspended'
            }, {
              label: 'Archived',
              value: 'Delete'
            }]
          }
        },
        trigger: {
          reset: function reset(options) {
            var component = _this;

            options = options || {};

            var filters = options.filters || {};

            var submitItem = {
              page: 1,
              size: 50
            };

            submitItem.name = filters.name || null;
            submitItem.organization_id = filters.organization_id || null;
            submitItem.status = filters.status || null;

            __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/options/users', {
              params: submitItem
            }).then(function (response) {
              var peopleList = response && response.data && response.data.data && response.data.data.users || [];

              component.items = [];

              for (var i = 0; i < peopleList.length; i++) {
                var targetPerson = peopleList[i] || {};

                _this.items.push({
                  id: targetPerson.id,
                  name: '' + (targetPerson.firstname && targetPerson.lastname ? targetPerson.firstname + ' ' + targetPerson.lastname : targetPerson.firstname || targetPerson.lastname ? targetPerson.firstname || targetPerson.lastname : ''),
                  organizations: targetPerson.organizations,
                  status: targetPerson.status,
                  drafts_amount: targetPerson.drafts_amount,
                  inventions_amount: targetPerson.inventions_amount
                });
              }

              component.C.filters.selected.name = submitItem.name;
              component.C.filters.selected.organization_id = submitItem.organization_id;
              component.C.filters.selected.status = submitItem.status;
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          }
        },
        dictionary: {
          status: {
            'Active': 'Enabled',
            'Delete': 'Archived',
            'Suspend': 'Suspended'
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    this.C.trigger.reset();

    __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].loggedInData({
      success: function success(loggedInItem) {
        if (component.CR.authorization.state.isGod || component.CR.authorization.state.isOrgAdmin) {
          component.headers.push({
            text: 'Status',
            value: 'status'
          });
        }

        __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getOrganizationsList({
          success: function success(organizationList) {
            component.C.filters.list.organizations = organizationList;
          }
        });
      },
      error: function error(errorResponse) {
        __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
          type: 'error',
          errorResponse: errorResponse
        });
      }
    });
  }
});

/***/ }),

/***/ "4xKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solution_vue__ = __webpack_require__("FxNq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d1da40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Solution_vue__ = __webpack_require__("fu9I");
function injectStyle (ssrContext) {
  __webpack_require__("SBZq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33d1da40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d1da40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Solution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4xcO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "56q3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "58+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('h2',[_vm._v("All Organizations")])])],1),_c('v-spacer'),_c('v-btn',{staticClass:"page-header__action",attrs:{"to":"/organizations/add","exact":"","color":"primary"}},[_vm._v("Add")])],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":_vm.$vuetify.breakpoint.smAndUp,"column":_vm.$vuetify.breakpoint.smAndDown,"nowrap":"nowrap"}},[_c('v-flex',{staticClass:"content--main pr-4"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"hide-actions":"hide-actions"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{attrs:{"width":"40%"}},[_c('router-link',{attrs:{"to":("/organizations/organization/" + (props.item.id))}},[_vm._v(_vm._s(props.item.name))])],1),_c('td',[_vm._v(_vm._s(props.item.inventions_amount))]),_c('td',[_vm._v(_vm._s(props.item.submissions_amount))]),_c('td',[_vm._v(_vm._s(props.item.inventors_amount))]),_c('td',[_vm._v(_vm._s(props.item.admins_amount))])]}}])})],1),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block pt-4",staticStyle:{"width":"220px","position":"fixed"}},[_c('div',{staticClass:"body-1 mb-0",staticStyle:{"position":"absolute","top":"10px"}},[_vm._v("Search:")]),_c('v-text-field',{staticClass:"input--box",attrs:{"append-icon":"search","label":"Search","single-line":"single-line","hide-details":"hide-details","clearable":"clearable"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5nnI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ADBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/organizations"}},[_c('h2',[_vm._v("All Organizations")])])],1),_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.C.data.organization.name))])])],1),_c('v-spacer'),_c('v-btn',{attrs:{"to":("/organizations/organization/" + (_vm.C.data.organization.id) + "/edit"),"exact":"","color":"primary"}},[_vm._v("Edit")]),(_vm.CR.show.unreleased)?_c('v-dialog',{attrs:{"persistent":"","max-width":"320"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","outline":"outline","color":"error"},slot:"activator"},[_vm._v("Remove Org")]),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to remove"),_c('strong',[_vm._v(_vm._s(_vm.C.data.organization.name))]),_vm._v("?")]),_c('v-card-text',[_vm._v("This action cannot be undone")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"error","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Yes, remove this organization")])],1)],1)],1):_vm._e()],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',[_c('div',{staticClass:"pb-3"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Organization Name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.organization.name))])])],1),(_vm.C.data.organization.business_address)?_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Business Address")])]):_vm._e(),(_vm.C.data.organization.business_address.street1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.organization.business_address.street1))]),(_vm.C.data.organization.business_address.street2)?_c('p',[_vm._v(_vm._s(_vm.C.data.organization.business_address.street2))]):_vm._e()])],1):_vm._e(),(_vm.C.data.organization.business_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.organization.business_address.state_province))])])],1):_vm._e(),(_vm.C.data.organization.business_address.city)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.organization.business_address.city))])])],1):_vm._e(),(_vm.C.data.organization.business_address.country)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.organization.business_address.country] && _vm.C.list.countries[_vm.C.data.organization.business_address.country].name))])])],1):_vm._e(),_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Admins")])]),_vm._l((_vm.C.data.organization.administrators_statuses),function(admin){return _c('v-layout',{key:admin.id,staticClass:"mb-3",attrs:{"row":"row","align-center":"align-center"}},[_c('avatar',{staticClass:"avatar--admin ml-0",attrs:{"username":admin.user_name,"size":48}}),_c('v-flex',{staticClass:"pl-3"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('h3',{staticClass:"ma-0"},[_vm._v(_vm._s(admin.user_name))])]),(admin.title)?_c('p',{staticClass:"ma-0"},[_c('label'),_vm._v(_vm._s(admin.title))]):_vm._e(),(admin.phone)?_c('p',{staticClass:"ma-0"},[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('label'),_vm._v(_vm._s(admin.phone))]):_vm._e()],1)],1)],1)})],2)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AG2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordSignIn_vue__ = __webpack_require__("IKM8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ece2b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordSignIn_vue__ = __webpack_require__("Gar8");
function injectStyle (ssrContext) {
  __webpack_require__("uvjK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ece2b0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordSignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ece2b0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordSignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BGMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants = {
  default: {
    froala: {
      key: '' + "nA4D2E2D1wG1G1B1B3B1D7D5E1D4A3jB-22qE-13sxG3mlp==",
      imageUploadURL: '' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/download_files/upload',
      imageUploadMethod: 'PUT',
      toolbarInline: true,
      charCounterCount: false,
      toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'help', 'html', '|', 'undo', 'redo']
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),

/***/ "BJ8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"py-4 px-5 presentation elevation-4"},[_c('v-toolbar',{staticClass:"editor__nav px-3",attrs:{"app":"app","fixed":"fixed","clipped-left":true,"clipped-right":true}},[_c('v-btn',{staticClass:"hidden-xs-only transparent",attrs:{"to":{name: "InventionSolution", params: {id: this.$route.params.id}},"flat":"flat","color":"secondary","icon":"icon"}},[_c('v-icon',{attrs:{"medium":"medium"}},[_vm._v("keyboard_arrow_left")])],1),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.C.data.invention.title)),_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[(_vm.C.data.invention.phase)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check_circle")]),_c('p',{staticClass:"body-2 mb-0 mr-3 ml-1"},[_vm._v(_vm._s(_vm.C.dictionary.phase[_vm.C.data.invention.phase]))])],1)],1):_vm._e(),_vm._l((_vm.C.data.invention.co_inventors),function(inventor){return _c('v-flex',{key:inventor.id},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("people")]),_c('p',{staticClass:"body-2 mb-0 mr-3 ml-1"},[_vm._v(_vm._s(inventor.user.fullname))])],1)],1)}),(_vm.C.data.invention.bulk_read_access)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("chat_bubble")]),_vm._v(_vm._s((_vm.C.data.invention.bulk_read_access && _vm.C.dictionary.bulk_read_access[_vm.C.data.invention.bulk_read_access]) ? _vm.C.dictionary.bulk_read_access[_vm.C.data.invention.bulk_read_access] : _vm.C.data.invention.bulk_read_access))],1)])],1):_vm._e(),(_vm.C.data.invention.role)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("person")]),_vm._v(_vm._s(_vm.C.data.invention.role))],1)])],1):_vm._e(),(_vm.C.data.invention.opportunity)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("add_to_photos")]),_vm._v(_vm._s(_vm.C.data.invention.opportunity && _vm.C.data.invention.opportunity.title))],1)])],1):_vm._e()],2)],1),_c('v-spacer'),(_vm.CR.show.unreleased)?_c('v-btn',{attrs:{"color":"primary","dark":"dark"}},[_vm._v("Print"),_c('v-icon',{attrs:{"right":"right","dark":"dark"}},[_vm._v("print")])],1):_vm._e(),_c('v-btn',{attrs:{"color":"primary","dark":"dark"},on:{"click":function($event){_vm.C.trigger.exportDocument()}}},[_vm._v("Export"),_c('v-icon',{attrs:{"right":"right","dark":"dark"}},[_vm._v("cloud_download")])],1),_c('v-btn',{attrs:{"to":{name: "InventionSolution", params: {id: this.$route.params.id}},"color":"secondary","dark":"dark"}},[_vm._v("Edit"),_c('v-icon',{attrs:{"right":"right","dark":"dark"}},[_vm._v("mode_edit")])],1)],1),_c('div',{staticStyle:{"font-family":"‘Source Sans Pro’, Helvetica, Arial, sans-serif"},attrs:{"id":"js-invention-document"}},[_c('v-layout',{staticClass:"pb-4",attrs:{"row":"row","nowrap":"nowrap","align-center":"align-center","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-3"},[_vm._v("Solution Report – Detailed Disclosure")]),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.C.data.invention.title))]),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.C.data.invention.opportunity && _vm.C.data.invention.opportunity.title))])]),_c('img',{attrs:{"src":__webpack_require__("sr+C")}})],1),_c('v-divider'),_c('ol',{staticClass:"presentation--list mt-4",attrs:{"type":"I"}},[_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("Specific Problem Being Addressed")]),_c('section',[_c('div',{staticClass:"d-inline"},[(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.problem_summary.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.gap.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.problem_significance.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.problem_summary.content || _vm.C.form.selected.invention.container_section.gap.content || _vm.C.form.selected.invention.container_section.problem_significance.content))?_c('no-content'):_vm._e()],1)])]),_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("Summary of the Solution (Maximum of 150 words)")]),_c('section',[_c('div',{staticClass:"d-inline"},[(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.summary.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.significance.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.draw.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.summary.content || _vm.C.form.selected.invention.container_section.significance.content || _vm.C.form.selected.invention.container_section.draw.content))?_c('no-content'):_vm._e()],1)])]),_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("Technical Landscape and Comparative Advantages of your Solution")]),_c('section',{staticClass:"pl-4"},[_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Landscape")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.landscape.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.landscape.content))?_c('no-content'):_vm._e(),_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Innovative Aspects")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content))?_c('no-content'):_vm._e(),(_vm.C.form.selected.invention.container_section.c_comparativeadvantages && _vm.C.form.selected.invention.container_section.c_comparativeadvantages.components)?_c('div',[_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Current Technologies")]),_vm._l((_vm.C.form.selected.invention.container_section.c_comparativeadvantages.components),function(component,componentIndex){return _c('section',{key:componentIndex,staticClass:"pl-4",attrs:{"id":("comparativeadvantages-" + componentIndex)}},[_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v(_vm._s(component.type))]),_c('div',{staticClass:"d-inline"},[(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(component.items.competing_howworks.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(component.items.shortcomings.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(component.items.howovercomes_shortcomings.content)}}):_vm._e(),(!(component.items.competing_howworks.content || component.items.shortcomings.content || component.items.howovercomes_shortcomings.content))?_c('no-content'):_vm._e()],1)])})],2):_vm._e(),_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Comparative Advantages Summary")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content))?_c('no-content'):_vm._e(),_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Relevant Background")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content))?_c('no-content'):_vm._e()],1)]),_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("Details of the Invention")]),(_vm.C.form.selected.invention.container_section.c_construction && _vm.C.form.selected.invention.container_section.c_construction.components)?_c('div',_vm._l((_vm.C.form.selected.invention.container_section.c_construction.components),function(component,componentIndex){return _c('section',{key:componentIndex,staticClass:"pl-4",attrs:{"id":("construction-" + componentIndex)}},[_c('div',{staticClass:"subheading mb-0 text--capitalize",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v(_vm._s(component.type))]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.ideal_example.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.properties.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.how_made.content)}}):_vm._e(),(!(component.items.ideal_example.content || component.items.properties.content || component.items.how_made.content))?_c('no-content'):_vm._e()],1)})):_vm._e(),_c('section',[_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("How is it used?")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.construction_howused.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.construction_howused.content))?_c('no-content'):_vm._e(),(_vm.C.form.selected.invention.container_section.construction_prototype.content)?_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Prototype")]):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.construction_prototype.content)}}):_vm._e(),_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Economics")]),_c('div',{staticClass:"d-inline"},[(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_need.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_enduser.content)}}):_vm._e()]),_c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"mb-3"}),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_keyresources.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_capitalexpenditure.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical.content)}}):_vm._e()]),_c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"mb-3"}),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_whomake.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_howmakemoney.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_howdelivered.content)}}):_vm._e()]),_c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"mb-3"}),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_economicburden.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts.content)}}):_vm._e(),(!_vm.C.state.isEditable)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_consumercosts.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.economics_need.content || _vm.C.form.selected.invention.container_section.economics_enduser.content || _vm.C.form.selected.invention.container_section.economics_keyresources.content || _vm.C.form.selected.invention.container_section.economics_capitalexpenditure.content || _vm.C.form.selected.invention.container_section.economics_feasiblyeconomical.content || _vm.C.form.selected.invention.container_section.economics_whomake.content || _vm.C.form.selected.invention.container_section.economics_howmakemoney.content || _vm.C.form.selected.invention.container_section.economics_howdelivered.content || _vm.C.form.selected.invention.container_section.economics_economicburden.content || _vm.C.form.selected.invention.container_section.economics_currentsolutioncosts.content || _vm.C.form.selected.invention.container_section.economics_consumercosts.content))?_c('no-content'):_vm._e()],1)],1)]),_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("Considerations for Commercialization")]),_c('section',{staticClass:"pl-4"},[_c('ol',[_vm._m(0),_c('li',[_vm._m(1),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.specificquestions.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.specificquestions.content))?_c('no-content'):_vm._e()],1),_vm._m(2),(_vm.C.form.selected.invention.container_section.c_development && _vm.C.form.selected.invention.container_section.c_development.components)?_c('div',_vm._l((_vm.C.form.selected.invention.container_section.c_development.components),function(component,componentIndex){return _c('div',{key:componentIndex,staticClass:"mb-4",attrs:{"id":("development-" + componentIndex)}},[_c('div',{staticClass:"subheading mb-0",staticStyle:{"font-size":"16px","font-weight":"600"}},[_vm._v("Milestone "+_vm._s((componentIndex + 1))+": "+_vm._s(component.type))]),_c('ul',{staticClass:"milestone--list"},[_c('li',[_c('strong',[_vm._v("Key Points:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.key_points.content)}}):_vm._e(),(!(component.items.key_points.content))?_c('no-content'):_vm._e()],1),_c('li',[_c('strong',[_vm._v("Resources Needed:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.resources_needed.content)}}):_vm._e(),(!(component.items.resources_needed.content))?_c('no-content'):_vm._e()],1),_c('li',[_c('strong',[_vm._v("Deliverables:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.deliverables.content)}}):_vm._e(),(!(component.items.deliverables.content))?_c('no-content'):_vm._e()],1),_c('li',[_c('strong',[_vm._v("Measure of Success:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.measure_of_success.content)}}):_vm._e(),(!(component.items.measure_of_success.content))?_c('no-content'):_vm._e()],1),_c('li',[_c('strong',[_vm._v("Key Risks:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.key_risks.content)}}):_vm._e(),(!(component.items.key_risks.content))?_c('no-content'):_vm._e()],1),_c('li',[_c('strong',[_vm._v("Suggested Approach:")]),(!_vm.C.state.isEditable)?_c('div',{staticClass:"d-inline ml-2",domProps:{"innerHTML":_vm._s(component.items.suggested_approach.content)}}):_vm._e(),(!(component.items.suggested_approach.content))?_c('no-content'):_vm._e()],1)])])})):_vm._e(),_vm._m(3)])])]),_c('li',[_c('h1',{staticClass:"d-inline-block mb-3 pl-1",staticStyle:{"font-size":"21px","font-weight":"600"}},[_vm._v("References")]),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.references.content)}}):_vm._e(),(!(_vm.C.form.selected.invention.container_section.references.content))?_c('no-content'):_vm._e()],1)])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('p',[_c('em',[_vm._v("What technical gaps must be filled in order to turn your solution into a product?  For each, please estimate when a practical solution will become available.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("Many RFIs have specific considerations for commercialization, found in a dedicated section within the RFI (next to “Invention Suggestions.”)  Refer to the RFI for detailed instructions and any RFI-specific questions.  If there are none, proceed to item 3.(For reference, example considerations may include: estimate the bulk cost of critical components or materials; estimate the time horizon when technology gaps will be filled.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('p',[_c('em',[_vm._v("What key milestones would you recommend for a project to demonstrate proof of concept for your solution?")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('p',[_c('em',[_vm._v("Are you interested in participating in a project to demonstrate proof of concept if the idea is selected? __yes  ___no.  If yes, please briefly describe your related expertise and any access facilities that could support the project.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CPr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__("r7Z3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0fc3bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__("1Jsw");
function injectStyle (ssrContext) {
  __webpack_require__("4xcO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e0fc3bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0fc3bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D2iW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      loader: null,
      loading: false,
      email: '',
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      },
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        state: {
          isLoggingIn: false,
          emailSent: false,
          magicLinkAttempt: false
        },
        form: {
          selected: {
            account: {
              email: ''
            }
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                email: _this.C.form.selected.account.email
              };

              component.C.state.isLoggingIn = true;

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/resend_magic_link', submitItem).then(function (response) {
                console.info('Magic Link Resend Magic Link Results: ', response.data);

                if (response.data.code === 200) {
                  component.C.state.emailSent = true;
                } else {
                  component.C.error.active = true;
                  component.C.error.message = 'E-mail failed to be sent.  Please try again.';
                }

                component.C.state.isLoggingIn = false;
              }).catch(function (errorResponse) {
                console.error('errorResponse', errorResponse);

                component.C.state.isLoggingIn = false;
              });
            },
            signin: function signin(magicLink) {
              var component = _this;

              var submitItem = {
                magic_link: magicLink
              };

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/login', submitItem).then(function (response) {
                var userData = response.data && response.data.data && response.data.data.user;

                console.info('Magic Link Sign In Results: ', {
                  response: response,
                  userData: userData
                });

                if (userData) {
                  __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.defaults.headers.common['Authorization'] = userData.access_token;
                  window.localStorage.prolific_authorization = userData.access_token;
                  __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].authorization.loggedIn = true;
                  __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].loggedInData({
                    success: function success(loggedInItem) {
                      window.localStorage.prolific_authorization_isGod = loggedInItem.state.isGod && 'yes' || 'no';

                      if (loggedInItem.state.isGod) {
                        component.$router.push({
                          name: 'People'
                        });
                      } else {
                        component.$router.push({
                          name: 'Inventions'
                        });
                      }
                    }
                  });
                } else {
                  component.C.state.magicLinkAttempt = false;

                  component.C.error.active = true;
                  component.C.error.message = 'Sign in has failed.  Please try again.';
                }
              }).catch(function (errorResponse) {
                console.error('errorResponse', errorResponse);

                component.C.state.magicLinkAttempt = false;

                component.C.error.active = true;
                component.C.error.message = 'Sign in has failed.  Please try again.';
              });
            }
          }
        },
        error: {
          active: false,
          message: ''
        }
      }
    };
  },
  created: function created() {
    if (this.$route.query.magic_link) {
      this.C.state.magicLinkAttempt = true;

      this.C.form.trigger.signin(this.$route.query.magic_link);
    }
  },

  watch: {
    loader: function loader() {
      var _this2 = this;

      var l = this.loader;
      this[l] = !this[l];

      setTimeout(function () {
        return _this2[l] = false;
      }, 3000);

      this.loader = null;
    }
  }
});

/***/ }),

/***/ "DPPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opportunities_vue__ = __webpack_require__("Wuqw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16733676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Opportunities_vue__ = __webpack_require__("p/LL");
function injectStyle (ssrContext) {
  __webpack_require__("nDc0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16733676"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opportunities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16733676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Opportunities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DRNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {}
});

/***/ }),

/***/ "Docm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"fill-height"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{attrs:{"md6":"md6","offset-md3":"offset-md3"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Create an Account")])]),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"Name","required":""},model:{value:(_vm.C.form.selected.account.name),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "name", $$v)},expression:"C.form.selected.account.name"}}),_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.C.form.selected.account.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "email", $$v)},expression:"C.form.selected.account.email"}}),_c('v-text-field',{attrs:{"label":"Password","type":"password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.C.form.selected.account.password),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "password", $$v)},expression:"C.form.selected.account.password"}}),_c('v-text-field',{attrs:{"label":"Confirm password","type":"password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.C.form.selected.account.confirm_password),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "confirm_password", $$v)},expression:"C.form.selected.account.confirm_password"}})],1)],1),_c('v-card-text',[_c('v-btn',{staticClass:"cyan",attrs:{"block":"block","large":"large","color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v("Sign up")])],1)],1),_c('p',{staticClass:"pa-3 text-xs-center"},[_vm._v("Have a login? "),_c('router-link',{attrs:{"to":"signin"}},[_vm._v("Login here")]),_vm._v(".")],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dqi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("yCdV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4cefa30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("wOh1");
function injectStyle (ssrContext) {
  __webpack_require__("5nnI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4cefa30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4cefa30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ECAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organization_vue__ = __webpack_require__("0kct");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_def338d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Organization_vue__ = __webpack_require__("ADBA");
function injectStyle (ssrContext) {
  __webpack_require__("rI/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-def338d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_def338d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Organization_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EL0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Empj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Uv+0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd9cf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("sc+C");
function injectStyle (ssrContext) {
  __webpack_require__("ZHDH")
  __webpack_require__("Xmqe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8dd9cf0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dd9cf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EopR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F8d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MagicSignIn_vue__ = __webpack_require__("D2iW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332f35ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MagicSignIn_vue__ = __webpack_require__("Z6j3");
function injectStyle (ssrContext) {
  __webpack_require__("EL0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-332f35ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MagicSignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332f35ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MagicSignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FxNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicTooltip__ = __webpack_require__("cdjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompletionCheck__ = __webpack_require__("bTge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js__ = __webpack_require__("yiUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_avatar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













function froalaContentChangeAutosave(component, targetAutosave) {
  if (component.C.state.initialized) {
    clearTimeout(component.C.timer.autoSave);

    component.C.state.autoSave[targetAutosave] = true;

    component.C.timer.autoSave = setTimeout(function () {
      function autoSaveContainers(callback) {
        component.C.form.trigger.updateAllContainerSections(function (responseData) {
          var containerSectionItem = responseData && responseData.data && responseData.data.invention && responseData.data.invention.container_section || {};
          containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
            components: []
          };
          containerSectionItem.c_construction = containerSectionItem.c_construction || {
            components: []
          };
          containerSectionItem.c_development = containerSectionItem.c_development || {
            components: []
          };

          for (var i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
            var componentItem = containerSectionItem.c_comparativeadvantages.components[i];

            if (component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i] && !component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i].id) {
              component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i].id = componentItem.id;
            }
          }

          for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
            componentItem = containerSectionItem.c_construction.components[i];

            if (component.C.form.selected.invention.container_section.c_construction.components[i] && !component.C.form.selected.invention.container_section.c_construction.components[i].id) {
              component.C.form.selected.invention.container_section.c_construction.components[i].id = componentItem.id;
            }
          }

          for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
            componentItem = containerSectionItem.c_development.components[i];

            if (component.C.form.selected.invention.container_section.c_development.components[i] && !component.C.form.selected.invention.container_section.c_development.components[i].id) {
              component.C.form.selected.invention.container_section.c_development.components[i].id = componentItem.id;
            }
          }

          callback();
        }, true);
      }
      function autoSaveScratchpad(callback) {
        component.C.form.trigger.saveSidePanelItems(function (response) {
          var inventionDataItem = response && response.data && response.data.invention || {};

          component.C.form.selected.invention.search = inventionDataItem.searches;

          callback();
        }, true);
      }

      function autoSaveComplete() {
        component.C.form.state.recentSaveActive = true;

        clearTimeout(component.C.timer.saveIndicator);

        component.C.timer.saveIndicator = setTimeout(function () {
          component.C.form.state.recentSaveActive = false;
        }, 5000);

        component.C.state.autoSave.containers = false;
        component.C.state.autoSave.scratchpad = false;
      }

      if (component.C.state.autoSave.containers && component.C.state.autoSave.scratchpad) {
        autoSaveContainers(function () {
          autoSaveScratchpad(function () {
            autoSaveComplete();
          });
        });
      } else if (component.C.state.autoSave.containers) {
        autoSaveContainers(function () {
          autoSaveComplete();
        });
      } else if (component.C.state.autoSave.scratchpad) {
        autoSaveScratchpad(function () {
          autoSaveComplete();
        });
      }
    }, 2000);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_7_vue_avatar___default.a,
    'basic-tooltip': __WEBPACK_IMPORTED_MODULE_1__BasicTooltip__["a" /* default */],
    'completion-check': __WEBPACK_IMPORTED_MODULE_2__CompletionCheck__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__["a" /* default */].show,
        trigger: {
          signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].signOut({
              success: function success() {
                _this.$router.push({
                  name: 'MagicSignIn'
                });
              }
            });
          }
        }
      },
      C: {
        config: {
          containerSections: []
        },
        timer: {
          autoSave: null,
          saveIndicator: null
        },
        state: {
          initialized: false,
          isEditable: false,
          autoSave: {
            containers: false,
            scratchpad: false
          },
          tab: {
            checklist: {
              active: null,
              item: null
            },
            inventionNotesSidepanel: {
              active: null,
              item: 'tab-commments'
            },
            construction: {
              active: null,
              item: null
            },
            comparativeadvantages: {
              active: null,
              item: null
            },
            development: {
              active: null,
              item: null
            }
          },
          panel: {
            settings: false
          },
          dialog: {
            confirmComparativeadvantagesComponentDelete: {
              active: false
            },
            confirmConstructionComponentDelete: {
              active: false
            },
            confirmDevelopmentComponentDelete: {
              active: false
            }
          },
          container: [{
            title: 'Solution',
            phaseThreshold: 2,
            active: true,
            items: [{
              key: 'summary',
              title: 'Summary',
              href: '#solution-summary',
              includeAPI: true
            }, {
              key: 'draw',
              title: 'Draw',
              href: '#solution-draw',
              includeAPI: true
            }, {
              key: 'significance',
              title: 'Significance',
              href: '#solution-significance',
              includeAPI: true
            }]
          }, {
            title: 'Problem',
            phaseThreshold: 2,
            inactive: true,
            items: [{
              key: 'problem_summary',
              title: 'Summary',
              href: '#problem-summary',
              includeAPI: true
            }, {
              key: 'gap',
              title: 'Gap',
              href: '#problem-gap',
              includeAPI: true
            }, {
              key: 'problem_significance',
              title: 'Significance',
              href: '#problem-significance',
              includeAPI: true
            }]
          }, {
            title: 'Comparative Advantages',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'comparativeadvantages',
            items: [{
              title: 'General Info',
              href: '#comparativeadvantages-general',
              includeAPI: false,
              notComponent: true,
              subAPIitems: [{
                key: 'landscape',
                title: 'Landscape',
                href: '#comparativeadvantages_landscape',
                includeAPI: true
              }, {
                key: 'comparativeadvantages_innovativeaspects',
                title: 'Innovative Aspects'
              }, {
                key: 'comparativeadvantages_advantagessummary',
                title: 'Summary'
              }, {
                key: 'comparativeadvantages_relevantbackground',
                title: 'Relevant Background'
              }]
            }],
            navSelectTrigger: function navSelectTrigger() {
              var component = _this;

              component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base';
            }
          }, {
            title: 'Construction',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'construction',
            items: [{
              title: 'General Info',
              href: '#construction-general',
              includeAPI: false,
              notComponent: true,
              subAPIitems: [{
                key: 'construction_howused',
                title: 'How is it used?'
              }, {
                key: 'construction_prototype',
                title: 'Prototype (Optional)',
                exemptRequired: true
              }]
            }]
          }, {
            title: 'Economics',
            phaseThreshold: 3,
            inactive: true,
            items: [{
              key: 'economics_need',
              title: 'Market Need',
              href: '#economics-need',
              includeAPI: true
            }, {
              key: 'economics_enduser',
              title: 'End User',
              href: '#economics-enduser',
              includeAPI: true
            }, {
              key: 'economics_keyresources',
              title: 'Key Resources',
              href: '#economics-keyresources',
              includeAPI: true
            }, {
              key: 'economics_capitalexpenditure',
              title: 'Expenditure Requirements',
              href: '#economics-capitalexpenditure',
              includeAPI: true
            }, {
              key: 'economics_feasiblyeconomical',
              title: 'Economical Feasibility',
              href: '#economics-feasiblyeconomical',
              includeAPI: true
            }, {
              key: 'economics_whomake',
              title: 'Who',
              href: '#economics-whomake',
              includeAPI: true
            }, {
              key: 'economics_howmakemoney',
              title: 'Make Money',
              href: '#economics-howmakemoney',
              includeAPI: true
            }, {
              key: 'economics_howdelivered',
              title: 'Delivery',
              href: '#economics-howdelivered',
              includeAPI: true
            }, {
              key: 'economics_economicburden',
              title: 'Economic Burden',
              href: '#economics-economicburden',
              includeAPI: true
            }, {
              key: 'economics_currentsolutioncosts',
              title: 'Current Solution Costs',
              href: '#economics-currentsolutioncosts',
              includeAPI: true
            }, {
              key: 'economics_consumercosts',
              title: 'Customer Costs',
              href: '#economics-consumercosts',
              includeAPI: true
            }]
          }, {
            title: 'Development',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'development',
            items: []
          }, {
            title: 'Specific Questions',
            phaseThreshold: 3,
            inactive: true,
            hideItemsList: true,
            items: [{
              key: 'specificquestions',
              title: '',
              href: '#specificquestions-specificquestions',
              includeAPI: true
            }]
          }, {
            title: 'References',
            phaseThreshold: 3,
            inactive: true,
            hideItemsList: true,
            items: [{
              key: 'references',
              title: '',
              href: '#references-references',
              includeAPI: true
            }]
          }]
        },
        data: {
          invention: {}
        },
        form: {
          config: {
            froala: {
              invention: {
                description: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig({
                  events: {
                    'froalaEditor.contentChanged': function froalaEditorContentChanged() {
                      var component = _this;

                      froalaContentChangeAutosave(component, 'containers');
                    }
                  }
                }),
                scratchpad: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig({
                  events: {
                    'froalaEditor.contentChanged': function froalaEditorContentChanged() {
                      var component = _this;

                      froalaContentChangeAutosave(component, 'scratchpad');
                    }
                  }
                }),
                container_section: {
                  draw: {
                    content: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig({
                      placeholderText: '',
                      toolbarInline: false,
                      pluginsEnabled: ['image'],
                      toolbarButtons: ['insertImage'],
                      events: {
                        'froalaEditor.contentChanged': function froalaEditorContentChanged() {
                          var component = _this;

                          froalaContentChangeAutosave(component, 'containers');
                        }
                      }
                    })
                  }
                }
              }
            }
          },
          state: {
            active: {
              $search: false
            },
            dialog: {
              checklist: false
            },
            recentSaveActive: false
          },
          list: {
            constructionComponentOptions: [{
              label: 'Material',
              key: 'material'
            }, {
              label: 'Sub-Component',
              key: 'sub-component'
            }, {
              label: 'Component',
              key: 'component'
            }, {
              label: 'Device',
              key: 'device'
            }, {
              label: 'System',
              key: 'system'
            }, {
              label: 'Service',
              key: 'service'
            }],
            collaboratorAccessOptions: {
              items: [{
                label: 'Co-inventor',
                value: 1
              }, {
                label: 'Mentor/Expert',
                value: 2
              }, {
                label: 'Commenter',
                value: 3
              }],
              dictionary: {
                '1': 'Co-inventor',
                '2': 'Mentor/Expert',
                '3': 'Commenter'
              }
            },
            bulkDefaultAccessOptions: [{
              label: 'Anyone in my organization can comment',
              value: 'anyone-organization'
            }, {
              label: 'Only collaborators in my organization can comment',
              value: 'only-inventors'
            }],
            opportunities: []
          },
          validation: {
            rules: {
              invention: {
                search: {
                  title: [function (v) {
                    return !!v || 'Title is required';
                  }, function (v) {
                    return v.length < 1000 || 'You have reached the maximum limit of 1,000 characters.';
                  }],
                  general: [function (v) {
                    return v.length < 1000 || 'You have reached the maximum limit of 1,000 characters.';
                  }]
                }
              }
            }
          },
          selected: {
            invention_id: null,
            invention: {
              title: '',
              description: '',
              search_list: '',
              keywords: '',
              search_results: '',
              action: '',
              action_note: '',
              search: [],
              $search: {
                title: '',
                url: '',
                note: '',
                tag: ''
              },
              uploaded_filename: '',
              invention_opportunity_id: null,
              organization_id: null,
              bulk_read_access: null,
              container_section: {}
            },
            $collaborator: {
              $item: null,
              access: null
            },
            scratchpad: '',
            co_inventors: [],
            upload: null,
            comments: {
              $list: [],
              content: ''
            }
          },
          event: {
            typeAutoSave: function typeAutoSave() {
              var component = _this;

              froalaContentChangeAutosave(component, 'containers');
            }
          },
          trigger: {
            addSearchItem: function addSearchItem(searchItem) {
              var component = _this;

              component.C.form.selected.invention.search.push({
                title: component.C.form.selected.invention.$search.title,
                url: component.C.form.selected.invention.$search.url,
                note: component.C.form.selected.invention.$search.note,
                tag: component.C.form.selected.invention.$search.tag
              });

              component.C.form.selected.invention.$search.title = '';
              component.C.form.selected.invention.$search.url = '';
              component.C.form.selected.invention.$search.note = '';
              component.C.form.selected.invention.$search.tag = '';

              component.C.form.state.active.$search = false;

              component.C.trigger.openChecklist();
              froalaContentChangeAutosave(component, 'scratchpad');
            },
            removeSearchItem: function removeSearchItem(searchItem, searchItemIndex) {
              var component = _this;

              if (!searchItem.id) {
                component.C.form.selected.invention.search.splice(searchItemIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(searchItem, 'remove', !searchItem.remove);
                froalaContentChangeAutosave(component, 'scratchpad');
              }
            },
            addCollaboratorItem: function addCollaboratorItem() {
              var component = _this;

              if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                component.C.form.selected.co_inventors.push({
                  $isNew: true,
                  $name: component.C.form.selected.$collaborator.$item.fullname,
                  user_id: component.C.form.selected.$collaborator.$item.id,
                  access: component.C.form.selected.$collaborator.access,
                  remove: false
                });

                component.C.form.selected.$collaborator.$item = null;
                component.C.form.selected.$collaborator.access = null;
              }
            },
            removeCollaboratorItem: function removeCollaboratorItem(collaboratorItem, collaboratorIndex) {
              var component = _this;

              if (collaboratorItem.$isNew) {
                component.C.form.selected.co_inventors.splice(collaboratorIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(collaboratorItem, 'remove', !collaboratorItem.remove);
              }
            },
            selectContainerItem: function selectContainerItem(targetContainer) {
              if (targetContainer.navSelectTrigger) {
                targetContainer.navSelectTrigger();
              }
            },
            selectContainerSectionItem: function selectContainerSectionItem(targetData) {
              targetData = targetData || {};
              var item = targetData.item || {};
              var subItem = targetData.subItem || {};
              var targetIndex = targetData.index;

              var component = _this;

              if (item.componentContainerKey) {
                if (subItem.useByIndex) {
                  component.C.state.tab[item.componentContainerKey].active = item.componentContainerKey + '-' + targetIndex;
                } else {
                  component.C.state.tab[item.componentContainerKey].active = ('' + subItem.href).substr(1);
                }
              }
            },
            updateAllContainerSections: function updateAllContainerSections(callback, negateDeletion) {
              var component = _this;
              callback = callback || __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;

              var submitItem = {
                invention_id: parseInt(component.$route.params.id)
              };

              for (var i = 0; i < component.C.config.containerSections.length; i++) {
                submitItem[component.C.config.containerSections[i]] = component.C.form.selected.invention.container_section[component.C.config.containerSections[i]].content;
              }

              submitItem.c_comparativeadvantages = [];
              submitItem.c_constructions = [];
              submitItem.c_developments = [];

              for (i = 0; i < component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length; i++) {
                var currentComponent = component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i];

                submitItem.c_comparativeadvantages.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  competing_howworks: currentComponent.items.competing_howworks.content,
                  shortcomings: currentComponent.items.shortcomings.content,
                  howovercomes_shortcomings: currentComponent.items.howovercomes_shortcomings.content
                });
              }

              for (i = 0; i < component.C.form.selected.invention.container_section.c_construction.components.length; i++) {
                currentComponent = component.C.form.selected.invention.container_section.c_construction.components[i];

                submitItem.c_constructions.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  ideal_example: currentComponent.items.ideal_example.content,
                  properties: currentComponent.items.properties.content,
                  how_made: currentComponent.items.how_made.content,
                  innovative_aspects: currentComponent.items.innovative_aspects.content,
                  why_hasnt_done_before: currentComponent.items.why_hasnt_done_before.content
                });
              }

              for (i = 0; i < component.C.form.selected.invention.container_section.c_development.components.length; i++) {
                currentComponent = component.C.form.selected.invention.container_section.c_development.components[i];

                submitItem.c_developments.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  key_points: currentComponent.items.key_points.content,
                  resources_needed: currentComponent.items.resources_needed.content,
                  deliverables: currentComponent.items.deliverables.content,
                  measure_of_success: currentComponent.items.measure_of_success.content,
                  key_risks: currentComponent.items.key_risks.content,
                  suggested_approach: currentComponent.items.suggested_approach.content
                });
              }

              __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/container_sections/update', submitItem).then(function (response) {
                console.info('Update Container Sections Results: ', response.data);

                callback(response.data);
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addComparativeadvantagesComponent: function addComparativeadvantagesComponent() {
              var component = _this;

              var targetComponentType = 'Current Technology ' + (component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length + 1);

              component.C.form.selected.invention.container_section.c_comparativeadvantages.components.push({
                type: targetComponentType,
                items: {
                  competing_howworks: {
                    content: ''
                  },
                  shortcomings: {
                    content: ''
                  },
                  howovercomes_shortcomings: {
                    content: ''
                  }
                }
              });

              var comparativeadvantagesComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length - 1;

              component.C.state.container[2].items.splice(component.C.state.container[2].items.length - 1, 0, {
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#comparativeadvantages-' + comparativeadvantagesComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-' + comparativeadvantagesComponentIndex;

              component.C.trigger.openChecklist();
              component.C.trigger.scrollToTop();
            },
            addConstructionComponent: function addConstructionComponent(targetComponentType) {
              var component = _this;

              component.C.form.selected.invention.container_section.c_construction.components.push({
                type: targetComponentType,
                items: {
                  ideal_example: {
                    content: ''
                  },
                  properties: {
                    content: ''
                  },
                  how_made: {
                    content: ''
                  },
                  innovative_aspects: {
                    content: ''
                  },
                  why_hasnt_done_before: {
                    content: ''
                  }
                }
              });

              var constructionComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.length - 1;

              component.C.state.container[3].items.splice(component.C.state.container[3].items.length - 1, 0, {
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#construction-' + constructionComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.construction.active = 'construction-' + constructionComponentIndex;

              component.C.trigger.openChecklist();
              component.C.trigger.scrollToTop();
            },
            addDevelopmentComponent: function addDevelopmentComponent() {
              var component = _this;

              var targetComponentType = 'Milestone ' + (component.C.form.selected.invention.container_section.c_development.components.length + 1);

              component.C.form.selected.invention.container_section.c_development.components.push({
                type: targetComponentType,
                items: {
                  key_points: {
                    content: ''
                  },
                  resources_needed: {
                    content: ''
                  },
                  deliverables: {
                    content: ''
                  },
                  measure_of_success: {
                    content: ''
                  },
                  key_risks: {
                    content: ''
                  },
                  suggested_approach: {
                    content: ''
                  }
                }
              });

              var developmentComponentIndex = component.C.form.selected.invention.container_section.c_development.components.length - 1;

              component.C.state.container[5].items.push({
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#development-' + developmentComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.development.active = 'development-' + developmentComponentIndex;

              component.C.trigger.openChecklist();
              component.C.trigger.scrollToTop();
            },
            deleteComparativeadvantagesComponent: function deleteComparativeadvantagesComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true;
                component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);

                  if (component.C.state.tab.comparativeadvantages.active === 'comparativeadvantages-' + targetComponentIndex) {
                    component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-' + (targetComponentIndex - 1);
                  }
                  component.C.form.trigger.saveAll(false);

                  component.C.trigger.confirmComparativeadvantagesComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false;
                };

                if (confirmedDeletion) {
                  component.C.trigger.confirmComparativeadvantagesComponentDelete();
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.competing_howworks.content || targetComponent.items.shortcomings.content || targetComponent.items.howovercomes_shortcomings.content)) {
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true;
                  component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                    component.C.form.trigger.deleteComparativeadvantagesComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.comparativeadvantages.active === 'comparativeadvantages-' + targetComponentIndex) {
                    component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[2].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_comparativeadvantages.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmComparativeadvantagesComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false;

                  component.C.trigger.openChecklist();
                }
              }
            },
            deleteConstructionComponent: function deleteConstructionComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                component.C.state.dialog.confirmConstructionComponentDelete.active = true;
                component.C.trigger.confirmConstructionComponentDelete = function () {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);

                  if (component.C.state.tab.construction.active === 'construction-' + targetComponentIndex) {
                    component.C.state.tab.construction.active = 'construction-' + (targetComponentIndex - 1);
                  }
                  component.C.form.trigger.saveAll(false);

                  component.C.trigger.confirmConstructionComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmConstructionComponentDelete.active = false;
                };

                if (confirmedDeletion) {
                  component.C.trigger.confirmConstructionComponentDelete();
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.how_made.content || targetComponent.items.ideal_example.content || targetComponent.items.innovative_aspects.content || targetComponent.items.properties.content || targetComponent.items.why_hasnt_done_before.content)) {
                  component.C.state.dialog.confirmConstructionComponentDelete.active = true;
                  component.C.trigger.confirmConstructionComponentDelete = function () {
                    component.C.form.trigger.deleteConstructionComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.construction.active === 'construction-' + targetComponentIndex) {
                    component.C.state.tab.construction.active = 'construction-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[3].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_construction.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmConstructionComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmConstructionComponentDelete.active = false;

                  component.C.trigger.openChecklist();
                }
              }
            },
            deleteDevelopmentComponent: function deleteDevelopmentComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_development.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                component.C.state.dialog.confirmDevelopmentComponentDelete.active = true;
                component.C.trigger.confirmDevelopmentComponentDelete = function () {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);

                  if (component.C.state.tab.development.active === 'development-' + targetComponentIndex) {
                    component.C.state.tab.development.active = 'development-' + (targetComponentIndex - 1);
                  }
                  component.C.form.trigger.saveAll(false);

                  component.C.trigger.confirmDevelopmentComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = false;
                };

                if (confirmedDeletion) {
                  component.C.trigger.confirmDevelopmentComponentDelete();
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.key_points.content || targetComponent.items.resources_needed.content || targetComponent.items.deliverables.content || targetComponent.items.measure_of_success.content || targetComponent.items.key_risks.content || targetComponent.items.suggested_approach.content)) {
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = true;
                  component.C.trigger.confirmDevelopmentComponentDelete = function () {
                    component.C.form.trigger.deleteDevelopmentComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.development.active === 'development-' + targetComponentIndex) {
                    component.C.state.tab.development.active = 'development-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[5].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_development.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmDevelopmentComponentDelete = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = false;

                  component.C.trigger.openChecklist();
                }
              }
            },
            saveSidePanelItems: function saveSidePanelItems(callback, skipClose) {
              var component = _this;
              callback = callback || __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop;

              var submitBlob = new FormData();
              submitBlob.append('invention[title]', component.C.form.selected.invention.title);
              submitBlob.append('scratchpad', component.C.form.selected.scratchpad);
              submitBlob.append('invention[keywords]', component.C.form.selected.invention.keywords);
              submitBlob.append('invention[search_results]', component.C.form.selected.invention.search_results);

              submitBlob.append('invention[organization_id]', component.C.form.selected.invention.organization_id);

              submitBlob.append('invention_id', component.C.form.selected.invention_id);

              for (i = 0; i < component.C.form.selected.invention.search.length; i++) {
                var targetSearchItem = component.C.form.selected.invention.search[i];

                submitBlob.append('searches[][id]', targetSearchItem.id || null);
                submitBlob.append('searches[][title]', targetSearchItem.title);
                submitBlob.append('searches[][url]', targetSearchItem.url);
                submitBlob.append('searches[][note]', targetSearchItem.note);
                submitBlob.append('searches[][tag]', targetSearchItem.tag);
                submitBlob.append('searches[][remove]', targetSearchItem.remove || false);
              }

              if (!skipClose) {
                if (component.C.form.selected.invention.invention_opportunity_id === '$other') {
                  submitBlob.append('invention[invention_opportunity_id]', 'other');
                } else if (component.C.form.selected.invention.invention_opportunity_id) {
                  submitBlob.append('invention[invention_opportunity_id]', component.C.form.selected.invention.invention_opportunity_id);
                }

                for (var i = 0; i < component.C.form.selected.co_inventors.length; i++) {
                  submitBlob.append('co_inventors[][user_id]', component.C.form.selected.co_inventors[i].user_id);
                  submitBlob.append('co_inventors[][access]', component.C.form.selected.co_inventors[i].access);
                  submitBlob.append('co_inventors[][remove]', component.C.form.selected.co_inventors[i].remove || false);
                }

                if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                  submitBlob.append('co_inventors[][user_id]', component.C.form.selected.$collaborator.$item.id);
                  submitBlob.append('co_inventors[][access]', component.C.form.selected.$collaborator.access);
                  submitBlob.append('co_inventors[][remove]', false);
                }

                if (component.C.form.selected.invention.$search.title) {
                  submitBlob.append('searches[][id]', null);
                  submitBlob.append('searches[][title]', component.C.form.selected.invention.$search.title);
                  submitBlob.append('searches[][url]', component.C.form.selected.invention.$search.url);
                  submitBlob.append('searches[][note]', component.C.form.selected.invention.$search.note);
                  submitBlob.append('searches[][tag]', component.C.form.selected.invention.$search.tag);
                  submitBlob.append('searches[][remove]', false);
                }

                if (component.C.form.selected.invention.bulk_read_access) {
                  submitBlob.append('invention[bulk_read_access]', component.C.form.selected.invention.bulk_read_access);
                }
              } else {
                var targetOpportunityID = component.C.data.invention.opportunity && component.C.data.invention.opportunity.id;

                if (targetOpportunityID === -1) {
                  submitBlob.append('invention[invention_opportunity_id]', 'other');
                } else {
                  submitBlob.append('invention[invention_opportunity_id]', targetOpportunityID);
                }

                if (component.C.data.invention.bulk_read_access) {
                  submitBlob.append('invention[bulk_read_access]', component.C.data.invention.bulk_read_access);
                }
              }

              __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update', submitBlob).then(function (response) {
                console.info('Manage Invention Results: ', response.data);

                callback(response.data);
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addComment: function addComment() {
              var component = _this;

              var apiCallPromise = null;

              var submitBlob = new FormData();
              submitBlob.append('invention_id', component.C.form.selected.invention_id);
              submitBlob.append('content', component.C.form.selected.comments.content);

              apiCallPromise = __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/add_comment', submitBlob);

              if (apiCallPromise) {
                apiCallPromise.then(function (response) {
                  console.info('Add Comment Results: ', response.data);

                  component.C.form.selected.comments.$list = response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments || [];

                  component.C.form.selected.comments.content = '';
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            markInventionComplete: function markInventionComplete() {
              var component = _this;

              if (component.C.data.invention.phase === 'phase-4' && component.C.data.invention.role === 'Mentor') {
                __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                  invention_id: component.$route.params.id,
                  phase: 'phase-5'
                }).then(function (response) {
                  console.info('Update Phase Results: ', response.data);

                  component.C.trigger.setupInvention();

                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: 'The status for ' + component.C.form.selected.invention.title + ' has been set to Invention Complete.'
                  });
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved, but status failed to be updated to Invention Review.',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            saveAll: function saveAll(isPresentation) {
              var component = _this;

              clearTimeout(component.C.timer.autoSave);

              component.C.form.trigger.saveSidePanelItems(function (sidePanelResponse) {
                component.C.form.trigger.updateAllContainerSections(function (containerSectionResponse) {
                  component.C.form.state.recentSaveActive = true;

                  if (isPresentation) {
                    component.$router.push({
                      name: 'InventionPresentation',
                      params: {
                        id: component.$route.params.id
                      }
                    });
                  } else {
                    component.C.trigger.setupInvention();

                    __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                      type: 'success',
                      message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved.'
                    });
                  }

                  clearTimeout(component.C.timer.saveIndicator);

                  component.C.timer.saveIndicator = setTimeout(function () {
                    component.C.form.state.recentSaveActive = false;
                  }, 5000);
                });
              });
            }
          }
        },
        report: {
          checklist: {
            percentage: 0,
            overview: {
              brief: {
                completionAll: false,
                searchOne: false
              },
              full: {
                completionAll: false,
                searchTwo: false,
                mentorOne: false
              },
              review: {
                mentorComplete: false
              }
            },
            detailed: {
              containerSections: {
                summary: false,
                draw: false,
                significance: false,
                problem_summary: false,
                gap: false,
                problem_significance: false,
                landscape: false,
                comparativeadvantages_innovativeaspects: false,
                comparativeadvantages_advantagessummary: false,
                comparativeadvantages_relevantbackground: false,
                construction_howused: false,
                construction_prototype: false,
                economics_need: false,
                economics_enduser: false,
                economics_keyresources: false,
                economics_capitalexpenditure: false,
                economics_feasiblyeconomical: false,
                economics_whomake: false,
                economics_howmakemoney: false,
                economics_howdelivered: false,
                economics_economicburden: false,
                economics_currentsolutioncosts: false,
                economics_consumercosts: false,
                specificquestions: false,
                references: false
              },
              componentContainers: {
                c_comparativeadvantages: {
                  complete: 0,
                  amount: 0
                },
                c_construction: {
                  complete: 0,
                  amount: 0
                },
                c_development: {
                  complete: 0,
                  amount: 0
                }
              },
              searchCount: {
                one: false,
                two: false
              },
              mentorCount: {
                one: false
              }
            }
          }
        },
        trigger: {
          openChecklist: function openChecklist() {
            var component = _this;

            function checkContainerBulkCompletion(targetContainer) {
              targetContainer.components = targetContainer.components || [];

              var isComplete = false;
              var completionCount = 0;
              var amountCount = 0;

              if (targetContainer.components.length > 0) {
                isComplete = true;

                for (var i = 0; i < targetContainer.components.length; i++) {
                  isComplete = isComplete && targetContainer.components[i].completion;

                  if (targetContainer.components[i].completion) {
                    completionCount++;
                  }

                  amountCount++;
                }
              }

              return {
                isComplete: isComplete,
                count: {
                  completion: completionCount,
                  amount: amountCount
                }
              };
            }

            component.C.report.checklist.percentage = 0;

            if (component.C.form.selected.invention.title) {
              component.C.report.checklist.percentage += 5;
            }
            if (component.C.form.selected.invention.description) {
              component.C.report.checklist.percentage += 5;
            }
            if (component.C.form.selected.invention.invention_opportunity_id) {
              component.C.report.checklist.percentage += 5;
            }

            var componentContainersResults = {
              comparativeadvantages: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_comparativeadvantages),
              construction: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_construction),
              development: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_development)
            };

            component.C.report.checklist.overview.brief.completionAll = false;
            component.C.report.checklist.overview.brief.searchOne = false;
            component.C.report.checklist.overview.full.completionAll = false;
            component.C.report.checklist.overview.full.searchTwo = false;
            component.C.report.checklist.overview.full.mentorOne = false;
            component.C.report.checklist.overview.review.mentorComplete = false;

            component.C.report.checklist.detailed.containerSections.summary = component.C.form.selected.invention.container_section.summary.completion || false;
            component.C.report.checklist.detailed.containerSections.draw = component.C.form.selected.invention.container_section.draw.completion || false;
            component.C.report.checklist.detailed.containerSections.significance = component.C.form.selected.invention.container_section.significance.completion || false;
            component.C.report.checklist.detailed.containerSections.problem_summary = component.C.form.selected.invention.container_section.problem_summary.completion || false;
            component.C.report.checklist.detailed.containerSections.gap = component.C.form.selected.invention.container_section.gap.completion || false;
            component.C.report.checklist.detailed.containerSections.problem_significance = component.C.form.selected.invention.container_section.problem_significance.completion || false;
            component.C.report.checklist.detailed.containerSections.landscape = component.C.form.selected.invention.container_section.landscape.completion || false;
            component.C.report.checklist.detailed.containerSections.comparativeadvantages_innovativeaspects = component.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.completion || false;
            component.C.report.checklist.detailed.containerSections.comparativeadvantages_advantagessummary = component.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.completion || false;
            component.C.report.checklist.detailed.containerSections.comparativeadvantages_relevantbackground = component.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.completion || false;
            component.C.report.checklist.detailed.containerSections.construction_howused = component.C.form.selected.invention.container_section.construction_howused.completion || false;
            component.C.report.checklist.detailed.containerSections.construction_prototype = component.C.form.selected.invention.container_section.construction_prototype.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_need = component.C.form.selected.invention.container_section.economics_need.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_enduser = component.C.form.selected.invention.container_section.economics_enduser.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_keyresources = component.C.form.selected.invention.container_section.economics_keyresources.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_capitalexpenditure = component.C.form.selected.invention.container_section.economics_capitalexpenditure.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_feasiblyeconomical = component.C.form.selected.invention.container_section.economics_feasiblyeconomical.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_whomake = component.C.form.selected.invention.container_section.economics_whomake.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_howmakemoney = component.C.form.selected.invention.container_section.economics_howmakemoney.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_howdelivered = component.C.form.selected.invention.container_section.economics_howdelivered.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_economicburden = component.C.form.selected.invention.container_section.economics_economicburden.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_currentsolutioncosts = component.C.form.selected.invention.container_section.economics_currentsolutioncosts.completion || false;
            component.C.report.checklist.detailed.containerSections.economics_consumercosts = component.C.form.selected.invention.container_section.economics_consumercosts.completion || false;
            component.C.report.checklist.detailed.containerSections.specificquestions = component.C.form.selected.invention.container_section.specificquestions.completion || false;
            component.C.report.checklist.detailed.containerSections.references = component.C.form.selected.invention.container_section.references.completion || false;
            component.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete = componentContainersResults.comparativeadvantages.count.completion || 0;
            component.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.amount = componentContainersResults.comparativeadvantages.count.amount || 0;
            component.C.report.checklist.detailed.componentContainers.c_construction.complete = componentContainersResults.construction.count.completion || 0;
            component.C.report.checklist.detailed.componentContainers.c_construction.amount = componentContainersResults.construction.count.amount || 0;
            component.C.report.checklist.detailed.componentContainers.c_development.complete = componentContainersResults.development.count.completion || 0;
            component.C.report.checklist.detailed.componentContainers.c_development.amount = componentContainersResults.development.count.amount || 0;
            component.C.report.checklist.detailed.searchCount.one = false;
            component.C.report.checklist.detailed.searchCount.two = false;
            component.C.report.checklist.detailed.mentorCount.one = false;

            function incrementPercentage(containerIndex, targetKey, isContainer) {
              if (isContainer) {
                if (component.C.report.checklist.detailed.componentContainers['c_' + targetKey].complete !== 0 && component.C.report.checklist.detailed.componentContainers['c_' + targetKey].complete === component.C.report.checklist.detailed.componentContainers['c_' + targetKey].amount) {
                  component.C.report.checklist.percentage += 3;
                }
              } else {
                if (component.C.report.checklist.detailed.containerSections[targetKey] && targetKey !== 'construction_prototype') {
                  if (containerIndex === 0 || containerIndex === 1) {
                    component.C.report.checklist.percentage += 4;
                  } else {
                    component.C.report.checklist.percentage += 1.5;
                  }
                }
              }
            }

            for (var i = 0; i < component.C.state.container.length; i++) {
              var currentContainer = component.C.state.container[i];

              if (currentContainer.componentContainerKey) {
                incrementPercentage(i, currentContainer.componentContainerKey, true);
              }

              for (var j = 0; j < currentContainer.items.length; j++) {
                if (currentContainer.items[j].includeAPI) {
                  incrementPercentage(i, currentContainer.items[j].key);
                }
                if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
                  for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
                    incrementPercentage(i, currentContainer.items[j].subAPIitems[k].key);
                  }
                }
              }
            }

            if (component.C.form.selected.invention.container_section.summary.completion && component.C.form.selected.invention.container_section.draw.completion && component.C.form.selected.invention.container_section.significance.completion && component.C.form.selected.invention.container_section.problem_summary.completion && component.C.form.selected.invention.container_section.gap.completion && component.C.form.selected.invention.container_section.problem_significance.completion) {
              component.C.report.checklist.percentage += 1;
              component.C.report.checklist.overview.brief.completionAll = true;
            }
            if (component.C.form.selected.invention.search.length >= 1) {
              component.C.report.checklist.percentage += 5;
              component.C.report.checklist.overview.brief.searchOne = true;
              component.C.report.checklist.detailed.searchCount.one = true;
            }

            if (component.C.form.selected.invention.container_section.landscape.completion && component.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.completion && component.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.completion && component.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.completion && component.C.form.selected.invention.container_section.construction_howused.completion && component.C.form.selected.invention.container_section.economics_need.completion && component.C.form.selected.invention.container_section.economics_enduser.completion && component.C.form.selected.invention.container_section.economics_keyresources.completion && component.C.form.selected.invention.container_section.economics_capitalexpenditure.completion && component.C.form.selected.invention.container_section.economics_feasiblyeconomical.completion && component.C.form.selected.invention.container_section.economics_whomake.completion && component.C.form.selected.invention.container_section.economics_howmakemoney.completion && component.C.form.selected.invention.container_section.economics_howdelivered.completion && component.C.form.selected.invention.container_section.economics_economicburden.completion && component.C.form.selected.invention.container_section.economics_currentsolutioncosts.completion && component.C.form.selected.invention.container_section.economics_consumercosts.completion && component.C.form.selected.invention.container_section.specificquestions.completion && component.C.form.selected.invention.container_section.references.completion && componentContainersResults.comparativeadvantages.isComplete && componentContainersResults.construction.isComplete && componentContainersResults.development.isComplete) {
              component.C.report.checklist.percentage += 4;
              component.C.report.checklist.overview.full.completionAll = true;
            }
            if (component.C.form.selected.invention.search.length >= 2) {
              component.C.report.checklist.percentage += 5;
              component.C.report.checklist.overview.full.searchTwo = true;
              component.C.report.checklist.detailed.searchCount.two = true;
            }
            if (__WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.find(component.C.form.selected.co_inventors, function (collaborator) {
              return parseInt(collaborator.access) === 2;
            })) {
              component.C.report.checklist.percentage += 5;
              component.C.report.checklist.overview.full.mentorOne = true;
              component.C.report.checklist.detailed.mentorCount.one = true;
            }

            if (component.C.data.invention.phase === 'phase-5') {
              component.C.report.checklist.percentage += 5;
              component.C.report.checklist.overview.review.mentorComplete = true;
            }

            var isPhase = {
              one: component.C.data.invention.phase === 'phase-1' || component.C.data.invention.phase === 'phase-2' || component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5',
              two: component.C.data.invention.phase === 'phase-2' || component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5',
              three: component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5',
              four: component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5',
              five: component.C.data.invention.phase === 'phase-5'
            };

            function updatePhase(targetPhase) {
              __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                invention_id: component.$route.params.id,
                phase: targetPhase
              }).then(function (response) {
                console.info('Update Phase Results: ', response.data);

                var inventionItem = response && response.data && response.data.data && response.data.data.invention || {};

                if (inventionItem.phase) {
                  component.C.data.invention.phase = inventionItem.phase;

                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: 'Invention ' + component.C.form.selected.invention.title + ' has been upgraded to ' + component.C.dictionary.phase[component.C.data.invention.phase] + '.'
                  });
                }
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  message: 'Invention ' + component.C.form.selected.invention.title + ' has failed to shift phases.  Please try refreshing the page.',
                  errorResponse: errorResponse
                });
              });
            }

            if (isPhase.two && !isPhase.three && component.C.report.checklist.overview.brief.completionAll && component.C.report.checklist.overview.brief.searchOne) {
              updatePhase('phase-3');
            } else if (isPhase.three && !isPhase.four && component.C.report.checklist.overview.brief.completionAll && component.C.report.checklist.overview.brief.searchOne && component.C.report.checklist.overview.full.completionAll && component.C.report.checklist.overview.full.searchTwo && component.C.report.checklist.overview.full.mentorOne) {
              updatePhase('phase-4');
            }
          },
          scrollToTop: function scrollToTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          },
          setupInvention: function setupInvention(isInitialization) {
            var component = _this;

            __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/detail', {
              params: {
                invention_id: component.$route.params.id
              }
            }).then(function (response) {
              var inventionDataItem = response && response.data && response.data.data && response.data.data.invention || {};
              var isEditable = response && response.data && response.data.data && response.data.data.is_editable || false;

              component.C.data.invention = inventionDataItem;
              component.C.state.isEditable = isEditable;

              component.C.form.selected.invention_id = inventionDataItem.id;
              component.C.form.selected.invention.title = inventionDataItem.title;
              component.C.form.selected.invention.description = inventionDataItem.description;
              component.C.form.selected.invention.keywords = inventionDataItem.keywords || '';
              component.C.form.selected.invention.search_results = inventionDataItem.search_results || '';
              component.C.form.selected.invention.action = inventionDataItem.action;
              component.C.form.selected.invention.action_note = inventionDataItem.action_note;
              component.C.form.selected.invention.search = inventionDataItem.searches; // ### Incomplete
              component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename;

              var targetOpportunityID = inventionDataItem.opportunity && inventionDataItem.opportunity.id;
              if (targetOpportunityID === -1) {
                component.C.form.selected.invention.invention_opportunity_id = '$other';
              } else {
                component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID;
              }

              component.C.form.selected.invention.organization_id = inventionDataItem.organization && inventionDataItem.organization.id;
              component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null;
              component.C.form.selected.scratchpad = inventionDataItem.scratchpad && inventionDataItem.scratchpad.content || '';

              component.C.form.selected.co_inventors = [];

              for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                component.C.form.selected.co_inventors.push({
                  $name: (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname) + ' ' + (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname),
                  user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                  access: inventionDataItem.co_inventors[i].access
                });
              }

              component.C.form.selected.comments.$list = inventionDataItem.comments;

              var containerSectionItem = inventionDataItem.container_section || {};

              function presetContainerSection(targetKey) {
                containerSectionItem[targetKey] = containerSectionItem[targetKey] || {
                  content: ''
                };
              }

              for (i = 0; i < component.C.config.containerSections.length; i++) {
                presetContainerSection(component.C.config.containerSections[i]);
              }

              containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
                components: []
              };
              containerSectionItem.c_construction = containerSectionItem.c_construction || {
                components: []
              };
              containerSectionItem.c_development = containerSectionItem.c_development || {
                components: []
              };

              component.C.state.container[2].items = [];
              for (i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
                var componentItem = containerSectionItem.c_comparativeadvantages.components[i];

                component.C.state.container[2].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#comparativeadvantages-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[2].$baseItems.length; i++) {
                component.C.state.container[2].items.push(component.C.state.container[2].$baseItems[i]);
              }

              component.C.state.container[3].items = [];
              for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
                componentItem = containerSectionItem.c_construction.components[i];

                component.C.state.container[3].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#construction-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[3].$baseItems.length; i++) {
                component.C.state.container[3].items.push(component.C.state.container[3].$baseItems[i]);
              }

              component.C.state.container[5].items = [];
              for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
                componentItem = containerSectionItem.c_development.components[i];

                component.C.state.container[5].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#development-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[5].$baseItems.length; i++) {
                component.C.state.container[5].items.push(component.C.state.container[5].$baseItems[i]);
              }

              component.C.form.selected.invention.container_section = containerSectionItem;

              component.C.trigger.openChecklist();

              if (isInitialization) {
                component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base';

                if (containerSectionItem.c_construction.components.length === 0) {
                  component.C.state.tab.construction.active = 'construction-base';
                } else {
                  component.C.state.tab.construction.active = 'construction-0';
                }

                if (containerSectionItem.c_development.components.length === 0) {
                  component.C.state.tab.development.active = 'development-base';
                } else {
                  component.C.state.tab.development.active = 'development-0';
                }

                if (component.C.form.selected.invention.organization_id) {
                  __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/opportunities_and_inventors', {
                    params: {
                      organization_id: component.C.form.selected.invention.organization_id
                    }
                  }).then(function (response) {
                    var opportunitiesList = response && response.data && response.data.data && response.data.data.invention_opportunities || [];
                    var peopleList = response && response.data && response.data.data && response.data.data.inventors || [];

                    opportunitiesList.push({
                      id: '$other',
                      title: 'Other'
                    });

                    component.C.form.list.opportunities = opportunitiesList;
                    component.C.form.list.inventors = peopleList;

                    component.C.form.selected.$collaborator.$item = null;
                    component.C.form.selected.$collaborator.access = null;
                  }).catch(function (errorResponse) {
                    __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                      type: 'error',
                      errorResponse: errorResponse
                    });
                  });
                }

                setTimeout(function () {
                  component.C.state.initialized = true;
                }, 10000);
              }
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          },
          confirmComparativeadvantagesComponentDelete: __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop,
          confirmConstructionComponentDelete: __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop,
          confirmDevelopmentComponentDelete: __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.noop
        },
        evaluate: {
          generalInfoIsChecked: function generalInfoIsChecked(subItem) {
            var component = _this;

            var isCheckedResults = true;

            if (subItem.subAPIitems) {
              for (var i = 0; i < subItem.subAPIitems.length; i++) {
                var targetSubAPIitem = subItem.subAPIitems[i];
                var isTargetSectionComplete = component.C.form.selected.invention.container_section && component.C.form.selected.invention.container_section[targetSubAPIitem.key] && component.C.form.selected.invention.container_section[targetSubAPIitem.key].completion || false;

                if (!targetSubAPIitem.exemptRequired) {
                  isCheckedResults = isCheckedResults && isTargetSectionComplete;
                }
              }
            } else {
              isCheckedResults = false;
            }

            return isCheckedResults;
          }
        },
        dictionary: {
          phase: {
            'phase-1': 'Concept',
            'phase-2': 'Invention Brief',
            'phase-3': 'Invention Full',
            'phase-4': 'Invention Review',
            'phase-5': 'Invention Complete'
          },
          bulk_read_access: {
            'only-inventors': 'Specific people',
            'anyone-organization': 'Anyone can comment'
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    function initializeContainerSection(targetKey) {
      component.C.form.selected.invention.container_section[targetKey] = {
        content: ''
      };
      component.C.config.containerSections.push(targetKey);
    }

    for (var i = 0; i < component.C.state.container.length; i++) {
      var currentContainer = component.C.state.container[i];
      currentContainer.$baseItems = currentContainer.items || [];

      for (var j = 0; j < currentContainer.items.length; j++) {
        if (currentContainer.items[j].includeAPI) {
          initializeContainerSection(currentContainer.items[j].key);
        }
        if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
          for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
            initializeContainerSection(currentContainer.items[j].subAPIitems[k].key);
          }
        }
      }
    }

    component.C.trigger.setupInvention(true);
  },
  beforeDestroy: function beforeDestroy() {
    var component = this;

    clearTimeout(component.C.timer.autoSave);
  },

  filters: {
    F_availableCollaborators: function F_availableCollaborators(currentList, selectedList) {
      currentList = currentList || [];
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        var correspondingSelectedCollaborator = __WEBPACK_IMPORTED_MODULE_6__node_modules_underscore_underscore_min_js___default.a.find(selectedList, function (selectedCollaborator) {
          return selectedCollaborator.user_id === currentCollaborator.id;
        });

        if (!correspondingSelectedCollaborator) {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    },
    F_availableAccess: function F_availableAccess(currentList, targetPhase) {
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        if (currentCollaborator.value === 2) {
          if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
            filteredList.push(currentCollaborator);
          }
        } else {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    }
  }
});

/***/ }),

/***/ "FxtL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MagicSignUp_vue__ = __webpack_require__("wHrf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12383eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MagicSignUp_vue__ = __webpack_require__("huXw");
function injectStyle (ssrContext) {
  __webpack_require__("56q3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12383eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MagicSignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12383eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MagicSignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gar8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"fill-height"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{attrs:{"md6":"md6","offset-md3":"offset-md3"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Sign In")])]),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.C.form.selected.account.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "email", $$v)},expression:"C.form.selected.account.email"}}),_c('v-text-field',{attrs:{"label":"Enter your password","type":"password","hint":"At least 8 characters","min":"8","counter":"","required":""},model:{value:(_vm.C.form.selected.account.password),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "password", $$v)},expression:"C.form.selected.account.password"}})],1)],1),_c('v-card-text',[_c('v-btn',{attrs:{"block":"block","large":"large","color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v("Login")])],1)],1),_c('p',{staticClass:"pa-3 text-xs-center"},[_vm._v("Not a member? "),_c('router-link',{attrs:{"to":"create-account"}},[_vm._v("Create an account")]),_vm._v(".")],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IDfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__ = __webpack_require__("4q66");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e98d5d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__ = __webpack_require__("RTKW");
function injectStyle (ssrContext) {
  __webpack_require__("VhTg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e98d5d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e98d5d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IFzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      C: {
        form: {
          selected: {
            account: {
              email: '',
              password: ''
            }
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                email: _this.C.form.selected.account.email,
                password: _this.C.form.selected.account.password
              };

              __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/sign_in', {
                params: submitItem
              }).then(function (response) {
                console.info('Sign In Results: ', response.data);

                component.$router.push({
                  name: 'People'
                });
              }).catch(function (errorResponse) {
                console.error('errorResponse', errorResponse);
              });
            }
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "JkBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66630ab2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("yLWY");
function injectStyle (ssrContext) {
  __webpack_require__("3C/V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66630ab2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66630ab2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mejg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      C: {
        form: {
          selected: {
            account: {
              name: '',
              email: '',
              password: '',
              confirm_password: ''
            }
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                name: _this.C.form.selected.account.name,
                email: _this.C.form.selected.account.email,
                password: _this.C.form.selected.account.password,
                confirm_password: _this.C.form.selected.account.confirm_password
              };

              __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/create_account', submitItem).then(function (response) {
                console.info('Create Account Results: ', response.data);

                component.$router.push({
                  name: 'SignIn'
                });
              }).catch(function (errorResponse) {
                console.error('errorResponse', errorResponse);
              });
            }
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "MxYT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__ = __webpack_require__("QCv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_override_styl__ = __webpack_require__("oENE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_override_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_override_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollactive__ = __webpack_require__("3ZR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_scrollactive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg__ = __webpack_require__("9fd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_infinite_scroll__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













// Import and use Vue Froala lib.




// Require Froala Editor js file.
__webpack_require__("sXnP");

// Require Froala Editor css files.
__webpack_require__("xoJ4");
__webpack_require__("5W1q");
__webpack_require__("yav+");

__WEBPACK_IMPORTED_MODULE_9__node_modules_axios_dist_axios_js___default.a.interceptors.response.use(function (responseItem) {
  // intercept the global error
  return responseItem;
}, function (errorItem) {
  if (errorItem && errorItem.response && errorItem.response.status === 401) {
    console.error('Authorization failed, clearing local auth data.', errorItem);

    __WEBPACK_IMPORTED_MODULE_8__assets_tools_js__["a" /* default */].signOut({
      skipAPIlogout: true,
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({
          name: 'MagicSignIn'
        });
      }
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorItem);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a, { theme: {
    primary: '#00bf1b',
    secondary: '#8D9AA3',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#00bf1b',
    warning: '#FFC107'
  } });

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__("mjDs"));

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_scrollactive___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_froala_wysiwyg___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_infinite_scroll___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

setTimeout(function () {
  location.reload();
}, 1000 * 60 * 60 * 8);

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QY3d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R2At":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R9Pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presentation_vue__ = __webpack_require__("oVYV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dd29b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Presentation_vue__ = __webpack_require__("BJ8W");
function injectStyle (ssrContext) {
  __webpack_require__("QY3d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61dd29b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dd29b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Presentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{staticClass:"ml-0",attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("All People")])])],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"disable-initial-sort":true,"hide-actions":"hide-actions"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"to":("/people/person/" + (props.item.id))}},[_c('td',{attrs:{"width":"30%"}},[_c('router-link',{attrs:{"to":("/people/person/" + (props.item.id))}},[_vm._v(_vm._s(props.item.name))])],1),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.drafts_amount))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.inventions_amount))]),_c('td',{attrs:{"width":"40%"}},_vm._l((props.item.organizations),function(organization){return _c('div',[_vm._v(_vm._s(organization.name)),((organization.highest_role && organization.highest_role.name) || (organization.user_organization_status))?_c('span',[_vm._v(" ("+_vm._s(organization.highest_role && organization.highest_role.name ? ((organization.highest_role.name) + ", ") : '')+_vm._s(organization.user_organization_status)+")")]):_vm._e()])})),(_vm.CR.authorization.state.isGod || _vm.CR.authorization.state.isOrgAdmin)?_c('td',[_vm._v(_vm._s(_vm.C.dictionary.status[props.item.status] ? _vm.C.dictionary.status[props.item.status] : props.item.status))]):_vm._e()])]}}])})],1),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block pt-4",staticStyle:{"width":"220px","position":"fixed"}},[_c('div',{staticClass:"body-1 mb-0",staticStyle:{"position":"absolute","top":"10px"}},[_vm._v("Sort by:")]),_c('v-text-field',{staticClass:"input--box",attrs:{"append-icon":"search","single-line":"single-line","label":"Search","clearable":"clearable","hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.name),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "name", $$v)},expression:"C.filters.selected.name"}}),(_vm.C.filters.list.organizations.length > 1)?_c('v-select',{staticClass:"input--box",attrs:{"label":"All Organizations","items":_vm.C.filters.list.organizations,"single-line":"single-line","item-text":"name","item-value":"id","clearable":true,"hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.organization_id),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "organization_id", $$v)},expression:"C.filters.selected.organization_id"}}):_vm._e(),(_vm.CR.authorization.state.isGod)?_c('v-select',{staticClass:"input--box",attrs:{"items":_vm.C.filters.list.globalStatuses,"label":"All Statuses","single-line":"single-line","item-text":"label","item-value":"value","clearable":true,"hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.status),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "status", $$v)},expression:"C.filters.selected.status"}}):_vm._e(),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{attrs:{"sm6":"sm6"}},[_c('v-btn',{attrs:{"block":"block"},on:{"click":function($event){_vm.C.trigger.reset({ filters: _vm.C.filters.selected })}}},[_vm._v("Go")])],1),_c('v-flex',{attrs:{"sm6":"sm6"}},[(_vm.C.filters.selected.name || _vm.C.filters.selected.organization_id || _vm.C.filters.selected.status)?_c('v-btn',{attrs:{"block":"block"},on:{"click":function($event){_vm.C.trigger.reset()}}},[_vm._v("Reset")]):_vm._e()],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SBZq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFiy":
/***/ (function(module, exports) {

module.exports = [{"code":"AED","decimals":2,"name":"United Arab Emirates dirham","number":"784"},{"code":"AFN","decimals":2,"name":"Afghan afghani","number":"971"},{"code":"ALL","decimals":2,"name":"Albanian lek","number":"8"},{"code":"AMD","decimals":2,"name":"Armenian dram","number":"51"},{"code":"ANG","decimals":2,"name":"Netherlands Antillean guilder","number":"532"},{"code":"AOA","decimals":2,"name":"Angolan kwanza","number":"973"},{"code":"ARS","decimals":2,"name":"Argentine peso","number":"32"},{"code":"AUD","decimals":2,"name":"Australian dollar","number":"36"},{"code":"AWG","decimals":2,"name":"Aruban florin","number":"533"},{"code":"AZN","decimals":2,"name":"Azerbaijani manat","number":"944"},{"code":"BAM","decimals":2,"name":"Bosnia and Herzegovina convertible mark","number":"977"},{"code":"BBD","decimals":2,"name":"Barbados dollar","number":"52"},{"code":"BDT","decimals":2,"name":"Bangladeshi taka","number":"50"},{"code":"BGN","decimals":2,"name":"Bulgarian lev","number":"975"},{"code":"BHD","decimals":3,"name":"Bahraini dinar","number":"48"},{"code":"BIF","decimals":0,"name":"Burundian franc","number":"108"},{"code":"BMD","decimals":2,"name":"Bermudian dollar (customarily known as Bermuda dollar)","number":"60"},{"code":"BND","decimals":2,"name":"Brunei dollar","number":"96"},{"code":"BOB","decimals":2,"name":"Boliviano","number":"68"},{"code":"BOV","decimals":2,"name":"Bolivian Mvdol (funds code)","number":"984"},{"code":"BRL","decimals":2,"name":"Brazilian real","number":"986"},{"code":"BSD","decimals":2,"name":"Bahamian dollar","number":"44"},{"code":"BTN","decimals":2,"name":"Bhutanese ngultrum","number":"64"},{"code":"BWP","decimals":2,"name":"Botswana pula","number":"72"},{"code":"BYR","decimals":0,"name":"Belarusian ruble","number":"974"},{"code":"BZD","decimals":2,"name":"Belize dollar","number":"84"},{"code":"CAD","decimals":2,"name":"Canadian dollar","number":"124"},{"code":"CDF","decimals":2,"name":"Congolese franc","number":"976"},{"code":"CHE","decimals":2,"name":"WIR Euro (complementary currency)","number":"947"},{"code":"CHF","decimals":2,"name":"Swiss franc","number":"756"},{"code":"CHW","decimals":2,"name":"WIR Franc (complementary currency)","number":"948"},{"code":"CLF","decimals":0,"name":"Unidad de Fomento (funds code)","number":"990"},{"code":"CLP","decimals":0,"name":"Chilean peso","number":"152"},{"code":"CNY","decimals":2,"name":"Chinese yuan","number":"156"},{"code":"COP","decimals":2,"name":"Colombian peso","number":"170"},{"code":"COU","decimals":2,"name":"Unidad de Valor Real","number":"970"},{"code":"CRC","decimals":2,"name":"Costa Rican colon","number":"188"},{"code":"CUC","decimals":2,"name":"Cuban convertible peso","number":"931"},{"code":"CUP","decimals":2,"name":"Cuban peso","number":"192"},{"code":"CVE","decimals":0,"name":"Cape Verde escudo","number":"132"},{"code":"CZK","decimals":2,"name":"Czech koruna","number":"203"},{"code":"DJF","decimals":0,"name":"Djiboutian franc","number":"262"},{"code":"DKK","decimals":2,"name":"Danish krone","number":"208"},{"code":"DOP","decimals":2,"name":"Dominican peso","number":"214"},{"code":"DZD","decimals":2,"name":"Algerian dinar","number":"12"},{"code":"EGP","decimals":2,"name":"Egyptian pound","number":"818"},{"code":"ERN","decimals":2,"name":"Eritrean nakfa","number":"232"},{"code":"ETB","decimals":2,"name":"Ethiopian birr","number":"230"},{"code":"EUR","decimals":2,"name":"Euro","number":"978"},{"code":"FJD","decimals":2,"name":"Fiji dollar","number":"242"},{"code":"FKP","decimals":2,"name":"Falkland Islands pound","number":"238"},{"code":"GBP","decimals":2,"name":"Pound sterling","number":"826"},{"code":"GEL","decimals":2,"name":"Georgian lari","number":"981"},{"code":"GHS","decimals":2,"name":"Ghanaian cedi","number":"936"},{"code":"GIP","decimals":2,"name":"Gibraltar pound","number":"292"},{"code":"GMD","decimals":2,"name":"Gambian dalasi","number":"270"},{"code":"GNF","decimals":0,"name":"Guinean franc","number":"324"},{"code":"GTQ","decimals":2,"name":"Guatemalan quetzal","number":"320"},{"code":"GYD","decimals":2,"name":"Guyanese dollar","number":"328"},{"code":"HKD","decimals":2,"name":"Hong Kong dollar","number":"344"},{"code":"HNL","decimals":2,"name":"Honduran lempira","number":"340"},{"code":"HRK","decimals":2,"name":"Croatian kuna","number":"191"},{"code":"HTG","decimals":2,"name":"Haitian gourde","number":"332"},{"code":"HUF","decimals":2,"name":"Hungarian forint","number":"348"},{"code":"IDR","decimals":2,"name":"Indonesian rupiah","number":"360"},{"code":"ILS","decimals":2,"name":"Israeli new shekel","number":"376"},{"code":"INR","decimals":2,"name":"Indian rupee","number":"356"},{"code":"IQD","decimals":3,"name":"Iraqi dinar","number":"368"},{"code":"IRR","decimals":0,"name":"Iranian rial","number":"364"},{"code":"ISK","decimals":0,"name":"Icelandic króna","number":"352"},{"code":"JMD","decimals":2,"name":"Jamaican dollar","number":"388"},{"code":"JOD","decimals":3,"name":"Jordanian dinar","number":"400"},{"code":"JPY","decimals":0,"name":"Japanese yen","number":"392"},{"code":"KES","decimals":2,"name":"Kenyan shilling","number":"404"},{"code":"KGS","decimals":2,"name":"Kyrgyzstani som","number":"417"},{"code":"KHR","decimals":2,"name":"Cambodian riel","number":"116"},{"code":"KMF","decimals":0,"name":"Comoro franc","number":"174"},{"code":"KPW","decimals":0,"name":"North Korean won","number":"408"},{"code":"KRW","decimals":0,"name":"South Korean won","number":"410"},{"code":"KWD","decimals":3,"name":"Kuwaiti dinar","number":"414"},{"code":"KYD","decimals":2,"name":"Cayman Islands dollar","number":"136"},{"code":"KZT","decimals":2,"name":"Kazakhstani tenge","number":"398"},{"code":"LAK","decimals":0,"name":"Lao kip","number":"418"},{"code":"LBP","decimals":0,"name":"Lebanese pound","number":"422"},{"code":"LKR","decimals":2,"name":"Sri Lankan rupee","number":"144"},{"code":"LRD","decimals":2,"name":"Liberian dollar","number":"430"},{"code":"LSL","decimals":2,"name":"Lesotho loti","number":"426"},{"code":"LTL","decimals":2,"name":"Lithuanian litas","number":"440"},{"code":"LVL","decimals":2,"name":"Latvian lats","number":"428"},{"code":"LYD","decimals":3,"name":"Libyan dinar","number":"434"},{"code":"MAD","decimals":2,"name":"Moroccan dirham","number":"504"},{"code":"MDL","decimals":2,"name":"Moldovan leu","number":"498"},{"code":"MGA","decimals":0,"name":"Malagasy ariary","number":"969"},{"code":"MKD","decimals":0,"name":"Macedonian denar","number":"807"},{"code":"MMK","decimals":0,"name":"Myanma kyat","number":"104"},{"code":"MNT","decimals":2,"name":"Mongolian tugrik","number":"496"},{"code":"MOP","decimals":2,"name":"Macanese pataca","number":"446"},{"code":"MRO","decimals":0,"name":"Mauritanian ouguiya","number":"478"},{"code":"MUR","decimals":2,"name":"Mauritian rupee","number":"480"},{"code":"MVR","decimals":2,"name":"Maldivian rufiyaa","number":"462"},{"code":"MWK","decimals":2,"name":"Malawian kwacha","number":"454"},{"code":"MXN","decimals":2,"name":"Mexican peso","number":"484"},{"code":"MXV","decimals":2,"name":"Mexican Unidad de Inversion (UDI) (funds code)","number":"979"},{"code":"MYR","decimals":2,"name":"Malaysian ringgit","number":"458"},{"code":"MZN","decimals":2,"name":"Mozambican metical","number":"943"},{"code":"NAD","decimals":2,"name":"Namibian dollar","number":"516"},{"code":"NGN","decimals":2,"name":"Nigerian naira","number":"566"},{"code":"NIO","decimals":2,"name":"Nicaraguan córdoba","number":"558"},{"code":"NOK","decimals":2,"name":"Norwegian krone","number":"578"},{"code":"NPR","decimals":2,"name":"Nepalese rupee","number":"524"},{"code":"NZD","decimals":2,"name":"New Zealand dollar","number":"554"},{"code":"OMR","decimals":3,"name":"Omani rial","number":"512"},{"code":"PAB","decimals":2,"name":"Panamanian balboa","number":"590"},{"code":"PEN","decimals":2,"name":"Peruvian nuevo sol","number":"604"},{"code":"PGK","decimals":2,"name":"Papua New Guinean kina","number":"598"},{"code":"PHP","decimals":2,"name":"Philippine peso","number":"608"},{"code":"PKR","decimals":2,"name":"Pakistani rupee","number":"586"},{"code":"PLN","decimals":2,"name":"Polish złoty","number":"985"},{"code":"PYG","decimals":0,"name":"Paraguayan guaraní","number":"600"},{"code":"QAR","decimals":2,"name":"Qatari riyal","number":"634"},{"code":"RON","decimals":2,"name":"Romanian new leu","number":"946"},{"code":"RSD","decimals":2,"name":"Serbian dinar","number":"941"},{"code":"RUB","decimals":2,"name":"Russian rouble","number":"643"},{"code":"RWF","decimals":0,"name":"Rwandan franc","number":"646"},{"code":"SAR","decimals":2,"name":"Saudi riyal","number":"682"},{"code":"SBD","decimals":2,"name":"Solomon Islands dollar","number":"90"},{"code":"SCR","decimals":2,"name":"Seychelles rupee","number":"690"},{"code":"SDG","decimals":2,"name":"Sudanese pound","number":"938"},{"code":"SEK","decimals":2,"name":"Swedish krona/kronor","number":"752"},{"code":"SGD","decimals":2,"name":"Singapore dollar","number":"702"},{"code":"SHP","decimals":2,"name":"Saint Helena pound","number":"654"},{"code":"SLL","decimals":0,"name":"Sierra Leonean leone","number":"694"},{"code":"SOS","decimals":2,"name":"Somali shilling","number":"706"},{"code":"SRD","decimals":2,"name":"Surinamese dollar","number":"968"},{"code":"SSP","decimals":2,"name":"South Sudanese pound","number":"728"},{"code":"STD","decimals":0,"name":"São Tomé and Príncipe dobra","number":"678"},{"code":"SYP","decimals":2,"name":"Syrian pound","number":"760"},{"code":"SZL","decimals":2,"name":"Swazi lilangeni","number":"748"},{"code":"THB","decimals":2,"name":"Thai baht","number":"764"},{"code":"TJS","decimals":2,"name":"Tajikistani somoni","number":"972"},{"code":"TMT","decimals":2,"name":"Turkmenistani manat","number":"934"},{"code":"TND","decimals":3,"name":"Tunisian dinar","number":"788"},{"code":"TOP","decimals":2,"name":"Tongan paʻanga","number":"776"},{"code":"TRY","decimals":2,"name":"Turkish lira","number":"949"},{"code":"TTD","decimals":2,"name":"Trinidad and Tobago dollar","number":"780"},{"code":"TWD","decimals":2,"name":"New Taiwan dollar","number":"901"},{"code":"TZS","decimals":2,"name":"Tanzanian shilling","number":"834"},{"code":"UAH","decimals":2,"name":"Ukrainian hryvnia","number":"980"},{"code":"UGX","decimals":2,"name":"Ugandan shilling","number":"800"},{"code":"USD","decimals":2,"name":"United States dollar","number":"840"},{"code":"USN","decimals":2,"name":"United States dollar (next day) (funds code)","number":"997"},{"code":"USS","decimals":2,"name":"United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)","number":"998"},{"code":"UYI","decimals":0,"name":"Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)","number":"940"},{"code":"UYU","decimals":2,"name":"Uruguayan peso","number":"858"},{"code":"UZS","decimals":2,"name":"Uzbekistan som","number":"860"},{"code":"VEF","decimals":2,"name":"Venezuelan bolívar fuerte","number":"937"},{"code":"VND","decimals":0,"name":"Vietnamese dong","number":"704"},{"code":"VUV","decimals":0,"name":"Vanuatu vatu","number":"548"},{"code":"WST","decimals":2,"name":"Samoan tala","number":"882"},{"code":"XAF","decimals":0,"name":"CFA franc BEAC","number":"950"},{"code":"XAG","decimals":null,"name":"Silver (one troy ounce)","number":"961"},{"code":"XAU","decimals":null,"name":"Gold (one troy ounce)","number":"959"},{"code":"XBA","decimals":null,"name":"European Composite Unit (EURCO) (bond market unit)","number":"955"},{"code":"XBB","decimals":null,"name":"European Monetary Unit (E.M.U.-6) (bond market unit)","number":"956"},{"code":"XBC","decimals":null,"name":"European Unit of Account 9 (E.U.A.-9) (bond market unit)","number":"957"},{"code":"XBD","decimals":null,"name":"European Unit of Account 17 (E.U.A.-17) (bond market unit)","number":"958"},{"code":"XCD","decimals":2,"name":"East Caribbean dollar","number":"951"},{"code":"XDR","decimals":null,"name":"Special drawing rights","number":"960"},{"code":"XFU","decimals":null,"name":"UIC franc (special settlement currency)","number":"Nil"},{"code":"XOF","decimals":0,"name":"CFA franc BCEAO","number":"952"},{"code":"XPD","decimals":null,"name":"Palladium (one troy ounce)","number":"964"},{"code":"XPF","decimals":0,"name":"CFP franc","number":"953"},{"code":"XPT","decimals":null,"name":"Platinum (one troy ounce)","number":"962"},{"code":"XTS","decimals":null,"name":"Code reserved for testing purposes","number":"963"},{"code":"XXX","decimals":null,"name":"No currency","number":"999"},{"code":"YER","decimals":2,"name":"Yemeni rial","number":"886"},{"code":"ZAR","decimals":2,"name":"South African rand","number":"710"},{"code":"ZMW","decimals":2,"name":"Zambian kwacha","number":"967"}]

/***/ }),

/***/ "T+e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ['message'],
  data: function data() {
    return {
      C: {
        data: {
          message: ''
        }
      }
    };
  },
  created: function created() {
    var component = this;

    component.C.data.message = component.message;
  }
});

/***/ }),

/***/ "T+p9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js__ = __webpack_require__("yiUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_avatar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_5_vue_avatar___default.a
  },
  props: ['P'],
  data: function data() {
    var _this = this;

    return {
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        state: {
          dialog: {
            confirmArchiveInvention: {
              active: false
            }
          }
        },
        timer: {
          autoSave: null,
          saveIndicator: null
        },
        form: {
          config: {
            froala: {
              invention: {
                description: __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].setupFroalaConfig({
                  events: {
                    'froalaEditor.contentChanged': function froalaEditorContentChanged() {
                      var component = _this;

                      if (component.P.state.selected.invention.details) {
                        clearTimeout(component.C.timer.autoSave);

                        component.C.timer.autoSave = setTimeout(function () {
                          component.C.form.trigger.submit(function () {
                            component.C.form.state.recentSaveActive = true;

                            clearTimeout(component.C.timer.saveIndicator);

                            component.C.timer.saveIndicator = setTimeout(function () {
                              component.C.form.state.recentSaveActive = false;
                            }, 5000);
                          }, true);
                        }, 2000);
                      }
                    }
                  }
                })
              }
            }
          },
          state: {
            active: {
              $search: false
            },
            recentSaveActive: false
          },
          list: {
            inventionActions: [{
              label: 'Brainstorm',
              value: 'Brainstorm'
            }, {
              label: 'Research',
              value: 'Research'
            }, {
              label: 'Archive',
              value: 'Archive'
            }, {
              label: 'Other',
              value: 'Other'
            }],
            collaboratorAccessOptions: {
              items: [{
                label: 'Co-inventor',
                value: 1
              }, {
                label: 'Mentor/Expert',
                value: 2
              }, {
                label: 'Commenter',
                value: 3
              }],
              dictionary: {
                '1': 'Co-inventor',
                '2': 'Mentor/Expert',
                '3': 'Commenter'
              }
            },
            bulkDefaultAccessOptions: [{
              label: 'Anyone in my organization can comment',
              value: 'anyone-organization'
            }, {
              label: 'Only collaborators in my organization can comment',
              value: 'only-inventors'
            }],
            organizations: [],
            opportunities: [],
            inventors: []
          },
          trigger: {
            addSearchItem: function addSearchItem(searchItem) {
              var component = _this;

              component.P.form.selected.invention.search.push({
                title: component.P.form.selected.invention.$search.title,
                url: component.P.form.selected.invention.$search.url,
                note: component.P.form.selected.invention.$search.note,
                tag: component.P.form.selected.invention.$search.tag
              });

              component.P.form.selected.invention.$search.title = '';
              component.P.form.selected.invention.$search.url = '';
              component.P.form.selected.invention.$search.note = '';
              component.P.form.selected.invention.$search.tag = '';

              component.C.form.state.active.$search = false;
            },
            removeSearchItem: function removeSearchItem(searchItem, searchItemIndex) {
              var component = _this;

              if (!searchItem.id) {
                component.P.form.selected.invention.search.splice(searchItemIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(searchItem, 'remove', !searchItem.remove);
              }
            },
            addCollaboratorItem: function addCollaboratorItem() {
              var component = _this;

              if (component.P.form.selected.$collaborator.$item && component.P.form.selected.$collaborator.access) {
                component.P.form.selected.co_inventors.push({
                  $isNew: true,
                  $name: component.P.form.selected.$collaborator.$item.fullname,
                  user_id: component.P.form.selected.$collaborator.$item.id,
                  access: component.P.form.selected.$collaborator.access,
                  remove: false
                });

                component.P.form.selected.$collaborator.$item = null;
                component.P.form.selected.$collaborator.access = null;
              }
            },
            removeCollaboratorItem: function removeCollaboratorItem(collaboratorItem, collaboratorIndex) {
              var component = _this;

              if (collaboratorItem.$isNew) {
                component.P.form.selected.co_inventors.splice(collaboratorIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(collaboratorItem, 'remove', !collaboratorItem.remove);
              }
            },
            fileUpload: function fileUpload($event) {
              var component = _this;

              var $files = $event.target.files || $event.dataTransfer.files;

              if (!$files.length) {
                return;
              }

              var targetFile = $files[0];

              component.P.form.selected.upload = targetFile;
            },
            downloadFile: function downloadFile() {
              var component = _this;

              console.log('Running C.form.trigger.downloadFile()');

              __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/download_uploaded_file', {
                params: {
                  invention_id: component.P.form.selected.invention_id
                },
                responseType: 'blob'
              }).then(function (response) {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', component.P.form.selected.invention.uploaded_filename);
                document.body.appendChild(link);
                link.click();
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addComment: function addComment() {
              var component = _this;

              var apiCallPromise = null;

              var submitBlob = new FormData();
              submitBlob.append('invention_id', component.P.form.selected.invention_id);
              submitBlob.append('content', component.P.form.selected.comments.content);

              apiCallPromise = __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/add_comment', submitBlob);

              if (apiCallPromise) {
                apiCallPromise.then(function (response) {
                  console.info('Add Comment Results: ', response.data);

                  component.P.form.selected.comments.$list = response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments || [];

                  component.P.form.selected.comments.content = '';
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            archiveInvention: function archiveInvention() {
              var component = _this;

              component.C.state.dialog.confirmArchiveInvention.active = true;
            },
            letsinvent: function letsinvent() {
              var component = _this;

              if ((component.P.form.selected.invention.organization_id || component.C.form.list.organizations.length <= 1) && component.P.form.selected.invention.invention_opportunity_id) {
                component.C.form.trigger.submit(function () {
                  __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                    invention_id: component.P.form.selected.invention_id,
                    phase: 'phase-2'
                  }).then(function (response) {
                    console.info('Update Phase Results: ', response.data);

                    component.$router.push({
                      name: 'InventionSolution',
                      params: {
                        id: component.P.form.selected.invention_id
                      }
                    });
                  }).catch(function (errorResponse) {
                    __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                      type: 'error',
                      errorResponse: errorResponse
                    });
                  });
                });
              } else {
                component.P.state.sidepanel.tab = 'tab-4';

                if (!(component.P.form.selected.invention.organization_id || component.C.form.list.organizations.length <= 1)) {
                  component.P.form.error.active = true;
                  component.P.form.error.type = 'letsinvent-missingfields-organization';
                } else if (!component.P.form.selected.invention.invention_opportunity_id) {
                  component.P.form.error.active = true;
                  component.P.form.error.type = 'letsinvent-missingfields-opportunity';
                } else {
                  component.P.form.error.active = true;
                  component.P.form.error.type = 'N/A';

                  console.error('component.P.form.selected.invention', component.P.form.selected.invention);
                }
              }
            },
            submit: function submit(callback, skipClose) {
              var component = _this;

              var apiCallPromise = null;

              var submitBlob = new FormData();
              submitBlob.append('invention[title]', component.P.form.selected.invention.title);
              submitBlob.append('invention[description]', component.P.form.selected.invention.description);
              submitBlob.append('invention[action]', component.P.form.selected.invention.action);
              submitBlob.append('invention[action_note]', component.P.form.selected.invention.action_note);

              submitBlob.append('scratchpad', component.P.form.selected.scratchpad);

              if (component.P.form.selected.invention.invention_opportunity_id === '$other') {
                submitBlob.append('invention[invention_opportunity_id]', 'other');
              } else if (component.P.form.selected.invention.invention_opportunity_id) {
                submitBlob.append('invention[invention_opportunity_id]', component.P.form.selected.invention.invention_opportunity_id);
              }

              if (!skipClose) {
                for (var i = 0; i < component.P.form.selected.co_inventors.length; i++) {
                  submitBlob.append('co_inventors[][user_id]', component.P.form.selected.co_inventors[i].user_id);
                  submitBlob.append('co_inventors[][access]', component.P.form.selected.co_inventors[i].access);
                  submitBlob.append('co_inventors[][remove]', component.P.form.selected.co_inventors[i].remove || false);
                }

                if (component.P.form.selected.$collaborator.$item && component.P.form.selected.$collaborator.access) {
                  submitBlob.append('co_inventors[][user_id]', component.P.form.selected.$collaborator.$item.id);
                  submitBlob.append('co_inventors[][access]', component.P.form.selected.$collaborator.access);
                  submitBlob.append('co_inventors[][remove]', false);
                }

                if (component.C.form.list.organizations.length === 1) {
                  submitBlob.append('invention[organization_id]', component.C.form.list.organizations[0].id);
                } else if (component.P.form.selected.invention.organization_id) {
                  submitBlob.append('invention[organization_id]', component.P.form.selected.invention.organization_id);
                }

                for (i = 0; i < component.P.form.selected.invention.search.length; i++) {
                  var targetSearchItem = component.P.form.selected.invention.search[i];

                  submitBlob.append('searches[][id]', targetSearchItem.id || null);
                  submitBlob.append('searches[][title]', targetSearchItem.title);
                  submitBlob.append('searches[][url]', targetSearchItem.url);
                  submitBlob.append('searches[][note]', targetSearchItem.note);
                  submitBlob.append('searches[][tag]', targetSearchItem.tag);
                  submitBlob.append('searches[][remove]', targetSearchItem.remove || false);
                }

                if (component.P.form.selected.invention.$search.title) {
                  submitBlob.append('searches[][id]', null);
                  submitBlob.append('searches[][title]', component.P.form.selected.invention.$search.title);
                  submitBlob.append('searches[][url]', component.P.form.selected.invention.$search.url);
                  submitBlob.append('searches[][note]', component.P.form.selected.invention.$search.note);
                  submitBlob.append('searches[][tag]', component.P.form.selected.invention.$search.tag);
                  submitBlob.append('searches[][remove]', false);
                }

                if (component.P.form.selected.upload) {
                  submitBlob.append('upload', component.P.form.selected.upload);
                }
              } else {
                if (!__WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js___default.a.isNull(component.P.state.selected.invention.data.organization && component.P.state.selected.invention.data.organization.id)) {
                  submitBlob.append('invention[organization_id]', component.P.state.selected.invention.data.organization && component.P.state.selected.invention.data.organization.id);
                }
              }

              if (component.P.form.selected.invention.bulk_read_access) {
                submitBlob.append('invention[bulk_read_access]', component.P.form.selected.invention.bulk_read_access);
              }

              if (!component.P.state.selected.invention.details) {
                apiCallPromise = __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/create', submitBlob);
              } else {
                submitBlob.append('invention_id', component.P.form.selected.invention_id);

                apiCallPromise = __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update', submitBlob);
              }

              if (apiCallPromise) {
                apiCallPromise.then(function (response) {
                  console.info('Manage Invention Results: ', response.data);

                  if (component.P.state.selected.invention.details) {
                    if (!skipClose) {
                      component.P.state.selected.invention.active = false;
                    }
                  } else {
                    component.P.trigger.selectInvention(response.data.data.invention);
                  }

                  if (__WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js___default.a.isFunction(callback)) {
                    callback();
                  } else {
                    component.P.trigger.refreshBaseData();

                    if (component.P.state.selected.invention.details) {
                      __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                        type: 'success',
                        message: component.P.form.selected.invention.title + ' has been successfully saved.'
                      });
                    }
                  }

                  if (!skipClose) {
                    component.P.form.selected.invention.$search.title = '';
                    component.P.form.selected.invention.$search.url = '';
                    component.P.form.selected.invention.$search.note = '';
                    component.P.form.selected.invention.$search.tag = '';
                    component.C.form.state.active.$search = false;
                  }
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            }
          }
        },
        trigger: {
          confirmArchiveInvention: function confirmArchiveInvention() {
            var component = _this;

            var submitItem = {
              invention_id: component.P.form.selected.invention_id,
              archived: true
            };

            __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_archived', submitItem).then(function (response) {
              console.info('Archive Invention Results: ', response.data);

              component.P.state.selected.invention.active = false;

              component.P.trigger.refreshBaseData();

              __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                type: 'success',
                message: component.P.form.selected.invention.title + ' has been successfully archived.'
              });

              component.P.form.selected.invention.$search.title = '';
              component.P.form.selected.invention.$search.url = '';
              component.P.form.selected.invention.$search.note = '';
              component.P.form.selected.invention.$search.tag = '';
              component.C.form.state.active.$search = false;

              component.C.state.dialog.confirmArchiveInvention.active = false;
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          },
          refreshFormListData: function refreshFormListData(options) {
            var component = _this;

            __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].getOrganizationsList({
              success: function success(organizationList) {
                component.P.filters.list.organizations = organizationList;
                component.C.form.list.organizations = organizationList;

                if (component.C.form.list.organizations.length === 1) {
                  component.C.trigger.refreshFormOrganizationOptions(component.C.form.list.organizations[0].id, true);
                }
              }
            });
          },
          refreshFormOrganizationOptions: function refreshFormOrganizationOptions(targetOrganizationID, isLoad) {
            var component = _this;

            if (targetOrganizationID) {
              __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/opportunities_and_inventors', {
                params: {
                  organization_id: targetOrganizationID
                }
              }).then(function (response) {
                var opportunitiesList = response && response.data && response.data.data && response.data.data.invention_opportunities || [];
                var peopleList = response && response.data && response.data.data && response.data.data.inventors || [];

                opportunitiesList.push({
                  id: '$other',
                  title: 'Other'
                });

                component.C.form.list.opportunities = opportunitiesList;
                component.C.form.list.inventors = peopleList;

                component.P.form.selected.$collaborator.$item = null;
                component.P.form.selected.$collaborator.access = null;

                if (!(component.P.state.selected.invention.details && isLoad)) {
                  component.P.form.selected.invention.invention_opportunity_id = null;
                  component.P.form.selected.co_inventors = [];
                }
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    component.C.trigger.refreshFormListData();
  },
  beforeDestroy: function beforeDestroy() {
    var component = this;

    clearTimeout(component.C.timer.autoSave);
  },

  filters: {
    F_availableCollaborators: function F_availableCollaborators(currentList, selectedList) {
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        var correspondingSelectedCollaborator = __WEBPACK_IMPORTED_MODULE_4__node_modules_underscore_underscore_min_js___default.a.find(selectedList, function (selectedCollaborator) {
          return selectedCollaborator.user_id === currentCollaborator.id;
        });

        if (!correspondingSelectedCollaborator) {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    },
    F_availableAccess: function F_availableAccess(currentList, targetPhase) {
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        if (currentCollaborator.value === 2) {
          if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
            filteredList.push(currentCollaborator);
          }
        } else {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    }
  }
});

/***/ }),

/***/ "Td+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UWgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideDrawer_vue__ = __webpack_require__("tMNk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5e77f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SideDrawer_vue__ = __webpack_require__("vdnw");
function injectStyle (ssrContext) {
  __webpack_require__("R2At")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e5e77f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5e77f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SideDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uv+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  computed: {
    binding: function binding() {
      var binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    }
  },
  data: function data() {
    var _this = this;

    return {
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        data: {
          person: {}
        },
        form: {
          validation: {
            overall: false,
            rules: {
              user: {
                firstname: [function (v) {
                  return !!v || 'First name is required';
                }],
                lastname: [function (v) {
                  return !!v || 'Last name is required';
                }],
                email: [function (v) {
                  return !!v || 'Email is required';
                }]
              }
            }
          },
          state: {
            assignToOrganizationActive: false
          },
          selected: {
            user: {
              firstname: '',
              lastname: '',
              email: '',
              citizenship: '',
              time_zone: ''
            },
            home_address: {
              street1: '',
              street2: '',
              city: '',
              state_province: '',
              postal_code: '',
              country: '',
              phone_number: ''
            },
            work_address: {
              employer: '',
              street1: '',
              street2: '',
              city: '',
              state_province: '',
              postal_code: '',
              country: '',
              phone_number: ''
            },
            global_status: null,
            addToOrganization: {
              organization_id: null
            }
          },
          list: {
            organizations: [],
            roles: [],
            countries: __WEBPACK_IMPORTED_MODULE_5_country_data___default.a.countries.all,
            organizationStatuses: [{
              label: 'Active',
              value: 'Active'
            }, {
              label: 'Inactive',
              value: 'Inactive'
            }],
            globalStatuses: [{
              label: 'Enabled',
              value: 'Active'
            }, {
              label: 'Suspended',
              value: 'Suspend'
            }, {
              label: 'Archived',
              value: 'Delete'
            }]
          },
          event: {
            toggleAssignToOrganization: function toggleAssignToOrganization(isOpen) {
              _this.C.form.state.assignToOrganizationActive = isOpen;
            }
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                user: component.C.form.selected.user,
                home_address: component.C.form.selected.home_address,
                work_address: component.C.form.selected.work_address
              };

              if (component.$route.params.id) {
                submitItem.user_id = component.$route.params.id;
              }

              function completeUpdateProcess(resultsItem) {
                console.info('User Update Results: ', resultsItem);

                if (component.$route.params.id) {
                  component.$router.push({
                    name: 'Person',
                    params: {
                      id: component.$route.params.id
                    }
                  });
                } else {
                  component.$router.push({
                    name: 'People'
                  });
                }

                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'success',
                  message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + ' has been updated.'
                });
              }

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/people/update', submitItem).then(function (response) {
                var userUpdateData = response.data;

                completeUpdateProcess({
                  user: userUpdateData
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            setGlobalStatus: function setGlobalStatus() {
              var component = _this;

              var submitItem = {
                user_id: component.$route.params.id,
                status: component.C.form.selected.global_status
              };

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/people/update_global_status', submitItem).then(function (response) {
                console.log('setGlobalStatus() success', response.data.data);

                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'success',
                  message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + '\'s global status has been updated.'
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addToOrganization: function addToOrganization() {
              var component = _this;

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/user_roles/join_organization', {
                user_id: _this.$route.params.id,
                organization_id: _this.C.form.selected.addToOrganization.organization_id
              }).then(function (response) {
                console.log('addToOrganization() success', response.data.data);

                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getUser({
                  id: component.$route.params.id,
                  success: function success(userData) {
                    __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getOrganizationsList({
                      success: function success(organizationList) {
                        component.C.data.person.user_organization_statuses = userData.user_organization_statuses;

                        component.C.form.event.toggleAssignToOrganization(false);
                        component.C.event.refreshOrganizationList(organizationList);

                        __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                          type: 'success',
                          message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + ' has been added to the organization.'
                        });
                      }
                    });
                  }
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            convertOrganizationAdminRole: function convertOrganizationAdminRole(organizationStatusItem, isPromoting) {
              var component = _this;

              console.log('convertOrganizationAdminRole', {
                organization_id: organizationStatusItem.organization_id,
                isPromoting: isPromoting
              });

              if (isPromoting) {
                __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/user_roles/make_oa', {
                  user_id: _this.$route.params.id,
                  organization_id: organizationStatusItem.organization_id
                }).then(function (response) {
                  console.log('convertOrganizationAdminRole() promote success', response.data.data);

                  organizationStatusItem.oa = true;

                  __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + ' has been promoted from organization user to administrator.'
                  });
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.delete('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/user_roles/remove_oa', {
                  params: {
                    user_id: _this.$route.params.id,
                    organization_id: organizationStatusItem.organization_id
                  }
                }).then(function (response) {
                  console.log('convertOrganizationAdminRole() demote success', response.data.data);

                  organizationStatusItem.oa = false;

                  __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + ' has been demoted from organization administrator to user.'
                  });
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            updateDataForOrganization: function updateDataForOrganization(organizationStatusItem) {
              var component = _this;

              console.log('updateDataForOrganization', {
                organizationStatusItem: organizationStatusItem
              });

              var submitItem = {
                user_id: _this.$route.params.id,
                organization_id: organizationStatusItem.organization_id,
                status: organizationStatusItem.status
              };

              if (organizationStatusItem.oa) {
                submitItem.title = organizationStatusItem.title;
                submitItem.phone = organizationStatusItem.phone;
              }

              __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/people/save_organization_status', submitItem).then(function (response) {
                console.log('updateDataForOrganization() success', response.data.data);

                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'success',
                  message: component.C.form.selected.user.firstname + ' ' + component.C.form.selected.user.lastname + '\'s organization data has been updated.'
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        },
        event: {
          refreshOrganizationList: function refreshOrganizationList(organizationList) {
            _this.C.form.list.organizations = [];

            for (var j = 0; j < organizationList.length; j++) {
              var statusOrganizationMatch = __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.find(_this.C.data.person.user_organization_statuses, function (userOrganizationStatusItem) {
                return userOrganizationStatusItem.organization_id === organizationList[j].id;
              });

              if (!statusOrganizationMatch) {
                _this.C.form.list.organizations.push({
                  id: organizationList[j].id,
                  name: organizationList[j].name
                });
              }
            }
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getUser({
        id: this.$route.params.id,
        success: function success(userData) {
          component.C.data.person = userData;

          component.C.form.selected.user.firstname = userData.firstname;
          component.C.form.selected.user.lastname = userData.lastname;
          component.C.form.selected.user.email = userData.email;
          component.C.form.selected.user.citizenship = userData.citizenship || 'USA';
          component.C.form.selected.user.time_zone = userData.time_zone;
          component.C.form.selected.home_address = userData.home_address || {};
          component.C.form.selected.work_address = userData.work_address || {};

          component.C.form.selected.home_address.country = component.C.form.selected.home_address.country || 'USA';
          component.C.form.selected.work_address.country = component.C.form.selected.work_address.country || 'USA';

          if (component.CR.authorization.state.isGod) {
            component.C.form.selected.global_status = userData.global_status || 'Active';
          }

          function runBase(dataItems) {
            var organizationList = dataItems.organizations;

            component.C.event.refreshOrganizationList(organizationList);
          }

          __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getOrganizationsList({
            success: function success(organizationList) {
              runBase({
                organizations: organizationList
              });
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "Uwka":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VhTg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W4Fv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SideDrawer__ = __webpack_require__("UWgY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'side-drawer': __WEBPACK_IMPORTED_MODULE_0__components_SideDrawer__["a" /* default */]
  },
  computed: {
    binding: function binding() {
      var binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    }
  },
  data: function data() {
    var _this = this;

    return {
      sideDrawer: {
        model: null,
        mini: false
      },
      sideItems: [{ icon: 'home', text: 'Home', link: '' }, { icon: 'lightbulb_outline', text: 'Inventions', link: '' }, { icon: 'people', text: 'People', link: '/people' }, { icon: 'work', text: 'Organizations', link: '' }],
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_1__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        data: {
          organization: {}
        },
        form: {
          validation: {
            overall: false,
            rules: {
              organization: {
                name: [function (v) {
                  return !!v || 'Name is required';
                }]
              }
            }
          },
          selected: {
            organization: {
              name: '',
              business_address: {
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                country: 'USA'
              }
            }
          },
          list: {
            countries: __WEBPACK_IMPORTED_MODULE_4_country_data___default.a.countries.all
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                name: component.C.form.selected.organization.name,
                business_address: component.C.form.selected.organization.business_address
              };

              var apiCallPromise;

              if (component.$route.params.id) {
                submitItem.organization_id = component.$route.params.id;

                apiCallPromise = __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/update', submitItem);
              } else {
                apiCallPromise = __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/create', submitItem);
              }

              apiCallPromise.then(function (response) {
                console.info('Manage Organization Results: ', response.data);

                if (component.$route.params.id) {
                  component.$router.push({
                    name: 'Organization',
                    params: {
                      id: component.$route.params.id
                    }
                  });
                } else {
                  component.$router.push({
                    name: 'Organizations'
                  });
                }

                __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                  type: 'success',
                  message: component.C.form.selected.organization.name + ' has been saved.'
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_2__assets_tools_js__["a" /* default */].getOrganization({
        id: this.$route.params.id,
        success: function success(organizationData) {
          component.C.data.organization = organizationData;

          component.C.form.selected.organization.name = organizationData.name;
          component.C.form.selected.organization.business_address = organizationData.business_address || {};

          component.C.form.selected.organization.business_address.country = component.C.form.selected.organization.business_address.country || 'USA';
        }
      });
    }
  }
});

/***/ }),

/***/ "Wuqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        data: {
          opportunities: []
        },
        filters: {
          selected: {
            organization_id: null,
            status: null
          },
          list: {
            organizations: [],
            statuses: [{
              label: 'Active',
              value: 'Active'
            }, {
              label: 'Inactive',
              value: 'Inactive'
            }]
          }
        },
        trigger: {
          downloadFile: function downloadFile(opportunityItem) {
            console.log('Running C.trigger.downloadFile()');

            __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/invention_opportunities/download_uploaded_file', {
              params: {
                invention_opportunity_id: opportunityItem.id
              },
              responseType: 'blob'
            }).then(function (response) {
              var url = window.URL.createObjectURL(new Blob([response.data]));
              var link = document.createElement('a');

              link.href = url;
              link.setAttribute('download', opportunityItem.uploaded_filename);
              document.body.appendChild(link);
              link.click();
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          },
          refreshBaseData: function refreshBaseData(options) {
            var component = _this;

            options = options || {};

            var filters = options.filters || {};

            var submitItem = {
              page: 1,
              size: 50,
              sort_column: 'created_at',
              sort_order: 'desc'
            };

            submitItem.organization_id = filters.organization_id || null;
            submitItem.status = filters.status || null;

            __WEBPACK_IMPORTED_MODULE_2__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/invention_opportunities/list', {
              params: submitItem
            }).then(function (response) {
              var opportunitiesList = response && response.data && response.data.data && response.data.data.invention_opportunities || [];

              component.C.data.opportunities = opportunitiesList;

              component.C.filters.selected.organization_id = submitItem.organization_id;
              component.C.filters.selected.status = submitItem.status;
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    component.C.trigger.refreshBaseData();

    __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].loggedInData({
      success: function success(loggedInItem) {
        if (loggedInItem.state.isGod || loggedInItem.state.isOrgAdmin) {
          __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getOrganizationsList({
            success: function success(organizationList) {
              component.C.filters.list.organizations = organizationList;
            }
          });
        }
      },
      error: function error(errorResponse) {
        __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
          type: 'error',
          errorResponse: errorResponse
        });
      }
    });
  }
});

/***/ }),

/***/ "Xmqe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layouts_Default__ = __webpack_require__("CPr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layouts_Editor__ = __webpack_require__("hvXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Authentication_MagicSignUp__ = __webpack_require__("FxtL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Authentication_MagicSignIn__ = __webpack_require__("F8d5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Authentication_PasswordSignUp__ = __webpack_require__("eYSH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Authentication_PasswordSignIn__ = __webpack_require__("AG2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_People_People__ = __webpack_require__("IDfc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_People_Add__ = __webpack_require__("Empj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_People_Person__ = __webpack_require__("2Dd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Opportunities_Opportunities__ = __webpack_require__("DPPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Opportunities_Add__ = __webpack_require__("jQ4P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Organizations_Organizations__ = __webpack_require__("gD1l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Organizations_Add__ = __webpack_require__("ZbMk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Organizations_Organization__ = __webpack_require__("ECAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Inventions_Inventions__ = __webpack_require__("rex7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Inventions_Solution__ = __webpack_require__("4xKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Inventions_Presentation__ = __webpack_require__("R9Pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_User_Profile__ = __webpack_require__("Dqi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_User_ProfileEdit__ = __webpack_require__("26kl");
























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/signup',
    name: 'MagicSignUp',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Authentication_MagicSignUp__["a" /* default */]
  }, {
    path: '/signin',
    name: 'MagicSignIn',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Authentication_MagicSignIn__["a" /* default */]
  }, {
    path: '/password-signin',
    name: 'PasswordSignIn',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Authentication_PasswordSignIn__["a" /* default */]
  }, {
    path: '/password-signup',
    name: 'PasswordSignUp',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Authentication_PasswordSignUp__["a" /* default */]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Layouts_Default__["a" /* default */],
    name: 'Default',
    redirect: function redirect(to) {
      if (window.localStorage.prolific_authorization) {
        if (window.localStorage.prolific_authorization_isGod === 'yes') {
          return {
            name: 'People'
          };
        } else {
          return {
            name: 'Inventions'
          };
        }
      } else {
        return {
          name: 'MagicSignIn'
        };
      }
    },
    children: [{
      path: '/people',
      name: 'People',
      component: __WEBPACK_IMPORTED_MODULE_8__components_People_People__["a" /* default */]
    }, {
      path: '/people/add',
      name: 'PeopleAdd',
      component: __WEBPACK_IMPORTED_MODULE_9__components_People_Add__["a" /* default */]
    }, {
      path: '/people/person/:id',
      name: 'Person',
      component: __WEBPACK_IMPORTED_MODULE_10__components_People_Person__["a" /* default */]
    }, {
      path: '/people/person/:id/edit',
      name: 'PersonEdit',
      component: __WEBPACK_IMPORTED_MODULE_9__components_People_Add__["a" /* default */]
    }, {
      path: '/opportunities',
      name: 'Opportunities',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Opportunities_Opportunities__["a" /* default */]
    }, {
      path: '/opportunities/opportunity/add',
      name: 'OpportunitiesAdd',
      component: __WEBPACK_IMPORTED_MODULE_12__components_Opportunities_Add__["a" /* default */]
    }, {
      path: '/opportunities/opportunity/:id/edit',
      name: 'OpportunityEdit',
      component: __WEBPACK_IMPORTED_MODULE_12__components_Opportunities_Add__["a" /* default */]
    }, {
      path: '/organizations',
      name: 'Organizations',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Organizations_Organizations__["a" /* default */]
    }, {
      path: '/organizations/add',
      name: 'OrganizationAdd',
      component: __WEBPACK_IMPORTED_MODULE_14__components_Organizations_Add__["a" /* default */]
    }, {
      path: '/organizations/organization/:id',
      name: 'Organization',
      component: __WEBPACK_IMPORTED_MODULE_15__components_Organizations_Organization__["a" /* default */]
    }, {
      path: '/organizations/organization/:id/edit',
      name: 'OrganizationEdit',
      component: __WEBPACK_IMPORTED_MODULE_14__components_Organizations_Add__["a" /* default */]
    }, {
      path: 'inventions',
      component: __WEBPACK_IMPORTED_MODULE_16__components_Inventions_Inventions__["a" /* default */],
      name: 'Inventions'
    }, {
      path: '/profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_19__components_User_Profile__["a" /* default */]
    }, {
      path: '/profile/edit',
      name: 'ProfileEdit',
      component: __WEBPACK_IMPORTED_MODULE_20__components_User_ProfileEdit__["a" /* default */]
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Layouts_Editor__["a" /* default */],
    children: [{
      path: '/inventions/:id',
      name: 'InventionSolution',
      component: __WEBPACK_IMPORTED_MODULE_17__components_Inventions_Solution__["a" /* default */]
    }, {
      path: '/inventions/:id/present',
      name: 'InventionPresentation',
      component: __WEBPACK_IMPORTED_MODULE_18__components_Inventions_Presentation__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "Z6j3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"login",attrs:{"fluid":"fluid","fill-height":"fill-height"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[(!_vm.C.state.emailSent && !_vm.C.state.magicLinkAttempt)?_c('v-flex',{attrs:{"sm6":"sm6","offset-sm3":"offset-sm3","lg4":"lg4","offset-lg4":"offset-lg4"}},[(_vm.C.error.active)?_c('v-alert',{staticClass:"mb-4",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.C.error.message))]):_vm._e(),_c('v-container',{attrs:{"grid-list-md":"grid-list-md","text-xs-center":"text-xs-center"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"xs12"}},[_c('svg',{attrs:{"width":"123","height":"29","viewbox":"0 0 123 29","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#FFFFFF","opacity":"0.5"}})])])])],1)],1),_c('v-card',{staticClass:"card--borderless pa-5"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Sign In")])]),_c('v-card-text',{staticClass:"py-0"},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.C.form.trigger.submit($event)}}},[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"E-mail","single-line":"single-line","rules":[_vm.rules.required, _vm.rules.email],"required":""},model:{value:(_vm.C.form.selected.account.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "email", $$v)},expression:"C.form.selected.account.email"}}),_c('v-card-text',{staticClass:"pa-0"},[_c('v-btn',{attrs:{"type":"submit","block":"block","large":"large","color":"primary","loading":_vm.C.state.isLoggingIn},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("Login"),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_vm._v("Logging in ...")])])],1)],1)],1)],1),(_vm.CR.show.unreleased)?_c('p',{staticClass:"pa-3 text-xs-center white--text"},[_vm._v("Not a member? "),_c('router-link',{staticClass:"text-link white--text",attrs:{"to":{name: "MagicSignUp"}}},[_vm._v("Create an account")]),_vm._v(".")],1):_vm._e()],1):_vm._e(),(!_vm.C.state.emailSent && _vm.C.state.magicLinkAttempt)?_c('v-flex',{attrs:{"sm6":"sm6","offset-sm3":"offset-sm3","lg4":"lg4","offset-lg4":"offset-lg4"}},[_c('v-layout',{staticClass:"text-xs-center",attrs:{"column":"column","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"xs12"}},[_c('svg',{attrs:{"width":"123","height":"29","viewbox":"0 0 123 29","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#FFFFFF","opacity":"0.5"}})])])])],1),_c('v-card',{staticClass:"card--borderless pa-5 pt-1"},[_c('v-card-title',{staticClass:"justify-center",attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Logging in...")])])],1)],1):_vm._e(),(_vm.C.state.emailSent)?_c('v-flex',{attrs:{"sm6":"sm6","offset-sm3":"offset-sm3","lg4":"lg4","offset-lg4":"offset-lg4"}},[_c('v-layout',{staticClass:"text-xs-center",attrs:{"column":"column","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"xs12"}},[_c('svg',{attrs:{"width":"123","height":"29","viewbox":"0 0 123 29","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#FFFFFF","opacity":"0.5"}})])])]),_c('v-card',{staticClass:"pa-5 pt-1"},[_c('v-card-title',{staticClass:"d-inline-flex",attrs:{"primary-title":""}},[_c('div',{staticClass:"icon-magic-link mb-4 d-block"},[_c('svg',{staticStyle:{"width":"160px","height":"140px","vertical-align":"middle","display":"inline-block","fill":"currentcolor"},attrs:{"viewbox":"0 0 160 140","aria-hidden":"true","focusable":"false"}},[_c('g',{attrs:{"id":"Admin-&-Settings","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"fill":"#b3c0c3","points":"5.568 0 60.9546667 51.9238095 116.333714 0"}}),_c('path',{attrs:{"d":"M53.3333333,91.4285714 C53.3333333,106.666667 38.0952381,106.666667 38.0952381,106.666667 C38.0952381,106.666667 53.3333333,106.666667 53.3333333,121.904762 C53.3333333,121.904762 53.3333333,106.666667 68.5714286,106.666667 C53.3333333,106.666667 53.3333333,91.4285714 53.3333333,91.4285714","fill":"#00BF1B"}}),_c('path',{attrs:{"d":"M84.2380952,109 C84.2380952,124.238095 69,124.238095 69,124.238095 C69,124.238095 84.2380952,124.238095 84.2380952,139.47619 C84.2380952,139.47619 84.2380952,124.238095 99.4761905,124.238095 C84.2380952,124.238095 84.2380952,109 84.2380952,109","fill":"#00BF1B"}}),_c('path',{attrs:{"d":"M144.761905,45.7142857 C144.761905,45.7142857 144.761905,30.4761905 160,30.4761905 C144.761905,30.4761905 144.761905,15.2380952 144.761905,15.2380952 C144.761905,30.4761905 129.52381,30.4761905 129.52381,30.4761905 C129.52381,30.4761905 144.761905,30.4761905 144.761905,45.7142857","fill":"#00BF1B"}}),_c('path',{attrs:{"d":"M121.904762,41.9047619 L121.904762,5.22285714 L60.952381,62.3657143 L0,5.22285714 L0,83.8095238 L80,83.8095238 C80,60.6666667 98.7619048,41.9047619 121.904762,41.9047619","fill":"#b3c0c3"}}),_c('path',{attrs:{"d":"M127.619048,91.4285714 C125.325714,91.4285714 123.20381,90.7961905 121.321905,89.7790476 L115.862857,95.2380952 L120.788571,100.16381 L115.401905,105.550476 L110.47619,100.624762 L105.550476,105.550476 L100.16381,100.16381 L115.935238,84.392381 C114.918095,82.5104762 114.285714,80.3885714 114.285714,78.0952381 C114.285714,70.7314286 120.255238,64.7619048 127.619048,64.7619048 C134.982857,64.7619048 140.952381,70.7314286 140.952381,78.0952381 C140.952381,85.4590476 134.982857,91.4285714 127.619048,91.4285714 M121.904762,49.5238095 C102.967619,49.5238095 87.6190476,64.872381 87.6190476,83.8095238 C87.6190476,102.746667 102.967619,118.095238 121.904762,118.095238 C140.841905,118.095238 156.190476,102.746667 156.190476,83.8095238 C156.190476,64.872381 140.841905,49.5238095 121.904762,49.5238095","fill":"#222222"}}),_c('path',{attrs:{"d":"M127.619048,72.3809524 C124.468571,72.3809524 121.904762,74.9447619 121.904762,78.0952381 C121.904762,81.2457143 124.468571,83.8095238 127.619048,83.8095238 C130.769524,83.8095238 133.333333,81.2457143 133.333333,78.0952381 C133.333333,74.9447619 130.769524,72.3809524 127.619048,72.3809524","fill":"#222222"}})])])])]),_c('v-card-text',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"title mb-3"},[_vm._v("Account access link sent to your inbox. ")]),_c('p',{staticClass:"mb-0"},[_vm._v("We sent a link to "),_c('strong',[_vm._v(_vm._s(_vm.C.form.selected.account.email))])]),_c('p',{staticClass:"mb-0"},[_vm._v("Click the link to be signed in")])])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZHDH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZbMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("W4Fv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275b614a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("tgRA");
function injectStyle (ssrContext) {
  __webpack_require__("4Buq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-275b614a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275b614a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zxa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{staticClass:"ml-0",attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/opportunities"}},[_c('h2',[_vm._v("Invention Opportunities")])])],1),_c('v-breadcrumbs-item',[(_vm.C.view.type.add)?_c('h2',{staticClass:"ma-0"},[_vm._v("Add Opportunity")]):_vm._e(),(_vm.C.view.type.edit)?_c('h2',{staticClass:"ma-0"},[_vm._v("Edit Opportunity")]):_vm._e()])],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[[_c('v-form',{ref:"form",staticClass:"form--edit",attrs:{"lazy-validation":"lazy-validation"},model:{value:(_vm.C.form.validation.overall),callback:function ($$v) {_vm.$set(_vm.C.form.validation, "overall", $$v)},expression:"C.form.validation.overall"}},[_c('div',{staticClass:"section__title"},[_c('div',{staticClass:"subheading"},[_vm._v("Opportunity Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Opportunity Title")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"rules":_vm.C.form.validation.rules.invention_opportunity.title,"single-line":"single-line","maxlength":255,"required":"required"},model:{value:(_vm.C.form.selected.invention_opportunity.title),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "title", $$v)},expression:"C.form.selected.invention_opportunity.title"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Opportunity Description")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"multi-line":"multi-line","rules":_vm.C.form.validation.rules.invention_opportunity.short_description,"required":"required"},model:{value:(_vm.C.form.selected.invention_opportunity.short_description),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "short_description", $$v)},expression:"C.form.selected.invention_opportunity.short_description"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Expires")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-menu',{staticClass:"d-block"},[_c('v-text-field',{staticClass:"input--box",attrs:{"slot":"activator","append-icon":"event","readonly":"readonly","single-line":"single-line","required":"required"},slot:"activator",model:{value:(_vm.C.form.selected.invention_opportunity.closing_date),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "closing_date", $$v)},expression:"C.form.selected.invention_opportunity.closing_date"}}),_c('v-date-picker',{staticClass:"input--box",attrs:{"no-title":"no-title","actions":"actions"},model:{value:(_vm.C.form.selected.invention_opportunity.closing_date),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "closing_date", $$v)},expression:"C.form.selected.invention_opportunity.closing_date"}})],1)],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Status")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box",attrs:{"label":"Status","items":_vm.C.form.list.status,"item-text":"label","item-value":"value","single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.invention_opportunity.status),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "status", $$v)},expression:"C.form.selected.invention_opportunity.status"}})],1)],1),(_vm.C.view.type.add && _vm.C.form.list.organizations.length > 1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Organization")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box",attrs:{"items":_vm.C.form.list.organizations,"item-text":"name","item-value":"id","single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.organization_id),callback:function ($$v) {_vm.$set(_vm.C.form.selected, "organization_id", $$v)},expression:"C.form.selected.organization_id"}})],1)],1):_vm._e(),_c('v-layout',{attrs:{"row":"row"}},[(!(_vm.C.view.type.edit && _vm.C.data.opportunity.uploaded_filename))?_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Upload PDF or Word Document")])],1):_vm._e(),((_vm.C.view.type.edit && _vm.C.data.opportunity.uploaded_filename) && !_vm.C.form.selected.upload)?_c('v-flex',{attrs:{"md4":"md4"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Uploaded Opportunity: "+_vm._s(_vm.C.data.opportunity.uploaded_filename))]),_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Replace file (upload PDF or Word Document)")])],1):_vm._e(),_c('v-flex',{attrs:{"md6":"md6"}},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.C.form.trigger.fileUpload}})])],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Presentation Template")])],1),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box",attrs:{"items":_vm.C.form.list.presentation_templates,"item-text":"label","item-value":"value","single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.invention_opportunity.presentation_template),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention_opportunity, "presentation_template", $$v)},expression:"C.form.selected.invention_opportunity.presentation_template"}})],1)],1)],1)],_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}}),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-btn',{staticClass:"ml-0",attrs:{"disabled":!_vm.C.form.validation.overall || (_vm.C.view.type.add && !_vm.C.form.selected.organization_id) || !(_vm.C.view.type.edit || (_vm.C.view.type.add && _vm.C.form.selected.upload)),"color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v("Save")]),_c('v-btn',{attrs:{"to":{name: "Opportunities"}}},[_vm._v("Cancel")])],1)],1)],2),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block",staticStyle:{"width":"220px","position":"fixed"}},[_c('v-card',[_c('v-card-title',[_vm._v("Some helpful tips on creating an attractive Invention Opportunity.")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ayUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var settings = {
  authorization: {
    loggedIn: false,
    state: {},
    data: {}
  },
  show: {
    unreleased: '' + "no" === 'yes',
    alert: {
      active: false,
      type: 'info',
      message: '',
      timer: null
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),

/***/ "bTge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletionCheck_vue__ = __webpack_require__("tNCf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c4c8aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CompletionCheck_vue__ = __webpack_require__("yB1E");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompletionCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c4c8aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CompletionCheck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cdjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicTooltip_vue__ = __webpack_require__("T+e2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d7d608_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_BasicTooltip_vue__ = __webpack_require__("yTgj");
function injectStyle (ssrContext) {
  __webpack_require__("fsAW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39d7d608"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d7d608_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_BasicTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e1M+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.C.state.dialog.confirmArchiveInvention.active),callback:function ($$v) {_vm.$set(_vm.C.state.dialog.confirmArchiveInvention, "active", $$v)},expression:"C.state.dialog.confirmArchiveInvention.active"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Notice")]),_c('v-card-text',[_vm._v("Do you wish to archive this invention?")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.state.dialog.confirmArchiveInvention.active = false}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.trigger.confirmArchiveInvention()}}},[_vm._v("Confirm")])],1)],1)],1)],1)],_c('v-navigation-drawer',{staticClass:"side-panel",attrs:{"width":"680","right":"right","temporary":"temporary","fixed":"fixed","hide-overlay":"hide-overlay","app":"app"},model:{value:(_vm.P.state.selected.invention.active),callback:function ($$v) {_vm.$set(_vm.P.state.selected.invention, "active", $$v)},expression:"P.state.selected.invention.active"}},[(_vm.P.state.selected.invention.details)?_c('v-toolbar',{staticClass:"transparent",attrs:{"tabs":"tabs","flat":"flat"}},[_c('v-layout',{staticClass:"pl-3 pr-2",attrs:{"row":"row","nowrap":"nowrap","fill-height":"fill-height","align-end":"align-end"}},[_c('v-tabs',{staticClass:"side-panel__tabbar",attrs:{"slot":"extension","slider-color":"primary"},slot:"extension",model:{value:(_vm.P.state.sidepanel.tab),callback:function ($$v) {_vm.$set(_vm.P.state.sidepanel, "tab", $$v)},expression:"P.state.sidepanel.tab"}},[_c('v-tab',{attrs:{"href":"#tab-1","ripple":false}},[_vm._v("Concept")]),_c('v-tab',{attrs:{"href":"#tab-2","ripple":false}},[_vm._v("Comments")]),_c('v-tab',{attrs:{"href":"#tab-3","ripple":false}},[_vm._v("Scratchpad")]),_c('v-tab',{attrs:{"href":"#tab-4","ripple":false},on:{"click":function($event){_vm.C.trigger.refreshFormOrganizationOptions(_vm.P.form.selected.invention.organization_id, true)}}},[_vm._v("Details")])],1),_c('v-spacer'),((_vm.P.state.selected.invention.data.phase !== "phase-2" && _vm.P.state.selected.invention.data.phase !== "phase-3" && _vm.P.state.selected.invention.data.phase !== "phase-4" && _vm.P.state.selected.invention.data.phase !== "phase-5") && _vm.P.state.selected.invention.isEditable)?_c('v-btn',{attrs:{"disabled":!_vm.P.form.selected.invention.title,"flat":"flat","color":"primary"},on:{"click":_vm.C.form.trigger.letsinvent}},[_vm._v("Let's Invent")]):_vm._e(),(_vm.P.state.selected.invention.isEditable)?_c('v-btn',{attrs:{"disabled":!_vm.P.form.selected.invention.title,"color":"primary","dark":"dark"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v(_vm._s(_vm.C.form.state.recentSaveActive ? 'Saved!' : 'Save'))]):_vm._e(),_c('div',[_c('v-btn',{attrs:{"icon":"icon","flat":"flat","color":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.P.state.selected.invention.active = !_vm.P.state.selected.invention.active}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1):_vm._e(),_c('v-tabs-items',{staticClass:"px-4",model:{value:(_vm.P.state.sidepanel.tab),callback:function ($$v) {_vm.$set(_vm.P.state.sidepanel, "tab", $$v)},expression:"P.state.sidepanel.tab"}},[_c('v-tab-item',{key:1,staticClass:"py-4 px-4",attrs:{"id":"tab-1"}},[_c('div',{staticClass:"text-xs-right"}),_c('v-layout',{attrs:{"column":"column","nowrap":"nowrap"}},[_c('v-flex',[_c('v-text-field',{staticClass:"mb-3 input-group-large",attrs:{"label":"Title of your concept","disabled":(_vm.P.state.selected.invention.details && !_vm.P.state.selected.invention.isEditable),"counter":100,"solo":"solo"},model:{value:(_vm.P.form.selected.invention.title),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention, "title", $$v)},expression:"P.form.selected.invention.title"}})],1)],1),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[(!_vm.P.state.selected.invention.details)?_c('v-flex',{staticStyle:{"flex":"0 0 auto"}},[_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.P.state.selected.invention.active = !_vm.P.state.selected.invention.active}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"disabled":!_vm.P.form.selected.invention.title,"color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v("Continue")])],1):_vm._e()],1),(_vm.P.state.selected.invention.details)?_c('v-layout',{staticClass:"mt-4",attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":"xs12"}},[_c('label',[_vm._v("Summary of concept")])]),_c('v-flex',{attrs:{"xs12":"xs12"}},[(_vm.P.state.selected.invention.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.P.form.selected.invention.description),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention, "description", $$v)},expression:"P.form.selected.invention.description"}}):_vm._e(),(!_vm.P.state.selected.invention.isEditable)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.P.form.selected.invention.description)}}):_vm._e()],1)],1):_vm._e()],1),_c('v-tab-item',{key:2,staticClass:"py-4 px-4",attrs:{"id":"tab-2"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_vm._l((_vm.P.form.selected.comments.$list),function(comment){return _c('v-flex',{key:comment.id,attrs:{"xs12":"xs12"}},[_c('v-card',{staticClass:"card--borderless pb-3",attrs:{"flat":"flat"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between"}},[_c('v-flex',{attrs:{"xs1":"xs1"}},[_c('avatar',{attrs:{"username":comment.user_name ? comment.user_name : "?"}})],1),_c('v-flex',{staticClass:"pl-4"},[_c('v-layout',{staticClass:"mb-2",attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between","align-center":"align-center"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(comment.user_name))]),_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm._f("moment")(comment.created_time,"h:mm A, MMM D, YYYY")))])]),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(comment.content))])],1)],1)],1),_c('v-divider')],1)}),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card',{staticClass:"card--borderless py-0",attrs:{"flat":"flat"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between"}},[_c('v-flex',{attrs:{"xs1":"xs1"}},[_c('avatar',{staticClass:"mt-4",attrs:{"username":_vm.CR.authorization.data.fullname ? _vm.CR.authorization.data.fullname : "?"}})],1),_c('v-flex',{staticClass:"pl-4"},[_c('v-text-field',{attrs:{"textarea":"textarea","label":"Comment","counter":500,"auto-grow":"auto-grow","rows":"2"},model:{value:(_vm.P.form.selected.comments.content),callback:function ($$v) {_vm.$set(_vm.P.form.selected.comments, "content", $$v)},expression:"P.form.selected.comments.content"}})],1)],1),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-end":"justify-end"}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"secondary"},on:{"click":_vm.C.form.trigger.addComment}},[_vm._v("Send")])],1)],1)],1)],2)],1),_c('v-tab-item',{key:3,staticClass:"py-4 px-4",attrs:{"id":"tab-3"}},[_c('div',{staticClass:"text-xs-right"}),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[(_vm.P.state.selected.invention.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.P.form.selected.scratchpad),callback:function ($$v) {_vm.$set(_vm.P.form.selected, "scratchpad", $$v)},expression:"P.form.selected.scratchpad"}}):_vm._e(),(!_vm.P.state.selected.invention.isEditable)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.P.form.selected.scratchpad)}}):_vm._e()],1)],1)],1),_c('v-tab-item',{key:4,staticClass:"py-4 px-4",attrs:{"id":"tab-4"}},[(_vm.P.form.error.active && ((_vm.P.form.error.type === "letsinvent-missingfields-organization" && !_vm.P.form.selected.invention.organization_id) || (_vm.P.form.error.type === "letsinvent-missingfields-opportunity" && !_vm.P.form.selected.invention.invention_opportunity_id) || (_vm.P.form.error.type === "N/A")))?_c('v-alert',{staticClass:"mt-1 mb-4",attrs:{"type":"error","value":true}},[(_vm.P.form.error.type === "letsinvent-missingfields-organization" && !_vm.P.form.selected.invention.organization_id)?_c('span',[_vm._v("Please select an organization.")]):_vm._e(),(_vm.P.form.error.type === "letsinvent-missingfields-opportunity" && !_vm.P.form.selected.invention.invention_opportunity_id)?_c('span',[_vm._v("Please select an opportunity.")]):_vm._e(),(_vm.P.form.error.type === "N/A")?_c('span',[_vm._v("Sorry, something has went wrong!")]):_vm._e()]):_vm._e(),(_vm.C.form.list.organizations.length > 1)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("business")])],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"Organization","disabled":_vm.P.state.selected.invention.details && (!!_vm.P.state.selected.invention.data.organization || !_vm.P.state.selected.invention.isEditable),"items":_vm.C.form.list.organizations,"item-text":"name","item-value":"id","required":"required"},on:{"change":function($event){_vm.C.trigger.refreshFormOrganizationOptions($event)}},model:{value:(_vm.P.form.selected.invention.organization_id),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention, "organization_id", $$v)},expression:"P.form.selected.invention.organization_id"}})],1)],1):_vm._e(),(_vm.P.form.selected.invention.organization_id || _vm.C.form.list.organizations.length === 1)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("add_to_photos")])],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"Opportunity","items":_vm.C.form.list.opportunities,"item-text":"title","item-value":"id","disabled":!_vm.P.state.selected.invention.isEditable},model:{value:(_vm.P.form.selected.invention.invention_opportunity_id),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention, "invention_opportunity_id", $$v)},expression:"P.form.selected.invention.invention_opportunity_id"}})],1)],1):_vm._e(),(_vm.P.state.selected.invention.isEditable && _vm.CR.show.unreleased)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Add a Search","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"search"},on:{"focus":function($event){_vm.C.form.state.active.$search = true}},model:{value:(_vm.P.form.selected.invention.$search.title),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention.$search, "title", $$v)},expression:"P.form.selected.invention.$search.title"}})],1)],1):_vm._e(),(_vm.P.state.selected.invention.isEditable && _vm.CR.show.unreleased)?_c('transition',{attrs:{"name":"expand"}},[(_vm.C.form.state.active.$search)?_c('div',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Paste URL","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"insert_link"},model:{value:(_vm.P.form.selected.invention.$search.url),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention.$search, "url", $$v)},expression:"P.form.selected.invention.$search.url"}})],1),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Search Note","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"note"},model:{value:(_vm.P.form.selected.invention.$search.note),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention.$search, "note", $$v)},expression:"P.form.selected.invention.$search.note"}})],1),_c('v-flex',{staticStyle:{"padding-left":"33px"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addSearchItem()}}},[_vm._v("Save Search")]),_c('v-btn',{on:{"click":function($event){_vm.C.form.state.active.$search = false}}},[_vm._v("Cancel")])],1)],1):_vm._e()]):_vm._e(),_vm._l((_vm.P.form.selected.invention.search),function(searchItem,searchItemIndex){return (_vm.CR.show.unreleased)?_c('v-layout',{key:searchItemIndex,staticClass:"mb-3",attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',[_vm._v("youtube_searched_for")]),_c('v-flex',{staticClass:"pl-3"},[(!searchItem.url)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),(searchItem.url)?_c('a',{attrs:{"href":searchItem.url,"target":"_blank"}},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),_c('p',{staticClass:"mb-0 grey--text"},[_vm._v(_vm._s(searchItem.note))])]),(_vm.P.state.selected.invention.isEditable)?_c('div',{staticClass:"search-list__close"},[(!searchItem.remove)?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),(searchItem.remove)?_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1):_vm._e()],1):_vm._e()}),((_vm.P.form.selected.invention.organization_id || _vm.C.form.list.organizations.length === 1) && _vm.P.state.selected.invention.isEditable)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("comment")])],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"hint":"Bulk Read Access","persistent-hint":"persistent-hint","items":_vm.C.form.list.bulkDefaultAccessOptions,"item-text":"label","item-value":"value"},model:{value:(_vm.P.form.selected.invention.bulk_read_access),callback:function ($$v) {_vm.$set(_vm.P.form.selected.invention, "bulk_read_access", $$v)},expression:"P.form.selected.invention.bulk_read_access"}})],1)],1):_vm._e(),((_vm.P.form.selected.invention.organization_id || _vm.C.form.list.organizations.length === 1) && _vm.P.state.selected.invention.isEditable)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row","align-start":"align-start","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("people")])],1),_c('v-flex',{staticClass:"mr-3",staticStyle:{"flex":"0 0 220px"}},[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"User","autocomplete":"autocomplete","items":_vm._f("F_availableCollaborators")(_vm.C.form.list.inventors,_vm.P.form.selected.co_inventors),"item-text":"fullname","hide-details":"hide-details"},model:{value:(_vm.P.form.selected.$collaborator.$item),callback:function ($$v) {_vm.$set(_vm.P.form.selected.$collaborator, "$item", $$v)},expression:"P.form.selected.$collaborator.$item"}})],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"Access","items":_vm._f("F_availableAccess")(_vm.C.form.list.collaboratorAccessOptions.items,_vm.P.state.selected.invention.data.phase),"item-text":"label","item-value":"value","hide-details":"hide-details"},model:{value:(_vm.P.form.selected.$collaborator.access),callback:function ($$v) {_vm.$set(_vm.P.form.selected.$collaborator, "access", $$v)},expression:"P.form.selected.$collaborator.access"}})],1),_c('v-spacer'),_c('v-flex',{staticStyle:{"flex":"0 0 auto"}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.addCollaboratorItem()}}},[_vm._v("Add Collaborator")])],1)],1):_vm._e(),_c('v-layout',{staticClass:"edit-inline"},[_c('v-flex'),_c('v-flex',_vm._l((_vm.P.form.selected.co_inventors),function(collaborator,collaboratorIndex){return _c('v-list',{key:collaborator.user_id,attrs:{"dense":"dense"}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('h3',{attrs:{"color":"primary"}},[_vm._v(_vm._s(collaborator.$name))])]),_c('v-list-tile-sub-title',[_vm._v(_vm._s(collaborator.access && _vm.C.form.list.collaboratorAccessOptions.dictionary[collaborator.access.toString()]))])],1),(_vm.P.state.selected.invention.isEditable)?_c('v-list-tile-action',[(!collaborator.remove)?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),(collaborator.remove)?_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1):_vm._e()],1)],1)}))],1),(_vm.P.state.selected.invention.data.role === "Inventor")?_c('v-layout',{staticClass:"edit-inline"},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("close")])],1),_c('v-flex',[_c('a',{on:{"click":function($event){_vm.C.form.trigger.archiveInvention()}}},[_vm._v("Archive this concept")])])],1):_vm._e()],2)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eYSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordSignUp_vue__ = __webpack_require__("Mejg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a4837d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordSignUp_vue__ = __webpack_require__("Docm");
function injectStyle (ssrContext) {
  __webpack_require__("EopR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a4837d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordSignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a4837d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordSignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fp2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('side-panel',{attrs:{"P":_vm.C}}),_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{staticClass:"ml-0",attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0 mr-3"},[_vm._v("Inventions")])])],1),_c('v-spacer'),_c('v-btn-toggle',{staticClass:"mr-5",model:{value:(_vm.inventionsListToggle),callback:function ($$v) {_vm.inventionsListToggle=$$v},expression:"inventionsListToggle"}},[_c('v-btn',{attrs:{"small":"small","flat":"flat"},on:{"click":function($event){_vm.seen = !_vm.seen}}},[_vm._v("List view")]),_c('v-btn',{attrs:{"small":"small","flat":"flat"},on:{"click":function($event){_vm.seen = !_vm.seen}}},[_vm._v("Table view")])],1),_c('v-btn',{staticClass:"page-header__action",attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.C.trigger.toggleAddInventionPanel($event)}}},[_vm._v("Add Concept")])],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[(!_vm.seen)?[_c('v-tabs',{attrs:{"slider-color":"primary","height":"45"}},[_c('v-tab',{attrs:{"ripple":false},on:{"click":function($event){_vm.C.filters.selected.user_role = null; _vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected });}}},[_vm._v("Recent concepts")]),_c('v-tab',{attrs:{"ripple":false},on:{"click":function($event){_vm.C.filters.selected.user_role = "inventor"; _vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected });}}},[_vm._v("Created by me")]),_c('v-tab',{attrs:{"ripple":false},on:{"click":function($event){_vm.C.filters.selected.user_role = "co_inventor"; _vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected });}}},[_vm._v("Co-inventing")]),_c('v-tab',{attrs:{"ripple":false},on:{"click":function($event){_vm.C.filters.selected.user_role = "mentor"; _vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected });}}},[_vm._v("Mentoring")])],1),_c('v-data-iterator',{staticClass:"inventions__list",attrs:{"items":_vm.C.data.inventions,"row":"row","wrap":"wrap","hide-actions":"hide-actions"},scopedSlots:_vm._u([{key:"item",fn:function(invention){return _c('v-flex',{staticClass:"px-0",attrs:{"xs12":"xs12","sm6":"sm6","md12":"md12"}},[_c('v-card',{staticClass:"card--borderless border--bottom",attrs:{"floating":"floating"}},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-center":"align-center"}},[_c('v-flex',[_c('v-card-title',{staticClass:"pa-0 pt-2"},[_c('h3',[_c('a',{on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item)}}},[_vm._v(_vm._s(invention.item.title))])])]),_c('v-card-text',{staticClass:"pl-2 pt-2"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[(invention.item.role)?_c('p',{staticClass:"body-1"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small","color":"primary"}},[_vm._v("person")]),_vm._v(_vm._s(invention.item.role)),_c('span',{staticClass:"grey--text px-3"},[_vm._v("•")])],1):_vm._e(),(invention.item.phase ? _vm.C.dictionary.phase[invention.item.phase] : 'Concept')?_c('p',{staticClass:"body-1"},[_c('v-icon',{attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]),_vm._v(_vm._s(invention.item.phase ? _vm.C.dictionary.phase[invention.item.phase] : 'Concept')),_c('span',{staticClass:"grey--text px-3"},[_vm._v("•")])],1):_vm._e(),(invention.item.opportunity)?_c('p',{staticClass:"body-1"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small","color":"primary"}},[_vm._v("add_to_photos")]),_vm._v(_vm._s(invention.item && invention.item.opportunity && invention.item.opportunity.title)),_c('span',{staticClass:"grey--text px-3"},[_vm._v("•")])],1):_vm._e(),_c('p',{staticClass:"body-1"},[_vm._v(_vm._s(_vm._f("moment")(invention.item.updated_time,"MMM D, YYYY")))])])],1)],1),_c('v-spacer'),_c('div',{staticClass:"pr-3"},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","justify-end":"justify-end","align-center":"align-center"}},[(invention.item.comments_count > 0)?_c('div',{staticClass:"comment",on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item, !(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"), "tab-2")}}},[_c('v-icon',{attrs:{"medium":"medium"}},[_vm._v("chat_bubble")]),_c('div',{staticClass:"comment--count white--text body-2"},[_vm._v(_vm._s(invention.item.comments_count))])],1):_vm._e(),((invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"))?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item, true)}}},[_c('v-icon',[_vm._v("mode_edit")])],1):_vm._e()],1)],1)],1)],1)],1)}}])})]:_vm._e(),(_vm.seen)?_c('v-data-table',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.C.event.extendInventionsList),expression:"C.event.extendInventionsList"}],attrs:{"headers":_vm.headers,"items":_vm.C.data.inventions,"hide-actions":"hide-actions","disable-initial-sort":true,"infinite-scroll-disabled":"C.state.infiniteScroll.inventionsList.active","infinite-scroll-throttle-delay":"C.state.infiniteScroll.inventionsList.throttle"},scopedSlots:_vm._u([{key:"items",fn:function(invention){return [_c('tr',[_c('td',[(invention.item.comments_count > 0)?_c('div',{staticClass:"comment",on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item, !(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"), "tab-2")}}},[_c('v-icon',{attrs:{"medium":"medium"}},[_vm._v("chat_bubble")]),_c('div',{staticClass:"comment--count white--text body-2"},[_vm._v(_vm._s(invention.item.comments_count))])],1):_vm._e()]),_c('td',{on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item)}}},[_c('a',[_vm._v(_vm._s(invention.item.title))])]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(invention.item.phase ? _vm.C.dictionary.phase[invention.item.phase] : 'Concept'))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(invention.item.role))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(invention.item && invention.item.opportunity && invention.item.opportunity.title))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm._f("moment")(invention.item.updated_time,"MMM D, YYYY")))]),_c('td',{staticClass:"text-xs-right"},[((invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"))?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.trigger.selectInvention(invention.item, true)}}},[_c('v-icon',[_vm._v("mode_edit")])],1):_vm._e()],1)])]}}])}):_vm._e()],2),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block pt-4",staticStyle:{"width":"220px","position":"fixed"}},[_c('div',{staticClass:"body-1 mb-0",staticStyle:{"position":"absolute","top":"10px"}},[_vm._v("Narrow Search")]),_c('v-text-field',{staticClass:"input--box",attrs:{"append-icon":"search","label":"Search","single-line":"single-line","hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.title),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "title", $$v)},expression:"C.filters.selected.title"}}),(_vm.C.filters.list.organizations.length > 1)?_c('v-select',{staticClass:"input--box",attrs:{"label":"All Organizations","items":_vm.C.filters.list.organizations,"item-text":"name","item-value":"id","clearable":true,"single-line":"single-line","hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.organization_id),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "organization_id", $$v)},expression:"C.filters.selected.organization_id"}}):_vm._e(),_c('v-select',{staticClass:"input--box",attrs:{"label":"All Roles","items":_vm.C.filters.list.user_roles,"item-text":"label","item-value":"value","clearable":true,"single-line":"single-line","hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.user_role),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "user_role", $$v)},expression:"C.filters.selected.user_role"}}),_c('v-select',{staticClass:"input--box",attrs:{"label":"All Statuses","items":_vm.C.filters.list.phases,"item-text":"label","item-value":"value","clearable":true,"single-line":"single-line","hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.phase),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "phase", $$v)},expression:"C.filters.selected.phase"}}),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',[_c('v-btn',{attrs:{"block":"block"},on:{"click":function($event){_vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected })}}},[_vm._v("Go")])],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fsAW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fu9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"py-3 px-5"},[_c('v-navigation-drawer',{staticClass:"side-panel",attrs:{"width":"680","right":"right","clipped":"clipped","temporary":"temporary","fixed":"fixed","hide-overlay":"hide-overlay"},model:{value:(_vm.C.state.panel.settings),callback:function ($$v) {_vm.$set(_vm.C.state.panel, "settings", $$v)},expression:"C.state.panel.settings"}},[(_vm.C.state.isEditable)?_c('v-toolbar',{staticClass:"transparent",attrs:{"tabs":"tabs","flat":"flat"}},[_c('v-layout',{staticClass:"px-3",attrs:{"row":"row","nowrap":"nowrap","fill-height":"fill-height","align-end":"align-end"}},[_c('v-btn',{attrs:{"disabled":!_vm.C.form.selected.invention.title,"color":"primary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.saveAll(false)}}},[_vm._v(_vm._s(_vm.C.form.state.recentSaveActive ? 'Saved!' : 'Save'))])],1)],1):_vm._e(),_c('v-card',{staticClass:"py-4 px-4"},[_c('v-layout',{staticClass:"edit-inline mb-3",attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("title")])],1),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Title","counter":100,"solo":"solo"},model:{value:(_vm.C.form.selected.invention.title),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention, "title", $$v)},expression:"C.form.selected.invention.title"}})],1)],1),_c('v-layout',{staticClass:"edit-inline mb-4",attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',{staticClass:"pt-0"},[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("business")])],1),_c('v-flex',[_c('p',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.C.data.invention.organization && _vm.C.data.invention.organization.name))])])],1),_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("add_to_photos")])],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"Opportunity","items":_vm.C.form.list.opportunities,"item-text":"title","item-value":"id","disabled":!_vm.C.state.isEditable},model:{value:(_vm.C.form.selected.invention.invention_opportunity_id),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention, "invention_opportunity_id", $$v)},expression:"C.form.selected.invention.invention_opportunity_id"}})],1)],1),(_vm.C.state.isEditable && _vm.CR.show.unreleased)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Add a Search","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"search"},on:{"focus":function($event){_vm.C.form.state.active.$search = true}},model:{value:(_vm.C.form.selected.invention.$search.title),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "title", $$v)},expression:"C.form.selected.invention.$search.title"}})],1)],1):_vm._e(),(_vm.C.state.isEditable && _vm.CR.show.unreleased)?_c('transition',{attrs:{"name":"expand"}},[(_vm.C.form.state.active.$search)?_c('div',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Paste URL","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"insert_link"},model:{value:(_vm.C.form.selected.invention.$search.url),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "url", $$v)},expression:"C.form.selected.invention.$search.url"}})],1),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"label":"Search Note","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"note"},model:{value:(_vm.C.form.selected.invention.$search.note),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "note", $$v)},expression:"C.form.selected.invention.$search.note"}})],1),_c('v-flex',{staticStyle:{"padding-left":"33px"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addSearchItem()}}},[_vm._v("Add")]),_c('v-btn',{on:{"click":function($event){_vm.C.form.state.active.$search = false}}},[_vm._v("Cancel")])],1)],1):_vm._e()]):_vm._e(),_vm._l((_vm.C.form.selected.invention.search),function(searchItem,searchItemIndex){return (_vm.CR.show.unreleased)?_c('v-layout',{key:searchItemIndex,staticClass:"mb-3",attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',[_vm._v("youtube_searched_for")]),_c('v-flex',{staticClass:"pl-4"},[(!searchItem.url)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),(searchItem.url)?_c('a',{attrs:{"href":searchItem.url,"target":"_blank"}},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),_c('p',{staticClass:"mb-0 grey--text"},[_vm._v(_vm._s(searchItem.note))])]),(_vm.C.state.isEditable)?_c('div',{staticClass:"search-list__close"},[(!searchItem.remove)?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),(searchItem.remove)?_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1):_vm._e()],1):_vm._e()}),(_vm.C.state.isEditable)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("comment")])],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"hint":"Bulk Read Access","persistent-hint":"persistent-hint","items":_vm.C.form.list.bulkDefaultAccessOptions,"item-text":"label","item-value":"value"},model:{value:(_vm.C.form.selected.invention.bulk_read_access),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention, "bulk_read_access", $$v)},expression:"C.form.selected.invention.bulk_read_access"}})],1)],1):_vm._e(),(_vm.C.state.isEditable)?_c('v-layout',{staticClass:"edit-inline",attrs:{"row":"row","align-start":"align-start","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("people")])],1),_c('v-flex',{staticClass:"mr-3",staticStyle:{"flex":"0 0 220px"}},[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"User","autocomplete":"autocomplete","items":_vm._f("F_availableCollaborators")(_vm.C.form.list.inventors,_vm.C.form.selected.co_inventors),"item-text":"fullname","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.$collaborator.$item),callback:function ($$v) {_vm.$set(_vm.C.form.selected.$collaborator, "$item", $$v)},expression:"C.form.selected.$collaborator.$item"}})],1),_c('v-flex',[_c('v-select',{staticClass:"input--box",attrs:{"single-line":"single-line","label":"Access","items":_vm._f("F_availableAccess")(_vm.C.form.list.collaboratorAccessOptions.items,_vm.C.data.invention.phase),"item-text":"label","item-value":"value","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.$collaborator.access),callback:function ($$v) {_vm.$set(_vm.C.form.selected.$collaborator, "access", $$v)},expression:"C.form.selected.$collaborator.access"}})],1),_c('v-spacer'),_c('v-flex',{staticStyle:{"flex":"0 0 auto"}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.addCollaboratorItem()}}},[_vm._v("Add Collaborator")])],1)],1):_vm._e(),_c('v-layout',{staticClass:"edit-inline"},[_c('v-flex'),_c('v-flex',_vm._l((_vm.C.form.selected.co_inventors),function(collaborator,collaboratorIndex){return _c('v-list',{key:collaborator.user_id,attrs:{"dense":"dense"}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('h3',{attrs:{"color":"primary"}},[_vm._v(_vm._s(collaborator.$name))])]),_c('v-list-tile-sub-title',[_vm._v(_vm._s(collaborator.access && _vm.C.form.list.collaboratorAccessOptions.dictionary[collaborator.access.toString()]))])],1),(_vm.C.state.isEditable)?_c('v-list-tile-action',[(!collaborator.remove)?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),(collaborator.remove)?_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1):_vm._e()],1)],1)}))],1)],2)],1),_c('v-navigation-drawer',{staticClass:"editor__leftpanel",attrs:{"app":"app","permanent":"permanent","fixed":"fixed","floating":"floating","clipped":"clipped","width":"220"}},[_c('v-layout',{attrs:{"column":"column","fill-height":"fill-height","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('v-list',{attrs:{"dense":"dense"}},_vm._l((_vm.C.state.container),function(item){return (((_vm.C.data.invention.phase === "phase-2" && item.phaseThreshold <= 2) || (_vm.C.data.invention.phase === "phase-3" && item.phaseThreshold <= 3) || (_vm.C.data.invention.phase === "phase-4" && item.phaseThreshold <= 4) || (_vm.C.data.invention.phase === "phase-5" && item.phaseThreshold <= 5)) && !(item.unreleased && !_vm.CR.show.unreleased))?_c('v-list-group',{key:item.title,attrs:{"append-icon":"false"},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}},[_c('v-list-tile',{attrs:{"slot":"activator","disabled":item.disabled},on:{"click":function($event){_vm.C.form.trigger.selectContainerItem(item)}},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1),_c('scrollactive',{attrs:{"offset":100,"duration":800,"bezier-easing-value":".5,0,.35,1"}},_vm._l((item.items),function(subItem,subItemIndex){return ((!item.componentContainerKey && !item.hideItemsList) || item.items.length > 1)?_c('v-list-tile',{key:subItemIndex,attrs:{"href":(item.componentContainerKey && subItem.useByIndex) ? ("#" + (item.componentContainerKey) + "-" + subItemIndex) : subItem.href,"active-class":"scrollactive-item"},on:{"click":function($event){_vm.C.form.trigger.selectContainerSectionItem({subItem: subItem, item: item, index: subItemIndex})}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}},[_c('v-list-tile-action',[((!item.componentContainerKey) && _vm.C.form.selected.invention.container_section[subItem.key] && _vm.C.form.selected.invention.container_section[subItem.key].completion)?_c('v-icon',[_vm._v("check")]):_vm._e(),((item.componentContainerKey && !subItem.notComponent) && _vm.C.form.selected.invention.container_section[("c_" + (item.componentContainerKey))] && _vm.C.form.selected.invention.container_section[("c_" + (item.componentContainerKey))].components && _vm.C.form.selected.invention.container_section[("c_" + (item.componentContainerKey))].components[subItemIndex] && _vm.C.form.selected.invention.container_section[("c_" + (item.componentContainerKey))].components[subItemIndex].completion)?_c('v-icon',[_vm._v("check")]):_vm._e(),((item.componentContainerKey && subItem.notComponent) && (_vm.C.evaluate.generalInfoIsChecked(subItem)))?_c('v-icon',[_vm._v("check")]):_vm._e()],1),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.title))])],1)],1):_vm._e()}))],1):_vm._e()}))],1),_c('div',[_c('v-list',{staticClass:"mb-4"},[_c('v-list-tile',{attrs:{"to":{name: "Profile"}}},[_c('v-list-tile-title',[_c('v-list-tile-title',[_vm._v("Profile")])],1)],1),_c('v-list-tile',{on:{"click":function($event){_vm.CR.trigger.signOut()}}},[_c('v-list-tile-title',[_vm._v("Sign Out")])],1)],1),_c('v-list',{staticClass:"mb-3",attrs:{"dense":"dense"}},[_c('v-list-tile',{attrs:{"avatar":"avatar"}},[_c('avatar',{attrs:{"username":_vm.CR.authorization.data.fullname ? _vm.CR.authorization.data.fullname : "?"}})],1),(_vm.CR.authorization.data.email)?_c('v-list-tile',[_c('v-list-tile-title',[_c('div',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.CR.authorization.data.firstname)+" "+_vm._s(_vm.CR.authorization.data.lastname))])])],1):_vm._e()],1),_c('svg',{staticClass:"ml-3",attrs:{"width":"123","height":"29","viewbox":"0 0 123 29"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#222"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#00D732"}})])])],1)],1)],1),_c('v-toolbar',{staticClass:"editor__nav px-3",attrs:{"app":"app","fixed":"fixed","clipped-left":true,"clipped-right":true}},[_c('v-btn',{staticClass:"hidden-xs-only transparent",attrs:{"to":{name: "Inventions"},"flat":"flat","color":"secondary","icon":"icon"}},[_c('v-icon',{attrs:{"medium":"medium"}},[_vm._v("keyboard_arrow_left")])],1),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.C.data.invention.title)+" "+_vm._s(_vm.C.form.state.recentSaveActive ? '(Saved!)' : '')),_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[(_vm.C.data.invention.phase)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check_circle")]),_c('p',{staticClass:"body-2 mb-0 mr-3 ml-1"},[_vm._v(_vm._s(_vm.C.dictionary.phase[_vm.C.data.invention.phase]))])],1)],1):_vm._e(),_vm._l((_vm.C.data.invention.co_inventors),function(inventor){return _c('v-flex',{key:inventor.id},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("people")]),_c('p',{staticClass:"body-2 mb-0 mr-3 ml-1"},[_vm._v(_vm._s(inventor.user.fullname))])],1)],1)}),(_vm.C.data.invention.bulk_read_access)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("chat_bubble")]),_vm._v(_vm._s((_vm.C.data.invention.bulk_read_access && _vm.C.dictionary.bulk_read_access[_vm.C.data.invention.bulk_read_access]) ? _vm.C.dictionary.bulk_read_access[_vm.C.data.invention.bulk_read_access] : _vm.C.data.invention.bulk_read_access))],1)])],1):_vm._e(),(_vm.C.data.invention.role)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("person")]),_vm._v(_vm._s(_vm.C.data.invention.role))],1)])],1):_vm._e(),(_vm.C.data.invention.opportunity)?_c('v-flex',[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-items-center":"align-items-center"}},[_c('p',{staticClass:"body-2 mb-0 mr-4"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small"}},[_vm._v("add_to_photos")]),_vm._v(_vm._s(_vm.C.data.invention.opportunity && _vm.C.data.invention.opportunity.title))],1)])],1):_vm._e()],2)],1),_c('v-spacer'),_c('div',{staticClass:"mr-3"},[_c('p',{staticClass:"ma-0 mb-1"},[_vm._v(_vm._s(_vm.C.report.checklist.percentage)+"% Completed")]),_c('v-progress-linear',{staticClass:"invention__progress my-0",attrs:{"value":_vm.C.report.checklist.percentage,"color":"primary","background-color":"blue-grey lighten-5"}})],1),_c('v-dialog',{attrs:{"max-width":"680"},model:{value:(_vm.C.state.dialog.checklist),callback:function ($$v) {_vm.$set(_vm.C.state.dialog, "checklist", $$v)},expression:"C.state.dialog.checklist"}},[_c('v-btn',{attrs:{"slot":"activator","color":"secondary","flat":"flat","icon":"icon","dark":"dark"},on:{"click":function($event){_vm.C.trigger.openChecklist()}},slot:"activator"},[_c('v-icon',[_vm._v("list")])],1),_c('v-card',{staticClass:"px-4"},[_c('v-card-title',{staticClass:"py-4"},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between"}},[_c('v-flex',{staticClass:"headline"},[_vm._v("Invention Checklist")]),_c('div',[_c('p',{staticClass:"ma-0 mb-1"},[_vm._v(_vm._s(_vm.C.report.checklist.percentage)+"% Completed")]),_c('v-progress-linear',{staticClass:"invention__progress my-0",attrs:{"value":_vm.C.report.checklist.percentage,"color":"primary","background-color":"blue-grey lighten-5"}})],1)],1)],1),_c('v-card-text',[_c('v-tabs',{staticClass:"invention-checklist",attrs:{"is-booted":true,"slider-color":"primary"},model:{value:(_vm.C.state.tab.checklist.active),callback:function ($$v) {_vm.$set(_vm.C.state.tab.checklist, "active", $$v)},expression:"C.state.tab.checklist.active"}},[_c('v-tab',{attrs:{"href":"#checklist-summary","ripple":false}},[_vm._v("Summary")]),_c('v-tab',{attrs:{"href":"#checklist-detailed","ripple":false}},[_vm._v("Detailed Checklist")]),_c('v-tabs-items',{model:{value:(_vm.C.state.tab.checklist.item),callback:function ($$v) {_vm.$set(_vm.C.state.tab.checklist, "item", $$v)},expression:"C.state.tab.checklist.item"}},[_c('v-tab-item',{staticClass:"pt-3",attrs:{"id":"checklist-summary"}},[_c('ul',[_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Concept"),(_vm.C.data.invention.phase === "phase-2" || _vm.C.data.invention.phase === "phase-3" || _vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-1")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Brief"),(_vm.C.data.invention.phase === "phase-3" || _vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-2")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.overview.brief.completionAll}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Complete content sections for all containers in this phase")],1),_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.overview.brief.searchOne}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Perform "),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.tab.inventionNotesSidepanel.active = "tab-keywords";}}},[_vm._v("one search")])],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Full"),(_vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-3")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.overview.full.completionAll}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Complete content sections for all containers in this phase")],1),_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.overview.full.searchTwo}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Perform total of "),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.tab.inventionNotesSidepanel.active = "tab-keywords";}}},[_vm._v("two or more searches")])],1),_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.overview.full.mentorOne}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.panel.settings = true;}}},[_vm._v("Add your mentor")])],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Review"),(_vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-4")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": _vm.C.data.invention.phase === "phase-5"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Mentor sign off on invention")],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Complete"),(_vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e()])])])]),_c('v-tab-item',{staticClass:"pt-3",attrs:{"id":"checklist-detailed"}},[_c('ol',[_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Concept"),(_vm.C.data.invention.phase === "phase-2" || _vm.C.data.invention.phase === "phase-3" || _vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-1")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": !!(_vm.C.form.selected.invention.title)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Title")],1),_c('li',{class:{"js-checklist-checked": !!(_vm.C.form.selected.invention.description)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Description")],1),_c('li',{class:{"js-checklist-checked": !!(_vm.C.form.selected.invention.invention_opportunity_id)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Opportunity")],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Brief"),(_vm.C.data.invention.phase === "phase-3" || _vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-2")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.summary && _vm.C.report.checklist.detailed.containerSections.draw && _vm.C.report.checklist.detailed.containerSections.significance)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Solution")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.problem_summary && _vm.C.report.checklist.detailed.containerSections.gap && _vm.C.report.checklist.detailed.containerSections.problem_significance)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Problem")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.searchCount.one)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Perform "),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.tab.inventionNotesSidepanel.active = "tab-keywords";}}},[_vm._v("one search")])],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Full"),(_vm.C.data.invention.phase === "phase-4" || _vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-3")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.landscape && _vm.C.report.checklist.detailed.containerSections.comparativeadvantages_innovativeaspects && _vm.C.report.checklist.detailed.containerSections.comparativeadvantages_advantagessummary && _vm.C.report.checklist.detailed.containerSections.comparativeadvantages_relevantbackground && !!_vm.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete && (_vm.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete === _vm.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.amount))}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Comparative Advantages")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.construction_howused && !!_vm.C.report.checklist.detailed.componentContainers.c_construction.complete && (_vm.C.report.checklist.detailed.componentContainers.c_construction.complete === _vm.C.report.checklist.detailed.componentContainers.c_construction.amount))}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Construction")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.economics_need && _vm.C.report.checklist.detailed.containerSections.economics_enduser && _vm.C.report.checklist.detailed.containerSections.economics_keyresources && _vm.C.report.checklist.detailed.containerSections.economics_capitalexpenditure && _vm.C.report.checklist.detailed.containerSections.economics_feasiblyeconomical && _vm.C.report.checklist.detailed.containerSections.economics_whomake && _vm.C.report.checklist.detailed.containerSections.economics_howmakemoney && _vm.C.report.checklist.detailed.containerSections.economics_howdelivered && _vm.C.report.checklist.detailed.containerSections.economics_economicburden && _vm.C.report.checklist.detailed.containerSections.economics_currentsolutioncosts && _vm.C.report.checklist.detailed.containerSections.economics_consumercosts)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Economics")],1),_c('li',{class:{"js-checklist-checked": (!!_vm.C.report.checklist.detailed.componentContainers.c_development.complete && (_vm.C.report.checklist.detailed.componentContainers.c_development.complete === _vm.C.report.checklist.detailed.componentContainers.c_development.amount))}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Development")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.specificquestions)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Specific Questions")],1),_c('li',{class:{"js-checklist-checked": (_vm.C.report.checklist.detailed.containerSections.references)}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("References")],1),_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.detailed.searchCount.two}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Perform total of "),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.tab.inventionNotesSidepanel.active = "tab-keywords";}}},[_vm._v("two or more searches")])],1),_c('li',{class:{"js-checklist-checked": _vm.C.report.checklist.detailed.mentorCount.one}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_c('a',{staticClass:"text-link",on:{"click":function($event){_vm.C.state.dialog.checklist = false; _vm.C.state.panel.settings = true;}}},[_vm._v("Add your mentor")])],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Review"),(_vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e(),(_vm.C.data.invention.phase === "phase-4")?_c('span',{staticClass:"grey"},[_vm._v("Current")]):_vm._e()]),_c('ul',[_c('li',{class:{"js-checklist-checked": _vm.C.data.invention.phase === "phase-5"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("check")]),_vm._v("Mentor sign off on invention")],1)])]),_c('li',[_c('div',{staticClass:"subheading"},[_vm._v("Invention Complete"),(_vm.C.data.invention.phase === "phase-5")?_c('span',{staticClass:"primary"},[_vm._v("Complete")]):_vm._e()])])])])],1)],1)],1)],1)],1),(_vm.C.state.isEditable)?_c('v-btn',{attrs:{"color":"secondary","flat":"flat","icon":"icon","dark":"dark"},on:{"click":function($event){$event.stopPropagation();_vm.C.state.panel.settings = !_vm.C.state.panel.settings;}}},[_c('v-icon',[_vm._v("settings")])],1):_vm._e(),(_vm.C.data.invention.phase === "phase-4" && _vm.C.data.invention.role === "Mentor")?_c('v-btn',{attrs:{"color":"info"},on:{"click":function($event){_vm.C.form.trigger.markInventionComplete()}}},[_vm._v("Complete")]):_vm._e(),(_vm.C.state.isEditable)?_c('v-btn',{attrs:{"disabled":!_vm.C.form.selected.invention.title,"color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.saveAll(true)}}},[_vm._v("Present")]):_vm._e(),(!_vm.C.state.isEditable)?_c('v-btn',{attrs:{"to":{name: "InventionPresentation", params: { id: this.$route.params.id }},"color":"secondary","dark":"dark"}},[_vm._v("Present")]):_vm._e()],1),(!_vm.C.form.selected.invention.title && _vm.C.state.isEditable)?_c('v-alert',{staticClass:"mt-1 mb-4",attrs:{"type":"error","value":true}},[_c('span',[_vm._v("Title is unavailable!")])]):_vm._e(),(_vm.C.state.container[0].active)?_c('div',[_vm._m(0),_c('section',{staticClass:"invention__section",attrs:{"id":"solution-summary"}},[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Solution Summary"),_c('basic-tooltip',{attrs:{"message":"Summarize the essence of your solution clearly and briefly.  What is the key advancement or core invention?   Reviewers will ask: \"What is the actual technical advancement, improvement or innovative step provided by this solution?\""}})],1)]),(_vm.C.form.selected.invention.container_section.summary.content)?_c('completion-check',{attrs:{"section-id":"summary","section-item":_vm.C.form.selected.invention.container_section.summary,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.summary.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.summary, "content", $$v)},expression:"C.form.selected.invention.container_section.summary.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.summary.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"solution-draw"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Draw"),_c('basic-tooltip',{attrs:{"message":"Draw and upload an illustrative overview of the core of the invention. Someone should be able to look at this picture and understand exactly what the invention is."}})],1)]),(_vm.C.form.selected.invention.container_section.draw.content)?_c('completion-check',{attrs:{"section-id":"draw","section-item":_vm.C.form.selected.invention.container_section.draw,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.container_section.draw.content},model:{value:(_vm.C.form.selected.invention.container_section.draw.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.draw, "content", $$v)},expression:"C.form.selected.invention.container_section.draw.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.draw.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"solution-significance"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Significance"),_c('basic-tooltip',{attrs:{"message":"lorem"}})],1)]),(_vm.C.form.selected.invention.container_section.significance.content)?_c('completion-check',{attrs:{"section-id":"significance","section-item":_vm.C.form.selected.invention.container_section.significance,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.significance.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.significance, "content", $$v)},expression:"C.form.selected.invention.container_section.significance.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.significance.content)}}):_vm._e()],1)]):_vm._e(),(_vm.C.state.container[1].active)?_c('div',[_vm._m(1),_c('section',{staticClass:"invention__section",attrs:{"id":"problem-summary"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Problem Summary"),_c('basic-tooltip',{attrs:{"message":"Write a brief statement on exactly what the specific problem is that you have solved.  Every solution targets a certain problem. Please use this section to highlight the specific problem the solution addresses. This section can be as short or as long as needed to describe the precise problem the solution addresses."}})],1)]),(_vm.C.form.selected.invention.container_section.problem_summary.content)?_c('completion-check',{attrs:{"section-id":"problem_summary","section-item":_vm.C.form.selected.invention.container_section.problem_summary,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.problem_summary.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.problem_summary, "content", $$v)},expression:"C.form.selected.invention.container_section.problem_summary.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.problem_summary.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"problem-gap"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Gap"),_c('basic-tooltip',{attrs:{"message":"What is the current technology in this area, and why doesn’t it solve the problem, i.e. what are the specific shortcomings?   Summarize in one or two sentences."}})],1)]),(_vm.C.form.selected.invention.container_section.gap.content)?_c('completion-check',{attrs:{"section-id":"gap","section-item":_vm.C.form.selected.invention.container_section.gap,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.gap.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.gap, "content", $$v)},expression:"C.form.selected.invention.container_section.gap.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.gap.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"problem-significance"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Significance"),_c('basic-tooltip',{attrs:{"message":"Why is this important to solve and what would it look like if this solution was available?   Summarize in one or two sentences."}})],1)]),(_vm.C.form.selected.invention.container_section.problem_significance.content)?_c('completion-check',{attrs:{"section-id":"problem_significance","section-item":_vm.C.form.selected.invention.container_section.problem_significance,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.problem_significance.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.problem_significance, "content", $$v)},expression:"C.form.selected.invention.container_section.problem_significance.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.problem_significance.content)}}):_vm._e()],1)]):_vm._e(),(_vm.C.state.container[2].active)?_c('div',[[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.C.state.dialog.confirmComparativeadvantagesComponentDelete.active),callback:function ($$v) {_vm.$set(_vm.C.state.dialog.confirmComparativeadvantagesComponentDelete, "active", $$v)},expression:"C.state.dialog.confirmComparativeadvantagesComponentDelete.active"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Notice")]),_c('v-card-text',[_vm._v("Do you wish to delete this technology?")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.trigger.confirmComparativeadvantagesComponentDelete()}}},[_vm._v("Confirm")])],1)],1)],1)],1)],_c('v-tabs',{staticClass:"construction-tabs",attrs:{"is-booted":true,"slider-color":"primary"},model:{value:(_vm.C.state.tab.comparativeadvantages.active),callback:function ($$v) {_vm.$set(_vm.C.state.tab.comparativeadvantages, "active", $$v)},expression:"C.state.tab.comparativeadvantages.active"}},[_c('v-tab',{staticClass:"hide",attrs:{"href":"#comparativeadvantages-base","ripple":false}},[_vm._v("Base")]),_vm._l((_vm.C.form.selected.invention.container_section.c_comparativeadvantages.components),function(component,componentIndex){return _c('v-tab',{key:componentIndex,staticClass:"hide",attrs:{"href":("#comparativeadvantages-" + componentIndex),"ripple":false}},[_vm._v(_vm._s(component.type))])}),_c('v-tab',{staticClass:"hide",attrs:{"href":"#comparativeadvantages-general","ripple":false}},[_vm._v("General")]),_c('v-tabs-items',{model:{value:(_vm.C.state.tab.comparativeadvantages.item),callback:function ($$v) {_vm.$set(_vm.C.state.tab.comparativeadvantages, "item", $$v)},expression:"C.state.tab.comparativeadvantages.item"}},[_c('v-tab-item',{staticClass:"construction pt-0",attrs:{"id":"comparativeadvantages-base"}},[(_vm.C.state.isEditable)?_c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("Comparative Advantages Overview")])]):_vm._e(),_c('section',{staticClass:"invention__section",attrs:{"id":"comparativeadvantages_landscape"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Landscape"),_c('basic-tooltip',{attrs:{"message":"Describe the landscape of competing technologies, methods, or products. "}})],1)]),(_vm.C.form.selected.invention.container_section.landscape.content)?_c('completion-check',{attrs:{"section-id":"landscape","section-item":_vm.C.form.selected.invention.container_section.landscape,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.landscape.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.landscape, "content", $$v)},expression:"C.form.selected.invention.container_section.landscape.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.landscape.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"comparativeadvantages_innovativeaspects"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Innovative Aspects"),_c('basic-tooltip',{attrs:{"message":"What are the innovative aspects of the invention and why hasn’t anyone thought of this before?"}})],1)]),_c('div',{staticClass:"d-inline-flex"},[(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content)?_c('completion-check',{attrs:{"section-id":"comparativeadvantages_innovativeaspects","section-item":_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects, "content", $$v)},expression:"C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content)}}):_vm._e()],1)]),_vm._l((_vm.C.form.selected.invention.container_section.c_comparativeadvantages.components),function(component,componentIndex){return _c('v-tab-item',{key:componentIndex,staticClass:"construction pt-0",attrs:{"id":("comparativeadvantages-" + componentIndex)}},[_c('section',[_c('div',{staticClass:"invention__title invention__title--actions"},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-end":"align-end"}},[_c('v-flex',[_c('div',{staticClass:"title text--capitalize pb-2"},[_vm._v(_vm._s(component.type))])]),_c('div',{staticClass:"d-inline-flex"},[_c('v-tooltip',{attrs:{"bottom":"bottom"}},[(_vm.C.state.isEditable)?_c('v-btn',{attrs:{"slot":"activator","flat":!component.delete,"outline":!component.delete,"fab":component.delete,"small":component.delete,"dark":component.delete,"icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.deleteComparativeadvantagesComponent(component)}},slot:"activator"},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("delete")])],1):_vm._e(),_c('span',[_vm._v("Delete")])],1),(component.id && component.items.competing_howworks.content && component.items.shortcomings.content && component.items.howovercomes_shortcomings.content)?_c('completion-check',{attrs:{"section-id":"c_comparativeadvantages","component-id":component.id,"section-item":component,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1)],1)]),(_vm.C.state.isEditable)?_c('section',[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Title")])])],1),_c('v-text-field',{staticClass:"mb-3",attrs:{"label":"Title","counter":100,"solo":"solo"},on:{"input":function($event){_vm.C.form.event.typeAutoSave()}},model:{value:(component.type),callback:function ($$v) {_vm.$set(component, "type", $$v)},expression:"component.type"}})],1):_vm._e(),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Describe a competing technology and how it works?"),(component.items.competing_howworks.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.competing_howworks.content),callback:function ($$v) {_vm.$set(component.items.competing_howworks, "content", $$v)},expression:"component.items.competing_howworks.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.competing_howworks.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Describe the shortcomings of the "+_vm._s(component.type)+"."),(component.items.shortcomings.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.shortcomings.content),callback:function ($$v) {_vm.$set(component.items.shortcomings, "content", $$v)},expression:"component.items.shortcomings.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.shortcomings.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Describe how your invention overcomes the specific shortcomings."),(component.items.howovercomes_shortcomings.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.howovercomes_shortcomings.content),callback:function ($$v) {_vm.$set(component.items.howovercomes_shortcomings, "content", $$v)},expression:"component.items.howovercomes_shortcomings.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.howovercomes_shortcomings.content)}}):_vm._e()],1)])}),_c('v-tab-item',{staticClass:"construction pt-0",attrs:{"id":"comparativeadvantages-general"}},[_c('section',{attrs:{"id":"comparativeadvantages-general"}},[_c('div',{staticClass:"invention__title"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"title"},[_vm._v("Comparative Advantages General")])])],1)],1)]),_c('section',{staticClass:"invention__section",attrs:{"id":"comparativeadvantages_advantagessummary"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Comparative Advantages Summary"),_c('basic-tooltip',{attrs:{"message":"Write a paragraph summarizing your listed current technologies. Reviewers will ask: \"How is the solution potentially better than what is out there? How is it different from what has been done before (or described in the literature)?\""}})],1)]),_c('div',{staticClass:"d-inline-flex"},[(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content)?_c('completion-check',{attrs:{"section-id":"comparativeadvantages_advantagessummary","section-item":_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary, "content", $$v)},expression:"C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"comparativeadvantages_relevantbackground"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Relevant Background"),_c('basic-tooltip',{attrs:{"message":"This section is used to highlight information that can be used by the reviewers or patent attorney to help put the solution in proper context. This section is specifically reserved for other people’s work (please include competitive work) as well as your past work that you believe will aid the reviewers in understanding the technical landscape.  Background can be in a paragraph format or listed.  Data related to or supporting your solution should NOT be in this section, it should be in the next section Construction"}})],1)]),_c('div',{staticClass:"d-inline-flex"},[(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content)?_c('completion-check',{attrs:{"section-id":"comparativeadvantages_relevantbackground","section-item":_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground, "content", $$v)},expression:"C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content)}}):_vm._e()],1)])],2)],2),(_vm.C.state.isEditable)?_c('section',[_c('v-container',{staticClass:"pa-0",staticStyle:{"margin-left":"-1.75em"},attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{attrs:{"xs4":"xs4"}},[_c('v-btn',{attrs:{"flat":"flat","color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addComparativeadvantagesComponent()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add_circle")]),_vm._v("Add"+_vm._s(_vm.C.form.selected.invention.container_section.c_comparativeadvantages.components.length === 0 ? "" : " Another")+" Current Technology")],1),(_vm.C.state.tab.comparativeadvantages.active !== "comparativeadvantages-base" && _vm.C.state.tab.comparativeadvantages.active !== "comparativeadvantages-general")?_c('v-btn',{attrs:{"flat":"flat","color":"secondary"},on:{"click":function($event){_vm.C.state.tab.comparativeadvantages.active = "comparativeadvantages-general"; _vm.C.trigger.scrollToTop();}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("check_circle")]),_vm._v("Complete the General Info Section")],1):_vm._e()],1)],1)],1)],1):_vm._e()],2):_vm._e(),(_vm.C.state.container[3].active)?_c('div',[[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.C.state.dialog.confirmConstructionComponentDelete.active),callback:function ($$v) {_vm.$set(_vm.C.state.dialog.confirmConstructionComponentDelete, "active", $$v)},expression:"C.state.dialog.confirmConstructionComponentDelete.active"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Notice")]),_c('v-card-text',[_vm._v("Do you wish to delete this element?")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.state.dialog.confirmConstructionComponentDelete.active = false}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.trigger.confirmConstructionComponentDelete()}}},[_vm._v("Confirm")])],1)],1)],1)],1)],_c('v-tabs',{staticClass:"construction-tabs",attrs:{"is-booted":true,"slider-color":"primary"},model:{value:(_vm.C.state.tab.construction.active),callback:function ($$v) {_vm.$set(_vm.C.state.tab.construction, "active", $$v)},expression:"C.state.tab.construction.active"}},[_c('v-tab',{staticClass:"hide",attrs:{"href":"#construction-base","ripple":false}},[_vm._v("Base")]),_vm._l((_vm.C.form.selected.invention.container_section.c_construction.components),function(component,componentIndex){return _c('v-tab',{key:componentIndex,staticClass:"hide",attrs:{"href":("#construction-" + componentIndex),"ripple":false}},[_vm._v(_vm._s(component.type))])}),_c('v-tab',{staticClass:"hide",attrs:{"href":"#construction-general","ripple":false}},[_vm._v("General")]),_c('v-tabs-items',{model:{value:(_vm.C.state.tab.construction.item),callback:function ($$v) {_vm.$set(_vm.C.state.tab.construction, "item", $$v)},expression:"C.state.tab.construction.item"}},[_c('v-tab-item',{staticClass:"construction pt-0",attrs:{"id":"construction-base"}},[(_vm.C.state.isEditable)?_c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("How Is The Invention Used and Made")])]):_vm._e(),(_vm.C.state.isEditable)?_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',[_c('ol',[_c('li',[_c('p',[_vm._v("Using this hierarchy of categories, from service level down to material level, check the box for the category that most accurately describes the inventive element of your solution.")])]),_c('li',[_c('p',[_vm._v("If your solution contains multiple inventive elements, choose the element highest up in the hierarchy first and work down from there, making only a single selection for each multiple choice.")])]),_c('li',[_c('p',[_vm._v("Then, using complete sentences, describe that inventive element by answering the subsequent questions in detail.")])]),_c('li',[_c('p',[_vm._v("This section should focus on how the solution is made; how it is used is addressed in the next section.")])])]),_c('p',[_vm._v("Select what type of invention it is.  Make only one selection, starting with the highest level of the invention.  Continue to the next multiple choice question if you have more than one inventive element (they will appear as you progress).")])])],1)],1):_vm._e()]),_vm._l((_vm.C.form.selected.invention.container_section.c_construction.components),function(component,componentIndex){return _c('v-tab-item',{key:componentIndex,staticClass:"construction pt-0",attrs:{"id":("construction-" + componentIndex)}},[_c('section',{staticClass:"invention__section"},[_c('div',{staticClass:"invention__title invention__title--actions"},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-end":"align-end"}},[_c('v-flex',[_c('div',{staticClass:"title text--capitalize pb-2"},[_vm._v(_vm._s(component.type))])]),_c('div',{staticClass:"d-inline-flex"},[(component.type !== "construction")?_c('v-tooltip',{attrs:{"bottom":"bottom"}},[(_vm.C.state.isEditable)?_c('v-btn',{attrs:{"slot":"activator","flat":!component.delete,"outline":!component.delete,"fab":component.delete,"small":component.delete,"dark":component.delete,"icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.deleteConstructionComponent(component)}},slot:"activator"},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("delete")])],1):_vm._e(),_c('span',[_vm._v("Delete")])],1):_vm._e(),(component.id && component.items.ideal_example.content && component.items.properties.content && component.items.how_made.content)?_c('completion-check',{attrs:{"section-id":"c_construction","component-id":component.id,"section-item":component,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1)],1),_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What is it?"),_c('basic-tooltip',{attrs:{"message":"How does the solution work? What is an ideal example and alternatives."}}),(component.items.ideal_example.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.ideal_example.content),callback:function ($$v) {_vm.$set(component.items.ideal_example, "content", $$v)},expression:"component.items.ideal_example.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.ideal_example.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What are the properties?"),_c('basic-tooltip',{attrs:{"message":"List systems/methods and/or material(s)."}}),(component.items.properties.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.properties.content),callback:function ($$v) {_vm.$set(component.items.properties, "content", $$v)},expression:"component.items.properties.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.properties.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("How is it made?"),_c('basic-tooltip',{attrs:{"message":"Focus on how you would make, assemble, synthesize or build the solution. How it is \"used\" will be detailed in next section."}}),(component.items.how_made.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.how_made.content),callback:function ($$v) {_vm.$set(component.items.how_made, "content", $$v)},expression:"component.items.how_made.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.how_made.content)}}):_vm._e()],1)])}),_c('v-tab-item',{staticClass:"construction pt-0",attrs:{"id":"construction-general"}},[_c('section',{attrs:{"id":"construction-general"}},[_c('div',{staticClass:"invention__title"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"title"},[_vm._v("Construction General")])])],1)],1)]),_c('section',{staticClass:"invention__section",attrs:{"id":"construction-howused"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("How is it used?")])]),_c('div',{staticClass:"d-inline-flex"},[(_vm.C.form.selected.invention.container_section.construction_howused.content)?_c('completion-check',{attrs:{"section-id":"construction_howused","section-item":_vm.C.form.selected.invention.container_section.construction_howused,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.construction_howused.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.construction_howused, "content", $$v)},expression:"C.form.selected.invention.container_section.construction_howused.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.construction_howused.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"construction-prototype"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Prototype (Optional)"),_c('basic-tooltip',{attrs:{"message":"Attach any relevant data in the form of graphs, tables, figures, photos, etc"}})],1)]),_c('div',{staticClass:"d-inline-flex"},[_c('completion-check',{attrs:{"section-id":"construction_prototype","section-item":_vm.C.form.selected.invention.container_section.construction_prototype,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}})],1)],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.construction_prototype.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.construction_prototype, "content", $$v)},expression:"C.form.selected.invention.container_section.construction_prototype.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.construction_prototype.content)}}):_vm._e()],1)])],2)],2),(_vm.C.state.isEditable)?_c('section',[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-2"},[_vm._v("Add "+_vm._s(_vm.C.state.tab.construction.active === "construction-base" ? "an" : "another")+" inventive element")])])],1),_c('v-container',{staticClass:"pa-0",staticStyle:{"margin-left":"-1.75em"},attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},_vm._l((_vm.C.form.list.constructionComponentOptions),function(componentOption){return _c('v-flex',{key:componentOption.key,attrs:{"xs4":"xs4"},on:{"click":function($event){_vm.C.form.trigger.addConstructionComponent(componentOption.key)}}},[_c('v-btn',{attrs:{"flat":"flat","color":"primary"}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add_circle")]),_vm._v(_vm._s(componentOption.label))],1)],1)}))],1),(_vm.C.state.tab.construction.active !== "construction-base" && _vm.C.state.tab.construction.active !== "construction-general")?_c('v-card',{staticClass:"mt-4"},[_c('v-card-text',{staticClass:"py-2"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Done adding inventive elements?")]),_c('p',[_c('a',{on:{"click":function($event){_vm.C.state.tab.construction.active = "construction-general"; _vm.C.trigger.scrollToTop();}}},[_vm._v("Complete the \"General Section\"")])])])],1)],1)],1):_vm._e()],1):_vm._e()],2):_vm._e(),(_vm.C.state.container[4].active)?_c('div',[_vm._m(2),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-need"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What is the actual market need?")])]),(_vm.C.form.selected.invention.container_section.economics_need.content)?_c('completion-check',{attrs:{"section-id":"economics_need","section-item":_vm.C.form.selected.invention.container_section.economics_need,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_need.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_need, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_need.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_need.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-enduser"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Who is the end user?")])]),(_vm.C.form.selected.invention.container_section.economics_enduser.content)?_c('completion-check',{attrs:{"section-id":"economics_enduser","section-item":_vm.C.form.selected.invention.container_section.economics_enduser,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_enduser.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_enduser, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_enduser.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_enduser.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-keyresources"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What are the key resources needed to commercialize this invention?")])]),(_vm.C.form.selected.invention.container_section.economics_keyresources.content)?_c('completion-check',{attrs:{"section-id":"economics_keyresources","section-item":_vm.C.form.selected.invention.container_section.economics_keyresources,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_keyresources.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_keyresources, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_keyresources.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_keyresources.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-capitalexpenditure"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What are the estimated capital expenditure requirements to make the first unit?"),_c('basic-tooltip',{attrs:{"message":"For example, can this be made with existing production capabilities (e.e. small CAPEX), does there need to be modifications to existing lines (medium CAPEX), or does a whole new production method need to be built (large CAPEX). Try to estimate a value if possible (e.g. is it 5K, $500K or $5M to build a line to make product at scale?)"}})],1)]),(_vm.C.form.selected.invention.container_section.economics_capitalexpenditure.content)?_c('completion-check',{attrs:{"section-id":"economics_capitalexpenditure","section-item":_vm.C.form.selected.invention.container_section.economics_capitalexpenditure,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_capitalexpenditure.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_capitalexpenditure, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_capitalexpenditure.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_capitalexpenditure.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-feasiblyeconomical"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Is it feasible that this solution can be delivered economically?")])]),(_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical.content)?_c('completion-check',{attrs:{"section-id":"economics_feasiblyeconomical","section-item":_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_feasiblyeconomical.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_feasiblyeconomical.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-whomake"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Ideally, who will make this invention?")])]),(_vm.C.form.selected.invention.container_section.economics_whomake.content)?_c('completion-check',{attrs:{"section-id":"economics_whomake","section-item":_vm.C.form.selected.invention.container_section.economics_whomake,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_whomake.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_whomake, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_whomake.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_whomake.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-howmakemoney"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("How do they make money from this technology?"),_c('basic-tooltip',{attrs:{"message":"Top line: product, extension, aftermarket, service, data, advertising. Bottom line: cost saving, labor saving, safety, etc."}})],1)]),(_vm.C.form.selected.invention.container_section.economics_howmakemoney.content)?_c('completion-check',{attrs:{"section-id":"economics_howmakemoney","section-item":_vm.C.form.selected.invention.container_section.economics_howmakemoney,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_howmakemoney.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_howmakemoney, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_howmakemoney.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_howmakemoney.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-howdelivered"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("How will the product/service be delivered to the consumer?")])]),(_vm.C.form.selected.invention.container_section.economics_howdelivered.content)?_c('completion-check',{attrs:{"section-id":"economics_howdelivered","section-item":_vm.C.form.selected.invention.container_section.economics_howdelivered,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_howdelivered.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_howdelivered, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_howdelivered.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_howdelivered.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-economicburden"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("What is the economic burden of the problem?")])]),(_vm.C.form.selected.invention.container_section.economics_economicburden.content)?_c('completion-check',{attrs:{"section-id":"economics_economicburden","section-item":_vm.C.form.selected.invention.container_section.economics_economicburden,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_economicburden.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_economicburden, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_economicburden.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_economicburden.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-currentsolutioncosts"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("If there are current solutions, what do they cost?"),_c('basic-tooltip',{attrs:{"message":"Competitors may be direct or indirect."}})],1)]),(_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts.content)?_c('completion-check',{attrs:{"section-id":"economics_currentsolutioncosts","section-item":_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_currentsolutioncosts.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_currentsolutioncosts.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section",attrs:{"id":"economics-consumercosts"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Would the consumer pay for your solution?"),_c('basic-tooltip',{attrs:{"message":"If so, why? If not, how do you make money from the inventions?"}})],1)]),(_vm.C.form.selected.invention.container_section.economics_consumercosts.content)?_c('completion-check',{attrs:{"section-id":"economics_consumercosts","section-item":_vm.C.form.selected.invention.container_section.economics_consumercosts,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.economics_consumercosts.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.economics_consumercosts, "content", $$v)},expression:"C.form.selected.invention.container_section.economics_consumercosts.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.economics_consumercosts.content)}}):_vm._e()],1)]):_vm._e(),(_vm.C.state.container[5].active)?_c('div',[[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.C.state.dialog.confirmDevelopmentComponentDelete.active),callback:function ($$v) {_vm.$set(_vm.C.state.dialog.confirmDevelopmentComponentDelete, "active", $$v)},expression:"C.state.dialog.confirmDevelopmentComponentDelete.active"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Notice")]),_c('v-card-text',[_vm._v("Do you wish to delete this milestone?")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.state.dialog.confirmDevelopmentComponentDelete.active = false}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.C.trigger.confirmDevelopmentComponentDelete()}}},[_vm._v("Confirm")])],1)],1)],1)],1)],_c('v-tabs',{staticClass:"construction-tabs",attrs:{"is-booted":true,"slider-color":"primary"},model:{value:(_vm.C.state.tab.development.active),callback:function ($$v) {_vm.$set(_vm.C.state.tab.development, "active", $$v)},expression:"C.state.tab.development.active"}},[_c('v-tab',{staticClass:"hide",attrs:{"href":"#development-base","ripple":false}},[_vm._v("Base")]),_vm._l((_vm.C.form.selected.invention.container_section.c_development.components),function(component,componentIndex){return _c('v-tab',{key:componentIndex,staticClass:"hide",attrs:{"href":("#development-" + componentIndex),"ripple":false}},[_vm._v(_vm._s(component.type))])}),_c('v-tabs-items',{model:{value:(_vm.C.state.tab.development.item),callback:function ($$v) {_vm.$set(_vm.C.state.tab.development, "item", $$v)},expression:"C.state.tab.development.item"}},[_c('v-tab-item',{staticClass:"construction pt-0",attrs:{"id":"development-base"}},[(_vm.C.state.isEditable)?_c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("Development")])]):_vm._e(),_c('section',{staticClass:"invention__section"},[_vm._v("Add as many steps (milestones) needed to develop the proof of concept or next stage prototype of the invention?")])]),_vm._l((_vm.C.form.selected.invention.container_section.c_development.components),function(component,componentIndex){return _c('v-tab-item',{key:componentIndex,staticClass:"construction pt-0",attrs:{"id":("development-" + componentIndex)}},[_c('section',[_c('div',{staticClass:"invention__title invention__title--actions"},[_c('v-layout',{attrs:{"row":"row","no-wrap":"no-wrap","align-end":"align-end"}},[_c('v-flex',[_c('div',{staticClass:"title text--capitalize pb-2"},[_vm._v(_vm._s(component.type))])]),_c('div',{staticClass:"d-inline-flex"},[_c('v-tooltip',{attrs:{"bottom":"bottom"}},[(_vm.C.state.isEditable)?_c('v-btn',{attrs:{"slot":"activator","flat":!component.delete,"outline":!component.delete,"fab":component.delete,"small":component.delete,"dark":component.delete,"icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.deleteDevelopmentComponent(component)}},slot:"activator"},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v("delete")])],1):_vm._e(),_c('span',[_vm._v("Delete")])],1),(component.id && component.items.key_points.content && component.items.resources_needed.content && component.items.deliverables.content && component.items.measure_of_success.content && component.items.key_risks.content && component.items.suggested_approach.content)?_c('completion-check',{attrs:{"section-id":"c_development","component-id":component.id,"section-item":component,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1)],1)],1)]),(_vm.C.state.isEditable)?_c('section',[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Short title for milestone")])])],1),_c('v-text-field',{staticClass:"mb-3",attrs:{"label":"Title","counter":100,"solo":"solo"},on:{"input":function($event){_vm.C.form.event.typeAutoSave()}},model:{value:(component.type),callback:function ($$v) {_vm.$set(component, "type", $$v)},expression:"component.type"}})],1):_vm._e(),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Key Points: What are the most important aspects of this development step"),(component.items.key_points.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.key_points.content),callback:function ($$v) {_vm.$set(component.items.key_points, "content", $$v)},expression:"component.items.key_points.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.key_points.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Resources Needed: Describe facilities, funding requirements, time and/or other key resources that would be needed to deliver the milestone."),(component.items.resources_needed.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.resources_needed.content),callback:function ($$v) {_vm.$set(component.items.resources_needed, "content", $$v)},expression:"component.items.resources_needed.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.resources_needed.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Deliverables: What is produced at the end of the development step."),(component.items.deliverables.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.deliverables.content),callback:function ($$v) {_vm.$set(component.items.deliverables, "content", $$v)},expression:"component.items.deliverables.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.deliverables.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Measure of Success: What are the metrics to know we have achieved the goal at the end of this development step?"),(component.items.measure_of_success.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.measure_of_success.content),callback:function ($$v) {_vm.$set(component.items.measure_of_success, "content", $$v)},expression:"component.items.measure_of_success.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.measure_of_success.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Key Risks: What can be foreseen as major areas of risk to the success of this development step and what can be done to migrate them?"),(component.items.key_risks.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.key_risks.content),callback:function ($$v) {_vm.$set(component.items.key_risks, "content", $$v)},expression:"component.items.key_risks.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.key_risks.content)}}):_vm._e()],1),_c('section',{staticClass:"invention__section"},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Suggested Approach: What materials and methods are required for this milestone?"),(component.items.suggested_approach.content && _vm.CR.show.unreleased)?_c('v-icon',{staticClass:"ml-2",attrs:{"small":"small","color":"primary"}},[_vm._v("check_circle")]):_vm._e()],1)])],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(component.items.suggested_approach.content),callback:function ($$v) {_vm.$set(component.items.suggested_approach, "content", $$v)},expression:"component.items.suggested_approach.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(component.items.suggested_approach.content)}}):_vm._e()],1)])})],2)],2),(_vm.C.state.isEditable)?_c('section',[_c('v-container',{staticClass:"pa-0",staticStyle:{"margin-left":"-1.75em"},attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[_c('v-flex',{attrs:{"xs4":"xs4"}},[_c('v-btn',{attrs:{"flat":"flat","color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addDevelopmentComponent()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add_circle")]),_vm._v("Add"+_vm._s(_vm.C.form.selected.invention.container_section.c_development.components.length === 0 ? "" : " Another")+" Step")],1)],1)],1)],1)],1):_vm._e()],2):_vm._e(),(_vm.C.state.container[6].active)?_c('div',[_vm._m(3),_c('section',{staticClass:"invention__section",attrs:{"id":"specificquestions-specificquestions"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Add Question & Answer for all questions asked in the Opportunity")])]),(_vm.C.form.selected.invention.container_section.specificquestions.content)?_c('completion-check',{attrs:{"section-id":"specificquestions","section-item":_vm.C.form.selected.invention.container_section.specificquestions,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.specificquestions.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.specificquestions, "content", $$v)},expression:"C.form.selected.invention.container_section.specificquestions.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.specificquestions.content)}}):_vm._e()],1)]):_vm._e(),(_vm.C.state.container[7].active)?_c('div',[_vm._m(4),_c('section',{staticClass:"invention__section",attrs:{"id":"references-references"}},[_c('v-layout',{attrs:{"row":"row","align-center":"align-center"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("List of relevant references (URLs).")])]),(_vm.C.form.selected.invention.container_section.references.content)?_c('completion-check',{attrs:{"section-id":"references","section-item":_vm.C.form.selected.invention.container_section.references,"save-callback":_vm.C.trigger.openChecklist,"is-editable":_vm.C.state.isEditable}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.description},model:{value:(_vm.C.form.selected.invention.container_section.references.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.container_section.references, "content", $$v)},expression:"C.form.selected.invention.container_section.references.content"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.container_section.references.content)}}):_vm._e()],1)]):_vm._e(),_c('v-navigation-drawer',{staticClass:"editor__rightpanel",attrs:{"app":"app","right":"right","permanent":"permanent","floating":"floating","fixed":"fixed","clipped":"clipped","width":"300"}},[_c('v-tabs',{staticClass:"mt-3",attrs:{"is-booted":true,"slider-color":"primary"},model:{value:(_vm.C.state.tab.inventionNotesSidepanel.active),callback:function ($$v) {_vm.$set(_vm.C.state.tab.inventionNotesSidepanel, "active", $$v)},expression:"C.state.tab.inventionNotesSidepanel.active"}},[_c('v-tab',{attrs:{"href":"#tab-comments","ripple":false}},[_vm._v("Comments")]),_c('v-tab',{attrs:{"href":"#tab-scratchpad","ripple":false}},[_vm._v("Scratchpad")]),_c('v-tab',{attrs:{"href":"#tab-keywords","ripple":false}},[_vm._v("Search")]),_c('v-tabs-items',{model:{value:(_vm.C.state.tab.inventionNotesSidepanel.item),callback:function ($$v) {_vm.$set(_vm.C.state.tab.inventionNotesSidepanel, "item", $$v)},expression:"C.state.tab.inventionNotesSidepanel.item"}},[_c('v-tab-item',{key:1,attrs:{"id":"tab-comments"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},_vm._l((_vm.C.form.selected.comments.$list),function(comment){return _c('v-flex',{key:comment.id,attrs:{"xs12":"xs12"}},[_c('v-card',{staticClass:"card--borderless py-3",attrs:{"flat":"flat"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('v-layout',{staticClass:"mb-2",attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between","align-center":"align-center"}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","align-center":"align-center"}},[_c('v-tooltip',{attrs:{"right":"right"}},[_c('avatar',{attrs:{"slot":"activator","size":32,"username":comment.user_name ? comment.user_name : "?"},slot:"activator"}),_c('span',[_vm._v(_vm._s(comment.user_name))])],1)],1)],1),_c('v-flex',{staticClass:"text-xs-right"},[_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm._f("moment")(comment.created_time,"h:mm A, MMM D, YYYY")))])])],1),_c('p',[_vm._v(_vm._s(comment.content))])],1)],1)],1),_c('v-divider')],1)})),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card',{staticClass:"card--borderless py-0",attrs:{"flat":"flat"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-space-between":"justify-space-between"}},[_c('v-flex',[_c('v-text-field',{attrs:{"textarea":"textarea","label":"Comment","counter":500,"auto-grow":"auto-grow","rows":"2"},model:{value:(_vm.C.form.selected.comments.content),callback:function ($$v) {_vm.$set(_vm.C.form.selected.comments, "content", $$v)},expression:"C.form.selected.comments.content"}})],1)],1),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","justify-end":"justify-end"}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"secondary"},on:{"click":_vm.C.form.trigger.addComment}},[_vm._v("Send")])],1)],1)],1)],1),_c('v-tab-item',{key:2,attrs:{"id":"tab-scratchpad"}},[_c('div',{staticClass:"text-xs-right"}),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.scratchpad},model:{value:(_vm.C.form.selected.scratchpad),callback:function ($$v) {_vm.$set(_vm.C.form.selected, "scratchpad", $$v)},expression:"C.form.selected.scratchpad"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.scratchpad)}}):_vm._e()],1)],1)],1),_c('v-tab-item',{key:3,attrs:{"id":"tab-keywords"}},[_c('div',[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Keywords")])]),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.scratchpad},model:{value:(_vm.C.form.selected.invention.keywords),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention, "keywords", $$v)},expression:"C.form.selected.invention.keywords"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.keywords)}}):_vm._e()],1),(_vm.C.state.isEditable)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Searches")])]),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"rules":_vm.C.form.validation.rules.invention.search.title,"maxlength":1000,"label":"Add a Search","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"search"},on:{"focus":function($event){_vm.C.form.state.active.$search = true}},model:{value:(_vm.C.form.selected.invention.$search.title),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "title", $$v)},expression:"C.form.selected.invention.$search.title"}})],1)],1):_vm._e(),(_vm.C.state.isEditable)?_c('transition',{attrs:{"name":"expand"}},[(_vm.C.form.state.active.$search)?_c('div',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"rules":_vm.C.form.validation.rules.invention.search.general,"maxlength":1000,"label":"Paste URL","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"insert_link"},model:{value:(_vm.C.form.selected.invention.$search.url),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "url", $$v)},expression:"C.form.selected.invention.$search.url"}})],1),_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"rules":_vm.C.form.validation.rules.invention.search.general,"maxlength":1000,"label":"Search Note","multi-line":"multi-line","auto-grow":"auto-grow","rows":"1","prepend-icon":"note"},model:{value:(_vm.C.form.selected.invention.$search.note),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention.$search, "note", $$v)},expression:"C.form.selected.invention.$search.note"}})],1),_c('v-flex',{staticStyle:{"padding-left":"33px"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addSearchItem()}}},[_vm._v("Save Search")]),_c('v-btn',{on:{"click":function($event){_vm.C.form.state.active.$search = false}}},[_vm._v("Cancel")])],1)],1):_vm._e()]):_vm._e(),_vm._l((_vm.C.form.selected.invention.search),function(searchItem,searchItemIndex){return _c('v-layout',{key:searchItemIndex,staticClass:"mb-3",attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',[_vm._v("youtube_searched_for")]),_c('v-flex',{staticClass:"pl-3"},[(!searchItem.url)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),(searchItem.url)?_c('a',{attrs:{"href":searchItem.url,"target":"_blank"}},[_vm._v(_vm._s(searchItem.title))]):_vm._e(),_c('p',{staticClass:"mb-0 grey--text"},[_vm._v(_vm._s(searchItem.note))])]),(_vm.C.state.isEditable)?_c('div',{staticClass:"search-list__close"},[(!searchItem.remove)?_c('v-btn',{attrs:{"flat":"flat","icon":"icon","color":"secondary"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),(searchItem.remove)?_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"},on:{"click":function($event){_vm.C.form.trigger.removeSearchItem(searchItem, searchItemIndex)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1):_vm._e()],1)}),_c('div',[_c('v-flex',[_c('div',{staticClass:"subheading mb-0"},[_vm._v("Results")])]),(_vm.C.state.isEditable)?_c('froala',{attrs:{"config":_vm.C.form.config.froala.invention.scratchpad},model:{value:(_vm.C.form.selected.invention.search_results),callback:function ($$v) {_vm.$set(_vm.C.form.selected.invention, "search_results", $$v)},expression:"C.form.selected.invention.search_results"}}):_vm._e(),(!_vm.C.state.isEditable)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.C.form.selected.invention.search_results)}}):_vm._e()],1)],2)],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("The Solution")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("The Problem")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("Economics")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("Specific Questions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invention__title"},[_c('div',{staticClass:"title"},[_vm._v("References")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gD1l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizations_vue__ = __webpack_require__("23iP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c7d81b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Organizations_vue__ = __webpack_require__("58+P");
function injectStyle (ssrContext) {
  __webpack_require__("MxYT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12c7d81b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organizations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c7d81b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Organizations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "huXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"login",attrs:{"fluid":"fluid","fill-height":"fill-height"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[(!_vm.C.state.emailSent)?_c('v-flex',{attrs:{"sm6":"sm6","offset-sm3":"offset-sm3","lg4":"lg4","offset-lg4":"offset-lg4"}},[(_vm.C.error.active)?_c('v-alert',{staticClass:"mb-4",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.C.error.message))]):_vm._e(),_c('v-container',{attrs:{"grid-list-md":"grid-list-md","text-xs-center":"text-xs-center"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":"xs12"}},[_c('svg',{attrs:{"width":"123","height":"29","viewbox":"0 0 123 29","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z","fill":"#FFFFFF"}}),_c('path',{attrs:{"d":"M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z","fill":"#FFFFFF","opacity":"0.5"}})])])])],1)],1),_c('v-card',{staticClass:"card--borderless pa-5"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Sign Up")])]),_c('v-card-text',[_c('v-form',[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"First Name","single-line":"single-line","required":""},model:{value:(_vm.C.form.selected.account.firstname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "firstname", $$v)},expression:"C.form.selected.account.firstname"}}),_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Last Name","single-line":"single-line","required":""},model:{value:(_vm.C.form.selected.account.lastname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "lastname", $$v)},expression:"C.form.selected.account.lastname"}}),_c('v-text-field',{staticClass:"input--box",attrs:{"label":"E-mail","single-line":"single-line","required":""},model:{value:(_vm.C.form.selected.account.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.account, "email", $$v)},expression:"C.form.selected.account.email"}})],1)],1),_c('v-card-text',[_c('v-btn',{attrs:{"block":"block","large":"large","color":"primary","loading":_vm.loading2},on:{"click":_vm.C.form.trigger.submit},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v(" Create Account"),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_vm._v("Creating Account ...")])])],1)],1),_c('p',{staticClass:"pa-3 text-xs-center white--text"},[_vm._v("Have an account? "),_c('router-link',{staticClass:"white--text",attrs:{"to":{name: "MagicSignIn"}}},[_vm._v("Sign in")]),_vm._v(".")],1)],1):_vm._e(),(_vm.C.state.emailSent)?_c('v-flex',{attrs:{"sm6":"sm6","offset-sm3":"offset-sm3","lg4":"lg4","offset-lg4":"offset-lg4"}},[_c('v-card',{staticClass:"pa-5"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h2',{staticClass:"headline mb-2"},[_vm._v("We've sent you an email.")]),_c('p',[_vm._v("Please sign up with the link sent to your inbox.")])])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hvXr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__("oJIF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2291d104_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__("Td+F");
function injectStyle (ssrContext) {
  __webpack_require__("/f5r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2291d104"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2291d104_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iERt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidePanel_vue__ = __webpack_require__("T+p9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b150e0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SidePanel_vue__ = __webpack_require__("e1M+");
function injectStyle (ssrContext) {
  __webpack_require__("ua16")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b150e0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidePanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b150e0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SidePanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jQ4P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("vdq1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39673f0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("Zxa5");
function injectStyle (ssrContext) {
  __webpack_require__("ltde")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39673f0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39673f0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kJPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/people"}},[_c('h2',[_vm._v("All People")])])],1),(!this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Add User")])]):_vm._e(),(this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('router-link',{attrs:{"to":("/people/person/" + (this.$route.params.id))}},[_c('h2',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname))])])],1):_vm._e()],1),_c('v-spacer'),(this.$route.params.id && (_vm.CR.authorization.state.isOrgAdmin || _vm.CR.authorization.state.isGod))?_c('v-btn',{staticClass:"page-header__action",attrs:{"to":{name: "PersonEdit", params: { id: this.$route.params.id }},"exact":"","color":"primary"}},[_vm._v("Edit")]):_vm._e()],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',[_c('div',{staticClass:"pb-3"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname))])])],1),(_vm.C.data.person.email)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Email")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.email))])])],1):_vm._e(),(_vm.C.data.person.citizenship)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Citizenship")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.person.citizenship] && _vm.C.list.countries[_vm.C.data.person.citizenship].name))])])],1):_vm._e(),(_vm.C.data.person.time_zone && _vm.CR.show.unreleased)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Time Zone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.time_zone))])])],1):_vm._e()],1),(_vm.C.data.person.home_address)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Home Address")])]),(_vm.C.data.person.home_address.street1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.street1))]),(_vm.C.data.person.home_address.street2)?_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.street2))]):_vm._e()])],1):_vm._e(),(_vm.C.data.person.home_address.city)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.city))])])],1):_vm._e(),(_vm.C.data.person.home_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.state_province))])])],1):_vm._e(),(_vm.C.data.person.home_address.postal_code)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.postal_code))])])],1):_vm._e(),(_vm.C.data.person.home_address.country)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.person.home_address.country] && _vm.C.list.countries[_vm.C.data.person.home_address.country].name))])])],1):_vm._e(),(_vm.C.data.person.home_address.phone_number && (_vm.CR.authorization.state.isGod || _vm.CR.authorization.state.isOrgAdmin))?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Phone Number")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.home_address.phone_number))])])],1):_vm._e()],1):_vm._e(),(_vm.C.data.person.work_address)?_c('div',{staticClass:"pb-5"},[(_vm.C.data.person.work_address)?_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Work Address")])]):_vm._e(),(_vm.C.data.person.work_address.street1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.street1))]),(_vm.C.data.person.work_address.street2)?_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.street2))]):_vm._e()])],1):_vm._e(),(_vm.C.data.person.work_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.state_province))])])],1):_vm._e(),(_vm.C.data.person.work_address.city)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.city))])])],1):_vm._e(),(_vm.C.data.person.work_address.postal_code)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.postal_code))])])],1):_vm._e(),(_vm.C.data.person.work_address.country)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.person.work_address.country] && _vm.C.list.countries[_vm.C.data.person.work_address.country].name))])])],1):_vm._e(),(_vm.C.data.person.work_address.phone_number && (_vm.CR.authorization.state.isGod || _vm.CR.authorization.state.isOrgAdmin))?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Phone Number")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.person.work_address.phone_number))])])],1):_vm._e()],1):_vm._e(),(_vm.C.data.person.organizations && _vm.C.data.person.organizations.length > 0)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Organizations")])]),_vm._l((_vm.C.data.person.user_organization_statuses),function(organizationStatusItem){return _c('v-layout',{key:organizationStatusItem.organization_id,attrs:{"row":"row","no-wrap":"no-wrap","align-center":"align-center"}},[_c('v-flex',[_c('v-card-title',{staticClass:"pa-0 pt-2"},[_c('h3',[_vm._v(_vm._s(organizationStatusItem.organization_name))])]),_c('v-card-text',{staticClass:"pl-0 pt-2"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[(organizationStatusItem.status)?_c('p',[_c('label',{staticClass:"mr-2"},[_vm._v("Status:")]),_vm._v(_vm._s(organizationStatusItem.status))]):_vm._e(),(organizationStatusItem.title && organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('label',{staticClass:"mr-2"},[_vm._v("Title:")]),_vm._v(_vm._s(organizationStatusItem.title))]):_vm._e(),(organizationStatusItem.phone && organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('label',{staticClass:"mr-2"},[_vm._v("Phone:")]),_vm._v(_vm._s(organizationStatusItem.phone))]):_vm._e(),(organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small","color":"secondary"}},[_vm._v("person")]),_vm._v("Org Admin")],1):_vm._e()])],1)],1)],1)})],2):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ltde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n4Bv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  computed: {
    binding: function binding() {
      var binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    }
  },
  data: function data() {
    var _this = this;

    return {
      CR: {},
      C: {
        data: {
          profile: {}
        },
        form: {
          validation: {
            overall: false,
            rules: {
              user: {
                firstname: [function (v) {
                  return !!v || 'First name is required';
                }],
                lastname: [function (v) {
                  return !!v || 'Last name is required';
                }],
                email: [function (v) {
                  return !!v || 'Email is required';
                }]
              }
            }
          },
          selected: {
            user: {
              firstname: '',
              lastname: '',
              email: '',
              citizenship: ''
            },
            home_address: {
              street1: '',
              street2: '',
              city: '',
              state_province: '',
              postal_code: '',
              country: '',
              phone_number: ''
            },
            work_address: {
              employer: '',
              street1: '',
              street2: '',
              city: '',
              state_province: '',
              postal_code: '',
              country: '',
              phone_number: ''
            }
          },
          list: {
            countries: __WEBPACK_IMPORTED_MODULE_3_country_data___default.a.countries.all
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                user: _this.C.form.selected.user,
                home_address: _this.C.form.selected.home_address,
                work_address: _this.C.form.selected.work_address
              };

              function completeUpdateProcess(resultsItem) {
                console.info('Profile Update Results: ', resultsItem);

                component.$router.push({
                  name: 'Profile'
                });

                __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                  type: 'success',
                  message: 'Your profile has been updated.'
                });
              }

              __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/people/self_update', submitItem).then(function (response) {
                var userUpdateData = response.data;

                completeUpdateProcess({
                  user: userUpdateData
                });
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].loggedInData({
      success: function success(loggedInItem) {
        component.C.data.person = loggedInItem.data;

        component.C.form.selected.user.firstname = loggedInItem.data.firstname;
        component.C.form.selected.user.lastname = loggedInItem.data.lastname;
        component.C.form.selected.user.email = loggedInItem.data.email;
        component.C.form.selected.user.citizenship = loggedInItem.data.citizenship || 'USA';
        component.C.form.selected.home_address = loggedInItem.data.home_address || {};
        component.C.form.selected.work_address = loggedInItem.data.work_address || {};

        component.C.form.selected.home_address.country = component.C.form.selected.home_address.country || 'USA';
        component.C.form.selected.work_address.country = component.C.form.selected.work_address.country || 'USA';
      },
      error: function error(errorResponse) {
        __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
          type: 'error',
          errorResponse: errorResponse
        });
      }
    });
  }
});

/***/ }),

/***/ "nBgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("There is no content available to display.")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nDc0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oENE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oJIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "oVYV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompletionCheck__ = __webpack_require__("bTge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoContent__ = __webpack_require__("u9PG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js__ = __webpack_require__("yiUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_html_docx_js_dist_html_docx_js__ = __webpack_require__("U3YJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_html_docx_js_dist_html_docx_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__node_modules_html_docx_js_dist_html_docx_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_html_docx_js_test_vendor_FileSaver_js__ = __webpack_require__("zA6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_html_docx_js_test_vendor_FileSaver_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__node_modules_html_docx_js_test_vendor_FileSaver_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_8_vue_avatar___default.a,
    'completion-check': __WEBPACK_IMPORTED_MODULE_1__CompletionCheck__["a" /* default */],
    'no-content': __WEBPACK_IMPORTED_MODULE_2__NoContent__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      settingsPanel: null,
      tab: 'tab-commments',
      active: null,
      toggleSectionCompleted: null,
      CR: {
        authorization: __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__["a" /* default */].authorization,
        show: __WEBPACK_IMPORTED_MODULE_3__assets_global_settings_js__["a" /* default */].show
      },
      C: {
        config: {
          containerSections: []
        },
        timer: {
          autoSave: null,
          saveIndicator: null
        },
        state: {
          initialized: false,
          isEditable: false,
          autoSave: {
            containers: false,
            scratchpad: false
          },
          tab: {
            construction: {
              active: null,
              item: null
            },
            comparativeadvantages: {
              active: null,
              item: null
            },
            development: {
              active: null,
              item: null
            }
          },
          dialog: {
            confirmComparativeadvantagesComponentDelete: {
              active: false
            },
            confirmConstructionComponentDelete: {
              active: false
            },
            confirmDevelopmentComponentDelete: {
              active: false
            }
          },
          container: [{
            title: 'Solution',
            phaseThreshold: 2,
            active: true,
            items: [{
              key: 'summary',
              title: 'Summary',
              href: '#solution-summary',
              includeAPI: true
            }, {
              key: 'draw',
              title: 'Draw',
              href: '#solution-draw',
              includeAPI: true
            }, {
              key: 'significance',
              title: 'Significance',
              href: '#solution-significance',
              includeAPI: true
            }, {
              key: 'landscape',
              title: 'Landscape',
              href: '#solution-landscape',
              includeAPI: true
            }]
          }, {
            title: 'Problem',
            phaseThreshold: 2,
            inactive: true,
            items: [{
              key: 'problem_summary',
              title: 'Summary',
              href: '#problem-summary',
              includeAPI: true
            }, {
              key: 'gap',
              title: 'Gap',
              href: '#problem-gap',
              includeAPI: true
            }, {
              key: 'problem_significance',
              title: 'Significance',
              href: '#problem-significance',
              includeAPI: true
            }]
          }, {
            title: 'Comparative Advantages',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'comparativeadvantages',
            items: [{
              title: 'General Info',
              href: '#comparativeadvantages-general',
              includeAPI: false,
              notComponent: true,
              subAPIitems: [{
                key: 'comparativeadvantages_innovativeaspects',
                title: 'Innovative Aspects'
              }, {
                key: 'comparativeadvantages_advantagessummary',
                title: 'Summary'
              }, {
                key: 'comparativeadvantages_relevantbackground',
                title: 'Relevant Background'
              }]
            }],
            navSelectTrigger: function navSelectTrigger() {
              var component = _this;

              component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base';
            }
          }, {
            title: 'Construction',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'construction',
            items: [{
              title: 'General Info',
              href: '#construction-general',
              includeAPI: false,
              notComponent: true,
              subAPIitems: [{
                key: 'construction_howused',
                title: 'How is it used?'
              }, {
                key: 'construction_prototype',
                title: 'Prototype (Optional)'
              }]
            }]
          }, {
            title: 'Economics',
            phaseThreshold: 3,
            inactive: true,
            items: [{
              key: 'economics_need',
              title: 'Market Need',
              href: '#economics-need',
              includeAPI: true
            }, {
              key: 'economics_enduser',
              title: 'End User',
              href: '#economics-enduser',
              includeAPI: true
            }, {
              key: 'economics_keyresources',
              title: 'Key Resources',
              href: '#economics-keyresources',
              includeAPI: true
            }, {
              key: 'economics_capitalexpenditure',
              title: 'Expenditure Requirements',
              href: '#economics-capitalexpenditure',
              includeAPI: true
            }, {
              key: 'economics_feasiblyeconomical',
              title: 'Economical Feasibility',
              href: '#economics-feasiblyeconomical',
              includeAPI: true
            }, {
              key: 'economics_whomake',
              title: 'Who',
              href: '#economics-whomake',
              includeAPI: true
            }, {
              key: 'economics_howmakemoney',
              title: 'Make Money',
              href: '#economics-howmakemoney',
              includeAPI: true
            }, {
              key: 'economics_howdelivered',
              title: 'Delivery',
              href: '#economics-howdelivered',
              includeAPI: true
            }, {
              key: 'economics_economicburden',
              title: 'Economic Burden',
              href: '#economics-economicburden',
              includeAPI: true
            }, {
              key: 'economics_currentsolutioncosts',
              title: 'Current Solution Costs',
              href: '#economics-currentsolutioncosts',
              includeAPI: true
            }, {
              key: 'economics_consumercosts',
              title: 'Customer Costs',
              href: '#economics-consumercosts',
              includeAPI: true
            }]
          }, {
            title: 'Development',
            phaseThreshold: 3,
            inactive: true,
            componentContainerKey: 'development',
            items: []
          }, {
            title: 'Specific Questions',
            phaseThreshold: 3,
            inactive: true,
            hideItemsList: true,
            items: [{
              key: 'specificquestions',
              title: '',
              href: '#specificquestions-specificquestions',
              includeAPI: true
            }]
          }, {
            title: 'References',
            phaseThreshold: 3,
            inactive: true,
            hideItemsList: true,
            items: [{
              key: 'references',
              title: '',
              href: '#references-references',
              includeAPI: true
            }]
          }]
        },
        data: {
          invention: {}
        },
        form: {
          config: {
            froala: {
              invention: {
                description: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig(),
                scratchpad: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig(),
                container_section: {
                  draw: {
                    content: __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].setupFroalaConfig({
                      placeholderText: '',
                      toolbarInline: false,
                      pluginsEnabled: ['image'],
                      toolbarButtons: ['insertImage']
                    })
                  }
                }
              }
            }
          },
          state: {
            active: {
              $search: false
            },
            recentSaveActive: false
          },
          list: {
            constructionComponentOptions: [{
              label: 'Material',
              key: 'material'
            }, {
              label: 'Sub-Component',
              key: 'sub-component'
            }, {
              label: 'Component',
              key: 'component'
            }, {
              label: 'Device',
              key: 'device'
            }, {
              label: 'System',
              key: 'system'
            }, {
              label: 'Service',
              key: 'service'
            }],
            collaboratorAccessOptions: {
              items: [{
                label: 'Co-inventor',
                value: 1
              }, {
                label: 'Mentor/Expert',
                value: 2
              }, {
                label: 'Commenter',
                value: 3
              }],
              dictionary: {
                '1': 'Co-inventor',
                '2': 'Mentor/Expert',
                '3': 'Commenter'
              }
            },
            bulkDefaultAccessOptions: [{
              label: 'Anyone in my organization can comment',
              value: 'anyone-organization'
            }, {
              label: 'Only collaborators in my organization can comment',
              value: 'only-inventors'
            }],
            opportunities: []
          },
          selected: {
            invention_id: null,
            invention: {
              title: '',
              description: '',
              search_list: '',
              keywords: '',
              search_results: '',
              action: '',
              action_note: '',
              search: [],
              $search: {
                title: '',
                url: '',
                note: '',
                tag: ''
              },
              uploaded_filename: '',
              invention_opportunity_id: null,
              organization_id: null,
              bulk_read_access: null,
              container_section: {}
            },
            $collaborator: {
              $item: null,
              access: null
            },
            scratchpad: '',
            co_inventors: [],
            upload: null,
            comments: {
              $list: [],
              content: ''
            }
          },
          trigger: {
            addSearchItem: function addSearchItem(searchItem) {
              var component = _this;

              component.C.form.selected.invention.search.push({
                title: component.C.form.selected.invention.$search.title,
                url: component.C.form.selected.invention.$search.url,
                note: component.C.form.selected.invention.$search.note,
                tag: component.C.form.selected.invention.$search.tag
              });

              component.C.form.selected.invention.$search.title = '';
              component.C.form.selected.invention.$search.url = '';
              component.C.form.selected.invention.$search.note = '';
              component.C.form.selected.invention.$search.tag = '';

              component.C.form.state.active.$search = false;
            },
            removeSearchItem: function removeSearchItem(searchItem, searchItemIndex) {
              var component = _this;

              if (!searchItem.id) {
                component.C.form.selected.invention.search.splice(searchItemIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(searchItem, 'remove', !searchItem.remove);
              }
            },
            addCollaboratorItem: function addCollaboratorItem() {
              var component = _this;

              if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                component.C.form.selected.co_inventors.push({
                  $isNew: true,
                  $name: component.C.form.selected.$collaborator.$item.fullname,
                  user_id: component.C.form.selected.$collaborator.$item.id,
                  access: component.C.form.selected.$collaborator.access,
                  remove: false
                });

                component.C.form.selected.$collaborator.$item = null;
                component.C.form.selected.$collaborator.access = null;
              }
            },
            removeCollaboratorItem: function removeCollaboratorItem(collaboratorItem, collaboratorIndex) {
              var component = _this;

              if (collaboratorItem.$isNew) {
                component.C.form.selected.co_inventors.splice(collaboratorIndex, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(collaboratorItem, 'remove', !collaboratorItem.remove);
              }
            },
            selectContainerItem: function selectContainerItem(targetContainer) {
              if (targetContainer.navSelectTrigger) {
                targetContainer.navSelectTrigger();
              }
            },
            selectContainerSectionItem: function selectContainerSectionItem(targetData) {
              targetData = targetData || {};
              var item = targetData.item || {};
              var subItem = targetData.subItem || {};
              var targetIndex = targetData.index;

              var component = _this;

              if (item.componentContainerKey) {
                if (subItem.useByIndex) {
                  component.C.state.tab[item.componentContainerKey].active = item.componentContainerKey + '-' + targetIndex;
                } else {
                  component.C.state.tab[item.componentContainerKey].active = ('' + subItem.href).substr(1);
                }
              }
            },
            updateAllContainerSections: function updateAllContainerSections(callback, negateDeletion) {
              var component = _this;
              callback = callback || __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop;

              var submitItem = {
                invention_id: parseInt(component.$route.params.id)
              };

              for (var i = 0; i < component.C.config.containerSections.length; i++) {
                submitItem[component.C.config.containerSections[i]] = component.C.form.selected.invention.container_section[component.C.config.containerSections[i]].content;
              }

              submitItem.c_comparativeadvantages = [];
              submitItem.c_constructions = [];
              submitItem.c_developments = [];

              for (i = 0; i < component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length; i++) {
                var currentComponent = component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i];

                submitItem.c_comparativeadvantages.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  competing_howworks: currentComponent.items.competing_howworks.content,
                  shortcomings: currentComponent.items.shortcomings.content,
                  howovercomes_shortcomings: currentComponent.items.howovercomes_shortcomings.content
                });
              }

              for (i = 0; i < component.C.form.selected.invention.container_section.c_construction.components.length; i++) {
                currentComponent = component.C.form.selected.invention.container_section.c_construction.components[i];

                submitItem.c_constructions.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  ideal_example: currentComponent.items.ideal_example.content,
                  properties: currentComponent.items.properties.content,
                  how_made: currentComponent.items.how_made.content,
                  innovative_aspects: currentComponent.items.innovative_aspects.content,
                  why_hasnt_done_before: currentComponent.items.why_hasnt_done_before.content
                });
              }

              for (i = 0; i < component.C.form.selected.invention.container_section.c_development.components.length; i++) {
                currentComponent = component.C.form.selected.invention.container_section.c_development.components[i];

                submitItem.c_developments.push({
                  id: currentComponent.id,
                  c_type: currentComponent.type,
                  delete: (currentComponent.delete || false) && !negateDeletion,
                  key_points: currentComponent.items.key_points.content,
                  resources_needed: currentComponent.items.resources_needed.content,
                  deliverables: currentComponent.items.deliverables.content,
                  measure_of_success: currentComponent.items.measure_of_success.content,
                  key_risks: currentComponent.items.key_risks.content,
                  suggested_approach: currentComponent.items.suggested_approach.content
                });
              }

              __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/container_sections/update', submitItem).then(function (response) {
                console.info('Update Container Sections Results: ', response.data);

                callback(response.data);
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addComparativeadvantagesComponent: function addComparativeadvantagesComponent() {
              var component = _this;

              var targetComponentType = 'Current Technology ' + (component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length + 1);

              component.C.form.selected.invention.container_section.c_comparativeadvantages.components.push({
                type: targetComponentType,
                items: {
                  competing_howworks: {
                    content: ''
                  },
                  shortcomings: {
                    content: ''
                  },
                  howovercomes_shortcomings: {
                    content: ''
                  }
                }
              });

              var comparativeadvantagesComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length - 1;

              component.C.state.container[2].items.splice(component.C.state.container[2].items.length - 1, 0, {
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#comparativeadvantages-' + comparativeadvantagesComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-' + comparativeadvantagesComponentIndex;

              component.C.trigger.scrollToTop();
            },
            addConstructionComponent: function addConstructionComponent(targetComponentType) {
              var component = _this;

              component.C.form.selected.invention.container_section.c_construction.components.push({
                type: targetComponentType,
                items: {
                  ideal_example: {
                    content: ''
                  },
                  properties: {
                    content: ''
                  },
                  how_made: {
                    content: ''
                  },
                  innovative_aspects: {
                    content: ''
                  },
                  why_hasnt_done_before: {
                    content: ''
                  }
                }
              });

              var constructionComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.length - 1;

              component.C.state.container[3].items.splice(component.C.state.container[3].items.length - 1, 0, {
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#construction-' + constructionComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.construction.active = 'construction-' + constructionComponentIndex;

              component.C.trigger.scrollToTop();
            },
            addDevelopmentComponent: function addDevelopmentComponent() {
              var component = _this;

              var targetComponentType = 'Milestone ' + (component.C.form.selected.invention.container_section.c_development.components.length + 1);

              component.C.form.selected.invention.container_section.c_development.components.push({
                type: targetComponentType,
                items: {
                  key_points: {
                    content: ''
                  },
                  resources_needed: {
                    content: ''
                  },
                  deliverables: {
                    content: ''
                  },
                  measure_of_success: {
                    content: ''
                  },
                  key_risks: {
                    content: ''
                  },
                  suggested_approach: {
                    content: ''
                  }
                }
              });

              var developmentComponentIndex = component.C.form.selected.invention.container_section.c_development.components.length - 1;

              component.C.state.container[5].items.push({
                key: targetComponentType,
                title: targetComponentType, // ### TEMPORARY - Need label
                href: '#development-' + developmentComponentIndex,
                useByIndex: true
              });

              component.C.state.tab.development.active = 'development-' + developmentComponentIndex;

              component.C.trigger.scrollToTop();
            },
            deleteComparativeadvantagesComponent: function deleteComparativeadvantagesComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                if (targetComponent.delete) {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', false);
                } else {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.competing_howworks.content || targetComponent.items.shortcomings.content || targetComponent.items.howovercomes_shortcomings.content)) {
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true;
                  component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                    component.C.form.trigger.deleteComparativeadvantagesComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.comparativeadvantages.active === 'comparativeadvantages-' + targetComponentIndex) {
                    component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[2].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_comparativeadvantages.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmComparativeadvantagesComponentDelete = __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false;
                }
              }
            },
            deleteConstructionComponent: function deleteConstructionComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                if (targetComponent.delete) {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', false);
                } else {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.how_made.content || targetComponent.items.ideal_example.content || targetComponent.items.innovative_aspects.content || targetComponent.items.properties.content || targetComponent.items.why_hasnt_done_before.content)) {
                  component.C.state.dialog.confirmConstructionComponentDelete.active = true;
                  component.C.trigger.confirmConstructionComponentDelete = function () {
                    component.C.form.trigger.deleteConstructionComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.construction.active === 'construction-' + targetComponentIndex) {
                    component.C.state.tab.construction.active = 'construction-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[3].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_construction.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmConstructionComponentDelete = __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmConstructionComponentDelete.active = false;
                }
              }
            },
            deleteDevelopmentComponent: function deleteDevelopmentComponent(targetComponent, confirmedDeletion) {
              var component = _this;

              var targetComponentIndex = component.C.form.selected.invention.container_section.c_development.components.indexOf(targetComponent);

              if (!__WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.isUndefined(targetComponent.id)) {
                if (targetComponent.delete) {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', false);
                } else {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(targetComponent, 'delete', true);
                }
              } else {
                if (!confirmedDeletion && (targetComponent.items.key_points.content || targetComponent.items.resources_needed.content || targetComponent.items.deliverables.content || targetComponent.items.measure_of_success.content || targetComponent.items.key_risks.content || targetComponent.items.suggested_approach.content)) {
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = true;
                  component.C.trigger.confirmDevelopmentComponentDelete = function () {
                    component.C.form.trigger.deleteDevelopmentComponent(targetComponent, true);
                  };
                } else {
                  if (component.C.state.tab.development.active === 'development-' + targetComponentIndex) {
                    component.C.state.tab.development.active = 'development-' + (targetComponentIndex - 1);
                  }

                  component.C.state.container[5].items.splice(targetComponentIndex, 1);
                  component.C.form.selected.invention.container_section.c_development.components.splice(targetComponentIndex, 1);

                  component.C.trigger.confirmDevelopmentComponentDelete = __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop;
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = false;
                }
              }
            },
            saveSidePanelItems: function saveSidePanelItems(callback, skipClose) {
              var component = _this;
              callback = callback || __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop;

              var submitBlob = new FormData();
              submitBlob.append('invention[title]', component.C.form.selected.invention.title);
              submitBlob.append('scratchpad', component.C.form.selected.scratchpad);
              submitBlob.append('invention[search_list]', component.C.form.selected.invention.search_list);
              submitBlob.append('invention[keywords]', component.C.form.selected.invention.keywords);
              submitBlob.append('invention[search_results]', component.C.form.selected.invention.search_results);

              submitBlob.append('invention[organization_id]', component.C.form.selected.invention.organization_id);

              submitBlob.append('invention_id', component.C.form.selected.invention_id);

              if (!skipClose) {
                if (component.C.form.selected.invention.invention_opportunity_id === '$other') {
                  submitBlob.append('invention[invention_opportunity_id]', 'other');
                } else if (component.C.form.selected.invention.invention_opportunity_id) {
                  submitBlob.append('invention[invention_opportunity_id]', component.C.form.selected.invention.invention_opportunity_id);
                }

                for (var i = 0; i < component.C.form.selected.co_inventors.length; i++) {
                  submitBlob.append('co_inventors[][user_id]', component.C.form.selected.co_inventors[i].user_id);
                  submitBlob.append('co_inventors[][access]', component.C.form.selected.co_inventors[i].access);
                  submitBlob.append('co_inventors[][remove]', component.C.form.selected.co_inventors[i].remove || false);
                }

                if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                  submitBlob.append('co_inventors[][user_id]', component.C.form.selected.$collaborator.$item.id);
                  submitBlob.append('co_inventors[][access]', component.C.form.selected.$collaborator.access);
                  submitBlob.append('co_inventors[][remove]', false);
                }

                for (i = 0; i < component.C.form.selected.invention.search.length; i++) {
                  var targetSearchItem = component.C.form.selected.invention.search[i];

                  submitBlob.append('searches[][id]', targetSearchItem.id || null);
                  submitBlob.append('searches[][title]', targetSearchItem.title);
                  submitBlob.append('searches[][url]', targetSearchItem.url);
                  submitBlob.append('searches[][note]', targetSearchItem.note);
                  submitBlob.append('searches[][tag]', targetSearchItem.tag);
                  submitBlob.append('searches[][remove]', targetSearchItem.remove || false);
                }

                if (component.C.form.selected.invention.$search.title) {
                  submitBlob.append('searches[][id]', null);
                  submitBlob.append('searches[][title]', component.C.form.selected.invention.$search.title);
                  submitBlob.append('searches[][url]', component.C.form.selected.invention.$search.url);
                  submitBlob.append('searches[][note]', component.C.form.selected.invention.$search.note);
                  submitBlob.append('searches[][tag]', component.C.form.selected.invention.$search.tag);
                  submitBlob.append('searches[][remove]', false);
                }

                if (component.C.form.selected.invention.bulk_read_access) {
                  submitBlob.append('invention[bulk_read_access]', component.C.form.selected.invention.bulk_read_access);
                }
              } else {
                var targetOpportunityID = component.C.data.invention.opportunity && component.C.data.invention.opportunity.id;

                if (targetOpportunityID === -1) {
                  submitBlob.append('invention[invention_opportunity_id]', 'other');
                } else {
                  submitBlob.append('invention[invention_opportunity_id]', targetOpportunityID);
                }

                if (component.C.data.invention.bulk_read_access) {
                  submitBlob.append('invention[bulk_read_access]', component.C.data.invention.bulk_read_access);
                }
              }

              __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update', submitBlob).then(function (response) {
                console.info('Manage Invention Results: ', response.data);

                callback(response.data);
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            },
            addComment: function addComment() {
              var component = _this;

              var apiCallPromise = null;

              var submitBlob = new FormData();
              submitBlob.append('invention_id', component.C.form.selected.invention_id);
              submitBlob.append('content', component.C.form.selected.comments.content);

              apiCallPromise = __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/add_comment', submitBlob);

              if (apiCallPromise) {
                apiCallPromise.then(function (response) {
                  console.info('Add Comment Results: ', response.data);

                  component.C.form.selected.comments.$list = response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments || [];

                  component.C.form.selected.comments.content = '';
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            markInventionComplete: function markInventionComplete() {
              var component = _this;

              if (component.C.data.invention.phase === 'phase-4' && component.C.data.invention.role === 'Mentor') {
                __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                  invention_id: component.$route.params.id,
                  phase: 'phase-5'
                }).then(function (response) {
                  console.info('Update Phase Results: ', response.data);

                  component.C.trigger.setupInvention();

                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: 'The status for ' + component.C.form.selected.invention.title + ' has been set to Invention Complete.'
                  });
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved, but status failed to be updated to Invention Review.',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            saveAll: function saveAll(isPresentation) {
              var component = _this;

              clearTimeout(component.C.timer.autoSave);

              component.C.form.trigger.saveSidePanelItems(function (sidePanelResponse) {
                component.C.form.trigger.updateAllContainerSections(function (containerSectionResponse) {
                  component.C.form.state.recentSaveActive = true;

                  function saveAllComplete(messageAddendum) {
                    component.C.trigger.setupInvention();

                    __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                      type: 'success',
                      message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved' + (messageAddendum ? ' and ' + messageAddendum : '') + '.'
                    });
                  }

                  function checkContainerBulkCompletion(targetContainer) {
                    targetContainer.components = targetContainer.components || [];

                    if (targetContainer.components.length > 0) {
                      targetContainer.completion = true;

                      for (var i = 0; i < targetContainer.components.length; i++) {
                        targetContainer.completion = targetContainer.completion && targetContainer.components[i].completion;
                      }
                    }
                  }

                  if (isPresentation) {
                    component.$router.push({
                      name: 'InventionPresentation',
                      params: {
                        id: component.$route.params.id
                      }
                    });
                  } else {
                    var inventionItem = containerSectionResponse && containerSectionResponse.data && containerSectionResponse.data.invention || {};

                    var csResult = inventionItem.container_section || {};
                    csResult.summary = csResult.summary || {};
                    csResult.draw = csResult.draw || {};
                    csResult.significance = csResult.significance || {};
                    csResult.landscape = csResult.landscape || {};
                    csResult.problem_summary = csResult.problem_summary || {};
                    csResult.gap = csResult.gap || {};
                    csResult.problem_significance = csResult.problem_significance || {};

                    csResult.comparativeadvantages_innovativeaspects = csResult.comparativeadvantages_innovativeaspects || {};
                    csResult.comparativeadvantages_advantagessummary = csResult.comparativeadvantages_advantagessummary || {};
                    csResult.comparativeadvantages_relevantbackground = csResult.comparativeadvantages_relevantbackground || {};
                    csResult.construction_howused = csResult.construction_howused || {};
                    csResult.construction_prototype = csResult.construction_prototype || {};
                    csResult.economics_need = csResult.economics_need || {};
                    csResult.economics_enduser = csResult.economics_enduser || {};
                    csResult.economics_keyresources = csResult.economics_keyresources || {};
                    csResult.economics_capitalexpenditure = csResult.economics_capitalexpenditure || {};
                    csResult.economics_feasiblyeconomical = csResult.economics_feasiblyeconomical || {};
                    csResult.economics_whomake = csResult.economics_whomake || {};
                    csResult.economics_howmakemoney = csResult.economics_howmakemoney || {};
                    csResult.economics_howdelivered = csResult.economics_howdelivered || {};
                    csResult.economics_economicburden = csResult.economics_economicburden || {};
                    csResult.economics_currentsolutioncosts = csResult.economics_currentsolutioncosts || {};
                    csResult.economics_consumercosts = csResult.economics_consumercosts || {};
                    csResult.specificquestions = csResult.specificquestions || {};
                    csResult.references = csResult.references || {};

                    csResult.c_comparativeadvantages = csResult.c_comparativeadvantages || {};
                    checkContainerBulkCompletion(csResult.c_comparativeadvantages);
                    csResult.c_construction = csResult.c_construction || {};
                    checkContainerBulkCompletion(csResult.c_construction);
                    csResult.c_development = csResult.c_development || {};
                    checkContainerBulkCompletion(csResult.c_development);

                    var hasMentor = !!__WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.find(inventionItem.collaborators, function (collaborator) {
                      return collaborator && collaborator.role && collaborator.role.code === 'mentor';
                    });

                    if (inventionItem.phase === 'phase-2' && inventionItem.searches.length >= 1 && csResult.summary.completion && csResult.draw.completion && csResult.significance.completion && csResult.landscape.completion && csResult.problem_summary.completion && csResult.gap.completion && csResult.problem_significance.completion) {
                      __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                        invention_id: component.$route.params.id,
                        phase: 'phase-3'
                      }).then(function (response) {
                        console.info('Update Phase Results: ', response.data);

                        saveAllComplete('invention status has been updated to Invention Full');
                      }).catch(function (errorResponse) {
                        __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                          type: 'error',
                          message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved, but status failed to be updated to Invention Full.',
                          errorResponse: errorResponse
                        });
                      });
                    } else if (inventionItem.phase === 'phase-3' && inventionItem.searches.length >= 2 && csResult.summary.completion && csResult.draw.completion && csResult.significance.completion && csResult.landscape.completion && csResult.problem_summary.completion && csResult.gap.completion && csResult.problem_significance.completion && hasMentor && csResult.comparativeadvantages_innovativeaspects.completion && csResult.comparativeadvantages_advantagessummary.completion && csResult.comparativeadvantages_relevantbackground.completion && csResult.construction_howused.completion && csResult.construction_prototype.completion && csResult.economics_need.completion && csResult.economics_enduser.completion && csResult.economics_keyresources.completion && csResult.economics_capitalexpenditure.completion && csResult.economics_feasiblyeconomical.completion && csResult.economics_whomake.completion && csResult.economics_howmakemoney.completion && csResult.economics_howdelivered.completion && csResult.economics_economicburden.completion && csResult.economics_currentsolutioncosts.completion && csResult.economics_consumercosts.completion && csResult.specificquestions.completion && csResult.references.completion && csResult.c_comparativeadvantages.completion && csResult.c_construction.completion && csResult.c_development.completion) {
                      __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/update_phase', {
                        invention_id: component.$route.params.id,
                        phase: 'phase-4'
                      }).then(function (response) {
                        console.info('Update Phase Results: ', response.data);

                        saveAllComplete('invention status has been updated to Invention Review');
                      }).catch(function (errorResponse) {
                        __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                          type: 'error',
                          message: 'Changes to ' + component.C.form.selected.invention.title + ' have been saved, but status failed to be updated to Invention Review.',
                          errorResponse: errorResponse
                        });
                      });
                    } else {
                      saveAllComplete();
                    }
                  }

                  clearTimeout(component.C.timer.saveIndicator);

                  component.C.timer.saveIndicator = setTimeout(function () {
                    component.C.form.state.recentSaveActive = false;
                  }, 5000);
                });
              });
            }
          }
        },
        trigger: {
          scrollToTop: function scrollToTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          },
          exportDocument: function exportDocument() {
            var component = _this;

            var $targetElement = __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#js-invention-document');

            var documentContent = '<!DOCTYPE html>' + $targetElement.get(0).outerHTML;

            var documentBlob = __WEBPACK_IMPORTED_MODULE_9__node_modules_html_docx_js_dist_html_docx_js___default.a.asBlob(documentContent, {
              orientation: 'portrait'
            });

            __WEBPACK_IMPORTED_MODULE_10__node_modules_html_docx_js_test_vendor_FileSaver_js___default()(documentBlob, component.C.form.selected.invention.title + '.docx');
          },
          setupInvention: function setupInvention(isInitialization) {
            var component = _this;

            __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/inventions/detail', {
              params: {
                invention_id: component.$route.params.id
              }
            }).then(function (response) {
              var inventionDataItem = response && response.data && response.data.data && response.data.data.invention || {};
              var isEditable = false;

              component.C.data.invention = inventionDataItem;
              component.C.state.isEditable = isEditable;

              component.C.form.selected.invention_id = inventionDataItem.id;
              component.C.form.selected.invention.title = inventionDataItem.title;
              component.C.form.selected.invention.description = inventionDataItem.description;
              component.C.form.selected.invention.search_list = inventionDataItem.search_list;
              component.C.form.selected.invention.keywords = inventionDataItem.keywords;
              component.C.form.selected.invention.search_results = inventionDataItem.search_results;
              component.C.form.selected.invention.action = inventionDataItem.action;
              component.C.form.selected.invention.action_note = inventionDataItem.action_note;
              component.C.form.selected.invention.search = inventionDataItem.searches; // ### Incomplete
              component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename;

              var targetOpportunityID = inventionDataItem.opportunity && inventionDataItem.opportunity.id;
              if (targetOpportunityID === -1) {
                component.C.form.selected.invention.invention_opportunity_id = '$other';
              } else {
                component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID;
              }

              component.C.form.selected.invention.organization_id = inventionDataItem.organization && inventionDataItem.organization.id;
              component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null;
              component.C.form.selected.scratchpad = inventionDataItem.scratchpad && inventionDataItem.scratchpad.content || '';

              component.C.form.selected.co_inventors = [];

              for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                component.C.form.selected.co_inventors.push({
                  $name: (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname) + ' ' + (inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname),
                  user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                  access: inventionDataItem.co_inventors[i].access
                });
              }

              component.C.form.selected.comments.$list = inventionDataItem.comments;

              var containerSectionItem = inventionDataItem.container_section || {};

              function presetContainerSection(targetKey) {
                containerSectionItem[targetKey] = containerSectionItem[targetKey] || {
                  content: ''
                };
              }

              for (i = 0; i < component.C.config.containerSections.length; i++) {
                presetContainerSection(component.C.config.containerSections[i]);
              }

              containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
                components: []
              };
              containerSectionItem.c_construction = containerSectionItem.c_construction || {
                components: []
              };
              containerSectionItem.c_development = containerSectionItem.c_development || {
                components: []
              };

              component.C.state.container[2].items = [];
              for (i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
                var componentItem = containerSectionItem.c_comparativeadvantages.components[i];

                component.C.state.container[2].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#comparativeadvantages-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[2].$baseItems.length; i++) {
                component.C.state.container[2].items.push(component.C.state.container[2].$baseItems[i]);
              }

              component.C.state.container[3].items = [];
              for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
                componentItem = containerSectionItem.c_construction.components[i];

                component.C.state.container[3].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#construction-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[3].$baseItems.length; i++) {
                component.C.state.container[3].items.push(component.C.state.container[3].$baseItems[i]);
              }

              component.C.state.container[5].items = [];
              for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
                componentItem = containerSectionItem.c_development.components[i];

                component.C.state.container[5].items.push({
                  key: componentItem.type,
                  title: componentItem.type, // ### TEMPORARY - Need label
                  href: '#development-' + i,
                  useByIndex: true
                });
              }
              for (i = 0; i < component.C.state.container[5].$baseItems.length; i++) {
                component.C.state.container[5].items.push(component.C.state.container[5].$baseItems[i]);
              }

              component.C.form.selected.invention.container_section = containerSectionItem;

              if (isInitialization) {
                component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base';

                if (containerSectionItem.c_construction.components.length === 0) {
                  component.C.state.tab.construction.active = 'construction-base';
                } else {
                  component.C.state.tab.construction.active = 'construction-0';
                }

                if (containerSectionItem.c_development.components.length === 0) {
                  component.C.state.tab.development.active = 'development-base';
                } else {
                  component.C.state.tab.development.active = 'development-0';
                }

                if (component.C.form.selected.invention.organization_id) {
                  __WEBPACK_IMPORTED_MODULE_5__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/organizations/opportunities_and_inventors', {
                    params: {
                      organization_id: component.C.form.selected.invention.organization_id
                    }
                  }).then(function (response) {
                    var opportunitiesList = response && response.data && response.data.data && response.data.data.invention_opportunities || [];
                    var peopleList = response && response.data && response.data.data && response.data.data.inventors || [];

                    opportunitiesList.push({
                      id: '$other',
                      title: 'Other'
                    });

                    component.C.form.list.opportunities = opportunitiesList;
                    component.C.form.list.inventors = peopleList;

                    component.C.form.selected.$collaborator.$item = null;
                    component.C.form.selected.$collaborator.access = null;
                  }).catch(function (errorResponse) {
                    __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                      type: 'error',
                      errorResponse: errorResponse
                    });
                  });
                }

                setTimeout(function () {
                  component.C.state.initialized = true;
                }, 10000);
              }
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_4__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });
            });
          },
          confirmComparativeadvantagesComponentDelete: __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop,
          confirmConstructionComponentDelete: __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop,
          confirmDevelopmentComponentDelete: __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.noop
        },
        dictionary: {
          phase: {
            'phase-1': 'Concept',
            'phase-2': 'Invention Brief',
            'phase-3': 'Invention Full',
            'phase-4': 'Invention Review',
            'phase-5': 'Invention Complete'
          },
          bulk_read_access: {
            'only-inventors': 'Specific people',
            'anyone-organization': 'Anyone can comment'
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    function initializeContainerSection(targetKey) {
      component.C.form.selected.invention.container_section[targetKey] = {
        content: ''
      };
      component.C.config.containerSections.push(targetKey);
    }

    for (var i = 0; i < component.C.state.container.length; i++) {
      var currentContainer = component.C.state.container[i];
      currentContainer.$baseItems = currentContainer.items || [];

      for (var j = 0; j < currentContainer.items.length; j++) {
        if (currentContainer.items[j].includeAPI) {
          initializeContainerSection(currentContainer.items[j].key);
        }
        if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
          for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
            initializeContainerSection(currentContainer.items[j].subAPIitems[k].key);
          }
        }
      }
    }

    component.C.trigger.setupInvention(true);
  },

  filters: {
    F_availableCollaborators: function F_availableCollaborators(currentList, selectedList) {
      currentList = currentList || [];
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        var correspondingSelectedCollaborator = __WEBPACK_IMPORTED_MODULE_7__node_modules_underscore_underscore_min_js___default.a.find(selectedList, function (selectedCollaborator) {
          return selectedCollaborator.user_id === currentCollaborator.id;
        });

        if (!correspondingSelectedCollaborator) {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    },
    F_availableAccess: function F_availableAccess(currentList, targetPhase) {
      var filteredList = [];

      for (var i = 0; i < currentList.length; i++) {
        var currentCollaborator = currentList[i];

        if (currentCollaborator.value === 2) {
          if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
            filteredList.push(currentCollaborator);
          }
        } else {
          filteredList.push(currentCollaborator);
        }
      }

      return filteredList;
    }
  }
});

/***/ }),

/***/ "p/LL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{staticClass:"ml-0",attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Invention Opportunities")])])],1),_c('v-spacer'),(_vm.CR.authorization.state.isOrgAdmin)?_c('v-btn',{staticClass:"page-header__action",attrs:{"to":"/opportunities/opportunity/add","exact":"","color":"primary"}},[_vm._v("New Opportunity")]):_vm._e()],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},_vm._l((_vm.C.data.opportunities),function(opportunity){return _c('v-flex',{key:opportunity.id,attrs:{"lg6":"lg6"}},[_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',{staticClass:"pb-0",attrs:{"primary-title":"primary-title"}},[_c('h2',{staticClass:"headline"},[_vm._v(_vm._s(opportunity.title))])]),_c('v-card-text',[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',[_c('span',{staticClass:"grey--text"},[_vm._v("Expires "+_vm._s(_vm._f("moment")(opportunity.closing_time,"MMM D, YYYY"))),(opportunity.status)?_c('span',[_vm._v(" ("+_vm._s(opportunity.status)+")")]):_vm._e()])]),_c('v-spacer'),_c('v-flex',{staticClass:"text-xs-right"},[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(opportunity.organization.name))])])],1)],1),_c('v-card-text',{staticClass:"pt-0"},[_vm._v(_vm._s(opportunity.short_description))]),_c('v-card-actions',[(opportunity.uploaded_filename)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.C.trigger.downloadFile(opportunity)}}},[_vm._v("Download")]):_vm._e(),(_vm.CR.authorization.state.isGod || (_vm.CR.authorization.state.organization && _vm.CR.authorization.state.organization[("id-" + (opportunity.organization.id))] && _vm.CR.authorization.state.organization[("id-" + (opportunity.organization.id))].isAdmin))?_c('v-btn',{attrs:{"to":{name: "OpportunityEdit", params: { id: opportunity.id }}}},[_vm._v("Edit")]):_vm._e()],1)],1)],1)}))],1),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block",staticStyle:{"width":"220px","position":"fixed"}},[_c('div',{staticClass:"body-1 mb-0"},[_vm._v("Sort by:")]),(_vm.C.filters.list.organizations.length > 1)?_c('v-select',{staticClass:"input--box",attrs:{"label":"All Organizations","items":_vm.C.filters.list.organizations,"item-text":"name","item-value":"id","single-line":"single-line","clearable":true,"hide-details":true},model:{value:(_vm.C.filters.selected.organization_id),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "organization_id", $$v)},expression:"C.filters.selected.organization_id"}}):_vm._e(),_c('v-select',{staticClass:"input--box",attrs:{"items":_vm.C.filters.list.statuses,"label":"All Statuses","item-text":"label","item-value":"value","single-line":"single-line","clearable":true,"hide-details":"hide-details"},model:{value:(_vm.C.filters.selected.status),callback:function ($$v) {_vm.$set(_vm.C.filters.selected, "status", $$v)},expression:"C.filters.selected.status"}}),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{attrs:{"sm6":"sm6"}},[_c('v-btn',{attrs:{"block":"block"},on:{"click":function($event){_vm.C.trigger.refreshBaseData({ filters: _vm.C.filters.selected })}}},[_vm._v("Go")])],1),_c('v-flex',{attrs:{"sm6":"sm6"}},[(_vm.C.filters.selected.organization_id || _vm.C.filters.selected.status)?_c('v-btn',{attrs:{"block":"block"},on:{"click":function($event){_vm.C.trigger.refreshBaseData()}}},[_vm._v("Reset")]):_vm._e()],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r7Z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default.a
  },
  data: function data() {
    var _this = this;

    return {
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].show,
        authorization: __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].authorization,
        trigger: {
          signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].signOut({
              success: function success() {
                _this.$router.push({
                  name: 'MagicSignIn'
                });
              }
            });
          }
        }
      },
      sideNav: false,
      navMainItems: [
      // { title: 'Home', targetState: 'Default' },
      { title: 'Inventions', targetState: 'Inventions', restriction: '!god' }, { title: 'Opportunities', targetState: 'Opportunities', restriction: 'atleast-1-org-and-not-god' }, { title: 'People', targetState: 'People', restriction: 'atleast-1-org' }, { title: 'Organizations', targetState: 'Organizations', restriction: 'god' }],
      navItems: [{ title: 'Sign In', targetState: 'MagicSignIn' }, { title: 'Sign Up', targetState: 'MagicSignUp' }],
      footer: {
        fixed: true
      }
    };
  },
  created: function created() {
    var component = this;

    if (window.localStorage.prolific_authorization) {
      __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.defaults.headers.common['Authorization'] = window.localStorage.prolific_authorization;
      __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].authorization.loggedIn = true;

      __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].loggedInData({
        success: function success(loggedInItem) {
          component.CR.authorization.state = loggedInItem.state;
          component.CR.authorization.data = loggedInItem.data;
        },
        error: function error(errorResponse) {
          __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
            type: 'error',
            errorResponse: errorResponse
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "rI/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rex7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventions_vue__ = __webpack_require__("4/ND");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e41a358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Inventions_vue__ = __webpack_require__("fp2Z");
function injectStyle (ssrContext) {
  __webpack_require__("s8bZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e41a358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e41a358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Inventions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s8bZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sc+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/people"}},[_c('h2',[_vm._v("All People")])])],1),(!this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Add User")])]):_vm._e(),(this.$route.params.id)?_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":("/people/person/" + (this.$route.params.id))}},[_c('h2',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname))])])],1):_vm._e(),(this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":"disabled"}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Edit")])]):_vm._e()],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[[_c('v-form',{ref:"form",attrs:{"lazy-validation":"lazy-validation"},model:{value:(_vm.C.form.validation.overall),callback:function ($$v) {_vm.$set(_vm.C.form.validation, "overall", $$v)},expression:"C.form.validation.overall"}},[_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Member Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("First name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.firstname,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.firstname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "firstname", $$v)},expression:"C.form.selected.user.firstname"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Last name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.lastname,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.lastname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "lastname", $$v)},expression:"C.form.selected.user.lastname"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Email")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.email,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "email", $$v)},expression:"C.form.selected.user.email"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Citizenship")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.user.citizenship),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "citizenship", $$v)},expression:"C.form.selected.user.citizenship"}})],1)],1),(_vm.CR.show.unreleased)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Time Zone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.user.time_zone),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "time_zone", $$v)},expression:"C.form.selected.user.time_zone"}})],1)],1):_vm._e()],1),_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Home Address")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.street1),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "street1", $$v)},expression:"C.form.selected.home_address.street1"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address (cont.)")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.street2),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "street2", $$v)},expression:"C.form.selected.home_address.street2"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.city),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "city", $$v)},expression:"C.form.selected.home_address.city"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.state_province),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "state_province", $$v)},expression:"C.form.selected.home_address.state_province"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.postal_code),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "postal_code", $$v)},expression:"C.form.selected.home_address.postal_code"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.home_address.country),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "country", $$v)},expression:"C.form.selected.home_address.country"}})],1)],1),(_vm.CR.authorization.state.isGod || _vm.CR.authorization.state.isOrgAdmin)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Phone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Phone","bottom":"","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.home_address.phone_number),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "phone_number", $$v)},expression:"C.form.selected.home_address.phone_number"}})],1)],1):_vm._e()],1),_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Work Address")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Employer")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.employer),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "employer", $$v)},expression:"C.form.selected.work_address.employer"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.street1),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "street1", $$v)},expression:"C.form.selected.work_address.street1"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address (cont.)")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.street2),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "street2", $$v)},expression:"C.form.selected.work_address.street2"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.city),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "city", $$v)},expression:"C.form.selected.work_address.city"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.state_province),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "state_province", $$v)},expression:"C.form.selected.work_address.state_province"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.postal_code),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "postal_code", $$v)},expression:"C.form.selected.work_address.postal_code"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.work_address.country),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "country", $$v)},expression:"C.form.selected.work_address.country"}})],1)],1),(_vm.CR.authorization.state.isGod || _vm.CR.authorization.state.isOrgAdmin)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Phone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Phone","bottom":"","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.work_address.phone_number),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "phone_number", $$v)},expression:"C.form.selected.work_address.phone_number"}})],1)],1):_vm._e()],1)])],_c('v-divider',{staticClass:"my-3"}),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}}),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-btn',{staticClass:"ml-0",attrs:{"disabled":!_vm.C.form.validation.overall,"color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v(_vm._s(this.$route.params.id ? "Update" : "Add"))]),(!this.$route.params.id)?_c('v-btn',{attrs:{"to":"/people","exact":"exact"}},[_vm._v("Cancel")]):_vm._e(),(this.$route.params.id)?_c('v-btn',{attrs:{"to":("/people/person/" + (this.$route.params.id)),"exact":"exact"}},[_vm._v("Cancel")]):_vm._e()],1)],1)],2),_c('v-flex',{staticStyle:{"position":"relative","flex":"0 0 236px"}},[_c('div',{staticClass:"d-block",staticStyle:{"width":"220px","margin-top":"8px"}},[_c('v-layout',{staticClass:"mb-2",attrs:{"column":"column"}},[(_vm.CR.authorization.state.isGod)?_c('v-card',{staticClass:"mb-3"},[_c('v-card-title',[_c('div',{staticStyle:{"width":"100%"}},[_c('h3',{staticClass:"mb-2"},[_vm._v("Global Status")]),_c('v-select',{staticClass:"input--box",attrs:{"label":"Status","bottom":"","items":_vm.C.form.list.globalStatuses,"item-text":"label","item-value":"value","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.global_status),callback:function ($$v) {_vm.$set(_vm.C.form.selected, "global_status", $$v)},expression:"C.form.selected.global_status"}})],1)]),_c('v-card-actions',{staticClass:"px-3 pb-3 pt-0"},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"primary"},on:{"click":function($event){_vm.C.form.trigger.setGlobalStatus()}}},[_vm._v("Save")])],1)],1):_vm._e(),_vm._l((_vm.C.data.person.user_organization_statuses),function(organizationStatusItem){return _c('v-card',{key:organizationStatusItem.id,staticClass:"mb-3"},[_c('v-card-title',[_c('div',{staticStyle:{"width":"100%"}},[_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(organizationStatusItem.organization_name))]),_c('v-select',{staticClass:"input--box",attrs:{"label":organizationStatusItem.id === 1 ? "Master Status" : "Organization Status","bottom":"","items":_vm.C.form.list.organizationStatuses,"item-text":"label","item-value":"value","hide-details":"hide-details"},model:{value:(organizationStatusItem.status),callback:function ($$v) {_vm.$set(organizationStatusItem, "status", $$v)},expression:"organizationStatusItem.status"}}),(organizationStatusItem.oa)?_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Title","bottom":"","hide-details":"hide-details"},model:{value:(organizationStatusItem.title),callback:function ($$v) {_vm.$set(organizationStatusItem, "title", $$v)},expression:"organizationStatusItem.title"}}):_vm._e(),(organizationStatusItem.oa)?_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Phone","bottom":"","hide-details":"hide-details"},model:{value:(organizationStatusItem.phone),callback:function ($$v) {_vm.$set(organizationStatusItem, "phone", $$v)},expression:"organizationStatusItem.phone"}}):_vm._e()],1)]),_c('v-card-actions',{staticClass:"px-3 pb-3 pt-0"},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"primary"},on:{"click":function($event){_vm.C.form.trigger.updateDataForOrganization(organizationStatusItem)}}},[_vm._v("Save")])],1),_c('v-divider'),(!organizationStatusItem.oa)?_c('v-card-text',{staticClass:"pa-4"},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',{staticClass:"mt-1",attrs:{"small":"small","color":"primary"}},[_vm._v("verified_user")]),_c('p',{staticClass:"body-2 ml-1 mb-0"},[_c('a',{on:{"click":function($event){_vm.C.form.trigger.convertOrganizationAdminRole(organizationStatusItem, true)}}},[_vm._v("Make "+_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname)+" this organization's administrator")])])],1)],1):_vm._e(),(organizationStatusItem.oa)?_c('v-card-text',{staticClass:"pa-4"},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',{staticClass:"mt-1",attrs:{"small":"small"}},[_vm._v("person")]),_c('p',{staticClass:"body-2 ml-1"},[_vm._v(_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname)+" is administrator")])],1),_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',{staticClass:"mt-1",attrs:{"small":"small","color":"error"}},[_vm._v("remove_circle")]),_c('p',{staticClass:"body-2 ml-1 mb-0"},[_c('a',{staticClass:"red--text",on:{"click":function($event){_vm.C.form.trigger.convertOrganizationAdminRole(organizationStatusItem, false)}}},[_vm._v("Remove "+_vm._s(_vm.C.data.person.firstname)+" "+_vm._s(_vm.C.data.person.lastname)+" as an administrator")])])],1)],1):_vm._e()],1)}),(!_vm.C.form.state.assignToOrganizationActive && (_vm.C.form.list.organizations.length !== 0 && _vm.CR.authorization.state.isGod))?_c('v-card',{staticClass:"mb-2"},[_c('v-card-text',{staticClass:"pa-4"},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap","align-start":"align-start"}},[_c('v-icon',{staticClass:"mt-1",attrs:{"small":"small","color":"primary"}},[_vm._v("add_circle")]),_c('p',{staticClass:"body-2 ml-1 mb-0"},[_c('a',{staticClass:"primary--text",on:{"click":function($event){_vm.C.form.event.toggleAssignToOrganization(true)}}},[_vm._v("Assign member to another org")])])],1)],1)],1):_vm._e(),(_vm.C.form.state.assignToOrganizationActive && (_vm.C.form.list.organizations.length !== 0 && _vm.CR.authorization.state.isGod))?_c('v-card',{staticClass:"mb-2"},[_c('v-card-title',[_c('v-select',{staticClass:"input--box",attrs:{"label":"Select Organization","multi-line":"","bottom":"","items":_vm.C.form.list.organizations,"item-text":"name","item-value":"id","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.addToOrganization.organization_id),callback:function ($$v) {_vm.$set(_vm.C.form.selected.addToOrganization, "organization_id", $$v)},expression:"C.form.selected.addToOrganization.organization_id"}})],1),_c('v-card-actions',{staticClass:"px-3 pb-3 pt-0"},[_c('v-btn',{staticClass:"ml-0",attrs:{"block":"block","color":"primary"},on:{"click":function($event){_vm.C.form.trigger.addToOrganization()}}},[_vm._v("Save")]),_c('v-btn',{staticClass:"mr-0",attrs:{"block":"block"},on:{"click":function($event){_vm.C.form.event.toggleAssignToOrganization(false)}}},[_vm._v("Cancel")])],1)],1):_vm._e()],2)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sr+C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "tMNk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inventionNavItems: [{
        action: 'tonality',
        title: 'Solution',
        active: true,
        items: [{ title: 'Summary' }, { title: 'Draw' }, { title: 'Significance' }, { title: 'Landscape' }, { title: 'Keywords' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Problem',
        items: [{ title: 'Summary' }, { title: 'Gap' }, { title: 'Significance' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Construction',
        items: [{ title: 'List Item' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Use',
        items: [{ title: 'List Item' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Development',
        items: [{ title: 'List Item' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Unique Selling Points',
        items: [{ title: 'List Item' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Economics',
        items: [{ title: 'List Item' }]
      }, {
        action: 'radio_button_unchecked',
        title: 'Commercialization',
        items: [{ title: 'List Item' }]
      }]
    };
  }
});

/***/ }),

/***/ "tNCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js__ = __webpack_require__("yiUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ['section-id', 'section-item', 'is-editable', 'component-id', 'save-callback'],
  data: function data() {
    var _this = this;

    return {
      C: {
        state: {
          containerSection: {},
          interstitial: false
        },
        trigger: {
          setCompletion: function setCompletion() {
            var component = _this;

            var submitItem = {
              section_name: component.C.state.containerSection.$key,
              completion: !component.C.state.containerSection.completion
            };

            if (component.C.state.$componentID) {
              submitItem.component_id = component.C.state.$componentID;
            } else {
              submitItem.invention_id = parseInt(component.$route.params.id);
            }

            component.C.state.interstitial = true;

            __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/container_sections/update_completion', submitItem).then(function (response) {
              var completionItem = response && response.data && response.data.data && response.data.data.invention && response.data.data.invention.container_section && response.data.data.invention.container_section[component.C.state.containerSection.$key] && response.data.data.invention.container_section[component.C.state.containerSection.$key] || {};
              var completionResults;

              if (component.C.state.$componentID) {
                var completionComponents = completionItem.components || [];

                var containerComponentResults = __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.find(completionComponents, function (containerComponentItem) {
                  return containerComponentItem.id === component.C.state.$componentID;
                }) || {};

                completionResults = containerComponentResults.completion || false;
              } else {
                completionResults = completionItem.completion || false;
              }

              component.C.state.containerSection.completion = completionResults;

              component.C.trigger.saveCallback();

              component.C.state.interstitial = false;
            }).catch(function (errorResponse) {
              __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                type: 'error',
                errorResponse: errorResponse
              });

              component.C.state.interstitial = false;
            });
          },
          saveCallback: __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.noop
        }
      }
    };
  },
  created: function created() {
    var component = this;

    component.C.state.containerSection = component.sectionItem;
    component.C.state.containerSection.$key = component.sectionId;
    component.C.state.$isEditable = component.isEditable;
    component.C.state.$componentID = component.componentId;
    component.C.trigger.saveCallback = component.saveCallback || __WEBPACK_IMPORTED_MODULE_2__node_modules_underscore_underscore_min_js___default.a.noop;
  }
});

/***/ }),

/***/ "tgRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/organizations"}},[_c('h2',[_vm._v("All Organizations")])])],1),(!this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Add Organization")])]):_vm._e(),(this.$route.params.id)?_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":("/organizations/organization/" + (this.$route.params.id))}},[_c('h2',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm.C.data.organization.name))])])],1):_vm._e(),(this.$route.params.id)?_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Edit")])]):_vm._e()],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[[_c('v-form',{ref:"form",attrs:{"lazy-validation":"lazy-validation"},model:{value:(_vm.C.form.validation.overall),callback:function ($$v) {_vm.$set(_vm.C.form.validation, "overall", $$v)},expression:"C.form.validation.overall"}},[_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Organization Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.organization.name,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.organization.name),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization, "name", $$v)},expression:"C.form.selected.organization.name"}})],1)],1)],1),_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Business Address")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.organization.business_address.street1),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization.business_address, "street1", $$v)},expression:"C.form.selected.organization.business_address.street1"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address (cont.)")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.organization.business_address.street2),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization.business_address, "street2", $$v)},expression:"C.form.selected.organization.business_address.street2"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.organization.business_address.city),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization.business_address, "city", $$v)},expression:"C.form.selected.organization.business_address.city"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.organization.business_address.state_province),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization.business_address, "state_province", $$v)},expression:"C.form.selected.organization.business_address.state_province"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.organization.business_address.country),callback:function ($$v) {_vm.$set(_vm.C.form.selected.organization.business_address, "country", $$v)},expression:"C.form.selected.organization.business_address.country"}})],1)],1)],1)])],_c('v-divider',{staticClass:"my-3"}),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}}),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-btn',{staticClass:"ml-0",attrs:{"disabled":!_vm.C.form.validation.overall,"color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v(_vm._s(this.$route.params.id ? "Update" : "Add"))]),(!this.$route.params.id)?_c('v-btn',{attrs:{"to":"/organizations","exact":"exact"}},[_vm._v("Cancel")]):_vm._e(),(this.$route.params.id)?_c('v-btn',{attrs:{"to":("/organizations/organization/" + (this.$route.params.id)),"exact":"exact"}},[_vm._v("Cancel")]):_vm._e()],1)],1)],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u1q8":
/***/ (function(module, exports) {

module.exports = [{"alpha2":"aa","alpha3":"aar","bibliographic":"","name":"Afar"},{"alpha2":"ab","alpha3":"abk","bibliographic":"","name":"Abkhazian"},{"alpha2":"","alpha3":"ace","bibliographic":"","name":"Achinese"},{"alpha2":"","alpha3":"ach","bibliographic":"","name":"Acoli"},{"alpha2":"","alpha3":"ada","bibliographic":"","name":"Adangme"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adygei"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adyghe"},{"alpha2":"","alpha3":"afa","bibliographic":"","name":"Afro-Asiatic languages"},{"alpha2":"","alpha3":"afh","bibliographic":"","name":"Afrihili"},{"alpha2":"af","alpha3":"afr","bibliographic":"","name":"Afrikaans"},{"alpha2":"","alpha3":"ain","bibliographic":"","name":"Ainu"},{"alpha2":"ak","alpha3":"aka","bibliographic":"","name":"Akan"},{"alpha2":"","alpha3":"akk","bibliographic":"","name":"Akkadian"},{"alpha2":"","alpha3":"ale","bibliographic":"","name":"Aleut"},{"alpha2":"","alpha3":"alg","bibliographic":"","name":"Algonquian languages"},{"alpha2":"","alpha3":"alt","bibliographic":"","name":"Southern Altai"},{"alpha2":"am","alpha3":"amh","bibliographic":"","name":"Amharic"},{"alpha2":"","alpha3":"ang","bibliographic":"","name":"English, Old (ca.450-1100)"},{"alpha2":"","alpha3":"anp","bibliographic":"","name":"Angika"},{"alpha2":"","alpha3":"apa","bibliographic":"","name":"Apache languages"},{"alpha2":"ar","alpha3":"ara","bibliographic":"","name":"Arabic"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Imperial Aramaic (700-300 BCE)"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Official Aramaic (700-300 BCE)"},{"alpha2":"an","alpha3":"arg","bibliographic":"","name":"Aragonese"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapuche"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapudungun"},{"alpha2":"","alpha3":"arp","bibliographic":"","name":"Arapaho"},{"alpha2":"","alpha3":"art","bibliographic":"","name":"Artificial languages"},{"alpha2":"","alpha3":"arw","bibliographic":"","name":"Arawak"},{"alpha2":"as","alpha3":"asm","bibliographic":"","name":"Assamese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturian"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturleonese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Bable"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Leonese"},{"alpha2":"","alpha3":"ath","bibliographic":"","name":"Athapascan languages"},{"alpha2":"","alpha3":"aus","bibliographic":"","name":"Australian languages"},{"alpha2":"av","alpha3":"ava","bibliographic":"","name":"Avaric"},{"alpha2":"ae","alpha3":"ave","bibliographic":"","name":"Avestan"},{"alpha2":"","alpha3":"awa","bibliographic":"","name":"Awadhi"},{"alpha2":"ay","alpha3":"aym","bibliographic":"","name":"Aymara"},{"alpha2":"az","alpha3":"aze","bibliographic":"","name":"Azerbaijani"},{"alpha2":"","alpha3":"bad","bibliographic":"","name":"Banda languages"},{"alpha2":"","alpha3":"bai","bibliographic":"","name":"Bamileke languages"},{"alpha2":"ba","alpha3":"bak","bibliographic":"","name":"Bashkir"},{"alpha2":"","alpha3":"bal","bibliographic":"","name":"Baluchi"},{"alpha2":"bm","alpha3":"bam","bibliographic":"","name":"Bambara"},{"alpha2":"","alpha3":"ban","bibliographic":"","name":"Balinese"},{"alpha2":"","alpha3":"bas","bibliographic":"","name":"Basa"},{"alpha2":"","alpha3":"bat","bibliographic":"","name":"Baltic languages"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Bedawiyet"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Beja"},{"alpha2":"be","alpha3":"bel","bibliographic":"","name":"Belarusian"},{"alpha2":"","alpha3":"bem","bibliographic":"","name":"Bemba"},{"alpha2":"bn","alpha3":"ben","bibliographic":"","name":"Bengali"},{"alpha2":"","alpha3":"ber","bibliographic":"","name":"Berber languages"},{"alpha2":"","alpha3":"bho","bibliographic":"","name":"Bhojpuri"},{"alpha2":"bh","alpha3":"bih","bibliographic":"","name":"Bihari languages"},{"alpha2":"","alpha3":"bik","bibliographic":"","name":"Bikol"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Bini"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Edo"},{"alpha2":"bi","alpha3":"bis","bibliographic":"","name":"Bislama"},{"alpha2":"","alpha3":"bla","bibliographic":"","name":"Siksika"},{"alpha2":"","alpha3":"bnt","bibliographic":"","name":"Bantu languages"},{"alpha2":"bo","alpha3":"bod","bibliographic":"tib","name":"Tibetan"},{"alpha2":"bs","alpha3":"bos","bibliographic":"","name":"Bosnian"},{"alpha2":"","alpha3":"bra","bibliographic":"","name":"Braj"},{"alpha2":"br","alpha3":"bre","bibliographic":"","name":"Breton"},{"alpha2":"","alpha3":"btk","bibliographic":"","name":"Batak languages"},{"alpha2":"","alpha3":"bua","bibliographic":"","name":"Buriat"},{"alpha2":"","alpha3":"bug","bibliographic":"","name":"Buginese"},{"alpha2":"bg","alpha3":"bul","bibliographic":"","name":"Bulgarian"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Bilin"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Blin"},{"alpha2":"","alpha3":"cad","bibliographic":"","name":"Caddo"},{"alpha2":"","alpha3":"cai","bibliographic":"","name":"Central American Indian languages"},{"alpha2":"","alpha3":"car","bibliographic":"","name":"Galibi Carib"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Catalan"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Valencian"},{"alpha2":"","alpha3":"cau","bibliographic":"","name":"Caucasian languages"},{"alpha2":"","alpha3":"ceb","bibliographic":"","name":"Cebuano"},{"alpha2":"","alpha3":"cel","bibliographic":"","name":"Celtic languages"},{"alpha2":"cs","alpha3":"ces","bibliographic":"cze","name":"Czech"},{"alpha2":"ch","alpha3":"cha","bibliographic":"","name":"Chamorro"},{"alpha2":"","alpha3":"chb","bibliographic":"","name":"Chibcha"},{"alpha2":"ce","alpha3":"che","bibliographic":"","name":"Chechen"},{"alpha2":"","alpha3":"chg","bibliographic":"","name":"Chagatai"},{"alpha2":"","alpha3":"chk","bibliographic":"","name":"Chuukese"},{"alpha2":"","alpha3":"chm","bibliographic":"","name":"Mari"},{"alpha2":"","alpha3":"chn","bibliographic":"","name":"Chinook jargon"},{"alpha2":"","alpha3":"cho","bibliographic":"","name":"Choctaw"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Chipewyan"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Dene Suline"},{"alpha2":"","alpha3":"chr","bibliographic":"","name":"Cherokee"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Bulgarian"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Slavonic"},{"alpha2":"cv","alpha3":"chv","bibliographic":"","name":"Chuvash"},{"alpha2":"","alpha3":"chy","bibliographic":"","name":"Cheyenne"},{"alpha2":"","alpha3":"cmc","bibliographic":"","name":"Chamic languages"},{"alpha2":"","alpha3":"cop","bibliographic":"","name":"Coptic"},{"alpha2":"kw","alpha3":"cor","bibliographic":"","name":"Cornish"},{"alpha2":"co","alpha3":"cos","bibliographic":"","name":"Corsican"},{"alpha2":"","alpha3":"cpe","bibliographic":"","name":"Creoles and pidgins, English based"},{"alpha2":"","alpha3":"cpf","bibliographic":"","name":"Creoles and pidgins, French-based"},{"alpha2":"","alpha3":"cpp","bibliographic":"","name":"Creoles and pidgins, Portuguese-based"},{"alpha2":"cr","alpha3":"cre","bibliographic":"","name":"Cree"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Tatar"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Turkish"},{"alpha2":"","alpha3":"crp","bibliographic":"","name":"Creoles and pidgins"},{"alpha2":"","alpha3":"csb","bibliographic":"","name":"Kashubian"},{"alpha2":"","alpha3":"cus","bibliographic":"","name":"Cushitic languages"},{"alpha2":"cy","alpha3":"cym","bibliographic":"wel","name":"Welsh"},{"alpha2":"","alpha3":"dak","bibliographic":"","name":"Dakota"},{"alpha2":"da","alpha3":"dan","bibliographic":"","name":"Danish"},{"alpha2":"","alpha3":"dar","bibliographic":"","name":"Dargwa"},{"alpha2":"","alpha3":"day","bibliographic":"","name":"Land Dayak languages"},{"alpha2":"","alpha3":"del","bibliographic":"","name":"Delaware"},{"alpha2":"","alpha3":"den","bibliographic":"","name":"Slave (Athapascan)"},{"alpha2":"de","alpha3":"deu","bibliographic":"ger","name":"German"},{"alpha2":"","alpha3":"dgr","bibliographic":"","name":"Dogrib"},{"alpha2":"","alpha3":"din","bibliographic":"","name":"Dinka"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Dhivehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Divehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Maldivian"},{"alpha2":"","alpha3":"doi","bibliographic":"","name":"Dogri"},{"alpha2":"","alpha3":"dra","bibliographic":"","name":"Dravidian languages"},{"alpha2":"","alpha3":"dsb","bibliographic":"","name":"Lower Sorbian"},{"alpha2":"","alpha3":"dua","bibliographic":"","name":"Duala"},{"alpha2":"","alpha3":"dum","bibliographic":"","name":"Dutch, Middle (ca.1050-1350)"},{"alpha2":"","alpha3":"dyu","bibliographic":"","name":"Dyula"},{"alpha2":"dz","alpha3":"dzo","bibliographic":"","name":"Dzongkha"},{"alpha2":"","alpha3":"efi","bibliographic":"","name":"Efik"},{"alpha2":"","alpha3":"egy","bibliographic":"","name":"Egyptian (Ancient)"},{"alpha2":"","alpha3":"eka","bibliographic":"","name":"Ekajuk"},{"alpha2":"el","alpha3":"ell","bibliographic":"gre","name":"Greek, Modern (1453-)"},{"alpha2":"","alpha3":"elx","bibliographic":"","name":"Elamite"},{"alpha2":"en","alpha3":"eng","bibliographic":"","name":"English"},{"alpha2":"","alpha3":"enm","bibliographic":"","name":"English, Middle (1100-1500)"},{"alpha2":"eo","alpha3":"epo","bibliographic":"","name":"Esperanto"},{"alpha2":"et","alpha3":"est","bibliographic":"","name":"Estonian"},{"alpha2":"eu","alpha3":"eus","bibliographic":"baq","name":"Basque"},{"alpha2":"ee","alpha3":"ewe","bibliographic":"","name":"Ewe"},{"alpha2":"","alpha3":"ewo","bibliographic":"","name":"Ewondo"},{"alpha2":"","alpha3":"fan","bibliographic":"","name":"Fang"},{"alpha2":"fo","alpha3":"fao","bibliographic":"","name":"Faroese"},{"alpha2":"fa","alpha3":"fas","bibliographic":"per","name":"Persian"},{"alpha2":"","alpha3":"fat","bibliographic":"","name":"Fanti"},{"alpha2":"fj","alpha3":"fij","bibliographic":"","name":"Fijian"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Filipino"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Pilipino"},{"alpha2":"fi","alpha3":"fin","bibliographic":"","name":"Finnish"},{"alpha2":"","alpha3":"fiu","bibliographic":"","name":"Finno-Ugrian languages"},{"alpha2":"","alpha3":"fon","bibliographic":"","name":"Fon"},{"alpha2":"fr","alpha3":"fra","bibliographic":"fre","name":"French"},{"alpha2":"","alpha3":"frm","bibliographic":"","name":"French, Middle (ca.1400-1600)"},{"alpha2":"","alpha3":"fro","bibliographic":"","name":"French, Old (842-ca.1400)"},{"alpha2":"","alpha3":"frr","bibliographic":"","name":"Northern Frisian"},{"alpha2":"","alpha3":"frs","bibliographic":"","name":"Eastern Frisian"},{"alpha2":"fy","alpha3":"fry","bibliographic":"","name":"Western Frisian"},{"alpha2":"ff","alpha3":"ful","bibliographic":"","name":"Fulah"},{"alpha2":"","alpha3":"fur","bibliographic":"","name":"Friulian"},{"alpha2":"","alpha3":"gaa","bibliographic":"","name":"Ga"},{"alpha2":"","alpha3":"gay","bibliographic":"","name":"Gayo"},{"alpha2":"","alpha3":"gba","bibliographic":"","name":"Gbaya"},{"alpha2":"","alpha3":"gem","bibliographic":"","name":"Germanic languages"},{"alpha2":"","alpha3":"gez","bibliographic":"","name":"Geez"},{"alpha2":"","alpha3":"gil","bibliographic":"","name":"Gilbertese"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Gaelic"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Scottish Gaelic"},{"alpha2":"ga","alpha3":"gle","bibliographic":"","name":"Irish"},{"alpha2":"gl","alpha3":"glg","bibliographic":"","name":"Galician"},{"alpha2":"gv","alpha3":"glv","bibliographic":"","name":"Manx"},{"alpha2":"","alpha3":"gmh","bibliographic":"","name":"German, Middle High (ca.1050-1500)"},{"alpha2":"","alpha3":"goh","bibliographic":"","name":"German, Old High (ca.750-1050)"},{"alpha2":"","alpha3":"gon","bibliographic":"","name":"Gondi"},{"alpha2":"","alpha3":"gor","bibliographic":"","name":"Gorontalo"},{"alpha2":"","alpha3":"got","bibliographic":"","name":"Gothic"},{"alpha2":"","alpha3":"grb","bibliographic":"","name":"Grebo"},{"alpha2":"","alpha3":"grc","bibliographic":"","name":"Greek, Ancient (to 1453)"},{"alpha2":"gn","alpha3":"grn","bibliographic":"","name":"Guarani"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alemannic"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alsatian"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Swiss German"},{"alpha2":"gu","alpha3":"guj","bibliographic":"","name":"Gujarati"},{"alpha2":"","alpha3":"gwi","bibliographic":"","name":"Gwich'in"},{"alpha2":"","alpha3":"hai","bibliographic":"","name":"Haida"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian Creole"},{"alpha2":"ha","alpha3":"hau","bibliographic":"","name":"Hausa"},{"alpha2":"","alpha3":"haw","bibliographic":"","name":"Hawaiian"},{"alpha2":"he","alpha3":"heb","bibliographic":"","name":"Hebrew"},{"alpha2":"hz","alpha3":"her","bibliographic":"","name":"Herero"},{"alpha2":"","alpha3":"hil","bibliographic":"","name":"Hiligaynon"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Himachali languages"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Western Pahari languages"},{"alpha2":"hi","alpha3":"hin","bibliographic":"","name":"Hindi"},{"alpha2":"","alpha3":"hit","bibliographic":"","name":"Hittite"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Hmong"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Mong"},{"alpha2":"ho","alpha3":"hmo","bibliographic":"","name":"Hiri Motu"},{"alpha2":"hr","alpha3":"hrv","bibliographic":"","name":"Croatian"},{"alpha2":"","alpha3":"hsb","bibliographic":"","name":"Upper Sorbian"},{"alpha2":"hu","alpha3":"hun","bibliographic":"","name":"Hungarian"},{"alpha2":"","alpha3":"hup","bibliographic":"","name":"Hupa"},{"alpha2":"hy","alpha3":"hye","bibliographic":"arm","name":"Armenian"},{"alpha2":"","alpha3":"iba","bibliographic":"","name":"Iban"},{"alpha2":"ig","alpha3":"ibo","bibliographic":"","name":"Igbo"},{"alpha2":"io","alpha3":"ido","bibliographic":"","name":"Ido"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Nuosu"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Sichuan Yi"},{"alpha2":"","alpha3":"ijo","bibliographic":"","name":"Ijo languages"},{"alpha2":"iu","alpha3":"iku","bibliographic":"","name":"Inuktitut"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Interlingue"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Occidental"},{"alpha2":"","alpha3":"ilo","bibliographic":"","name":"Iloko"},{"alpha2":"ia","alpha3":"ina","bibliographic":"","name":"Interlingua (International Auxiliary Language Association)"},{"alpha2":"","alpha3":"inc","bibliographic":"","name":"Indic languages"},{"alpha2":"id","alpha3":"ind","bibliographic":"","name":"Indonesian"},{"alpha2":"","alpha3":"ine","bibliographic":"","name":"Indo-European languages"},{"alpha2":"","alpha3":"inh","bibliographic":"","name":"Ingush"},{"alpha2":"ik","alpha3":"ipk","bibliographic":"","name":"Inupiaq"},{"alpha2":"","alpha3":"ira","bibliographic":"","name":"Iranian languages"},{"alpha2":"","alpha3":"iro","bibliographic":"","name":"Iroquoian languages"},{"alpha2":"is","alpha3":"isl","bibliographic":"ice","name":"Icelandic"},{"alpha2":"it","alpha3":"ita","bibliographic":"","name":"Italian"},{"alpha2":"jv","alpha3":"jav","bibliographic":"","name":"Javanese"},{"alpha2":"","alpha3":"jbo","bibliographic":"","name":"Lojban"},{"alpha2":"ja","alpha3":"jpn","bibliographic":"","name":"Japanese"},{"alpha2":"","alpha3":"jpr","bibliographic":"","name":"Judeo-Persian"},{"alpha2":"","alpha3":"jrb","bibliographic":"","name":"Judeo-Arabic"},{"alpha2":"","alpha3":"kaa","bibliographic":"","name":"Kara-Kalpak"},{"alpha2":"","alpha3":"kab","bibliographic":"","name":"Kabyle"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Jingpho"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Kachin"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Greenlandic"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Kalaallisut"},{"alpha2":"","alpha3":"kam","bibliographic":"","name":"Kamba"},{"alpha2":"kn","alpha3":"kan","bibliographic":"","name":"Kannada"},{"alpha2":"","alpha3":"kar","bibliographic":"","name":"Karen languages"},{"alpha2":"ks","alpha3":"kas","bibliographic":"","name":"Kashmiri"},{"alpha2":"ka","alpha3":"kat","bibliographic":"geo","name":"Georgian"},{"alpha2":"kr","alpha3":"kau","bibliographic":"","name":"Kanuri"},{"alpha2":"","alpha3":"kaw","bibliographic":"","name":"Kawi"},{"alpha2":"kk","alpha3":"kaz","bibliographic":"","name":"Kazakh"},{"alpha2":"","alpha3":"kbd","bibliographic":"","name":"Kabardian"},{"alpha2":"","alpha3":"kha","bibliographic":"","name":"Khasi"},{"alpha2":"","alpha3":"khi","bibliographic":"","name":"Khoisan languages"},{"alpha2":"km","alpha3":"khm","bibliographic":"","name":"Central Khmer"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Khotanese"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Sakan"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Gikuyu"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Kikuyu"},{"alpha2":"rw","alpha3":"kin","bibliographic":"","name":"Kinyarwanda"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kirghiz"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kyrgyz"},{"alpha2":"","alpha3":"kmb","bibliographic":"","name":"Kimbundu"},{"alpha2":"","alpha3":"kok","bibliographic":"","name":"Konkani"},{"alpha2":"kv","alpha3":"kom","bibliographic":"","name":"Komi"},{"alpha2":"kg","alpha3":"kon","bibliographic":"","name":"Kongo"},{"alpha2":"ko","alpha3":"kor","bibliographic":"","name":"Korean"},{"alpha2":"","alpha3":"kos","bibliographic":"","name":"Kosraean"},{"alpha2":"","alpha3":"kpe","bibliographic":"","name":"Kpelle"},{"alpha2":"","alpha3":"krc","bibliographic":"","name":"Karachay-Balkar"},{"alpha2":"","alpha3":"krl","bibliographic":"","name":"Karelian"},{"alpha2":"","alpha3":"kro","bibliographic":"","name":"Kru languages"},{"alpha2":"","alpha3":"kru","bibliographic":"","name":"Kurukh"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kuanyama"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kwanyama"},{"alpha2":"","alpha3":"kum","bibliographic":"","name":"Kumyk"},{"alpha2":"ku","alpha3":"kur","bibliographic":"","name":"Kurdish"},{"alpha2":"","alpha3":"kut","bibliographic":"","name":"Kutenai"},{"alpha2":"","alpha3":"lad","bibliographic":"","name":"Ladino"},{"alpha2":"","alpha3":"lah","bibliographic":"","name":"Lahnda"},{"alpha2":"","alpha3":"lam","bibliographic":"","name":"Lamba"},{"alpha2":"lo","alpha3":"lao","bibliographic":"","name":"Lao"},{"alpha2":"la","alpha3":"lat","bibliographic":"","name":"Latin"},{"alpha2":"lv","alpha3":"lav","bibliographic":"","name":"Latvian"},{"alpha2":"","alpha3":"lez","bibliographic":"","name":"Lezghian"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgan"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburger"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgish"},{"alpha2":"ln","alpha3":"lin","bibliographic":"","name":"Lingala"},{"alpha2":"lt","alpha3":"lit","bibliographic":"","name":"Lithuanian"},{"alpha2":"","alpha3":"lol","bibliographic":"","name":"Mongo"},{"alpha2":"","alpha3":"loz","bibliographic":"","name":"Lozi"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Letzeburgesch"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Luxembourgish"},{"alpha2":"","alpha3":"lua","bibliographic":"","name":"Luba-Lulua"},{"alpha2":"lu","alpha3":"lub","bibliographic":"","name":"Luba-Katanga"},{"alpha2":"lg","alpha3":"lug","bibliographic":"","name":"Ganda"},{"alpha2":"","alpha3":"lui","bibliographic":"","name":"Luiseno"},{"alpha2":"","alpha3":"lun","bibliographic":"","name":"Lunda"},{"alpha2":"","alpha3":"luo","bibliographic":"","name":"Luo (Kenya and Tanzania)"},{"alpha2":"","alpha3":"lus","bibliographic":"","name":"Lushai"},{"alpha2":"","alpha3":"mad","bibliographic":"","name":"Madurese"},{"alpha2":"","alpha3":"mag","bibliographic":"","name":"Magahi"},{"alpha2":"mh","alpha3":"mah","bibliographic":"","name":"Marshallese"},{"alpha2":"","alpha3":"mai","bibliographic":"","name":"Maithili"},{"alpha2":"","alpha3":"mak","bibliographic":"","name":"Makasar"},{"alpha2":"ml","alpha3":"mal","bibliographic":"","name":"Malayalam"},{"alpha2":"","alpha3":"man","bibliographic":"","name":"Mandingo"},{"alpha2":"","alpha3":"map","bibliographic":"","name":"Austronesian languages"},{"alpha2":"mr","alpha3":"mar","bibliographic":"","name":"Marathi"},{"alpha2":"","alpha3":"mas","bibliographic":"","name":"Masai"},{"alpha2":"","alpha3":"mdf","bibliographic":"","name":"Moksha"},{"alpha2":"","alpha3":"mdr","bibliographic":"","name":"Mandar"},{"alpha2":"","alpha3":"men","bibliographic":"","name":"Mende"},{"alpha2":"","alpha3":"mga","bibliographic":"","name":"Irish, Middle (900-1200)"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Mi'kmaq"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Micmac"},{"alpha2":"","alpha3":"min","bibliographic":"","name":"Minangkabau"},{"alpha2":"","alpha3":"mis","bibliographic":"","name":"Uncoded languages"},{"alpha2":"mk","alpha3":"mkd","bibliographic":"mac","name":"Macedonian"},{"alpha2":"","alpha3":"mkh","bibliographic":"","name":"Mon-Khmer languages"},{"alpha2":"mg","alpha3":"mlg","bibliographic":"","name":"Malagasy"},{"alpha2":"mt","alpha3":"mlt","bibliographic":"","name":"Maltese"},{"alpha2":"","alpha3":"mnc","bibliographic":"","name":"Manchu"},{"alpha2":"","alpha3":"mni","bibliographic":"","name":"Manipuri"},{"alpha2":"","alpha3":"mno","bibliographic":"","name":"Manobo languages"},{"alpha2":"","alpha3":"moh","bibliographic":"","name":"Mohawk"},{"alpha2":"mn","alpha3":"mon","bibliographic":"","name":"Mongolian"},{"alpha2":"","alpha3":"mos","bibliographic":"","name":"Mossi"},{"alpha2":"","alpha3":"mot","bibliographic":"","name":"Montenegrin"},{"alpha2":"mi","alpha3":"mri","bibliographic":"mao","name":"Maori"},{"alpha2":"ms","alpha3":"msa","bibliographic":"may","name":"Malay"},{"alpha2":"","alpha3":"mul","bibliographic":"","name":"Multiple languages"},{"alpha2":"","alpha3":"mun","bibliographic":"","name":"Munda languages"},{"alpha2":"","alpha3":"mus","bibliographic":"","name":"Creek"},{"alpha2":"","alpha3":"mwl","bibliographic":"","name":"Mirandese"},{"alpha2":"","alpha3":"mwr","bibliographic":"","name":"Marwari"},{"alpha2":"my","alpha3":"mya","bibliographic":"bur","name":"Burmese"},{"alpha2":"","alpha3":"myn","bibliographic":"","name":"Mayan languages"},{"alpha2":"","alpha3":"myv","bibliographic":"","name":"Erzya"},{"alpha2":"","alpha3":"nah","bibliographic":"","name":"Nahuatl languages"},{"alpha2":"","alpha3":"nai","bibliographic":"","name":"North American Indian languages"},{"alpha2":"","alpha3":"nap","bibliographic":"","name":"Neapolitan"},{"alpha2":"na","alpha3":"nau","bibliographic":"","name":"Nauru"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navaho"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navajo"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"Ndebele, South"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"South Ndebele"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"Ndebele, North"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"North Ndebele"},{"alpha2":"ng","alpha3":"ndo","bibliographic":"","name":"Ndonga"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"German, Low"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low German"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low Saxon"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Saxon, Low"},{"alpha2":"ne","alpha3":"nep","bibliographic":"","name":"Nepali"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Nepal Bhasa"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Newari"},{"alpha2":"","alpha3":"nia","bibliographic":"","name":"Nias"},{"alpha2":"","alpha3":"nic","bibliographic":"","name":"Niger-Kordofanian languages"},{"alpha2":"","alpha3":"niu","bibliographic":"","name":"Niuean"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Dutch"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Flemish"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Norwegian Nynorsk"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Nynorsk, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Bokmål, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Norwegian Bokmål"},{"alpha2":"","alpha3":"nog","bibliographic":"","name":"Nogai"},{"alpha2":"","alpha3":"non","bibliographic":"","name":"Norse, Old"},{"alpha2":"no","alpha3":"nor","bibliographic":"","name":"Norwegian"},{"alpha2":"","alpha3":"nqo","bibliographic":"","name":"N'Ko"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Northern Sotho"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Pedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sepedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sotho, Northern"},{"alpha2":"","alpha3":"nub","bibliographic":"","name":"Nubian languages"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Nepal Bhasa"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Newari"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Old Newari"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chichewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Nyanja"},{"alpha2":"","alpha3":"nym","bibliographic":"","name":"Nyamwezi"},{"alpha2":"","alpha3":"nyn","bibliographic":"","name":"Nyankole"},{"alpha2":"","alpha3":"nyo","bibliographic":"","name":"Nyoro"},{"alpha2":"","alpha3":"nzi","bibliographic":"","name":"Nzima"},{"alpha2":"oc","alpha3":"oci","bibliographic":"","name":"Occitan (post 1500)"},{"alpha2":"oj","alpha3":"oji","bibliographic":"","name":"Ojibwa"},{"alpha2":"or","alpha3":"ori","bibliographic":"","name":"Oriya"},{"alpha2":"om","alpha3":"orm","bibliographic":"","name":"Oromo"},{"alpha2":"","alpha3":"osa","bibliographic":"","name":"Osage"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetian"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetic"},{"alpha2":"","alpha3":"ota","bibliographic":"","name":"Turkish, Ottoman (1500-1928)"},{"alpha2":"","alpha3":"oto","bibliographic":"","name":"Otomian languages"},{"alpha2":"","alpha3":"paa","bibliographic":"","name":"Papuan languages"},{"alpha2":"","alpha3":"pag","bibliographic":"","name":"Pangasinan"},{"alpha2":"","alpha3":"pal","bibliographic":"","name":"Pahlavi"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Kapampangan"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Pampanga"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Panjabi"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Punjabi"},{"alpha2":"","alpha3":"pap","bibliographic":"","name":"Papiamento"},{"alpha2":"","alpha3":"pau","bibliographic":"","name":"Palauan"},{"alpha2":"","alpha3":"peo","bibliographic":"","name":"Persian, Old (ca.600-400 B.C.)"},{"alpha2":"","alpha3":"phi","bibliographic":"","name":"Philippine languages"},{"alpha2":"","alpha3":"phn","bibliographic":"","name":"Phoenician"},{"alpha2":"pi","alpha3":"pli","bibliographic":"","name":"Pali"},{"alpha2":"pl","alpha3":"pol","bibliographic":"","name":"Polish"},{"alpha2":"","alpha3":"pon","bibliographic":"","name":"Pohnpeian"},{"alpha2":"pt","alpha3":"por","bibliographic":"","name":"Portuguese"},{"alpha2":"","alpha3":"pra","bibliographic":"","name":"Prakrit languages"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Occitan, Old (to 1500)"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Provençal, Old (to 1500)"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pashto"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pushto"},{"alpha2":"qu","alpha3":"que","bibliographic":"","name":"Quechua"},{"alpha2":"","alpha3":"raj","bibliographic":"","name":"Rajasthani"},{"alpha2":"","alpha3":"rap","bibliographic":"","name":"Rapanui"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Cook Islands Maori"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Rarotongan"},{"alpha2":"","alpha3":"roa","bibliographic":"","name":"Romance languages"},{"alpha2":"rm","alpha3":"roh","bibliographic":"","name":"Romansh"},{"alpha2":"","alpha3":"rom","bibliographic":"","name":"Romany"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Moldavian"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Romanian"},{"alpha2":"rn","alpha3":"run","bibliographic":"","name":"Rundi"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Aromanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Arumanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Macedo-Romanian"},{"alpha2":"ru","alpha3":"rus","bibliographic":"","name":"Russian"},{"alpha2":"","alpha3":"sad","bibliographic":"","name":"Sandawe"},{"alpha2":"sg","alpha3":"sag","bibliographic":"","name":"Sango"},{"alpha2":"","alpha3":"sah","bibliographic":"","name":"Yakut"},{"alpha2":"","alpha3":"sai","bibliographic":"","name":"South American Indian languages"},{"alpha2":"","alpha3":"sal","bibliographic":"","name":"Salishan languages"},{"alpha2":"","alpha3":"sam","bibliographic":"","name":"Samaritan Aramaic"},{"alpha2":"sa","alpha3":"san","bibliographic":"","name":"Sanskrit"},{"alpha2":"","alpha3":"sas","bibliographic":"","name":"Sasak"},{"alpha2":"","alpha3":"sat","bibliographic":"","name":"Santali"},{"alpha2":"","alpha3":"scn","bibliographic":"","name":"Sicilian"},{"alpha2":"","alpha3":"sco","bibliographic":"","name":"Scots"},{"alpha2":"","alpha3":"sel","bibliographic":"","name":"Selkup"},{"alpha2":"","alpha3":"sem","bibliographic":"","name":"Semitic languages"},{"alpha2":"","alpha3":"sga","bibliographic":"","name":"Irish, Old (to 900)"},{"alpha2":"","alpha3":"sgn","bibliographic":"","name":"Sign Languages"},{"alpha2":"","alpha3":"shn","bibliographic":"","name":"Shan"},{"alpha2":"","alpha3":"sid","bibliographic":"","name":"Sidamo"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhala"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhalese"},{"alpha2":"","alpha3":"sio","bibliographic":"","name":"Siouan languages"},{"alpha2":"","alpha3":"sit","bibliographic":"","name":"Sino-Tibetan languages"},{"alpha2":"","alpha3":"sla","bibliographic":"","name":"Slavic languages"},{"alpha2":"sk","alpha3":"slk","bibliographic":"slo","name":"Slovak"},{"alpha2":"sl","alpha3":"slv","bibliographic":"","name":"Slovenian"},{"alpha2":"","alpha3":"sma","bibliographic":"","name":"Southern Sami"},{"alpha2":"se","alpha3":"sme","bibliographic":"","name":"Northern Sami"},{"alpha2":"","alpha3":"smi","bibliographic":"","name":"Sami languages"},{"alpha2":"","alpha3":"smj","bibliographic":"","name":"Lule Sami"},{"alpha2":"","alpha3":"smn","bibliographic":"","name":"Inari Sami"},{"alpha2":"sm","alpha3":"smo","bibliographic":"","name":"Samoan"},{"alpha2":"","alpha3":"sms","bibliographic":"","name":"Skolt Sami"},{"alpha2":"sn","alpha3":"sna","bibliographic":"","name":"Shona"},{"alpha2":"sd","alpha3":"snd","bibliographic":"","name":"Sindhi"},{"alpha2":"","alpha3":"snk","bibliographic":"","name":"Soninke"},{"alpha2":"","alpha3":"sog","bibliographic":"","name":"Sogdian"},{"alpha2":"so","alpha3":"som","bibliographic":"","name":"Somali"},{"alpha2":"","alpha3":"son","bibliographic":"","name":"Songhai languages"},{"alpha2":"st","alpha3":"sot","bibliographic":"","name":"Sotho, Southern"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Castilian"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Spanish"},{"alpha2":"sq","alpha3":"sqi","bibliographic":"alb","name":"Albanian"},{"alpha2":"sc","alpha3":"srd","bibliographic":"","name":"Sardinian"},{"alpha2":"","alpha3":"srn","bibliographic":"","name":"Sranan Tongo"},{"alpha2":"sr","alpha3":"srp","bibliographic":"","name":"Serbian"},{"alpha2":"","alpha3":"srr","bibliographic":"","name":"Serer"},{"alpha2":"","alpha3":"ssa","bibliographic":"","name":"Nilo-Saharan languages"},{"alpha2":"ss","alpha3":"ssw","bibliographic":"","name":"Swati"},{"alpha2":"","alpha3":"suk","bibliographic":"","name":"Sukuma"},{"alpha2":"su","alpha3":"sun","bibliographic":"","name":"Sundanese"},{"alpha2":"","alpha3":"sus","bibliographic":"","name":"Susu"},{"alpha2":"","alpha3":"sux","bibliographic":"","name":"Sumerian"},{"alpha2":"sw","alpha3":"swa","bibliographic":"","name":"Swahili"},{"alpha2":"sv","alpha3":"swe","bibliographic":"","name":"Swedish"},{"alpha2":"","alpha3":"syc","bibliographic":"","name":"Classical Syriac"},{"alpha2":"","alpha3":"syr","bibliographic":"","name":"Syriac"},{"alpha2":"ty","alpha3":"tah","bibliographic":"","name":"Tahitian"},{"alpha2":"","alpha3":"tai","bibliographic":"","name":"Tai languages"},{"alpha2":"ta","alpha3":"tam","bibliographic":"","name":"Tamil"},{"alpha2":"tt","alpha3":"tat","bibliographic":"","name":"Tatar"},{"alpha2":"te","alpha3":"tel","bibliographic":"","name":"Telugu"},{"alpha2":"","alpha3":"tem","bibliographic":"","name":"Timne"},{"alpha2":"","alpha3":"ter","bibliographic":"","name":"Tereno"},{"alpha2":"","alpha3":"tet","bibliographic":"","name":"Tetum"},{"alpha2":"tg","alpha3":"tgk","bibliographic":"","name":"Tajik"},{"alpha2":"tl","alpha3":"tgl","bibliographic":"","name":"Tagalog"},{"alpha2":"th","alpha3":"tha","bibliographic":"","name":"Thai"},{"alpha2":"","alpha3":"tig","bibliographic":"","name":"Tigre"},{"alpha2":"ti","alpha3":"tir","bibliographic":"","name":"Tigrinya"},{"alpha2":"","alpha3":"tiv","bibliographic":"","name":"Tiv"},{"alpha2":"","alpha3":"tkl","bibliographic":"","name":"Tokelau"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"Klingon"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"tlhIngan-Hol"},{"alpha2":"","alpha3":"tli","bibliographic":"","name":"Tlingit"},{"alpha2":"","alpha3":"tmh","bibliographic":"","name":"Tamashek"},{"alpha2":"","alpha3":"tog","bibliographic":"","name":"Tonga (Nyasa)"},{"alpha2":"to","alpha3":"ton","bibliographic":"","name":"Tonga (Tonga Islands)"},{"alpha2":"","alpha3":"tpi","bibliographic":"","name":"Tok Pisin"},{"alpha2":"","alpha3":"tsi","bibliographic":"","name":"Tsimshian"},{"alpha2":"tn","alpha3":"tsn","bibliographic":"","name":"Tswana"},{"alpha2":"ts","alpha3":"tso","bibliographic":"","name":"Tsonga"},{"alpha2":"tk","alpha3":"tuk","bibliographic":"","name":"Turkmen"},{"alpha2":"","alpha3":"tum","bibliographic":"","name":"Tumbuka"},{"alpha2":"","alpha3":"tup","bibliographic":"","name":"Tupi languages"},{"alpha2":"tr","alpha3":"tur","bibliographic":"","name":"Turkish"},{"alpha2":"","alpha3":"tut","bibliographic":"","name":"Altaic languages"},{"alpha2":"","alpha3":"tvl","bibliographic":"","name":"Tuvalu"},{"alpha2":"tw","alpha3":"twi","bibliographic":"","name":"Twi"},{"alpha2":"","alpha3":"tyv","bibliographic":"","name":"Tuvinian"},{"alpha2":"","alpha3":"udm","bibliographic":"","name":"Udmurt"},{"alpha2":"","alpha3":"uga","bibliographic":"","name":"Ugaritic"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uighur"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uyghur"},{"alpha2":"uk","alpha3":"ukr","bibliographic":"","name":"Ukrainian"},{"alpha2":"","alpha3":"umb","bibliographic":"","name":"Umbundu"},{"alpha2":"","alpha3":"und","bibliographic":"","name":"Undetermined"},{"alpha2":"ur","alpha3":"urd","bibliographic":"","name":"Urdu"},{"alpha2":"uz","alpha3":"uzb","bibliographic":"","name":"Uzbek"},{"alpha2":"","alpha3":"vai","bibliographic":"","name":"Vai"},{"alpha2":"ve","alpha3":"ven","bibliographic":"","name":"Venda"},{"alpha2":"vi","alpha3":"vie","bibliographic":"","name":"Vietnamese"},{"alpha2":"vo","alpha3":"vol","bibliographic":"","name":"Volapük"},{"alpha2":"","alpha3":"vot","bibliographic":"","name":"Votic"},{"alpha2":"","alpha3":"wak","bibliographic":"","name":"Wakashan languages"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaitta"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaytta"},{"alpha2":"","alpha3":"war","bibliographic":"","name":"Waray"},{"alpha2":"","alpha3":"was","bibliographic":"","name":"Washo"},{"alpha2":"","alpha3":"wen","bibliographic":"","name":"Sorbian languages"},{"alpha2":"wa","alpha3":"wln","bibliographic":"","name":"Walloon"},{"alpha2":"wo","alpha3":"wol","bibliographic":"","name":"Wolof"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Kalmyk"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Oirat"},{"alpha2":"xh","alpha3":"xho","bibliographic":"","name":"Xhosa"},{"alpha2":"","alpha3":"yao","bibliographic":"","name":"Yao"},{"alpha2":"","alpha3":"yap","bibliographic":"","name":"Yapese"},{"alpha2":"yi","alpha3":"yid","bibliographic":"","name":"Yiddish"},{"alpha2":"yo","alpha3":"yor","bibliographic":"","name":"Yoruba"},{"alpha2":"","alpha3":"ypk","bibliographic":"","name":"Yupik languages"},{"alpha2":"","alpha3":"zap","bibliographic":"","name":"Zapotec"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Bliss"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbolics"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbols"},{"alpha2":"","alpha3":"zen","bibliographic":"","name":"Zenaga"},{"alpha2":"","alpha3":"zgh","bibliographic":"","name":"Standard Moroccan Tamazight"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Chuang"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Zhuang"},{"alpha2":"zh","alpha3":"zho","bibliographic":"chi","name":"Chinese"},{"alpha2":"","alpha3":"znd","bibliographic":"","name":"Zande languages"},{"alpha2":"zu","alpha3":"zul","bibliographic":"","name":"Zulu"},{"alpha2":"","alpha3":"zun","bibliographic":"","name":"Zuni"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"No linguistic content"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"Not applicable"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimili"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimli"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirdki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirmanjki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zaza"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zazaki"}]

/***/ }),

/***/ "u9PG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoContent_vue__ = __webpack_require__("DRNF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b586d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NoContent_vue__ = __webpack_require__("nBgM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b586d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NoContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ua16":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvjK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vdnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"side-drawer"},_vm._l((_vm.inventionNavItems),function(item){return _c('v-list-group',{key:item.title,attrs:{"value":item.active}},[_c('v-list-tile',{attrs:{"slot":"item"},on:{"click":function($event){}},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.action))])],1),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1),_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1),_vm._l((item.items),function(subItem){return _c('v-list-tile',{key:subItem.title,on:{"click":function($event){}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.title))])],1),_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(subItem.action))])],1)],1)})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vdq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      C: {
        view: {
          id: null,
          type: {}
        },
        data: {
          opportunity: {}
        },
        form: {
          validation: {
            overall: false,
            rules: {
              invention_opportunity: {
                title: [function (v) {
                  return !!v || 'Name is required';
                }, function (v) {
                  return v.length < 255 || 'You have reached the maximum limit of 255 characters.';
                }],
                short_description: [function (v) {
                  return !!v || 'Description is required';
                }]
              }
            }
          },
          selected: {
            invention_opportunity: {
              title: '',
              short_description: '',
              status: 'Active',
              closing_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
              presentation_template: 'xinova'
            },
            organization_id: null,
            upload: null
          },
          list: {
            status: [{
              label: 'Active',
              value: 'Active'
            }, {
              label: 'Inactive',
              value: 'Inactive'
            }],
            presentation_templates: [{
              label: 'Xinova',
              value: 'xinova'
            }],
            organizations: []
          },
          trigger: {
            fileUpload: function fileUpload($event) {
              var component = _this;

              var $files = $event.target.files || $event.dataTransfer.files;

              if (!$files.length) {
                return;
              }

              var targetFile = $files[0];

              component.C.form.selected.upload = targetFile;
            },
            submit: function submit() {
              var component = _this;
              var apiCallPromise = null;

              var submitBlob = new FormData();
              submitBlob.append('invention_opportunity[title]', component.C.form.selected.invention_opportunity.title);
              submitBlob.append('invention_opportunity[closing_date]', __WEBPACK_IMPORTED_MODULE_2_moment___default()(component.C.form.selected.invention_opportunity.closing_date, 'YYYY-MM-DD').unix());
              submitBlob.append('invention_opportunity[short_description]', component.C.form.selected.invention_opportunity.short_description);
              submitBlob.append('invention_opportunity[status]', component.C.form.selected.invention_opportunity.status);

              if (component.C.form.selected.upload) {
                submitBlob.append('upload', component.C.form.selected.upload);
              }

              if (component.C.view.type.add) {
                submitBlob.append('organization_id', component.C.form.selected.organization_id);

                apiCallPromise = __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/invention_opportunities/create', submitBlob);
              } else if (component.C.view.type.edit) {
                submitBlob.append('invention_opportunity_id', component.C.view.id);

                apiCallPromise = __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default.a.put('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/invention_opportunities/update', submitBlob);
              }

              if (apiCallPromise) {
                apiCallPromise.then(function (response) {
                  console.info('Manage Opportunity Results: ', response.data);

                  component.$router.push({
                    name: 'Opportunities'
                  });

                  __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                    type: 'success',
                    message: component.C.form.selected.invention_opportunity.title + ' has been saved.'
                  });
                }).catch(function (errorResponse) {
                  __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                    type: 'error',
                    errorResponse: errorResponse
                  });
                });
              }
            },
            refreshBaseData: function refreshBaseData() {
              var component = _this;

              __WEBPACK_IMPORTED_MODULE_1__node_modules_axios_dist_axios_js___default.a.get('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/invention_opportunities/detail', {
                params: {
                  invention_opportunity_id: component.C.view.id
                }
              }).then(function (response) {
                var opportunityData = response && response.data && response.data.data && response.data.data.invention_opportunity || {};

                component.C.data.opportunity = opportunityData;

                component.C.form.selected.invention_opportunity = {
                  title: opportunityData.title,
                  short_description: opportunityData.short_description,
                  closing_date: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(opportunityData.closing_time).format('YYYY-MM-DD'),
                  status: opportunityData.status,
                  presentation_template: 'xinova'
                };
              }).catch(function (errorResponse) {
                __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
                  type: 'error',
                  errorResponse: errorResponse
                });
              });
            }
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    if (this.$route.params.id) {
      component.C.view.type.edit = true;
      component.C.view.id = this.$route.params.id;

      component.C.form.trigger.refreshBaseData();
    } else {
      component.C.view.type.add = true;

      __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].getOrganizationsList({
        success: function success(organizationList) {
          component.C.form.list.organizations = organizationList;

          if (component.C.form.list.organizations.length === 1) {
            component.C.form.selected.organization_id = component.C.form.list.organizations[0].id;
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "vmn8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].show,
        authorization: __WEBPACK_IMPORTED_MODULE_0__assets_global_settings_js__["a" /* default */].authorization
      },
      C: {
        data: {
          person: {}
        },
        list: {
          countries: __WEBPACK_IMPORTED_MODULE_2_country_data___default.a.countries
        }
      },
      dialog: false
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].getUser({
      id: this.$route.params.id,
      success: function success(userData) {
        component.C.data.person = userData;
      }
    });
  }
});

/***/ }),

/***/ "wHrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      C: {
        state: {
          emailSent: false
        },
        form: {
          selected: {
            account: {
              firstname: '',
              lastname: '',
              email: ''
            }
          },
          trigger: {
            submit: function submit() {
              var component = _this;

              var submitItem = {
                firstname: _this.C.form.selected.account.firstname,
                lastname: _this.C.form.selected.account.lastname,
                email: _this.C.form.selected.account.email
              };

              __WEBPACK_IMPORTED_MODULE_0__node_modules_axios_dist_axios_js___default.a.post('' + "https://prolific-server-staging-nza65.ondigitalocean.app/API" + "/v1" + '/users/sign_up', submitItem).then(function (response) {
                console.info('Magic Link Sign Up Results: ', response.data);

                if (response.data.code === 200) {
                  component.C.state.emailSent = true;
                } else {
                  component.C.error.active = true;
                  component.C.error.message = response.data.message;
                }
              }).catch(function (errorResponse) {
                console.error('errorResponse', errorResponse);
              });
            }
          }
        },
        error: {
          active: false,
          message: ''
        }
      }
    };
  }
});

/***/ }),

/***/ "wOh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('h2',[_vm._v("Profile")])])],1),_c('v-spacer'),_c('v-btn',{staticClass:"page-header__action",attrs:{"to":"/profile/edit","exact":"","color":"primary"}},[_vm._v("Edit")])],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',[_c('div',{staticClass:"pb-3"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.firstname)+" "+_vm._s(_vm.C.data.profile.lastname))])])],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Email")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.email))])])],1),(_vm.C.data.profile.citizenship)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Citizenship")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.profile.citizenship] && _vm.C.list.countries[_vm.C.data.profile.citizenship].name))])])],1):_vm._e(),(_vm.C.data.profile.time_zone)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Time Zone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.time_zone))])])],1):_vm._e()],1),(_vm.C.data.profile.home_address)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Home Address")])]),(_vm.C.data.profile.home_address.street1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.street1))]),(_vm.C.data.profile.home_address.street2)?_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.street2))]):_vm._e()])],1):_vm._e(),(_vm.C.data.profile.home_address.city)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.city))])])],1):_vm._e(),(_vm.C.data.profile.home_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.state_province))])])],1):_vm._e(),(_vm.C.data.profile.home_address.postal_code)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.postal_code))])])],1):_vm._e(),(_vm.C.data.profile.home_address.country)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.profile.home_address.country] && _vm.C.list.countries[_vm.C.data.profile.home_address.country].name))])])],1):_vm._e(),(_vm.C.data.profile.home_address.phone_number)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Phone Number")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.home_address.phone_number))])])],1):_vm._e()],1):_vm._e(),(_vm.C.data.profile.work_address)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Work Address")])]),(_vm.C.data.profile.work_address.street1)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.street1))]),(_vm.C.data.profile.work_address.street2)?_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.street2))]):_vm._e()])],1):_vm._e(),(_vm.C.data.profile.work_address.city)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.city))])])],1):_vm._e(),(_vm.C.data.profile.work_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.state_province))])])],1):_vm._e(),(_vm.C.data.profile.work_address.state_province)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.postal_code))])])],1):_vm._e(),(_vm.C.data.profile.work_address.country)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.list.countries[_vm.C.data.profile.work_address.country] && _vm.C.list.countries[_vm.C.data.profile.work_address.country].name))])])],1):_vm._e(),(_vm.C.data.profile.work_address.phone_number)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0"},[_vm._v("Phone Number")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('p',[_vm._v(_vm._s(_vm.C.data.profile.work_address.phone_number))])])],1):_vm._e()],1):_vm._e(),(_vm.C.data.profile.work_address)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Organizations")])]),_vm._l((_vm.C.data.profile.user_organization_statuses),function(organizationStatusItem){return (_vm.C.data.profile.organizations && _vm.C.data.profile.organizations.length > 0)?_c('v-layout',{key:organizationStatusItem.organization_id,attrs:{"row":"row","no-wrap":"no-wrap","align-center":"align-center"}},[_c('v-flex',[_c('v-card-title',{staticClass:"pa-0 pt-2"},[_c('h3',[_vm._v(_vm._s(organizationStatusItem.organization_name))])]),_c('v-card-text',{staticClass:"pl-0 pt-2"},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap","align-center":"align-center"}},[(organizationStatusItem.status)?_c('p',[_c('label',{staticClass:"mr-2"},[_vm._v("Status:")]),_vm._v(_vm._s(organizationStatusItem.status))]):_vm._e(),(organizationStatusItem.title && organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('label',{staticClass:"mr-2"},[_vm._v("Title:")]),_vm._v(_vm._s(organizationStatusItem.title))]):_vm._e(),(organizationStatusItem.phone && organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('label',{staticClass:"mr-2"},[_vm._v("Phone:")]),_vm._v(_vm._s(organizationStatusItem.phone))]):_vm._e(),(organizationStatusItem.oa)?_c('p',[_c('span',{staticClass:"px-3"},[_vm._v("•")]),_c('v-icon',{staticClass:"mr-1",attrs:{"small":"small","color":"secondary"}},[_vm._v("person")]),_vm._v("Org Admin")],1):_vm._e()])],1)],1)],1):_vm._e()})],2):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar__ = __webpack_require__("Y50r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__ = __webpack_require__("ayUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__ = __webpack_require__("cDPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default.a
  },
  data: function data() {
    var _this = this;

    return {
      alert: true,
      CR: {
        show: __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].show,
        authorization: __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].authorization,
        trigger: {
          signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].signOut({
              success: function success() {
                _this.$router.push({
                  name: 'MagicSignIn'
                });
              }
            });
          }
        }
      }
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert = function (options) {
      options = options || {};
      options.duration = options.duration || 5000;

      if (options.type === 'error') {
        options.message = options.message || 'We\'re sorry, but something went wrong.';
      }

      if (options.message && options.type) {
        component.CR.show.alert.active = true;
        component.CR.show.alert.type = options.type;
        component.CR.show.alert.message = options.message;

        clearTimeout(component.CR.show.alert.timer);
        component.CR.show.alert.timer = setTimeout(function () {
          component.CR.show.alert.active = false;
        }, options.duration);
      } else {
        console.warn('### tools.alert() did not trigger due to missing message/type. ###');
      }

      if (options.errorResponse) {
        console.error('errorResponse', options.errorResponse);
      }
    };

    if (window.localStorage.prolific_authorization) {
      __WEBPACK_IMPORTED_MODULE_3__node_modules_axios_dist_axios_js___default.a.defaults.headers.common['Authorization'] = window.localStorage.prolific_authorization;
      __WEBPACK_IMPORTED_MODULE_2__assets_global_settings_js__["a" /* default */].authorization.loggedIn = true;

      __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].loggedInData({
        success: function success(loggedInItem) {
          component.CR.authorization.state = loggedInItem.state;
          component.CR.authorization.data = loggedInItem.data;
        },
        error: function error(errorResponse) {
          __WEBPACK_IMPORTED_MODULE_1__assets_tools_js__["a" /* default */].alert({
            type: 'error',
            errorResponse: errorResponse
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "xZ7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-toolbar',{staticClass:"page-header",attrs:{"app":"app","flat":"flat","fixed":"fixed","color":"white","height":"105"}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},[_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":"/profile"}},[_c('h2',[_vm._v("Profile")])])],1),_c('v-breadcrumbs-item',{attrs:{"disabled":"disabled"}},[_c('h2',{staticClass:"ma-0"},[_vm._v("Edit")])])],1)],1),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"fluid","grid-list-lg":"grid-list-lg"}},[_c('v-layout',{attrs:{"row":"row","nowrap":"nowrap"}},[_c('v-flex',{staticClass:"pr-4"},[[_c('v-form',{ref:"form",attrs:{"lazy-validation":"lazy-validation"},model:{value:(_vm.C.form.validation.overall),callback:function ($$v) {_vm.$set(_vm.C.form.validation, "overall", $$v)},expression:"C.form.validation.overall"}},[_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Member Info")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("First name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.firstname,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.firstname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "firstname", $$v)},expression:"C.form.selected.user.firstname"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Last name")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.lastname,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.lastname),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "lastname", $$v)},expression:"C.form.selected.user.lastname"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Email")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",attrs:{"rules":_vm.C.form.validation.rules.user.email,"single-line":"single-line","required":"required"},model:{value:(_vm.C.form.selected.user.email),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "email", $$v)},expression:"C.form.selected.user.email"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Citizenship")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.user.citizenship),callback:function ($$v) {_vm.$set(_vm.C.form.selected.user, "citizenship", $$v)},expression:"C.form.selected.user.citizenship"}})],1)],1)],1),_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Home Address")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.street1),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "street1", $$v)},expression:"C.form.selected.home_address.street1"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address (cont.)")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.street2),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "street2", $$v)},expression:"C.form.selected.home_address.street2"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.city),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "city", $$v)},expression:"C.form.selected.home_address.city"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.state_province),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "state_province", $$v)},expression:"C.form.selected.home_address.state_province"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.home_address.postal_code),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "postal_code", $$v)},expression:"C.form.selected.home_address.postal_code"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.home_address.country),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "country", $$v)},expression:"C.form.selected.home_address.country"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Phone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Phone","bottom":"","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.home_address.phone_number),callback:function ($$v) {_vm.$set(_vm.C.form.selected.home_address, "phone_number", $$v)},expression:"C.form.selected.home_address.phone_number"}})],1)],1)],1),_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"section__title mb-5"},[_c('div',{staticClass:"subheading"},[_vm._v("Work Address")])]),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Employer")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.employer),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "employer", $$v)},expression:"C.form.selected.work_address.employer"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.street1),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "street1", $$v)},expression:"C.form.selected.work_address.street1"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Street Address (cont.)")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.street2),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "street2", $$v)},expression:"C.form.selected.work_address.street2"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("City")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.city),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "city", $$v)},expression:"C.form.selected.work_address.city"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("State/Province")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.state_province),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "state_province", $$v)},expression:"C.form.selected.work_address.state_province"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Postal Code")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box pt-0",model:{value:(_vm.C.form.selected.work_address.postal_code),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "postal_code", $$v)},expression:"C.form.selected.work_address.postal_code"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Country")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-select',{staticClass:"input--box pt-0",attrs:{"items":_vm.C.form.list.countries,"item-text":"name","item-value":"alpha3"},model:{value:(_vm.C.form.selected.work_address.country),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "country", $$v)},expression:"C.form.selected.work_address.country"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}},[_c('label',{staticClass:"pl-0 mt-2"},[_vm._v("Phone")])]),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-text-field',{staticClass:"input--box",attrs:{"label":"Phone","bottom":"","hide-details":"hide-details"},model:{value:(_vm.C.form.selected.work_address.phone_number),callback:function ($$v) {_vm.$set(_vm.C.form.selected.work_address, "phone_number", $$v)},expression:"C.form.selected.work_address.phone_number"}})],1)],1)],1)])],_c('v-divider',{staticClass:"my-3"}),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"md3":"md3"}}),_c('v-flex',{attrs:{"md6":"md6"}},[_c('v-btn',{staticClass:"ml-0",attrs:{"disabled":!_vm.C.form.validation.overall,"color":"primary"},on:{"click":_vm.C.form.trigger.submit}},[_vm._v("Update")]),_c('v-btn',{attrs:{"to":"/profile","exact":"exact","outline":"outline","color":"primary"}},[_vm._v("Cancel")])],1)],1)],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xoJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xyEA":
/***/ (function(module, exports) {

module.exports = [{"alpha2":"AC","alpha3":"","countryCallingCodes":["+247"],"currencies":["USD"],"emoji":"","ioc":"SHP","languages":["eng"],"name":"Ascension Island","status":"reserved"},{"alpha2":"AD","alpha3":"AND","countryCallingCodes":["+376"],"currencies":["EUR"],"emoji":"🇦🇩","ioc":"AND","languages":["cat"],"name":"Andorra","status":"assigned"},{"alpha2":"AE","alpha3":"ARE","countryCallingCodes":["+971"],"currencies":["AED"],"emoji":"🇦🇪","ioc":"UAE","languages":["ara"],"name":"United Arab Emirates","status":"assigned"},{"alpha2":"AF","alpha3":"AFG","countryCallingCodes":["+93"],"currencies":["AFN"],"emoji":"🇦🇫","ioc":"AFG","languages":["pus"],"name":"Afghanistan","status":"assigned"},{"alpha2":"AG","alpha3":"ATG","countryCallingCodes":["+1 268"],"currencies":["XCD"],"emoji":"🇦🇬","ioc":"ANT","languages":["eng"],"name":"Antigua And Barbuda","status":"assigned"},{"alpha2":"AI","alpha3":"AIA","countryCallingCodes":["+1 264"],"currencies":["XCD"],"emoji":"🇦🇮","ioc":"","languages":["eng"],"name":"Anguilla","status":"assigned"},{"alpha2":"AI","alpha3":"AFI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Afar and Issas","status":"deleted"},{"alpha2":"AL","alpha3":"ALB","countryCallingCodes":["+355"],"currencies":["ALL"],"emoji":"🇦🇱","ioc":"ALB","languages":["sqi"],"name":"Albania","status":"assigned"},{"alpha2":"AM","alpha3":"ARM","countryCallingCodes":["+374"],"currencies":["AMD"],"emoji":"🇦🇲","ioc":"ARM","languages":["hye","rus"],"name":"Armenia","status":"assigned"},{"alpha2":"AN","alpha3":"ANT","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Netherlands Antilles","status":"deleted"},{"alpha2":"AO","alpha3":"AGO","countryCallingCodes":["+244"],"currencies":["AOA"],"emoji":"🇦🇴","ioc":"ANG","languages":["por"],"name":"Angola","status":"assigned"},{"alpha2":"AQ","alpha3":"ATA","countryCallingCodes":["+672"],"currencies":[],"emoji":"🇦🇶","ioc":"","languages":[],"name":"Antarctica","status":"assigned"},{"alpha2":"AR","alpha3":"ARG","countryCallingCodes":["+54"],"currencies":["ARS"],"emoji":"🇦🇷","ioc":"ARG","languages":["spa"],"name":"Argentina","status":"assigned"},{"alpha2":"AS","alpha3":"ASM","countryCallingCodes":["+1 684"],"currencies":["USD"],"emoji":"🇦🇸","ioc":"ASA","languages":["eng","smo"],"name":"American Samoa","status":"assigned"},{"alpha2":"AT","alpha3":"AUT","countryCallingCodes":["+43"],"currencies":["EUR"],"emoji":"🇦🇹","ioc":"AUT","languages":["deu"],"name":"Austria","status":"assigned"},{"alpha2":"AU","alpha3":"AUS","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇦🇺","ioc":"AUS","languages":["eng"],"name":"Australia","status":"assigned"},{"alpha2":"AW","alpha3":"ABW","countryCallingCodes":["+297"],"currencies":["AWG"],"emoji":"🇦🇼","ioc":"ARU","languages":["nld"],"name":"Aruba","status":"assigned"},{"alpha2":"AX","alpha3":"ALA","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇦🇽","ioc":"","languages":["swe"],"name":"Åland Islands","status":"assigned"},{"alpha2":"AZ","alpha3":"AZE","countryCallingCodes":["+994"],"currencies":["AZN"],"emoji":"🇦🇿","ioc":"AZE","languages":["aze"],"name":"Azerbaijan","status":"assigned"},{"alpha2":"BA","alpha3":"BIH","countryCallingCodes":["+387"],"currencies":["BAM"],"emoji":"🇧🇦","ioc":"BIH","languages":["bos","cre","srp"],"name":"Bosnia & Herzegovina","status":"assigned"},{"alpha2":"BB","alpha3":"BRB","countryCallingCodes":["+1 246"],"currencies":["BBD"],"emoji":"🇧🇧","ioc":"BAR","languages":["eng"],"name":"Barbados","status":"assigned"},{"alpha2":"BD","alpha3":"BGD","countryCallingCodes":["+880"],"currencies":["BDT"],"emoji":"🇧🇩","ioc":"BAN","languages":["ben"],"name":"Bangladesh","status":"assigned"},{"alpha2":"BE","alpha3":"BEL","countryCallingCodes":["+32"],"currencies":["EUR"],"emoji":"🇧🇪","ioc":"BEL","languages":["nld","fra","deu"],"name":"Belgium","status":"assigned"},{"alpha2":"BF","alpha3":"BFA","countryCallingCodes":["+226"],"currencies":["XOF"],"emoji":"🇧🇫","ioc":"BUR","languages":["fra"],"name":"Burkina Faso","status":"assigned"},{"alpha2":"BG","alpha3":"BGR","countryCallingCodes":["+359"],"currencies":["BGN"],"emoji":"🇧🇬","ioc":"BUL","languages":["bul"],"name":"Bulgaria","status":"assigned"},{"alpha2":"BH","alpha3":"BHR","countryCallingCodes":["+973"],"currencies":["BHD"],"emoji":"🇧🇭","ioc":"BRN","languages":["ara"],"name":"Bahrain","status":"assigned"},{"alpha2":"BI","alpha3":"BDI","countryCallingCodes":["+257"],"currencies":["BIF"],"emoji":"🇧🇮","ioc":"BDI","languages":["fra"],"name":"Burundi","status":"assigned"},{"alpha2":"BJ","alpha3":"BEN","countryCallingCodes":["+229"],"currencies":["XOF"],"emoji":"🇧🇯","ioc":"BEN","languages":["fra"],"name":"Benin","status":"assigned"},{"alpha2":"BL","alpha3":"BLM","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇧🇱","ioc":"","languages":["fra"],"name":"Saint Barthélemy","status":"assigned"},{"alpha2":"BM","alpha3":"BMU","countryCallingCodes":["+1 441"],"currencies":["BMD"],"emoji":"🇧🇲","ioc":"BER","languages":["eng"],"name":"Bermuda","status":"assigned"},{"alpha2":"BN","alpha3":"BRN","countryCallingCodes":["+673"],"currencies":["BND"],"emoji":"🇧🇳","ioc":"BRU","languages":["msa","eng"],"name":"Brunei Darussalam","status":"assigned"},{"alpha2":"BO","alpha3":"BOL","countryCallingCodes":["+591"],"currencies":["BOB","BOV"],"emoji":"🇧🇴","ioc":"BOL","languages":["spa","aym","que"],"name":"Bolivia, Plurinational State Of","status":"assigned"},{"alpha2":"BQ","alpha3":"BES","countryCallingCodes":["+599"],"currencies":["USD"],"emoji":"🇧🇶","ioc":"","languages":["nld"],"name":"Bonaire, Saint Eustatius And Saba","status":"assigned"},{"alpha2":"BQ","alpha3":"ATB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"British Antarctic Territory","status":"deleted"},{"alpha2":"BR","alpha3":"BRA","countryCallingCodes":["+55"],"currencies":["BRL"],"emoji":"🇧🇷","ioc":"BRA","languages":["por"],"name":"Brazil","status":"assigned"},{"alpha2":"BS","alpha3":"BHS","countryCallingCodes":["+1 242"],"currencies":["BSD"],"emoji":"🇧🇸","ioc":"BAH","languages":["eng"],"name":"Bahamas","status":"assigned"},{"alpha2":"BT","alpha3":"BTN","countryCallingCodes":["+975"],"currencies":["INR","BTN"],"emoji":"🇧🇹","ioc":"BHU","languages":["dzo"],"name":"Bhutan","status":"assigned"},{"alpha2":"BU","alpha3":"BUR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Burma","status":"deleted"},{"alpha2":"BV","alpha3":"BVT","countryCallingCodes":[],"currencies":["NOK"],"emoji":"🇧🇻","ioc":"","languages":[],"name":"Bouvet Island","status":"assigned"},{"alpha2":"BW","alpha3":"BWA","countryCallingCodes":["+267"],"currencies":["BWP"],"emoji":"🇧🇼","ioc":"BOT","languages":["eng","tsn"],"name":"Botswana","status":"assigned"},{"alpha2":"BY","alpha3":"BLR","countryCallingCodes":["+375"],"currencies":["BYR"],"emoji":"🇧🇾","ioc":"BLR","languages":["bel","rus"],"name":"Belarus","status":"assigned"},{"alpha2":"BY","alpha3":"BYS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Byelorussian SSR","status":"deleted"},{"alpha2":"BZ","alpha3":"BLZ","countryCallingCodes":["+501"],"currencies":["BZD"],"emoji":"🇧🇿","ioc":"BIZ","languages":["eng"],"name":"Belize","status":"assigned"},{"alpha2":"CA","alpha3":"CAN","countryCallingCodes":["+1"],"currencies":["CAD"],"emoji":"🇨🇦","ioc":"CAN","languages":["eng","fra"],"name":"Canada","status":"assigned"},{"alpha2":"CC","alpha3":"CCK","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇨","ioc":"","languages":["eng"],"name":"Cocos (Keeling) Islands","status":"assigned"},{"alpha2":"CD","alpha3":"COD","countryCallingCodes":["+243"],"currencies":["CDF"],"emoji":"🇨🇩","ioc":"COD","languages":["fra","lin","kon","swa"],"name":"Democratic Republic Of Congo","status":"assigned"},{"alpha2":"CF","alpha3":"CAF","countryCallingCodes":["+236"],"currencies":["XAF"],"emoji":"🇨🇫","ioc":"CAF","languages":["fra","sag"],"name":"Central African Republic","status":"assigned"},{"alpha2":"CG","alpha3":"COG","countryCallingCodes":["+242"],"currencies":["XAF"],"emoji":"🇨🇬","ioc":"CGO","languages":["fra","lin"],"name":"Republic Of Congo","status":"assigned"},{"alpha2":"CH","alpha3":"CHE","countryCallingCodes":["+41"],"currencies":["CHF","CHE","CHW"],"emoji":"🇨🇭","ioc":"SUI","languages":["deu","fra","ita","roh"],"name":"Switzerland","status":"assigned"},{"alpha2":"CI","alpha3":"CIV","countryCallingCodes":["+225"],"currencies":["XOF"],"emoji":"🇨🇮","ioc":"CIV","languages":["fra"],"name":"Côte d'Ivoire","status":"assigned"},{"alpha2":"CK","alpha3":"COK","countryCallingCodes":["+682"],"currencies":["NZD"],"emoji":"🇨🇰","ioc":"COK","languages":["eng","mri"],"name":"Cook Islands","status":"assigned"},{"alpha2":"CL","alpha3":"CHL","countryCallingCodes":["+56"],"currencies":["CLP","CLF"],"emoji":"🇨🇱","ioc":"CHI","languages":["spa"],"name":"Chile","status":"assigned"},{"alpha2":"CM","alpha3":"CMR","countryCallingCodes":["+237"],"currencies":["XAF"],"emoji":"🇨🇲","ioc":"CMR","languages":["eng","fra"],"name":"Cameroon","status":"assigned"},{"alpha2":"CN","alpha3":"CHN","countryCallingCodes":["+86"],"currencies":["CNY"],"emoji":"🇨🇳","ioc":"CHN","languages":["zho"],"name":"China","status":"assigned"},{"alpha2":"CO","alpha3":"COL","countryCallingCodes":["+57"],"currencies":["COP","COU"],"emoji":"🇨🇴","ioc":"COL","languages":["spa"],"name":"Colombia","status":"assigned"},{"alpha2":"CP","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Clipperton Island","status":"reserved"},{"alpha2":"CR","alpha3":"CRI","countryCallingCodes":["+506"],"currencies":["CRC"],"emoji":"🇨🇷","ioc":"CRC","languages":["spa"],"name":"Costa Rica","status":"assigned"},{"alpha2":"CS","alpha3":"CSK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Czechoslovakia","status":"deleted"},{"alpha2":"CS","alpha3":"SCG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Serbia and Montenegro","status":"deleted"},{"alpha2":"CT","alpha3":"CTE","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Canton and Enderbury Islands","status":"deleted"},{"alpha2":"CU","alpha3":"CUB","countryCallingCodes":["+53"],"currencies":["CUP","CUC"],"emoji":"🇨🇺","ioc":"CUB","languages":["spa"],"name":"Cuba","status":"assigned"},{"alpha2":"CV","alpha3":"CPV","countryCallingCodes":["+238"],"currencies":["CVE"],"emoji":"🇨🇻","ioc":"CPV","languages":["por"],"name":"Cabo Verde","status":"assigned"},{"alpha2":"CW","alpha3":"CUW","countryCallingCodes":["+599"],"currencies":["ANG"],"emoji":"🇨🇼","ioc":"","languages":["nld"],"name":"Curacao","status":"assigned"},{"alpha2":"CX","alpha3":"CXR","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇽","ioc":"","languages":["eng"],"name":"Christmas Island","status":"assigned"},{"alpha2":"CY","alpha3":"CYP","countryCallingCodes":["+357"],"currencies":["EUR"],"emoji":"🇨🇾","ioc":"CYP","languages":["ell","tur"],"name":"Cyprus","status":"assigned"},{"alpha2":"CZ","alpha3":"CZE","countryCallingCodes":["+420"],"currencies":["CZK"],"emoji":"🇨🇿","ioc":"CZE","languages":["ces"],"name":"Czech Republic","status":"assigned"},{"alpha2":"DD","alpha3":"DDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"German Democratic Republic","status":"deleted"},{"alpha2":"DE","alpha3":"DEU","countryCallingCodes":["+49"],"currencies":["EUR"],"emoji":"🇩🇪","ioc":"GER","languages":["deu"],"name":"Germany","status":"assigned"},{"alpha2":"DG","alpha3":"","countryCallingCodes":[],"currencies":["USD"],"emoji":"","ioc":"","languages":[],"name":"Diego Garcia","status":"reserved"},{"alpha2":"DJ","alpha3":"DJI","countryCallingCodes":["+253"],"currencies":["DJF"],"emoji":"🇩🇯","ioc":"DJI","languages":["ara","fra"],"name":"Djibouti","status":"assigned"},{"alpha2":"DK","alpha3":"DNK","countryCallingCodes":["+45"],"currencies":["DKK"],"emoji":"🇩🇰","ioc":"DEN","languages":["dan"],"name":"Denmark","status":"assigned"},{"alpha2":"DM","alpha3":"DMA","countryCallingCodes":["+1 767"],"currencies":["XCD"],"emoji":"🇩🇲","ioc":"DMA","languages":["eng"],"name":"Dominica","status":"assigned"},{"alpha2":"DO","alpha3":"DOM","countryCallingCodes":["+1 809","+1 829","+1 849"],"currencies":["DOP"],"emoji":"🇩🇴","ioc":"DOM","languages":["spa"],"name":"Dominican Republic","status":"assigned"},{"alpha2":"DY","alpha3":"DHY","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dahomey","status":"deleted"},{"alpha2":"DZ","alpha3":"DZA","countryCallingCodes":["+213"],"currencies":["DZD"],"emoji":"🇩🇿","ioc":"ALG","languages":["ara"],"name":"Algeria","status":"assigned"},{"alpha2":"EA","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Ceuta, Mulilla","status":"reserved"},{"alpha2":"EC","alpha3":"ECU","countryCallingCodes":["+593"],"currencies":["USD"],"emoji":"🇪🇨","ioc":"ECU","languages":["spa","que"],"name":"Ecuador","status":"assigned"},{"alpha2":"EE","alpha3":"EST","countryCallingCodes":["+372"],"currencies":["EUR"],"emoji":"🇪🇪","ioc":"EST","languages":["est"],"name":"Estonia","status":"assigned"},{"alpha2":"EG","alpha3":"EGY","countryCallingCodes":["+20"],"currencies":["EGP"],"emoji":"🇪🇬","ioc":"EGY","languages":["ara"],"name":"Egypt","status":"assigned"},{"alpha2":"EH","alpha3":"ESH","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇪🇭","ioc":"","languages":[],"name":"Western Sahara","status":"assigned"},{"alpha2":"ER","alpha3":"ERI","countryCallingCodes":["+291"],"currencies":["ERN"],"emoji":"🇪🇷","ioc":"ERI","languages":["eng","ara","tir"],"name":"Eritrea","status":"assigned"},{"alpha2":"ES","alpha3":"ESP","countryCallingCodes":["+34"],"currencies":["EUR"],"emoji":"🇪🇸","ioc":"ESP","languages":["spa"],"name":"Spain","status":"assigned"},{"alpha2":"ET","alpha3":"ETH","countryCallingCodes":["+251"],"currencies":["ETB"],"emoji":"🇪🇹","ioc":"ETH","languages":["amh"],"name":"Ethiopia","status":"assigned"},{"alpha2":"EU","alpha3":"","countryCallingCodes":["+388"],"currencies":["EUR"],"emoji":"🇪🇺","ioc":"","languages":[],"name":"European Union","status":"reserved"},{"alpha2":"FI","alpha3":"FIN","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇫🇮","ioc":"FIN","languages":["fin","swe"],"name":"Finland","status":"assigned"},{"alpha2":"FJ","alpha3":"FJI","countryCallingCodes":["+679"],"currencies":["FJD"],"emoji":"🇫🇯","ioc":"FIJ","languages":["eng","fij"],"name":"Fiji","status":"assigned"},{"alpha2":"FK","alpha3":"FLK","countryCallingCodes":["+500"],"currencies":["FKP"],"emoji":"🇫🇰","ioc":"","languages":["eng"],"name":"Falkland Islands","status":"assigned"},{"alpha2":"FM","alpha3":"FSM","countryCallingCodes":["+691"],"currencies":["USD"],"emoji":"🇫🇲","ioc":"FSM","languages":["eng"],"name":"Micronesia, Federated States Of","status":"assigned"},{"alpha2":"FO","alpha3":"FRO","countryCallingCodes":["+298"],"currencies":["DKK"],"emoji":"🇫🇴","ioc":"FAI","languages":["fao","dan"],"name":"Faroe Islands","status":"assigned"},{"alpha2":"FQ","alpha3":"ATF","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Southern and Antarctic Territories","status":"deleted"},{"alpha2":"FR","alpha3":"FRA","countryCallingCodes":["+33"],"currencies":["EUR"],"emoji":"🇫🇷","ioc":"FRA","languages":["fra"],"name":"France","status":"assigned"},{"alpha2":"FX","alpha3":"","countryCallingCodes":["+241"],"currencies":["EUR"],"emoji":"","ioc":"","languages":["fra"],"name":"France, Metropolitan","status":"reserved"},{"alpha2":"GA","alpha3":"GAB","countryCallingCodes":["+241"],"currencies":["XAF"],"emoji":"🇬🇦","ioc":"GAB","languages":["fra"],"name":"Gabon","status":"assigned"},{"alpha2":"GB","alpha3":"GBR","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇧","ioc":"GBR","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"assigned"},{"alpha2":"GD","alpha3":"GRD","countryCallingCodes":["+473"],"currencies":["XCD"],"emoji":"🇬🇩","ioc":"GRN","languages":["eng"],"name":"Grenada","status":"assigned"},{"alpha2":"GE","alpha3":"GEO","countryCallingCodes":["+995"],"currencies":["GEL"],"emoji":"🇬🇪","ioc":"GEO","languages":["kat"],"name":"Georgia","status":"assigned"},{"alpha2":"GE","alpha3":"GEL","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Gilbert and Ellice Islands","status":"deleted"},{"alpha2":"GF","alpha3":"GUF","countryCallingCodes":["+594"],"currencies":["EUR"],"emoji":"🇬🇫","ioc":"","languages":["fra"],"name":"French Guiana","status":"assigned"},{"alpha2":"GG","alpha3":"GGY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇬","ioc":"GCI","languages":["fra"],"name":"Guernsey","status":"assigned"},{"alpha2":"GH","alpha3":"GHA","countryCallingCodes":["+233"],"currencies":["GHS"],"emoji":"🇬🇭","ioc":"GHA","languages":["eng"],"name":"Ghana","status":"assigned"},{"alpha2":"GI","alpha3":"GIB","countryCallingCodes":["+350"],"currencies":["GIP"],"emoji":"🇬🇮","ioc":"","languages":["eng"],"name":"Gibraltar","status":"assigned"},{"alpha2":"GL","alpha3":"GRL","countryCallingCodes":["+299"],"currencies":["DKK"],"emoji":"🇬🇱","ioc":"","languages":["kal"],"name":"Greenland","status":"assigned"},{"alpha2":"GM","alpha3":"GMB","countryCallingCodes":["+220"],"currencies":["GMD"],"emoji":"🇬🇲","ioc":"GAM","languages":["eng"],"name":"Gambia","status":"assigned"},{"alpha2":"GN","alpha3":"GIN","countryCallingCodes":["+224"],"currencies":["GNF"],"emoji":"🇬🇳","ioc":"GUI","languages":["fra"],"name":"Guinea","status":"assigned"},{"alpha2":"GP","alpha3":"GLP","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇬🇵","ioc":"","languages":["fra"],"name":"Guadeloupe","status":"assigned"},{"alpha2":"GQ","alpha3":"GNQ","countryCallingCodes":["+240"],"currencies":["XAF"],"emoji":"🇬🇶","ioc":"GEQ","languages":["spa","fra","por"],"name":"Equatorial Guinea","status":"assigned"},{"alpha2":"GR","alpha3":"GRC","countryCallingCodes":["+30"],"currencies":["EUR"],"emoji":"🇬🇷","ioc":"GRE","languages":["ell"],"name":"Greece","status":"assigned"},{"alpha2":"GS","alpha3":"SGS","countryCallingCodes":[],"currencies":["GBP"],"emoji":"🇬🇸","ioc":"","languages":["eng"],"name":"South Georgia And The South Sandwich Islands","status":"assigned"},{"alpha2":"GT","alpha3":"GTM","countryCallingCodes":["+502"],"currencies":["GTQ"],"emoji":"🇬🇹","ioc":"GUA","languages":["spa"],"name":"Guatemala","status":"assigned"},{"alpha2":"GU","alpha3":"GUM","countryCallingCodes":["+1 671"],"currencies":["USD"],"emoji":"🇬🇺","ioc":"GUM","languages":["eng"],"name":"Guam","status":"assigned"},{"alpha2":"GW","alpha3":"GNB","countryCallingCodes":["+245"],"currencies":["XOF"],"emoji":"🇬🇼","ioc":"GBS","languages":["por"],"name":"Guinea-bissau","status":"assigned"},{"alpha2":"GY","alpha3":"GUY","countryCallingCodes":["+592"],"currencies":["GYD"],"emoji":"🇬🇾","ioc":"GUY","languages":["eng"],"name":"Guyana","status":"assigned"},{"alpha2":"HK","alpha3":"HKG","countryCallingCodes":["+852"],"currencies":["HKD"],"emoji":"🇭🇰","ioc":"HKG","languages":["zho","eng"],"name":"Hong Kong","status":"assigned"},{"alpha2":"HM","alpha3":"HMD","countryCallingCodes":[],"currencies":["AUD"],"emoji":"🇭🇲","ioc":"","languages":[],"name":"Heard Island And McDonald Islands","status":"assigned"},{"alpha2":"HN","alpha3":"HND","countryCallingCodes":["+504"],"currencies":["HNL"],"emoji":"🇭🇳","ioc":"HON","languages":["spa"],"name":"Honduras","status":"assigned"},{"alpha2":"HR","alpha3":"HRV","countryCallingCodes":["+385"],"currencies":["HRK"],"emoji":"🇭🇷","ioc":"CRO","languages":["hrv"],"name":"Croatia","status":"assigned"},{"alpha2":"HT","alpha3":"HTI","countryCallingCodes":["+509"],"currencies":["HTG","USD"],"emoji":"🇭🇹","ioc":"HAI","languages":["fra","hat"],"name":"Haiti","status":"assigned"},{"alpha2":"HU","alpha3":"HUN","countryCallingCodes":["+36"],"currencies":["HUF"],"emoji":"🇭🇺","ioc":"HUN","languages":["hun"],"name":"Hungary","status":"assigned"},{"alpha2":"HV","alpha3":"HVO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Upper Volta","status":"deleted"},{"alpha2":"IC","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Canary Islands","status":"reserved"},{"alpha2":"ID","alpha3":"IDN","countryCallingCodes":["+62"],"currencies":["IDR"],"emoji":"🇮🇩","ioc":"INA","languages":["ind"],"name":"Indonesia","status":"assigned"},{"alpha2":"IE","alpha3":"IRL","countryCallingCodes":["+353"],"currencies":["EUR"],"emoji":"🇮🇪","ioc":"IRL","languages":["eng","gle"],"name":"Ireland","status":"assigned"},{"alpha2":"IL","alpha3":"ISR","countryCallingCodes":["+972"],"currencies":["ILS"],"emoji":"🇮🇱","ioc":"ISR","languages":["heb","ara","eng"],"name":"Israel","status":"assigned"},{"alpha2":"IM","alpha3":"IMN","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇮🇲","ioc":"","languages":["eng","glv"],"name":"Isle Of Man","status":"assigned"},{"alpha2":"IN","alpha3":"IND","countryCallingCodes":["+91"],"currencies":["INR"],"emoji":"🇮🇳","ioc":"IND","languages":["eng","hin"],"name":"India","status":"assigned"},{"alpha2":"IO","alpha3":"IOT","countryCallingCodes":["+246"],"currencies":["USD"],"emoji":"🇮🇴","ioc":"","languages":["eng"],"name":"British Indian Ocean Territory","status":"assigned"},{"alpha2":"IQ","alpha3":"IRQ","countryCallingCodes":["+964"],"currencies":["IQD"],"emoji":"🇮🇶","ioc":"IRQ","languages":["ara","kur"],"name":"Iraq","status":"assigned"},{"alpha2":"IR","alpha3":"IRN","countryCallingCodes":["+98"],"currencies":["IRR"],"emoji":"🇮🇷","ioc":"IRI","languages":["fas"],"name":"Iran, Islamic Republic Of","status":"assigned"},{"alpha2":"IS","alpha3":"ISL","countryCallingCodes":["+354"],"currencies":["ISK"],"emoji":"🇮🇸","ioc":"ISL","languages":["isl"],"name":"Iceland","status":"assigned"},{"alpha2":"IT","alpha3":"ITA","countryCallingCodes":["+39"],"currencies":["EUR"],"emoji":"🇮🇹","ioc":"ITA","languages":["ita"],"name":"Italy","status":"assigned"},{"alpha2":"JE","alpha3":"JEY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇯🇪","ioc":"JCI","languages":["eng","fra"],"name":"Jersey","status":"assigned"},{"alpha2":"JM","alpha3":"JAM","countryCallingCodes":["+1 876"],"currencies":["JMD"],"emoji":"🇯🇲","ioc":"JAM","languages":["eng"],"name":"Jamaica","status":"assigned"},{"alpha2":"JO","alpha3":"JOR","countryCallingCodes":["+962"],"currencies":["JOD"],"emoji":"🇯🇴","ioc":"JOR","languages":["ara"],"name":"Jordan","status":"assigned"},{"alpha2":"JP","alpha3":"JPN","countryCallingCodes":["+81"],"currencies":["JPY"],"emoji":"🇯🇵","ioc":"JPN","languages":["jpn"],"name":"Japan","status":"assigned"},{"alpha2":"JT","alpha3":"JTN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Johnston Island","status":"deleted"},{"alpha2":"KE","alpha3":"KEN","countryCallingCodes":["+254"],"currencies":["KES"],"emoji":"🇰🇪","ioc":"KEN","languages":["eng","swa"],"name":"Kenya","status":"assigned"},{"alpha2":"KG","alpha3":"KGZ","countryCallingCodes":["+996"],"currencies":["KGS"],"emoji":"🇰🇬","ioc":"KGZ","languages":["rus"],"name":"Kyrgyzstan","status":"assigned"},{"alpha2":"KH","alpha3":"KHM","countryCallingCodes":["+855"],"currencies":["KHR"],"emoji":"🇰🇭","ioc":"CAM","languages":["khm"],"name":"Cambodia","status":"assigned"},{"alpha2":"KI","alpha3":"KIR","countryCallingCodes":["+686"],"currencies":["AUD"],"emoji":"🇰🇮","ioc":"KIR","languages":["eng"],"name":"Kiribati","status":"assigned"},{"alpha2":"KM","alpha3":"COM","countryCallingCodes":["+269"],"currencies":["KMF"],"emoji":"🇰🇲","ioc":"COM","languages":["ara","fra"],"name":"Comoros","status":"assigned"},{"alpha2":"KN","alpha3":"KNA","countryCallingCodes":["+1 869"],"currencies":["XCD"],"emoji":"🇰🇳","ioc":"SKN","languages":["eng"],"name":"Saint Kitts And Nevis","status":"assigned"},{"alpha2":"KP","alpha3":"PRK","countryCallingCodes":["+850"],"currencies":["KPW"],"emoji":"🇰🇵","ioc":"PRK","languages":["kor"],"name":"Korea, Democratic People's Republic Of","status":"assigned"},{"alpha2":"KR","alpha3":"KOR","countryCallingCodes":["+82"],"currencies":["KRW"],"emoji":"🇰🇷","ioc":"KOR","languages":["kor"],"name":"Korea, Republic Of","status":"assigned"},{"alpha2":"KW","alpha3":"KWT","countryCallingCodes":["+965"],"currencies":["KWD"],"emoji":"🇰🇼","ioc":"KUW","languages":["ara"],"name":"Kuwait","status":"assigned"},{"alpha2":"KY","alpha3":"CYM","countryCallingCodes":["+1 345"],"currencies":["KYD"],"emoji":"🇰🇾","ioc":"CAY","languages":["eng"],"name":"Cayman Islands","status":"assigned"},{"alpha2":"KZ","alpha3":"KAZ","countryCallingCodes":["+7","+7 6","+7 7"],"currencies":["KZT"],"emoji":"🇰🇿","ioc":"KAZ","languages":["kaz","rus"],"name":"Kazakhstan","status":"assigned"},{"alpha2":"LA","alpha3":"LAO","countryCallingCodes":["+856"],"currencies":["LAK"],"emoji":"🇱🇦","ioc":"LAO","languages":["lao"],"name":"Lao People's Democratic Republic","status":"assigned"},{"alpha2":"LB","alpha3":"LBN","countryCallingCodes":["+961"],"currencies":["LBP"],"emoji":"🇱🇧","ioc":"LIB","languages":["ara","hye"],"name":"Lebanon","status":"assigned"},{"alpha2":"LC","alpha3":"LCA","countryCallingCodes":["+1 758"],"currencies":["XCD"],"emoji":"🇱🇨","ioc":"LCA","languages":["eng"],"name":"Saint Lucia","status":"assigned"},{"alpha2":"LI","alpha3":"LIE","countryCallingCodes":["+423"],"currencies":["CHF"],"emoji":"🇱🇮","ioc":"LIE","languages":["deu"],"name":"Liechtenstein","status":"assigned"},{"alpha2":"LK","alpha3":"LKA","countryCallingCodes":["+94"],"currencies":["LKR"],"emoji":"🇱🇰","ioc":"SRI","languages":["sin","tam"],"name":"Sri Lanka","status":"assigned"},{"alpha2":"LR","alpha3":"LBR","countryCallingCodes":["+231"],"currencies":["LRD"],"emoji":"🇱🇷","ioc":"LBR","languages":["eng"],"name":"Liberia","status":"assigned"},{"alpha2":"LS","alpha3":"LSO","countryCallingCodes":["+266"],"currencies":["LSL","ZAR"],"emoji":"🇱🇸","ioc":"LES","languages":["eng","sot"],"name":"Lesotho","status":"assigned"},{"alpha2":"LT","alpha3":"LTU","countryCallingCodes":["+370"],"currencies":["EUR"],"emoji":"🇱🇹","ioc":"LTU","languages":["lit"],"name":"Lithuania","status":"assigned"},{"alpha2":"LU","alpha3":"LUX","countryCallingCodes":["+352"],"currencies":["EUR"],"emoji":"🇱🇺","ioc":"LUX","languages":["fra","deu","ltz"],"name":"Luxembourg","status":"assigned"},{"alpha2":"LV","alpha3":"LVA","countryCallingCodes":["+371"],"currencies":["EUR"],"emoji":"🇱🇻","ioc":"LAT","languages":["lav"],"name":"Latvia","status":"assigned"},{"alpha2":"LY","alpha3":"LBY","countryCallingCodes":["+218"],"currencies":["LYD"],"emoji":"🇱🇾","ioc":"LBA","languages":["ara"],"name":"Libya","status":"assigned"},{"alpha2":"MA","alpha3":"MAR","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇲🇦","ioc":"MAR","languages":["ara"],"name":"Morocco","status":"assigned"},{"alpha2":"MC","alpha3":"MCO","countryCallingCodes":["+377"],"currencies":["EUR"],"emoji":"🇲🇨","ioc":"MON","languages":["fra"],"name":"Monaco","status":"assigned"},{"alpha2":"MD","alpha3":"MDA","countryCallingCodes":["+373"],"currencies":["MDL"],"emoji":"🇲🇩","ioc":"MDA","languages":["ron"],"name":"Moldova","status":"assigned"},{"alpha2":"ME","alpha3":"MNE","countryCallingCodes":["+382"],"currencies":["EUR"],"emoji":"🇲🇪","ioc":"MNE","languages":["mot"],"name":"Montenegro","status":"assigned"},{"alpha2":"MF","alpha3":"MAF","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇲🇫","ioc":"","languages":["fra"],"name":"Saint Martin","status":"assigned"},{"alpha2":"MG","alpha3":"MDG","countryCallingCodes":["+261"],"currencies":["MGA"],"emoji":"🇲🇬","ioc":"MAD","languages":["fra","mlg"],"name":"Madagascar","status":"assigned"},{"alpha2":"MH","alpha3":"MHL","countryCallingCodes":["+692"],"currencies":["USD"],"emoji":"🇲🇭","ioc":"MHL","languages":["eng","mah"],"name":"Marshall Islands","status":"assigned"},{"alpha2":"MI","alpha3":"MID","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Midway Islands","status":"deleted"},{"alpha2":"MK","alpha3":"MKD","countryCallingCodes":["+389"],"currencies":["MKD"],"emoji":"🇲🇰","ioc":"MKD","languages":["mkd"],"name":"Macedonia, The Former Yugoslav Republic Of","status":"assigned"},{"alpha2":"ML","alpha3":"MLI","countryCallingCodes":["+223"],"currencies":["XOF"],"emoji":"🇲🇱","ioc":"MLI","languages":["fra"],"name":"Mali","status":"assigned"},{"alpha2":"MM","alpha3":"MMR","countryCallingCodes":["+95"],"currencies":["MMK"],"emoji":"🇲🇲","ioc":"MYA","languages":["mya"],"name":"Myanmar","status":"assigned"},{"alpha2":"MN","alpha3":"MNG","countryCallingCodes":["+976"],"currencies":["MNT"],"emoji":"🇲🇳","ioc":"MGL","languages":["mon"],"name":"Mongolia","status":"assigned"},{"alpha2":"MO","alpha3":"MAC","countryCallingCodes":["+853"],"currencies":["MOP"],"emoji":"🇲🇴","ioc":"MAC","languages":["zho","por"],"name":"Macao","status":"assigned"},{"alpha2":"MP","alpha3":"MNP","countryCallingCodes":["+1 670"],"currencies":["USD"],"emoji":"🇲🇵","ioc":"","languages":["eng"],"name":"Northern Mariana Islands","status":"assigned"},{"alpha2":"MQ","alpha3":"MTQ","countryCallingCodes":["+596"],"currencies":["EUR"],"emoji":"🇲🇶","ioc":"","languages":[],"name":"Martinique","status":"assigned"},{"alpha2":"MR","alpha3":"MRT","countryCallingCodes":["+222"],"currencies":["MRO"],"emoji":"🇲🇷","ioc":"MTN","languages":["ara","fra"],"name":"Mauritania","status":"assigned"},{"alpha2":"MS","alpha3":"MSR","countryCallingCodes":["+1 664"],"currencies":["XCD"],"emoji":"🇲🇸","ioc":"","languages":[],"name":"Montserrat","status":"assigned"},{"alpha2":"MT","alpha3":"MLT","countryCallingCodes":["+356"],"currencies":["EUR"],"emoji":"🇲🇹","ioc":"MLT","languages":["mlt","eng"],"name":"Malta","status":"assigned"},{"alpha2":"MU","alpha3":"MUS","countryCallingCodes":["+230"],"currencies":["MUR"],"emoji":"🇲🇺","ioc":"MRI","languages":["eng","fra"],"name":"Mauritius","status":"assigned"},{"alpha2":"MV","alpha3":"MDV","countryCallingCodes":["+960"],"currencies":["MVR"],"emoji":"🇲🇻","ioc":"MDV","languages":["div"],"name":"Maldives","status":"assigned"},{"alpha2":"MW","alpha3":"MWI","countryCallingCodes":["+265"],"currencies":["MWK"],"emoji":"🇲🇼","ioc":"MAW","languages":["eng","nya"],"name":"Malawi","status":"assigned"},{"alpha2":"MX","alpha3":"MEX","countryCallingCodes":["+52"],"currencies":["MXN","MXV"],"emoji":"🇲🇽","ioc":"MEX","languages":["spa"],"name":"Mexico","status":"assigned"},{"alpha2":"MY","alpha3":"MYS","countryCallingCodes":["+60"],"currencies":["MYR"],"emoji":"🇲🇾","ioc":"MAS","languages":["msa","eng"],"name":"Malaysia","status":"assigned"},{"alpha2":"MZ","alpha3":"MOZ","countryCallingCodes":["+258"],"currencies":["MZN"],"emoji":"🇲🇿","ioc":"MOZ","languages":["por"],"name":"Mozambique","status":"assigned"},{"alpha2":"NA","alpha3":"NAM","countryCallingCodes":["+264"],"currencies":["NAD","ZAR"],"emoji":"🇳🇦","ioc":"NAM","languages":["eng"],"name":"Namibia","status":"assigned"},{"alpha2":"NC","alpha3":"NCL","countryCallingCodes":["+687"],"currencies":["XPF"],"emoji":"🇳🇨","ioc":"","languages":["fra"],"name":"New Caledonia","status":"assigned"},{"alpha2":"NE","alpha3":"NER","countryCallingCodes":["+227"],"currencies":["XOF"],"emoji":"🇳🇪","ioc":"NIG","languages":["fra"],"name":"Niger","status":"assigned"},{"alpha2":"NF","alpha3":"NFK","countryCallingCodes":["+672"],"currencies":["AUD"],"emoji":"🇳🇫","ioc":"","languages":["eng"],"name":"Norfolk Island","status":"assigned"},{"alpha2":"NG","alpha3":"NGA","countryCallingCodes":["+234"],"currencies":["NGN"],"emoji":"🇳🇬","ioc":"NGR","languages":["eng"],"name":"Nigeria","status":"assigned"},{"alpha2":"NH","alpha3":"NHB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"New Hebrides","status":"deleted"},{"alpha2":"NI","alpha3":"NIC","countryCallingCodes":["+505"],"currencies":["NIO"],"emoji":"🇳🇮","ioc":"NCA","languages":["spa"],"name":"Nicaragua","status":"assigned"},{"alpha2":"NL","alpha3":"NLD","countryCallingCodes":["+31"],"currencies":["EUR"],"emoji":"🇳🇱","ioc":"NED","languages":["nld"],"name":"Netherlands","status":"assigned"},{"alpha2":"NO","alpha3":"NOR","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇳🇴","ioc":"NOR","languages":["nor"],"name":"Norway","status":"assigned"},{"alpha2":"NP","alpha3":"NPL","countryCallingCodes":["+977"],"currencies":["NPR"],"emoji":"🇳🇵","ioc":"NEP","languages":["nep"],"name":"Nepal","status":"assigned"},{"alpha2":"NQ","alpha3":"ATN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dronning Maud Land","status":"deleted"},{"alpha2":"NR","alpha3":"NRU","countryCallingCodes":["+674"],"currencies":["AUD"],"emoji":"🇳🇷","ioc":"NRU","languages":["eng","nau"],"name":"Nauru","status":"assigned"},{"alpha2":"NT","alpha3":"NTZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Neutral Zone","status":"deleted"},{"alpha2":"NU","alpha3":"NIU","countryCallingCodes":["+683"],"currencies":["NZD"],"emoji":"🇳🇺","ioc":"","languages":["eng"],"name":"Niue","status":"assigned"},{"alpha2":"NZ","alpha3":"NZL","countryCallingCodes":["+64"],"currencies":["NZD"],"emoji":"🇳🇿","ioc":"NZL","languages":["eng"],"name":"New Zealand","status":"assigned"},{"alpha2":"OM","alpha3":"OMN","countryCallingCodes":["+968"],"currencies":["OMR"],"emoji":"🇴🇲","ioc":"OMA","languages":["ara"],"name":"Oman","status":"assigned"},{"alpha2":"PA","alpha3":"PAN","countryCallingCodes":["+507"],"currencies":["PAB","USD"],"emoji":"🇵🇦","ioc":"PAN","languages":["spa"],"name":"Panama","status":"assigned"},{"alpha2":"PC","alpha3":"PCI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Pacific Islands, Trust Territory of the","status":"deleted"},{"alpha2":"PE","alpha3":"PER","countryCallingCodes":["+51"],"currencies":["PEN"],"emoji":"🇵🇪","ioc":"PER","languages":["spa","aym","que"],"name":"Peru","status":"assigned"},{"alpha2":"PF","alpha3":"PYF","countryCallingCodes":["+689"],"currencies":["XPF"],"emoji":"🇵🇫","ioc":"","languages":["fra"],"name":"French Polynesia","status":"assigned"},{"alpha2":"PG","alpha3":"PNG","countryCallingCodes":["+675"],"currencies":["PGK"],"emoji":"🇵🇬","ioc":"PNG","languages":["eng"],"name":"Papua New Guinea","status":"assigned"},{"alpha2":"PH","alpha3":"PHL","countryCallingCodes":["+63"],"currencies":["PHP"],"emoji":"🇵🇭","ioc":"PHI","languages":["eng"],"name":"Philippines","status":"assigned"},{"alpha2":"PK","alpha3":"PAK","countryCallingCodes":["+92"],"currencies":["PKR"],"emoji":"🇵🇰","ioc":"PAK","languages":["urd","eng"],"name":"Pakistan","status":"assigned"},{"alpha2":"PL","alpha3":"POL","countryCallingCodes":["+48"],"currencies":["PLN"],"emoji":"🇵🇱","ioc":"POL","languages":["pol"],"name":"Poland","status":"assigned"},{"alpha2":"PM","alpha3":"SPM","countryCallingCodes":["+508"],"currencies":["EUR"],"emoji":"🇵🇲","ioc":"","languages":["eng"],"name":"Saint Pierre And Miquelon","status":"assigned"},{"alpha2":"PN","alpha3":"PCN","countryCallingCodes":["+872"],"currencies":["NZD"],"emoji":"🇵🇳","ioc":"","languages":["eng"],"name":"Pitcairn","status":"assigned"},{"alpha2":"PR","alpha3":"PRI","countryCallingCodes":["+1 787","+1 939"],"currencies":["USD"],"emoji":"🇵🇷","ioc":"PUR","languages":["spa","eng"],"name":"Puerto Rico","status":"assigned"},{"alpha2":"PS","alpha3":"PSE","countryCallingCodes":["+970"],"currencies":["JOD","EGP","ILS"],"emoji":"🇵🇸","ioc":"PLE","languages":["ara"],"name":"Palestinian Territory, Occupied","status":"assigned"},{"alpha2":"PT","alpha3":"PRT","countryCallingCodes":["+351"],"currencies":["EUR"],"emoji":"🇵🇹","ioc":"POR","languages":["por"],"name":"Portugal","status":"assigned"},{"alpha2":"PU","alpha3":"PUS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"U.S. Miscellaneous Pacific Islands","status":"deleted"},{"alpha2":"PW","alpha3":"PLW","countryCallingCodes":["+680"],"currencies":["USD"],"emoji":"🇵🇼","ioc":"PLW","languages":["eng"],"name":"Palau","status":"assigned"},{"alpha2":"PY","alpha3":"PRY","countryCallingCodes":["+595"],"currencies":["PYG"],"emoji":"🇵🇾","ioc":"PAR","languages":["spa"],"name":"Paraguay","status":"assigned"},{"alpha2":"PZ","alpha3":"PCZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Panama Canal Zone","status":"deleted"},{"alpha2":"QA","alpha3":"QAT","countryCallingCodes":["+974"],"currencies":["QAR"],"emoji":"🇶🇦","ioc":"QAT","languages":["ara"],"name":"Qatar","status":"assigned"},{"alpha2":"RE","alpha3":"REU","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇷🇪","ioc":"","languages":["fra"],"name":"Reunion","status":"assigned"},{"alpha2":"RH","alpha3":"RHO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Southern Rhodesia","status":"deleted"},{"alpha2":"RO","alpha3":"ROU","countryCallingCodes":["+40"],"currencies":["RON"],"emoji":"🇷🇴","ioc":"ROU","languages":["ron"],"name":"Romania","status":"assigned"},{"alpha2":"RS","alpha3":"SRB","countryCallingCodes":["+381"],"currencies":["RSD"],"emoji":"🇷🇸","ioc":"SRB","languages":["srp"],"name":"Serbia","status":"assigned"},{"alpha2":"RU","alpha3":"RUS","countryCallingCodes":["+7","+7 3","+7 4","+7 8"],"currencies":["RUB"],"emoji":"🇷🇺","ioc":"RUS","languages":["rus"],"name":"Russian Federation","status":"assigned"},{"alpha2":"RW","alpha3":"RWA","countryCallingCodes":["+250"],"currencies":["RWF"],"emoji":"🇷🇼","ioc":"RWA","languages":["eng","fra","kin"],"name":"Rwanda","status":"assigned"},{"alpha2":"SA","alpha3":"SAU","countryCallingCodes":["+966"],"currencies":["SAR"],"emoji":"🇸🇦","ioc":"KSA","languages":["ara"],"name":"Saudi Arabia","status":"assigned"},{"alpha2":"SB","alpha3":"SLB","countryCallingCodes":["+677"],"currencies":["SBD"],"emoji":"🇸🇧","ioc":"SOL","languages":["eng"],"name":"Solomon Islands","status":"assigned"},{"alpha2":"SC","alpha3":"SYC","countryCallingCodes":["+248"],"currencies":["SCR"],"emoji":"🇸🇨","ioc":"SEY","languages":["eng","fra"],"name":"Seychelles","status":"assigned"},{"alpha2":"SD","alpha3":"SDN","countryCallingCodes":["+249"],"currencies":["SDG"],"emoji":"🇸🇩","ioc":"SUD","languages":["ara","eng"],"name":"Sudan","status":"assigned"},{"alpha2":"SE","alpha3":"SWE","countryCallingCodes":["+46"],"currencies":["SEK"],"emoji":"🇸🇪","ioc":"SWE","languages":["swe"],"name":"Sweden","status":"assigned"},{"alpha2":"SG","alpha3":"SGP","countryCallingCodes":["+65"],"currencies":["SGD"],"emoji":"🇸🇬","ioc":"SIN","languages":["eng","zho","msa","tam"],"name":"Singapore","status":"assigned"},{"alpha2":"SH","alpha3":"SHN","countryCallingCodes":["+290"],"currencies":["SHP"],"emoji":"🇸🇭","ioc":"","languages":["eng"],"name":"Saint Helena, Ascension And Tristan Da Cunha","status":"assigned"},{"alpha2":"SI","alpha3":"SVN","countryCallingCodes":["+386"],"currencies":["EUR"],"emoji":"🇸🇮","ioc":"SLO","languages":["slv"],"name":"Slovenia","status":"assigned"},{"alpha2":"SJ","alpha3":"SJM","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇸🇯","ioc":"","languages":[],"name":"Svalbard And Jan Mayen","status":"assigned"},{"alpha2":"SK","alpha3":"SVK","countryCallingCodes":["+421"],"currencies":["EUR"],"emoji":"🇸🇰","ioc":"SVK","languages":["slk"],"name":"Slovakia","status":"assigned"},{"alpha2":"SK","alpha3":"SKM","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Sikkim","status":"deleted"},{"alpha2":"SL","alpha3":"SLE","countryCallingCodes":["+232"],"currencies":["SLL"],"emoji":"🇸🇱","ioc":"SLE","languages":["eng"],"name":"Sierra Leone","status":"assigned"},{"alpha2":"SM","alpha3":"SMR","countryCallingCodes":["+378"],"currencies":["EUR"],"emoji":"🇸🇲","ioc":"SMR","languages":["ita"],"name":"San Marino","status":"assigned"},{"alpha2":"SN","alpha3":"SEN","countryCallingCodes":["+221"],"currencies":["XOF"],"emoji":"🇸🇳","ioc":"SEN","languages":["fra"],"name":"Senegal","status":"assigned"},{"alpha2":"SO","alpha3":"SOM","countryCallingCodes":["+252"],"currencies":["SOS"],"emoji":"🇸🇴","ioc":"SOM","languages":["som"],"name":"Somalia","status":"assigned"},{"alpha2":"SR","alpha3":"SUR","countryCallingCodes":["+597"],"currencies":["SRD"],"emoji":"🇸🇷","ioc":"SUR","languages":["nld"],"name":"Suriname","status":"assigned"},{"alpha2":"SS","alpha3":"SSD","countryCallingCodes":["+211"],"currencies":["SSP"],"emoji":"🇸🇸","ioc":"SSD","languages":["eng"],"name":"South Sudan","status":"assigned"},{"alpha2":"ST","alpha3":"STP","countryCallingCodes":["+239"],"currencies":["STD"],"emoji":"🇸🇹","ioc":"STP","languages":["por"],"name":"Sao Tome and Principe","status":"assigned"},{"alpha2":"SU","alpha3":"","countryCallingCodes":[],"currencies":["RUB"],"emoji":"","ioc":"","languages":["rus"],"name":"USSR","status":"reserved"},{"alpha2":"SV","alpha3":"SLV","countryCallingCodes":["+503"],"currencies":["USD"],"emoji":"🇸🇻","ioc":"ESA","languages":["spa"],"name":"El Salvador","status":"assigned"},{"alpha2":"SX","alpha3":"SXM","countryCallingCodes":["+1 721"],"currencies":["ANG"],"emoji":"🇸🇽","ioc":"","languages":["nld"],"name":"Sint Maarten","status":"assigned"},{"alpha2":"SY","alpha3":"SYR","countryCallingCodes":["+963"],"currencies":["SYP"],"emoji":"🇸🇾","ioc":"SYR","languages":["ara"],"name":"Syrian Arab Republic","status":"assigned"},{"alpha2":"SZ","alpha3":"SWZ","countryCallingCodes":["+268"],"currencies":["SZL"],"emoji":"🇸🇿","ioc":"SWZ","languages":["eng","ssw"],"name":"Swaziland","status":"assigned"},{"alpha2":"TA","alpha3":"","countryCallingCodes":["+290"],"currencies":["GBP"],"emoji":"","ioc":"","languages":[],"name":"Tristan de Cunha","status":"reserved"},{"alpha2":"TC","alpha3":"TCA","countryCallingCodes":["+1 649"],"currencies":["USD"],"emoji":"🇹🇨","ioc":"","languages":["eng"],"name":"Turks And Caicos Islands","status":"assigned"},{"alpha2":"TD","alpha3":"TCD","countryCallingCodes":["+235"],"currencies":["XAF"],"emoji":"🇹🇩","ioc":"CHA","languages":["ara","fra"],"name":"Chad","status":"assigned"},{"alpha2":"TF","alpha3":"ATF","countryCallingCodes":[],"currencies":["EUR"],"emoji":"🇹🇫","ioc":"","languages":["fra"],"name":"French Southern Territories","status":"assigned"},{"alpha2":"TG","alpha3":"TGO","countryCallingCodes":["+228"],"currencies":["XOF"],"emoji":"🇹🇬","ioc":"TOG","languages":["fra"],"name":"Togo","status":"assigned"},{"alpha2":"TH","alpha3":"THA","countryCallingCodes":["+66"],"currencies":["THB"],"emoji":"🇹🇭","ioc":"THA","languages":["tha"],"name":"Thailand","status":"assigned"},{"alpha2":"TJ","alpha3":"TJK","countryCallingCodes":["+992"],"currencies":["TJS"],"emoji":"🇹🇯","ioc":"TJK","languages":["tgk","rus"],"name":"Tajikistan","status":"assigned"},{"alpha2":"TK","alpha3":"TKL","countryCallingCodes":["+690"],"currencies":["NZD"],"emoji":"🇹🇰","ioc":"","languages":["eng"],"name":"Tokelau","status":"assigned"},{"alpha2":"TL","alpha3":"TLS","countryCallingCodes":["+670"],"currencies":["USD"],"emoji":"🇹🇱","ioc":"TLS","languages":["por"],"name":"Timor-Leste, Democratic Republic of","status":"assigned"},{"alpha2":"TM","alpha3":"TKM","countryCallingCodes":["+993"],"currencies":["TMT"],"emoji":"🇹🇲","ioc":"TKM","languages":["tuk","rus"],"name":"Turkmenistan","status":"assigned"},{"alpha2":"TN","alpha3":"TUN","countryCallingCodes":["+216"],"currencies":["TND"],"emoji":"🇹🇳","ioc":"TUN","languages":["ara"],"name":"Tunisia","status":"assigned"},{"alpha2":"TO","alpha3":"TON","countryCallingCodes":["+676"],"currencies":["TOP"],"emoji":"🇹🇴","ioc":"TGA","languages":["eng"],"name":"Tonga","status":"assigned"},{"alpha2":"TP","alpha3":"TMP","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"East Timor","status":"deleted"},{"alpha2":"TR","alpha3":"TUR","countryCallingCodes":["+90"],"currencies":["TRY"],"emoji":"🇹🇷","ioc":"TUR","languages":["tur"],"name":"Turkey","status":"assigned"},{"alpha2":"TT","alpha3":"TTO","countryCallingCodes":["+1 868"],"currencies":["TTD"],"emoji":"🇹🇹","ioc":"TTO","languages":["eng"],"name":"Trinidad And Tobago","status":"assigned"},{"alpha2":"TV","alpha3":"TUV","countryCallingCodes":["+688"],"currencies":["AUD"],"emoji":"🇹🇻","ioc":"TUV","languages":["eng"],"name":"Tuvalu","status":"assigned"},{"alpha2":"TW","alpha3":"TWN","countryCallingCodes":["+886"],"currencies":["TWD"],"emoji":"🇹🇼","ioc":"TPE","languages":["zho"],"name":"Taiwan","status":"assigned"},{"alpha2":"TZ","alpha3":"TZA","countryCallingCodes":["+255"],"currencies":["TZS"],"emoji":"🇹🇿","ioc":"TAN","languages":["swa","eng"],"name":"Tanzania, United Republic Of","status":"assigned"},{"alpha2":"UA","alpha3":"UKR","countryCallingCodes":["+380"],"currencies":["UAH"],"emoji":"🇺🇦","ioc":"UKR","languages":["ukr","rus"],"name":"Ukraine","status":"assigned"},{"alpha2":"UG","alpha3":"UGA","countryCallingCodes":["+256"],"currencies":["UGX"],"emoji":"🇺🇬","ioc":"UGA","languages":["eng","swa"],"name":"Uganda","status":"assigned"},{"alpha2":"UK","alpha3":"","countryCallingCodes":[],"currencies":["GBP"],"emoji":"","ioc":"","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"reserved"},{"alpha2":"UM","alpha3":"UMI","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇲","ioc":"","languages":["eng"],"name":"United States Minor Outlying Islands","status":"assigned"},{"alpha2":"US","alpha3":"USA","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇸","ioc":"USA","languages":["eng"],"name":"United States","status":"assigned"},{"alpha2":"UY","alpha3":"URY","countryCallingCodes":["+598"],"currencies":["UYU","UYI"],"emoji":"🇺🇾","ioc":"URU","languages":["spa"],"name":"Uruguay","status":"assigned"},{"alpha2":"UZ","alpha3":"UZB","countryCallingCodes":["+998"],"currencies":["UZS"],"emoji":"🇺🇿","ioc":"UZB","languages":["uzb","rus"],"name":"Uzbekistan","status":"assigned"},{"alpha2":"VA","alpha3":"VAT","countryCallingCodes":["+379","+39"],"currencies":["EUR"],"emoji":"🇻🇦","ioc":"","languages":["ita"],"name":"Vatican City State","status":"assigned"},{"alpha2":"VC","alpha3":"VCT","countryCallingCodes":["+1 784"],"currencies":["XCD"],"emoji":"🇻🇨","ioc":"VIN","languages":["eng"],"name":"Saint Vincent And The Grenadines","status":"assigned"},{"alpha2":"VD","alpha3":"VDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Viet-Nam, Democratic Republic of","status":"deleted"},{"alpha2":"VE","alpha3":"VEN","countryCallingCodes":["+58"],"currencies":["VEF"],"emoji":"🇻🇪","ioc":"VEN","languages":["spa"],"name":"Venezuela, Bolivarian Republic Of","status":"assigned"},{"alpha2":"VG","alpha3":"VGB","countryCallingCodes":["+1 284"],"currencies":["USD"],"emoji":"🇻🇬","ioc":"IVB","languages":["eng"],"name":"Virgin Islands (British)","status":"assigned"},{"alpha2":"VI","alpha3":"VIR","countryCallingCodes":["+1 340"],"currencies":["USD"],"emoji":"🇻🇮","ioc":"ISV","languages":["eng"],"name":"Virgin Islands (US)","status":"assigned"},{"alpha2":"VN","alpha3":"VNM","countryCallingCodes":["+84"],"currencies":["VND"],"emoji":"🇻🇳","ioc":"VIE","languages":["vie"],"name":"Viet Nam","status":"assigned"},{"alpha2":"VU","alpha3":"VUT","countryCallingCodes":["+678"],"currencies":["VUV"],"emoji":"🇻🇺","ioc":"VAN","languages":["bis","eng","fra"],"name":"Vanuatu","status":"assigned"},{"alpha2":"WF","alpha3":"WLF","countryCallingCodes":["+681"],"currencies":["XPF"],"emoji":"🇼🇫","ioc":"","languages":["fra"],"name":"Wallis And Futuna","status":"assigned"},{"alpha2":"WK","alpha3":"WAK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Wake Island","status":"deleted"},{"alpha2":"WS","alpha3":"WSM","countryCallingCodes":["+685"],"currencies":["WST"],"emoji":"🇼🇸","ioc":"SAM","languages":["eng","smo"],"name":"Samoa","status":"assigned"},{"alpha2":"XK","alpha3":"","countryCallingCodes":["+383"],"currencies":["EUR"],"emoji":"","ioc":"KOS","languages":["sqi","srp","bos","tur","rom"],"name":"Kosovo","status":"user assigned"},{"alpha2":"YD","alpha3":"YMD","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yemen, Democratic","status":"deleted"},{"alpha2":"YE","alpha3":"YEM","countryCallingCodes":["+967"],"currencies":["YER"],"emoji":"🇾🇪","ioc":"YEM","languages":["ara"],"name":"Yemen","status":"assigned"},{"alpha2":"YT","alpha3":"MYT","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇾🇹","ioc":"","languages":["fra"],"name":"Mayotte","status":"assigned"},{"alpha2":"YU","alpha3":"YUG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yugoslavia","status":"deleted"},{"alpha2":"ZA","alpha3":"ZAF","countryCallingCodes":["+27"],"currencies":["ZAR"],"emoji":"🇿🇦","ioc":"RSA","languages":["afr","eng","nbl","som","tso","ven","xho","zul"],"name":"South Africa","status":"assigned"},{"alpha2":"ZM","alpha3":"ZMB","countryCallingCodes":["+260"],"currencies":["ZMW"],"emoji":"🇿🇲","ioc":"ZAM","languages":["eng"],"name":"Zambia","status":"assigned"},{"alpha2":"ZR","alpha3":"ZAR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Zaire","status":"deleted"},{"alpha2":"ZW","alpha3":"ZWE","countryCallingCodes":["+263"],"currencies":["USD","ZAR","BWP","GBP","EUR"],"emoji":"🇿🇼","ioc":"ZIM","languages":["eng","sna","nde"],"name":"Zimbabwe","status":"assigned"}]

/***/ }),

/***/ "yB1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.C.state.containerSection.completion && _vm.C.state.$isEditable)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":"xs1"},on:{"click":_vm.C.trigger.setCompletion}},[_c('v-btn',{attrs:{"fab":"fab","small":"small","icon":"icon","color":"secondary","dark":"dark"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v(_vm._s(_vm.C.state.interstitial ? "blur_on" : "check"))])],1)],1):_vm._e(),(!_vm.C.state.containerSection.completion && _vm.C.state.$isEditable)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":"xs1"},on:{"click":_vm.C.trigger.setCompletion}},[_c('v-btn',{attrs:{"flat":"flat","icon":"icon","outline":"outline","color":"secondary"}},[_c('v-icon',{attrs:{"small":"small"}},[_vm._v(_vm._s(_vm.C.state.interstitial ? "blur_on" : "check"))])],1)],1):_vm._e(),(_vm.C.state.containerSection.completion && !_vm.C.state.$isEditable)?_c('v-icon',{staticClass:"ml-2"},[_vm._v("check_circle")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yCdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__ = __webpack_require__("1Fki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_country_data__ = __webpack_require__("in4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_country_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      C: {
        data: {
          profile: {}
        },
        list: {
          countries: __WEBPACK_IMPORTED_MODULE_1_country_data___default.a.countries
        }
      }
    };
  },
  created: function created() {
    var component = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].loggedInData({
      success: function success(loggedInItem) {
        component.C.data.profile = loggedInItem && loggedInItem.data || {};
      },
      error: function error(errorResponse) {
        __WEBPACK_IMPORTED_MODULE_0__assets_tools_js__["a" /* default */].alert({
          type: 'error',
          errorResponse: errorResponse
        });
      }
    });
  }
});

/***/ }),

/***/ "yLWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-alert',{staticClass:"alert--global",attrs:{"type":_vm.CR.show.alert.type,"value":_vm.CR.show.alert.active,"transition":"slide-y-reverse-transition","dismissible":"dismissible"}},[_vm._v(_vm._s(_vm.CR.show.alert.message))]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yTgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"bottom","content-class":"tooltip--long"}},[_c('v-icon',{attrs:{"slot":"activator","dark":"dark","color":"secondary"},slot:"activator"},[_vm._v("info_outline")]),_c('span',[_vm._v(_vm._s(_vm.C.data.message))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yav+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.de589eed43aec88d32bc.js